<!--<app-pdfdata [content]='contents' [front]="frontpages"></app-pdfdata>-->
<div *ngFor="let page of frontpages" style="clear:both">
						<h1 *ngIf="!page.OSNAME" style="font-weight:bold; font-size:14px; margin-top: 20px;">{{page.SECTION_TITLE}}</h1>
						<div *ngIf='page.text&&page.text.length>0' class="ck-content" style="font-family:Segoe UI, sans-serif; width:100%; font-size:12px; padding:0; margin:0" [innerHTML]="page.htmltext?.changingThisBreaksApplicationSecurity|safeHtml">
						</div>
						<div *ngFor="let page1 of page.SUB_SECTIONS">
							<div  style="clear:both" *ngIf="!(page1.TYPE=='TABLE'&&page1.OTABLE)&&(!page1.HIDE)">
							<h2 *ngIf="(!(page1.OTNAME&&page1.TYPE=='TABLE'))&&(!(page1.OPNAME&&page1.TYPE=='PHOTOS'))&&(!(page1.OSNAME&&(page1.TYPE=='PARA'||page1.TYPE=='SEALS'||page1.TYPE=='SIGNS')))"style="font-weight:bold; font-size:14px; margin-top: 20px">{{page1.SECTION_TITLE}}</h2>
							<div *ngIf='page1.text&&page1.text.length>0' class="ck-content" style="font-family:Segoe UI, sans-serif;; font-size:12px; width:100%; padding:0; margin:0" [innerHtml]="page1.htmltext?.changingThisBreaksApplicationSecurity|safeHtml">
							</div>
							<div style="width:100%; padding:8px 16px" *ngIf="page1.TYPE=='PHOTOS'&&page1.photos&&page1.photos.length>0">
								<div class="row">
									<ng-container *ngFor="let photo of page1.photos; let s=index">
										<div style="padding: 10px; float: left;  width: 50%;">
											<div  style="border:1px solid #CCC;  padding-bottom: 10px;  height:300px;">
												<img [src]="photo.FILE_URL" [alt]="photo.FILE_NAME" style="width:100%; height:90%">
												<p class="desc">{{photo.FILE_DESCRIPTION}}</p>
											</div>
										</div>
									</ng-container>
								</div>
							</div>
							<div *ngIf="page1.id=='phaseI_project_summary_table'">
					
								<table style="width:100%; font-family:Arial, sans-serif;border:1px solid black;border-collapse: collapse;margin-top: 10px" [ngClass]="{'pcasummary':headerClass=='PCA', 'phase1summary':page1['tableClass']=='PHASE1'}">
									<thead>
										<tr>
											<ng-container *ngFor="let h of page1.data.cols; let o=index; trackBy:trackByFuntion">
												<th *ngIf='!h["hide"]' [ngStyle]="{'width':h.width+h.unit}" style="font-weight: bold;text-align: center;" [ngClass]="h.bk">
													{{h.NAME}}
												</th>	
											</ng-container>
										</tr>
									</thead>
								<tbody>
								<ng-container *ngFor="let r of page1.data.rows; let h=index; trackBy:trackByFuntion">
									<tr>
									   <ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
											
												<td *ngIf='!k.secHtml' [ngStyle]="{'text-align':page1.data.cols[q].celAllign}">
													{{k.data}}
												</td>
												<td *ngIf='k.secHtml' [ngStyle]="{'text-align':page1.data.cols[q].celAllign}">
													<span  [innerHTML]="k.secHtml.changingThisBreaksApplicationSecurity|safeHtml"></span>
												</td>
											
										</ng-container>
									</tr>
								</ng-container> 
							</tbody> 
								</table>
						</div>
							<div *ngIf="(page1.TYPE=='SEALS'&&page1.seals&&page1.seals.length>0)||(page1.TYPE=='SIGNS'&&page1.signs&&page1.signs.length>0)" style="width:100%; padding:0" >
								<div class="row">
								<ng-container *ngFor="let photo of page1.signs; let s=index; trackBy:trackByFuntion">
									<div *ngIf="photo.TYPE=='signature'&&(!photo['ALIGN']||photo['ALIGN']=='D')" style="padding: 0; flex: 0 49%;">
										<div *ngIf="!photo.signatureTemplate&&rptInfo&&rptInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'" style='margin-right: 5%;'>
											<div style="display:flex;">
												<div style="vertical-align: bottom;line-height:40px">{{photo['AUTHOR']}}</div>
												<div style="border-bottom: 1px solid black;flex: 1;text-align: center">
													<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="height:40px;max-width:100%;vertical-align:bottom; margin-bottom: 2px;">
												</div>												
											</div>
											<p>{{photo.NAME}}</p>
											<p [innerHTML]="photo.TITLE"></p>
											<p *ngIf="photo.DATE">Date: {{photo.DATE}}</p>					
										</div>	
										<div *ngIf="!photo.signatureTemplate&&rptInfo&&rptInfo['SPECIAL_SIGNATURE_FORMAT']!='Y'"   style="padding-left: 15px">
										<div  class="gallery2">
											<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
										</div>
										<p class="desc1">{{photo.NAME}}</p>
										<p class="desc1" [innerHTML]="photo.TITLE"></p>
										<p *ngIf="photo.DATE" class="desc1">Date: {{photo.DATE}}</p>
									</div>
									<div *ngIf="photo.signatureTemplate" style="width:100%; ">
											<div style="padding: 4px 15px; width:100%;" [innerHTML]="photo.htmlSec?.changingThisBreaksApplicationSecurity|safeHtml"></div>											
										</div>
									</div>
									<div *ngIf="photo.TYPE=='signature'&&(photo['ALIGN']&&photo['ALIGN']!='D')" style="padding:0; width:100%" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L','alignRight':photo['ALIGN']=='R'}">
										<div *ngIf="!photo.signatureTemplate&&rptInfo&&rptInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'" style='margin-right: 5%;width:50%'>
											<div style="display:flex;">
												<div style="vertical-align: bottom;line-height:40px; font-size: 10pt;">{{photo['AUTHOR']}}</div>
												<div style="border-bottom: 1px solid black;flex: 1;text-align: center">
													<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="height:40px;max-width:100%;vertical-align:bottom; margin-bottom: 2px;">
												</div>												
											</div>
											<p style="font-weight: bold;font-size: 10pt;">{{photo.NAME}}</p>
											<p style="font-weight: bold;font-size: 10pt;" [innerHTML]="photo.TITLE"></p>
											<p style="font-weight: bold;font-size: 10pt;" *ngIf="photo.DATE">Date: {{photo.DATE}}</p>					
										</div>
										<div *ngIf="!photo.signatureTemplate&&rptInfo&&rptInfo['SPECIAL_SIGNATURE_FORMAT']!='Y'" class="gallery1" style="display:block" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L'}">
											<div  class="gallery2">
												<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
											</div>
											<p><span class="desc2">{{photo.NAME}}</span></p>
											<p *ngIf="photo['ALIGN']=='C'"><span class="desc2" [innerHTML]="photo.TITLE"></span></p>
											<p *ngIf="photo['ALIGN']=='L'" class="desc2" [innerHTML]="photo.TITLE"></p>
						
											<p *ngIf="photo.DATE"><label class="desc2">Date: {{photo.DATE}}</label></p>
										</div>
										<div *ngIf="photo.signatureTemplate&&photo['ALIGN']=='C'&&(!(rptInfo&&rptInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'))" style="width: 49%;margin:0 auto; text-align: center;">
											<div style="padding: 4px 15px; width:	100%;text-align: left;" [innerHTML]="photo.htmlSec?.changingThisBreaksApplicationSecurity|safeHtml"></div>												
										</div>
										<div *ngIf="photo.signatureTemplate&&photo['ALIGN']=='L'&&(!(rptInfo&&rptInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'))" style="width: 49%;display:flex; justify-content: start;">
											<div style="padding: 4px 15px; width:100%;" [innerHTML]="photo.htmlSec?.changingThisBreaksApplicationSecurity|safeHtml"></div>												
										</div>
										<div *ngIf="photo.signatureTemplate&&rptInfo&&rptInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'" style="width:100%; padding:0; margin: 0;display:flex; justify-content: start;">
											<div  style="padding:0; margin: 0; width:50%" [innerHTML]="processSignatureTemplate(photo.htmlSec)?.changingThisBreaksApplicationSecurity|safeHtml"></div>
										</div>
									</div>
								</ng-container>
									<ng-container *ngFor="let photo of page1.seals; let s=index; trackBy:trackByFuntion">
									<div *ngIf="photo.TYPE=='seal'&&(!photo['ALIGN']||photo['ALIGN']=='D')" class="gallery1">
										<div  class="gallery3">
											<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;max-width:90%;vertical-align:bottom">
										</div>
					
									</div>
									<div *ngIf="photo.TYPE=='seal'&&(photo['ALIGN']&&photo['ALIGN']!='D')" class="gallery4" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L','alignRight':photo['ALIGN']=='R'}">
										<div  class="gallery3">
											<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
										</div>					
									</div>
								</ng-container>
							</div>
							</div>
							<ng-container *ngIf="page1.TYPE=='TABLE'&&page1.data&&page1.data.rows.length>0&&page1.id!='phaseI_project_summary_table'">
								<table style="width:100%; border: 1px solid black;  border-collapse: collapse; font-size:10px;margin-top: 20px">
									<!--<caption *ngIf="page1.data['caption']" [ngStyle]="{'border':page1.data['caption']['border']?'solid 1px black':'none', 'text-align':page1.data['caption']['align']?page1.data['caption']['align']:'center'}">
										<span style="font-weight:bold" [innerHTML]="page1.data['caption'].htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
								   </caption>-->
									<thead>
										<ng-container *ngFor="let brow of page1.data.beforeHeaders; let bindex=index">
											<tr style="background-color:#eeeeee;">
												<ng-container *ngFor="let col of brow; let u=index">
													<th *ngIf="!col.colspan" style="border-collapse: collapse;"  [ngClass]="{'align-left':col.colAlign=='Left','align-right':col.colAlign=='Right','align-center':col.colAlign=='Center'}"  [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}">
														<span style="font-weight:bold" [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
													</th>
													<th *ngIf="col.colspan&&u==0" [attr.colspan]="col.colspan"  [ngClass]="{'align-left':col.colAlign=='Left','align-right':col.colAlign=='Right','align-center':col.colAlign=='Center'}"  style="border-collapse: collapse;" [ngStyle]="{'text-align':col.colAlign}">
														<span style="font-weight:bold" [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
													</th>
												</ng-container>
											</tr>
										</ng-container>
										<tr style="background-color:#eeeeee;">
											<ng-container *ngFor="let h of page1.data?.cols; let o=index">
												<th [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="border: 1px solid black;  border-collapse: collapse;">
													<span style="font-weight:bold" [innerHTML]="h.htmltext?.changingThisBreaksApplicationSecurity|safeHtml"></span>
						
												</th>
											</ng-container>
										</tr>
										<ng-container *ngFor="let brow of page1.data.afterHeaders; let bindex=index">
											<tr style="background-color:#eeeeee;">
												<ng-container *ngFor="let col of brow; let u=index">
													<th *ngIf="!col.colspan" style="border-collapse: collapse;" [ngClass]="{'align-left':col.colAlign=='Left','align-right':col.colAlign=='Right','align-center':col.colAlign=='Center'}" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}">
														<span style="font-weight:bold" [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
													</th>
													<th *ngIf="col.colspan&&u==0" [attr.colspan]="col.colspan"  [ngClass]="{'align-left':col.colAlign=='Left','align-right':col.colAlign=='Right','align-center':col.colAlign=='Center'}"  style="border-collapse: collapse" [ngStyle]="{'text-align':col.colAlign}">
														<span style="font-weight:bold" [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
													</th>
												</ng-container>
											</tr>
										</ng-container>
									</thead>
									<tbody>
										<ng-container *ngFor="let r of page1.data?.rows; let h=index">
											<tr *ngIf="r.items&&r.items.length>0&&(!r.items[0].colspan)&&(!r.hide)">
												<ng-container *ngFor="let m of r.items; let q=index">
													<td [ngStyle]="{'text-align':page1.data?.cols[q].celAllign, 'background':m.bkcolor}" style="border: 1px solid black;  border-collapse: collapse;vertical-align:top">
														<span *ngIf="m.DATA" [innerHTML]="m.DATA?.changingThisBreaksApplicationSecurity|safeHtml"></span>
													</td>																			
												</ng-container>
											</tr>
											<tr *ngIf="r.items?.length==1&&r.items[0].colspan&&(!r.hide)">					
												<td colSpan='{{r.items[0].colspan}}' [ngStyle]="{'text-align':r.items[0].celAllign, 'background':r.items[0].bkcolor}"  style="font-weight:bold; border: 1px solid black;  border-collapse: collapse;vertical-align:top">
													<span *ngIf="r.items[0].DATA" [innerHTML]="r.items[0].DATA?.changingThisBreaksApplicationSecurity|safeHtml"></span>
												</td>
											</tr>
						
										</ng-container>
									</tbody>			
								</table>
							</ng-container>	
						</div>						
						</div>
</div>
<div *ngIf="curReport?.PCA_INDICATOR!='frm1104'&&curReport?.PHASE1_TYPE!='1103'">
	<ng-container *ngFor="let doc of contents; let i=index">
		<div *ngIf="!doc.HIDE" style="clear:both">
		<div style="margin:20px 0; font-family:Segoe UI, sans-serif;clear: left">
			<div *ngIf="doc.NEW" class="page-after"></div>
			<h1 *ngIf="doc.id.indexOf('frm_sec')==-1">			
			<label style="font-weight:bold; font-size:18px" *ngIf="!(doc.OSNAME||(doc.TYPE=='PHOTOS'&&doc.OPNAME))">{{doc.SECTION_SEQUENCE}}
				<ng-container *ngIf="doc.DISPLAY_SEQUENCE=='Y'">
					<ng-container *ngFor="let i of head1Space|fill">
						&nbsp;
					</ng-container>
				</ng-container>
				{{doc.SECTION_TITLE}}</label></h1>
			
		</div>
		<div *ngIf='doc.text&&doc.text.length>0&&(!doc?.intro)' class="ck-content" style="font-family:Segoe UI, sans-serif; width:100%; font-size:12px; padding:0; margin:0" [innerHTML]="doc.htmltext?.changingThisBreaksApplicationSecurity|safeHtml">
		</div>
		<div  *ngIf="doc.id=='frm_sec'" style="pointer-events: none; background-color: none;color:black">
			<!--<app-frm *ngIf="doc.id=='frm_sec'" [src]='"rpt"' [inputData]="doc.frmData"></app-frm>-->
			<iframe *ngIf="iframeSrc1" id="printFrame" (load)="resizeIframe($event)" style="width:100%; border:none;" [src]="iframeSrc1"></iframe>
		</div>
		
		<div style="width:100%; padding:8px 16px" *ngIf="doc.TYPE=='PHOTOS'&&doc.photos&&doc.photos.length>0">
			<div class="row">
			<ng-container *ngFor="let photo of doc.photos; let s=index">
				<div style="padding: 10px; float: left;  width: 50%;">
					<div  style="border:1px solid #CCC;  padding-bottom: 10px;  height:300px;">
						<img [src]="photo.FILE_URL" [alt]="photo.FILE_NAME" style="width:100%; height:90%">
						<p class="desc">{{photo.FILE_DESCRIPTION}}</p>
					</div>
				</div>
			</ng-container>
			</div>
		</div>
		<ng-container *ngFor="let doc1 of doc.SUB_SECTIONS; let j=index">
		<div *ngIf="!doc1.HIDE" [ngStyle]="{'margin': '18px 0', 'font-family': 'Arial, sans-serif', 'clear': 'both', 'overflow': hasSpecialSignatureFormat(doc1) ? 'visible' : 'hidden'}">
			<ng-container *ngIf="(doc1.TYPE!='TABLE'&&doc1.TYPE!='COSTTABLE')||(doc1.TYPE=='TABLE'&&doc1.data&&doc1.data.rows.length>0)||(doc1.TYPE=='COSTTABLE'&&doc1.data&&doc1.data.rows.length>1)">
				<div *ngIf="doc1.NEW" class="page-after"></div>
				<ng-container *ngIf="!((doc1.TYPE=='TABLE'&&doc1.OTNAME)||doc1.OSNAME||(doc1.TYPE=='PHOTOS'&&doc1.OPNAME))">
					<h2 *ngIf="doc1.id.indexOf('frm_sec')==-1" style="font-weight:bold; font-size:14px"><label>{{doc1.SECTION_SEQUENCE}}
					<ng-container *ngIf="doc1.DISPLAY_SEQUENCE=='Y'">
					<ng-container *ngFor="let i of head2Space|fill">
						&nbsp;
					</ng-container>
				</ng-container>
					{{doc1.SECTION_TITLE}}</label></h2>
				</ng-container>
				<div *ngIf="doc1.id=='phaseI_project_summary_table'">
					
					<table style="width:100%; font-family:Arial, sans-serif;border:1px solid black;border-collapse: collapse;margin-top: 10px" [ngClass]="{'pcasummary':headerClass=='PCA', 'phase1summary':doc1['tableClass']=='PHASE1'}">
						<thead>
							<tr>
								<ng-container *ngFor="let h of doc1.data.cols; let o=index; trackBy:trackByFuntion">
									<th *ngIf='!h["hide"]' [ngStyle]="{'width':h.width+h.unit}" style="font-weight: bold;text-align: center;" [ngClass]="h.bk">
										{{h.NAME}}
									</th>	
								</ng-container>
							</tr>
						</thead>
					<tbody>
					<ng-container *ngFor="let r of doc1.data.rows; let h=index; trackBy:trackByFuntion">
						<tr>
						   <ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
								
									<td *ngIf='!k.secHtml' [ngStyle]="{'text-align':doc1.data.cols[q].celAllign}">
										{{k.data}}
									</td>
									<td *ngIf='k.secHtml' [ngStyle]="{'text-align':doc1.data.cols[q].celAllign}">
										<span  [innerHTML]="k.secHtml.changingThisBreaksApplicationSecurity|safeHtml"></span>
									</td>
								
							</ng-container>
						</tr>
					</ng-container> 
				</tbody> 
					</table>
			
				  </div>
				  <div *ngIf="doc1.tableClass">
			
			<table style="width:100%; font-family:Arial, sans-serif;border: none;border-collapse: collapse;margin-top: 10px" [ngClass]="{'pcasummary':doc1.tableClass=='PCA', 'phase1summary':doc1.tableClass=='PHASE1'}">
				<thead>
					<tr *ngIf="!doc1.OHEADER">
						<ng-container *ngFor="let h of doc1.data.cols; let o=index; trackBy:trackByFuntion">
							<th *ngIf='!h["hide"]' [ngStyle]="{'width':h.width+h.unit, 'border':h.border}" style="font-weight: bold;text-align: center;" [ngClass]="h.bk">
								{{h.NAME}}
							</th>	
						</ng-container>
					</tr>
				</thead>
			<tbody>
			<ng-container *ngFor="let r of doc1.data.rows; let h=index; trackBy:trackByFuntion">
				<tr *ngIf="!r[0]['rowhide']">
				   <ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
						<ng-container *ngIf="!k.colspan">
							<td *ngIf='(!k.secHtml||doc1.id!="pca_summary_0")&&(!(k["hide"]&&doc1.id=="pca_summary_1")||doc1.id!="pca_summary_1")' [ngStyle]="{'text-align':doc1.data.cols[q].celAllign, 'background-color':k.bk , 'font-weight':k.weight, width:doc1.data.cols[q].width+doc1.data.cols[q].unit, 'border':k.border,'padding-left':k.sub}">
							    <ng-container *ngIf="k.data=='NaN'||k.data==''"></ng-container>
                            	<ng-container *ngIf="k.data!='NaN'&&k.data!=''">
									<ng-container *ngIf="k.sign">
										{{k.sign}}
									</ng-container>{{k.data}}
								</ng-container>
							</td>
							<td *ngIf='k.secHtml' [ngStyle]="{'text-align':doc1.data.cols[q].celAllign, 'background-color':k.bk , 'font-weight':k.weight, width:doc1.data.cols[q].width+doc1.data.cols[q].unit, 'border':k.border,'padding-left':k.sub}">
								<span  [innerHTML]="k.secHtml.changingThisBreaksApplicationSecurity|safeHtml"></span>
							</td>
						</ng-container>
						<ng-container  *ngIf="k.colspan">
							<td [attr.colspan]='k.colspan' [ngStyle]="{'text-align':k.celAllign, 'font-weight':k.weight, width:doc1.data.cols[q].width+doc1.data.cols[q].unit, 'border':k.border}">
								{{k.data}}
							</td>
						</ng-container>		
					</ng-container>
				</tr>
			</ng-container> 
		</tbody> 
			</table>
		
		  </div>
		  <!--<p-table *ngIf="doc1.TYPE=='TABLE'&&doc1.data&&doc1.data.erisName&&!doc1['HIDEERIS']"  [value]="doc1.data.rows|slice: 0:20" [columns]="doc1.data.cols|slice:1">
			<ng-template pTemplate="header"  let-columns>
					<tr>
						<th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" style="padding:1px; font-size:11px">
							{{col.NAME}}              
						</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-rowData let-columns="columns">
					<tr>
						<td *ngFor="let col of rowData|slice:1" style="padding:1px; font-size:11px">
							<span>{{col.DATA}}</span>																
						</td>																	
					</tr>
				</ng-template>
			</p-table>-->
			<p *ngIf="reportInfo?.ORDER_NUM&&doc1.TYPE=='TABLE'&&doc1.data&&doc1.data.erisName&&doc1.data.rows.length>100" class="erislabel">100 of {{doc1.data.rows.length}} total records shown</p>
			<p *ngIf="reportInfo?.ORDER_NUM&&doc1.TYPE=='TABLE'&&doc1.data&&doc1.data.erisName&&doc1.data.rows.length<101" class="erislabel">{{doc1.data.rows.length}} of {{doc1.data.rows.length}} total records shown</p>
			<p *ngIf="!reportInfo?.ORDER_NUM&&doc1.TYPE=='TABLE'&&doc1.data&&doc1.data.erisName&&doc1.data.rows.length==1" class="erislabel">0 of 0 total records shown</p>
			<table *ngIf="doc1.TYPE=='TABLE'&&doc1.data&&doc1.data.erisName" style="width:100%; border: 1px solid #ccc;  border-collapse: collapse;font-size:10px; font-family:Arial, sans-serif;">
				<thead>
				<tr>
					<ng-container *ngFor="let h of doc1.data?.cols; let o=index; trackBy:trackByFuntion">
						<th *ngIf="(!h.hide||h.hide=='N')" [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="border: 1px solid #ccc;  border-collapse: collapse;">
							<span style="font-weight:bold"> {{h.NAME}}</span>
						</th>
					</ng-container>
				</tr>
				</thead>
				<tbody>
				<ng-container *ngFor="let r of doc1.data?.rows|slice: 0:100; let h=index; trackBy:trackByFuntion">
					<tr *ngIf="r[0]['SUBHEADER']!='Y'&&(r[0].DATA&&r[0].DATA.length>0)">
						<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
							<td *ngIf="!k.hide||k.hide=='N'" [ngStyle]="{'text-align':doc1.data?.cols[q].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;vertical-align:top;">
								<span *ngIf="k.sign&&k.sign==currSign">{{k.sign}}</span>
								<span *ngIf="!k.HTML" [innerHTML]="k.DATA"></span>
								<span *ngIf="k.HTML" [innerHTML]="k.SEC.changingThisBreaksApplicationSecurity|safeHtml"></span>
								<span *ngIf="k.sign&&k.sign!=currSign">{{k.sign}}</span>
							</td>
						</ng-container>		
					</tr>
					<tr *ngIf="r[0].SUBHEADER=='Y'">
						<td colSpan='{{doc1.data.cols.length}}'  [ngStyle]="{'text-align':r[0]['celAllign']?r[0]['celAllign']:'Center'}" style="font-weight:bold; border: 1px solid #ccc; border-collapse: collapse;vertical-align:top;">
							<span *ngIf="!r[1].HTML" [innerHTML]="r[1].DATA"></span>
							<span *ngIf="r[1].HTML" [innerHTML]="r[1].SEC.changingThisBreaksApplicationSecurity|safeHtml"></span>
						</td>
					</tr>
				</ng-container>
				</tbody>
			</table>
			<table *ngIf="!doc1.OTABLE&&(doc1.TYPE=='COSTTABLE'||doc1.TYPE=='PCATABLE'||doc1.TYPE=='UNITTABLE')&&doc1.data" [ngStyle]="{'width':doc1.TYPE=='UNITTABLE'?'50%':'100%'}" style="border: 1px solid black;  border-collapse: collapse;font-size:10px; font-family:Arial, sans-serif;">
				<thead *ngIf="!doc1.OHEADER">
				<tr style="background-color:#eeeeee;">
					<ng-container *ngFor="let h of doc1.data?.cols; let o=index">
						<th *ngIf="!h.hide||h.hide=='N'" [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="border: 1px solid black;  border-collapse: collapse;">
							<span style="font-weight:bold"> {{h.NAME}}</span>
						</th>
					</ng-container>
				</tr>
				</thead>
				<tbody>
				<ng-container *ngFor="let r of doc1.data?.rows; let h=index">
					<tr *ngIf="(r.length>1&&r.hide!='Y')&&(!(doc1.TYPE=='COSTTABLE'&&h==0))&&(!doc1.filted||doc1.filted.indexOf(r[0].DATA)>-1)">
						<ng-container *ngFor="let k of r; let q=index">
							<td *ngIf="!k.hide||k.hide=='N'" [ngStyle]="{'width':doc1.data?.cols[q]?.width+doc1.data?.cols[q]?.unit,'text-align':doc1.data?.cols[q]?.celAllign}" style="border: 1px solid black;  border-collapse: collapse;vertical-align:top">
								<span *ngIf="k.sign&&k.sign==currSign">{{k.sign}}</span><span [innerHTML]='k.DATA'></span><span *ngIf="k.sign&&k.sign!=currSign">{{k.sign}}</span>
							</td>
						</ng-container>
					</tr>
					<tr *ngIf="r.length==1&&doc1.data&&r.hide!='Y'">
						<td colSpan='{{doc1.data.cols.length}}' [ngStyle]="{'text-align':r[0].celAllign}" style="font-weight:bold; border: 1px solid black;  border-collapse: collapse;vertical-align:top">
							<span> {{r[0]?.DATA}}</span>
						</td>
					</tr>
				</ng-container>
				</tbody>
			</table>
			<table *ngIf="!doc1.OTABLE&&(doc1.TYPE=='TABLE'&&!doc1.data?.erisName)" [ngStyle]="{'width':doc1.TYPE=='UNITTABLE'?'50%':'100%'}" style="border: 1px solid black;  border-collapse: collapse; font-size:10px">
				<!--<caption *ngIf="doc1.data['caption']" [ngStyle]="{'border':doc1.data['caption']['border']?'solid 1px black':'none', 'text-align':doc1.data['caption']['align']?doc1.data['caption']['align']:'center'}">
					<span style="font-weight:bold" [innerHTML]="doc1.data['caption'].htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
			   </caption>-->		
				<thead *ngIf="!doc1.OHEADER">
					<ng-container *ngFor="let brow of doc1.data.beforeHeaders; let bindex=index">
						<tr style="background-color:#eeeeee;">
							<ng-container *ngFor="let col of brow; let u=index">
								<th *ngIf="!col.colspan" style="border-collapse: collapse;"  [ngClass]="{'align-left':col.colAlign=='Left','align-right':col.colAlign=='Right','align-center':col.colAlign=='Center'}"  [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}">
									<span style="font-weight:bold" [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
								</th>
								<th *ngIf="col.colspan&&u==0" [attr.colspan]="col.colspan"  [ngClass]="{'align-left':col.colAlign=='Left','align-right':col.colAlign=='Right','align-center':col.colAlign=='Center'}"  style="border-collapse: collapse;" [ngStyle]="{'text-align':col.colAlign}">
									<span style="font-weight:bold" [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
								</th>
							</ng-container>
						</tr>
					</ng-container>
					<tr style="background-color:#eeeeee;">
						<ng-container *ngFor="let h of doc1.data?.cols; let o=index">
							<th [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="border: 1px solid black;  border-collapse: collapse;">
								<span style="font-weight:bold" [innerHTML]="h.htmltext?.changingThisBreaksApplicationSecurity|safeHtml"></span>
						
							</th>
						</ng-container>
					</tr>
					<ng-container *ngFor="let brow of doc1.data.afterHeaders; let bindex=index">
						<tr style="background-color:#eeeeee;">
							<ng-container *ngFor="let col of brow; let u=index">
								<th *ngIf="!col.colspan" style="border-collapse: collapse;" [ngClass]="{'align-left':col.colAlign=='Left','align-right':col.colAlign=='Right','align-center':col.colAlign=='Center'}" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}">
									<span style="font-weight:bold" [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
								</th>
								<th *ngIf="col.colspan&&u==0" [attr.colspan]="col.colspan"  [ngClass]="{'align-left':col.colAlign=='Left','align-right':col.colAlign=='Right','align-center':col.colAlign=='Center'}"  style="border-collapse: collapse" [ngStyle]="{'text-align':col.colAlign}">
									<span style="font-weight:bold" [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
								</th>
							</ng-container>
						</tr>
					</ng-container>
					</thead>
					<tbody>
					<ng-container *ngFor="let r of doc1.data?.rows; let h=index">
					
						<tr *ngIf="r.items&&r.items.length>0&&(!r.items[0].colspan)&&(!r.hide)">
						    <ng-container *ngFor="let m of r.items; let q=index">
								<td [ngStyle]="{'width':doc1.data?.cols[q].width+doc1.data?.cols[q].unit,'text-align':doc1.data?.cols[q].celAllign, 'background':m.bkcolor}" style="border: 1px solid black;  border-collapse: collapse;vertical-align:top">
									<span *ngIf="m.DATA" [innerHTML]="m.DATA?.changingThisBreaksApplicationSecurity|safeHtml"></span>
								</td>
							</ng-container>
						</tr>
						<tr *ngIf="r.items?.length==1&&r.items[0].colspan&&(!r.hide)">					
							<td colSpan='{{r.items[0].colspan}}' [ngStyle]="{'text-align':r.items[0].celAllign, 'background':r.items[0].bkcolor}"  style="font-weight:bold; border: 1px solid black;  border-collapse: collapse;vertical-align:top">
								<span *ngIf="r.items[0].DATA" [innerHTML]="r.items[0].DATA?.changingThisBreaksApplicationSecurity|safeHtml"></span>
							</td>
						</tr>
						
					</ng-container>
					</tbody>			
				</table>
			</ng-container>
			<div *ngIf='doc1.text&&doc1.text.length>0&&(!doc1?.intro)' class="ck-content" style="font-family:Segoe UI, sans-serif;; font-size:12px; width:100%; padding:0; margin:0" [innerHtml]="doc1.htmltext?.changingThisBreaksApplicationSecurity|safeHtml">
			</div>
			<div style="width:100%; padding:8px 16px" *ngIf="doc1.TYPE=='PHOTOS'&&doc1.photos&&doc1.photos.length>0">
			<div class="row">
			<ng-container *ngFor="let photo of doc1.photos; let s=index">
				<div style="padding: 10px; float: left;  width: 50%;">
					<div  style="border:1px solid #CCC;  padding-bottom: 10px;  height:300px;">
						<img [src]="photo.FILE_URL" [alt]="photo.FILE_NAME" style="width:100%; height:90%">
						<p class="desc">{{photo.FILE_DESCRIPTION}}</p>
					</div>
				</div>
			</ng-container>
			</div>
		</div>
		<div *ngIf="(doc1.TYPE=='SEALS'&&doc1.seals&&doc1.seals.length>0)||(doc1.TYPE=='SIGNS'&&doc1.signs&&doc1.signs.length>0)" style="width:100%; padding:0" >
								<div class="row">
								<ng-container *ngFor="let photo of doc1.signs; let s=index; trackBy:trackByFuntion">
									<div *ngIf="photo.TYPE=='signature'&&(!photo['ALIGN']||photo['ALIGN']=='D')" style="padding: 0; flex: 0 49%;">
										<div *ngIf="!photo.signatureTemplate&&rptInfo&&rptInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'" style='margin-right: 5%;'>
											<div style="display:flex;">
												<div style="vertical-align: bottom;line-height:40px">{{photo['AUTHOR']}}</div>
												<div style="border-bottom: 1px solid black;flex: 1;text-align: center">
													<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="height:40px;max-width:100%;vertical-align:bottom; margin-bottom: 2px;">
												</div>												
											</div>
											<p>{{photo.NAME}}</p>
											<p [innerHTML]="photo.TITLE"></p>
											<p *ngIf="photo.DATE">Date: {{photo.DATE}}</p>					
										</div>
										<div *ngIf="!photo.signatureTemplate&&rptInfo&&rptInfo['SPECIAL_SIGNATURE_FORMAT']!='Y'"   style="padding-left: 15px">
											<div  class="gallery2">
												<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
											</div>
											<p class="desc1">{{photo.NAME}}</p>
											<p class="desc1" [innerHTML]="photo.TITLE"></p>
											<p *ngIf="photo.DATE" class="desc1">Date: {{photo.DATE}}</p>
										</div>
										<div *ngIf="photo.signatureTemplate" style="width:100%">
											<div style="padding: 4px 15px; width:100%;" [innerHTML]="photo.htmlSec?.changingThisBreaksApplicationSecurity|safeHtml"></div>												
										</div>
									</div>
									<div *ngIf="photo.TYPE=='signature'&&(photo['ALIGN']&&photo['ALIGN']!='D')" style="padding:0; width:100%" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L','alignRight':photo['ALIGN']=='R'}">
										<div *ngIf="!photo.signatureTemplate&&rptInfo&&rptInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'" style='margin-right: 5%;width:50%'>
											<div style="display:flex;">
												<div style="vertical-align: bottom;line-height:40px;font-size: 10pt">{{photo['AUTHOR']}}</div>
												<div style="border-bottom: 1px solid black;flex: 1;text-align: center">
													<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="height:40px;max-width:100%;vertical-align:bottom; margin-bottom: 2px;">
												</div>												
											</div>
											<p style="font-weight: bold;font-size: 10pt;">{{photo.NAME}}</p>
											<p  style="font-weight: bold;font-size: 10pt;" [innerHTML]="photo.TITLE"></p>
											<p *ngIf="photo.DATE"  style="font-weight: bold;font-size: 10pt;">Date: {{photo.DATE}}</p>					
										</div>
										<div *ngIf="!photo.signatureTemplate&&rptInfo&&rptInfo['SPECIAL_SIGNATURE_FORMAT']!='Y'" class="gallery1" style="display:block" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L'}">
											<div  class="gallery2">
												<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
											</div>
											<p><span class="desc2">{{photo.NAME}}</span></p>
											<p *ngIf="photo['ALIGN']=='C'"><span class="desc2" [innerHTML]="photo.TITLE"></span></p>
											<p *ngIf="photo['ALIGN']=='L'" class="desc2" [innerHTML]="photo.TITLE"></p>					
											<p *ngIf="photo.DATE"><label class="desc2">Date: {{photo.DATE}}</label></p>
										</div>
										<div *ngIf="photo.signatureTemplate&&photo['ALIGN']=='C'&&(!(rptInfo&&rptInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'))" style="width: 49%;margin:0 auto; text-align: center;">
											<div style="padding: 4px 15px; width:	100%;text-align: left;" [innerHTML]="photo.htmlSec?.changingThisBreaksApplicationSecurity|safeHtml"></div>												
										</div>
										<div *ngIf="photo.signatureTemplate&&photo['ALIGN']=='L'&&(!(rptInfo&&rptInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'))" style="width: 49%;display:flex; justify-content: start;">
											<div style="padding: 4px 15px; width:100%;" [innerHTML]="photo.htmlSec?.changingThisBreaksApplicationSecurity|safeHtml"></div>												
										</div>
										<div *ngIf="photo.signatureTemplate&&rptInfo&&rptInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'" style="width:100%; padding:0; margin: 0;display:flex; justify-content: start;">
											<div  style="padding:0; margin: 0; width:50%" [innerHTML]="processSignatureTemplate(photo.htmlSec)?.changingThisBreaksApplicationSecurity|safeHtml"></div>
										</div>	
									</div>
									</ng-container>
									<ng-container *ngFor="let photo of doc1.seals; let s=index; trackBy:trackByFuntion">
								
									<div *ngIf="photo.TYPE=='seal'&&(!photo['ALIGN']||photo['ALIGN']=='D')" class="gallery1">
										<div  class="gallery3">
											<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;max-width:90%;vertical-align:bottom">
										</div>
					
									</div>
									<div *ngIf="photo.TYPE=='seal'&&(photo['ALIGN']&&photo['ALIGN']!='D')" class="gallery4" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L','alignRight':photo['ALIGN']=='R'}">
										<div  class="gallery3">
											<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
										</div>					
									</div>
				
								</ng-container>
							</div>
							</div>
			<ng-container *ngFor="let doc2 of doc1.SUB_SECTIONS; let k=index">
			<div *ngIf="!doc2.HIDE" [ngStyle]="{'overflow': hasSpecialSignatureFormat(doc2) ? 'visible' : 'hidden', 'clear': 'both'}">
			<ng-container *ngIf="(doc2.TYPE!='TABLE'&&doc2.TYPE!='COSTTABLE')||(doc2.TYPE=='TABLE'&&doc2.data&&doc2.data.rows.length>0)||(doc2.TYPE=='COSTTABLE'&&doc2.data&&doc2.data.rows.length>1)">
			
				
				<div style="margin:16px 0; font-family:Arial, sans-serif;clear: left">
				<div *ngIf="doc1.NEW" class="page-after"></div>
				<ng-container *ngIf="!((doc2.TYPE=='TABLE'&&doc2.OTNAME)||doc2.OSNAME||(doc2.TYPE=='PHOTOS'&&doc2.OPNAME))">
				<h3 *ngIf="doc2.id.indexOf('frm_sec')==-1" style="font-weight:bold; font-size:14px"><label>{{doc2.SECTION_SEQUENCE}}
				<ng-container *ngIf="doc2.DISPLAY_SEQUENCE=='Y'">
					<ng-container *ngFor="let i of head3Space|fill">
						&nbsp;
					</ng-container>
				</ng-container>
					{{doc2.SECTION_TITLE}}</label></h3>
				</ng-container>
				</div>
				<div *ngIf='doc2.text&&doc2.text.length>0&&(!doc2?.intro)' class="ck-content" style="font-family:Segoe UI, sans-serif;; width:100%; font-size:12px;  padding:0; margin:0" [innerHtml]="doc2.htmltext?.changingThisBreaksApplicationSecurity|safeHtml">
				</div>
				<div style="width:100%; padding:8px 16px" *ngIf="doc2.TYPE=='PHOTOS'&&doc2.photos&&doc2.photos.length>0">
			<div>
			<ng-container *ngFor="let photo of doc2.photos; let s=index">
				<div style="padding: 10px; float: left;  width: 50%;">
					<div style="border:1px solid #CCC;  padding-bottom: 10px;  height:300px;">
						<img [src]="photo.FILE_URL" [alt]="photo.FILE_NAME" style="width:100%; height:90%">
						<p class="desc">{{photo.FILE_DESCRIPTION}}</p>
				
					</div>
				</div>
			</ng-container>
			</div>
		</div>
			<div *ngIf="(doc2.TYPE=='SEALS'&&doc2.seals&&doc2.seals.length>0)||(doc2.TYPE=='SIGNS'&&doc2.signs&&doc2.signs.length>0)" style="width:100%; padding:0" >
								<div class="row">
								<ng-container *ngFor="let photo of doc2.signs; let s=index; trackBy:trackByFuntion">
									<div *ngIf="photo.TYPE=='signature'&&(!photo['ALIGN']||photo['ALIGN']=='D')" style="padding: 0; flex: 0 49%;">
										<div *ngIf="!photo.signatureTemplate&&rptInfo&&rptInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'" style='margin-right: 5%;'>
											<div style="display:flex;">
												<div style="vertical-align: bottom;line-height:40px">{{photo['AUTHOR']}}</div>
												<div style="border-bottom: 1px solid black;flex: 1;text-align: center">
													<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="height:40px;max-width:100%;vertical-align:bottom; margin-bottom: 2px;">
												</div>												
											</div>
											<p>{{photo.NAME}}</p>
											<p [innerHTML]="photo.TITLE"></p>
											<p *ngIf="photo.DATE">Date: {{photo.DATE}}</p>					
										</div>
										<div *ngIf="!photo.signatureTemplate&&rptInfo&&rptInfo['SPECIAL_SIGNATURE_FORMAT']!='Y'"   style="padding-left: 15px">
											<div  class="gallery2">
												<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
											</div>
											<p class="desc1">{{photo.NAME}}</p>
											<p class="desc1" [innerHTML]="photo.TITLE"></p>
											<p *ngIf="photo.DATE" class="desc1">Date: {{photo.DATE}}</p>
										</div>
										<div *ngIf="photo.signatureTemplate" style="width:100%">
											<div style="padding: 4px 15px; width:100%;" [innerHTML]="photo.htmlSec?.changingThisBreaksApplicationSecurity|safeHtml"></div>												
										</div>	
									</div>
									<div *ngIf="photo.TYPE=='signature'&&(photo['ALIGN']&&photo['ALIGN']!='D')" style="padding:0; width:100%"  [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L','alignRight':photo['ALIGN']=='R'}">
										<div *ngIf="!photo.signatureTemplate&&rptInfo&&rptInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'" style='margin-right: 5%;width:50%'>
											<div style="display:flex;">
												<div style="vertical-align: bottom;line-height:40px;font-size: 10pt">{{photo['AUTHOR']}}</div>
												<div style="border-bottom: 1px solid black;flex: 1;text-align: center">
													<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="height:40px;max-width:100%;vertical-align:bottom; margin-bottom: 2px;">
												</div>												
											</div>
											<p style="font-weight: bold;font-size: 10pt;">{{photo.NAME}}</p>
											<p  style="font-weight: bold;font-size: 10pt;" [innerHTML]="photo.TITLE"></p>
											<p  style="font-weight: bold;font-size: 10pt;" *ngIf="photo.DATE">Date: {{photo.DATE}}</p>					
										</div>
										<div *ngIf="!photo.signatureTemplate&&rptInfo&&rptInfo['SPECIAL_SIGNATURE_FORMAT']!='Y'" class="gallery1" style="display:block" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L'}">
											<div  class="gallery2">
												<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
											</div>
											<p><span class="desc2">{{photo.NAME}}</span></p>
											<p *ngIf="photo['ALIGN']=='C'"><span class="desc2" [innerHTML]="photo.TITLE"></span></p>
											<p *ngIf="photo['ALIGN']=='L'" class="desc2" [innerHTML]="photo.TITLE"></p>
											<p *ngIf="photo.DATE"><label class="desc2">Date: {{photo.DATE}}</label></p>
										</div>
										<div *ngIf="photo.signatureTemplate&&photo['ALIGN']=='C'&&(!(rptInfo&&rptInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'))" style="width: 49%;margin:0 auto; text-align: center;">
											<div style="padding: 4px 15px; width:	100%;text-align: left;" [innerHTML]="photo.htmlSec?.changingThisBreaksApplicationSecurity|safeHtml"></div>												
										</div>
										<div *ngIf="photo.signatureTemplate&&photo['ALIGN']=='L'&&(!(rptInfo&&rptInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'))" style="width: 49%;display:flex; justify-content: start;">
												<div style="padding: 4px 15px; width:100%;" [innerHTML]="photo.htmlSec?.changingThisBreaksApplicationSecurity|safeHtml"></div>												
										</div>
										<div *ngIf="photo.signatureTemplate&&rptInfo&&rptInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'" style="width:100%; padding:0; margin: 0;display:flex; justify-content: start;">
											<div  style="padding:0; margin: 0; width:50%" [innerHTML]="processSignatureTemplate(photo.htmlSec)?.changingThisBreaksApplicationSecurity|safeHtml"></div>
										</div>	
									</div>
									</ng-container>
									<ng-container *ngFor="let photo of doc2.seals; let s=index; trackBy:trackByFuntion">
								
									<div *ngIf="photo.TYPE=='seal'&&(!photo['ALIGN']||photo['ALIGN']=='D')" class="gallery1">
										<div  class="gallery3">
											<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;max-width:90%;vertical-align:bottom">
										</div>
					
									</div>
									<div *ngIf="photo.TYPE=='seal'&&(photo['ALIGN']&&photo['ALIGN']!='D')" class="gallery4" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L','alignRight':photo['ALIGN']=='R'}">
										<div  class="gallery3">
											<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
										</div>					
									</div>
				
								</ng-container>
							</div>
							</div>
							<!--<p-table *ngIf="doc2.TYPE=='TABLE'&&doc2.data&&doc2.data.erisName&&!doc2['HIDEERIS']"  [value]="doc2.data.rows|slice: 0:20" [columns]="doc2.data.cols|slice:1">
								<ng-template pTemplate="header"  let-columns>
										<tr>
											<th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" style="padding:1px; font-size:11px">
												{{col.NAME}}              
											</th>
										</tr>
									</ng-template>
									<ng-template pTemplate="body" let-rowData let-columns="columns">
										<tr>
											<td *ngFor="let col of rowData|slice:1" style="padding:1px; font-size:11px">
												<span>{{col.DATA}}</span>																
											</td>																	
										</tr>
									</ng-template>
								</p-table>-->
								<p *ngIf="reportInfo?.ORDER_NUM&&doc2.TYPE=='TABLE'&&doc2.data&&doc2.data.erisName&&doc2.data.rows.length>100" class="erislabel">100 of {{doc2.data.rows.length}} total records shown</p>
								<p *ngIf="reportInfo?.ORDER_NUM&&doc2.TYPE=='TABLE'&&doc2.data&&doc2.data.erisName&&doc2.data.rows.length<101" class="erislabel">{{doc2.data.rows.length}} of {{doc2.data.rows.length}} total records shown</p> 
								<p *ngIf="!reportInfo?.ORDER_NUM&&doc2.TYPE=='TABLE'&&doc2.data&&doc2.data.erisName&&doc2.data.rows.length==1" class="erislabel">0 of 0 total records shown</p>
								<table *ngIf="doc2.TYPE=='TABLE'&&doc2.data&&doc2.data.erisName" [ngStyle]="{'width':doc2.TYPE=='UNITTABLE'?'50%':'100%'}" style="border: 1px solid #ccc;  border-collapse: collapse;font-size:10px; font-family:Arial, sans-serif;">
									<thead>
									<tr>
										<ng-container *ngFor="let h of doc2.data?.cols; let o=index; trackBy:trackByFuntion">
											<th *ngIf="(!h.hide||h.hide=='N')" [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="border: 1px solid #ccc;  border-collapse: collapse;">
												<span style="font-weight:bold"> {{h.NAME}}</span>
											</th>
										</ng-container>
									</tr>
									</thead>
									<tbody>
									<ng-container *ngFor="let r of doc2.data?.rows|slice: 0:100; let h=index; trackBy:trackByFuntion">
										<tr *ngIf="r[0]['SUBHEADER']!='Y'&&(r[0].DATA&&r[0].DATA.length>0)">
											<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
												<td *ngIf="!k.hide||k.hide=='N'" [ngStyle]="{'text-align':doc2.data?.cols[q].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;vertical-align:top;">
													<span *ngIf="k.sign&&k.sign==currSign">{{k.sign}}</span>
													<span *ngIf="!k.HTML" [innerHTML]="k.DATA"></span>
													<span *ngIf="k.HTML" [innerHTML]="k.SEC.changingThisBreaksApplicationSecurity|safeHtml"></span>

													<span *ngIf="k.sign&&k.sign!=currSign">{{k.sign}}</span>
												</td>
											</ng-container>		
										</tr>
										<tr *ngIf="r[0].SUBHEADER=='Y'">
											<td colSpan='{{doc2.data.cols.length}}' [ngStyle]="{'text-align':r[0]['celAllign']?r[0]['celAllign']:'Center'}" style="font-weight:bold; border: 1px solid #ccc; border-collapse: collapse;vertical-align:top;">
												<span *ngIf="!r[1].HTML" [innerHTML]="r[1].DATA"></span>
												<span *ngIf="r[1].HTML" [innerHTML]="r[1].SEC.changingThisBreaksApplicationSecurity|safeHtml"></span>
											</td>
										</tr>
									</ng-container>
									</tbody>
								</table>

				<table *ngIf="doc2.TYPE=='4099e'"  [ngClass]="{'fme-captitalcost':doc2.id=='fme_exec_sum_capital_needs_0'||doc2.id=='fme_exec_sum_capital_needs_1', 'fme-other':doc2.id!='fme_exec_sum_capital_needs_0'&&doc2.id!='fme_exec_sum_capital_needs_1'}" style="border-collapse: collapse;" [ngStyle]="{'border':doc2['ZOOM']||doc2.id=='fme_exec_sum_title_0'?'none':'solid black 1px','margin-top':doc2.OTNAME?'20px':'0', 'width':doc2.halfwidth?'50%':'100%'}">
									<thead *ngIf="doc2.data.titlerow||doc2.header">
									<tr *ngIf="doc2.data.titlerow">
										<th  [ngClass]="doc2.data.titlerow[0].bk" [colSpan]="doc2.data.cols.length" [ngStyle]="{'text-align':doc2.data.titlerow[0].colAlign}" style="font-weight: bold;border: 1px solid black">{{doc2.data.titlerow[0].NAME}}
										</th>	
									</tr>
									<tr *ngIf="doc2.header">
										<ng-container *ngFor="let h of doc2.data.cols; let o=index; trackBy:trackByFuntion">
											<th [ngClass]="h.bk" [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="font-weight: bold;border: 1px solid black">{{h.NAME}}
											</th>	
										</ng-container>
									</tr>
								</thead>
								<tbody>
									<ng-container *ngFor="let r of doc2.data?.rows; let l=index; trackBy:trackByFuntion">
										<tr style="height: 20px;">
											<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
												<td *ngIf="!k.colspan&&doc2.header" [ngClass]="k.bk" class="cellItem" (dblclick)="selectCell(doc2, l, doc2.data.cols[q], k);" [ngStyle]="{'text-align':doc2.data?.cols[q]?.celAllign, 'font-weight':k.weight, 'border':k.border}">
													<span *ngIf="k.sign">{{USDollar.format(k.data)}}</span>
													<span *ngIf="!k.sign">{{k.data}}</span>
													<!--<span *ngIf="k.sign">{{k.sign}}</span>
													<span class="innerCell" *ngIf="k.DATA" [innerHTML]="k.DATA?.changingThisBreaksApplicationSecurity|safeHtml" [ngStyle]="{'text-align':doc2.data?.cols[q]?.celAllign}"></span>
													<span class="innerCell" >{{k.data}}</span>
													{{k.data}}-->
												</td>
												<td *ngIf="!k.colspan&&(!doc2.header)" [ngClass]="k.bk" class="cellItem" (dblclick)="selectCell(doc2, l, doc2.data.cols[q], k);" [ngStyle]="{'text-align':doc2.data?.cols[q]?.celAllign, 'font-weight':k.weight, 'width':doc2.data.cols[q].width+doc2.data.cols[q].unit, 'border':k.border}">
													<!--<<span *ngIf="k.sign">{{k.sign}}</span>
													span class="innerCell" *ngIf="k.DATA" [innerHTML]="k.DATA?.changingThisBreaksApplicationSecurity|safeHtml" [ngStyle]="{'text-align':doc2.data?.cols[q]?.celAllign}"></span>
													<span class="innerCell" >{{k.data}}</span>-->
													<span *ngIf="k.sign">{{USDollar.format(k.data)}}</span>
													<span *ngIf="!k.sign">{{k.data}}</span>
												</td>
												<td *ngIf="k.colspan"  [ngClass]="k.bk" colSpan='{{k.colspan}}' [ngStyle]="{'text-align':doc2.data?.cols[q].celAllign, 'font-weight':k.weight, 'border':k.border}">
													<span *ngIf="k.sign">{{USDollar.format(k.data)}}</span>
													<span *ngIf="!k.sign">{{k.data}}</span>
												</td>			
											</ng-container>
										</tr>					
									</ng-container>
								</tbody>  
								</table>				
				<table *ngIf="!doc2.OTABLE&&(doc2.TYPE=='COSTTABLE'||doc2.TYPE=='PCATABLE'||doc2.TYPE=='UNITTABLE')&&doc2.data" [ngStyle]="{'width':doc2.TYPE=='UNITTABLE'?'50%':'100%'}" style="border: 1px solid black;  border-collapse: collapse; font-size:10px">
					<thead *ngIf="!doc2.OHEADER">
					<tr style="background-color:#eeeeee;">
						<ng-container *ngFor="let h of doc2.data?.cols; let o=index">
							<th  *ngIf="!h.hide||h.hide=='N'" [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="border: 1px solid black;  border-collapse: collapse;">
								<span>{{h.NAME}}</span>
							</th>
						</ng-container>
					</tr>
					</thead>
					<tbody>
					<ng-container *ngFor="let r of doc2.data?.rows; let h=index">
						<tr *ngIf="r.length>1&&r.hide!='Y'&&(!(doc2.TYPE=='COSTTABLE'&&h==0))&&(!doc2.filted||doc2.filted.indexOf(r[0].DATA)>-1)">
						    <ng-container *ngFor="let m of r; let q=index">
								<td *ngIf="!m.hide||m.hide=='N'" [ngStyle]="{'width':doc2.data?.cols[q]?.width+doc2.data?.cols[q]?.unit,'text-align':doc2.data?.cols[q]?.celAllign}" style="border: 1px solid black;  border-collapse: collapse;vertical-align:top">
									<span *ngIf="m.sign&&m.sign==currSign">{{m.sign}}</span><span [innerHTML]="m.DATA"></span><span *ngIf="m.sign&&m.sign!=currSign">{{m.sign}}</span>
								</td>
							</ng-container>
						</tr>
						<tr *ngIf="r.length==1&&doc2.data&&r.hide!='Y'">					
							<td colSpan='{{doc2.data.cols.length}}' [ngStyle]="{'text-align':r[0].celAllign}"  style="font-weight:bold; border: 1px solid black;  border-collapse: collapse;vertical-align:top">
								<span>{{r[0]?.DATA}}</span>
							</td>
						</tr>
					</ng-container>
					</tbody>
				</table>
				<table *ngIf="!doc2.OTABLE&&(doc2.TYPE=='TABLE'&&!doc2.data?.erisName)" [ngStyle]="{'width':doc2.TYPE=='UNITTABLE'?'50%':'100%'}" style="border: 1px solid black;  border-collapse: collapse; font-size:10px;">
					<!--<caption *ngIf="doc2.data['caption']" [ngStyle]="{'border':doc2.data['caption']['border']?'solid 1px black':'none', 'text-align':doc2.data['caption']['align']?doc2.data['caption']['align']:'center'}">
						<span style="font-weight:bold" [innerHTML]="doc2.data['caption'].htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
				   </caption>-->
					<thead *ngIf="!doc2.OHEADER">
						<ng-container *ngFor="let brow of doc2.data.beforeHeaders; let bindex=index">
							<tr style="background-color:#eeeeee;">
								<ng-container *ngFor="let col of brow; let u=index">
									<th *ngIf="!col.colspan" style="border-collapse: collapse;"  [ngClass]="{'align-left':col.colAlign=='Left','align-right':col.colAlign=='Right','align-center':col.colAlign=='Center'}"  [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}">
										<span style="font-weight:bold" [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
									</th>
									<th *ngIf="col.colspan&&u==0" [attr.colspan]="col.colspan"  [ngClass]="{'align-left':col.colAlign=='Left','align-right':col.colAlign=='Right','align-center':col.colAlign=='Center'}"  style="border-collapse: collapse;" [ngStyle]="{'text-align':col.colAlign}">
										<span style="font-weight:bold" [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
									</th>
								</ng-container>
							</tr>
						</ng-container>
					<tr style="background-color:#eeeeee;">
						<ng-container *ngFor="let h of doc2.data?.cols; let o=index">
							<th [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="border: 1px solid black;  border-collapse: collapse;">
								<span style="font-weight:bold" [innerHTML]="h.htmltext?.changingThisBreaksApplicationSecurity|safeHtml"></span>
						
							</th>
						</ng-container>
					</tr>
					<ng-container *ngFor="let brow of doc2.data.afterHeaders; let bindex=index">
						<tr style="background-color:#eeeeee;">
							<ng-container *ngFor="let col of brow; let u=index">
								<th *ngIf="!col.colspan" style="border-collapse: collapse;" [ngClass]="{'align-left':col.colAlign=='Left','align-right':col.colAlign=='Right','align-center':col.colAlign=='Center'}" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}">
									<span style="font-weight:bold" [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
								</th>
								<th *ngIf="col.colspan&&u==0" [attr.colspan]="col.colspan"  [ngClass]="{'align-left':col.colAlign=='Left','align-right':col.colAlign=='Right','align-center':col.colAlign=='Center'}"  style="border-collapse: collapse" [ngStyle]="{'text-align':col.colAlign}">
									<span style="font-weight:bold" [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
								</th>
							</ng-container>
						</tr>
					</ng-container>
					</thead>
					<tbody>
					<ng-container *ngFor="let r of doc2.data?.rows; let h=index">
					
						<tr *ngIf="r.items?.length>0&&(!r.items[0].colspan)&&(!r.hide)">
						    <ng-container *ngFor="let m of r.items; let q=index">
								<td [ngStyle]="{'width':doc2.data?.cols[q].width+doc2.data?.cols[q].unit,'text-align':doc2.data?.cols[q].celAllign, 'background':m.bkcolor}" style="border: 1px solid black;  border-collapse: collapse;vertical-align:top">
									<span *ngIf="m.DATA" [innerHTML]="m.DATA?.changingThisBreaksApplicationSecurity|safeHtml"></span>
								</td>
							</ng-container>
						</tr>
						<tr *ngIf="r.items?.length==1&&r.items[0].colspan&&(!r.hide)">					
							<td colSpan='{{r.items[0].colspan}}' [ngStyle]="{'text-align':r.items[0].celAllign, 'background':r.items[0].bkcolor}"  style="font-weight:bold; border: 1px solid black;  border-collapse: collapse;vertical-align:top">
								<span *ngIf="r.items[0].DATA" [innerHTML]="r.items[0].DATA?.changingThisBreaksApplicationSecurity|safeHtml"></span>
							</td>
						</tr>
						
					</ng-container>
					</tbody>			
				</table>
				</ng-container>
				</div>
			</ng-container>
			</div>
		</ng-container>
		
</div>		
	</ng-container>
</div>
<div #frmContent id="frmContent" style="display:none" *ngIf="curReport?.PCA_INDICATOR=='frm1104'">
	<ng-container *ngIf="curReport?.PCA_INDICATOR=='frm1104'&&contents.length>0">
		<section class="page-before" data-section-title="Section I">
            <header>
                <div class="freddie-mac-header">
                    <div class="freddie-mac-logo">
                        <img src="https://erisservice9.erisinfo.com/exreportw/frmimages/logo.jpg" alt="Freddie Mac Multifamily">
                    </div>
                    <div class="freddie-mac-title">
                        <strong>SBL Physical Risk Report</strong><br>
						<strong>{{contents[0].SUB_SECTIONS[0].data?.AsReportedName?.text}} ({{contents[0].SUB_SECTIONS[0].data?.CityName?.text}}, {{contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.text}})</strong>
                    </div>
                </div>
            </header>
			<h1>Section I: General Information, Documentation and Certification</h1>
            <h2>Mortgage and Property Information</h2>
            <table class="section-header">
                <tr>
                    <td width="25%">
                        <div>
							<p *ngIf="contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.text"></p>
							<label>Freddie Mac loan number</label>
                        </div>
                    </td>
                    <td width="25%">
                        <div>
                            <p [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate|date:'MMMM dd, yyyy'"></p>
                            <label>Report date</label>
                        </div>
                    </td>
                    <td colspan="2" width="50%">
                        <div>
                            <p *ngIf="contents[0].SUB_SECTIONS[0].data?.AsReportedName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AsReportedName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[0].data?.AsReportedName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AsReportedName?.text"></p>
                            <label>Property name</label>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2">
                        <div>
                            <p *ngIf="contents[0].SUB_SECTIONS[0].data?.AccountName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AccountName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[0].data?.AccountName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AccountName?.text"></p>
                            <label>Seller/Servicer name</label>
                        </div>
                    </td>
                    <td colspan="2" class="fh">
                        <div>
                            <p *ngIf="contents[0].SUB_SECTIONS[0].data?.AddressLineText?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AddressLineText?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[0].data?.AddressLineText?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AddressLineText?.text"></p>
							<label>Address</label>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div>
							<p *ngIf="contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.text"></p>
							<label>Seller/Servicer number</label>
                        </div>
                    </td>
					<td>
                        
                    </td>
                   	<td colspan="2" class="fh">
                        <div>
                            <p>
							<ng-container *ngIf="contents[0].SUB_SECTIONS[0].data?.CityName?.html"><span style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.CityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
							<ng-container *ngIf="!contents[0].SUB_SECTIONS[0].data?.CityName?.html&&contents[0].SUB_SECTIONS[0].data?.CityName?.text"><span style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.CityName?.text"></span>,&nbsp;</ng-container>
							<ng-container *ngIf="contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.html"><span style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
							<ng-container *ngIf="!contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.html&&contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.text"><span style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.text"></span>,&nbsp;</ng-container>
							<span *ngIf="contents[0].SUB_SECTIONS[0].data?.PostalCode?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>
							<span *ngIf="!contents[0].SUB_SECTIONS[0].data?.PostalCode?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PostalCode?.secHtml?.text"></span></p>
							<label>City, State, Zip</label>
                        </div>
                    </td>
                </tr>                
            </table>
			<h2>Consultant Information</h2>
            <table class="section-header">
				<colgroup>
                    <col style="width:34%">
                    <col style="width:8%">
                    <col style="width:8%">
                    <col style="width:25%">
                    <col style="width:25%">
                </colgroup>
                <tbody>
                <tr>
                    <td colspan="3">
                        <div>
							<p *ngIf="contents[0].SUB_SECTIONS[1].data?.FirmName?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.FirmName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[1].data?.FirmName?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.FirmName?.text"></p>
							<label>Firm name</label>
                        </div>
                    </td>
                    <td colspan="2">
                        <div>
                           	<p *ngIf="contents[0].SUB_SECTIONS[1].data?.InspectorName?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.InspectorName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[1].data?.InspectorName?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.InspectorName?.text"></p>
                            <label>Inspector's name and title</label>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="3" class="fh">
                        <div>
                            <p *ngIf="contents[0].SUB_SECTIONS[1].data?.FirmAddressLineText?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.FirmAddressLineText?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[1].data?.FirmAddressLineText?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.FirmAddressLineText?.text"></p>
                            <label>Address</label>
                        </div>
                    </td>
                    <td colspan="2" class="fh">
                        <div>
                            <p *ngIf="contents[0].SUB_SECTIONS[1].data?.WriterName?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.WriterName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[1].data?.WriterName?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.WriterName?.text"></p>
                            <label>Report writer's name and title</label>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="fh">
                        <div>
                            <p *ngIf="contents[0].SUB_SECTIONS[1].data?.FirmCityName?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.FirmCityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[1].data?.FirmCityName?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.FirmCityName?.text"></p>
                            <label>City</label>
						</div>
					</td>
					<td >
						<div>
                            <p *ngIf="contents[0].SUB_SECTIONS[1].data?.FirmStateUspsCode?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.FirmStateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[1].data?.FirmStateUspsCode?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.FirmStateUspsCode?.text"></p>
                            <label>State</label>
						</div>
					</td>
					<td >
						<div>
                            <p *ngIf="contents[0].SUB_SECTIONS[1].data?.FirmPostalCode?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.FirmPostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[1].data?.FirmPostalCode?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.FirmPostalCode?.text"></p>
                            <label>Zip</label>
                        </div>
                    </td>
                   	<td colspan="2" class="fh">
                        <div>
                            <p *ngIf="contents[0].SUB_SECTIONS[1].data?.ReviewerName?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.ReviewerName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[1].data?.ReviewerName?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.ReviewerName?.text"></p>
                            <label>Environmental reviewer's name and title</label>
                        </div>
                    </td>
                </tr>
				<tr>
                    <td class="fh">
                        <div>
                             <p>{{contents[0].SUB_SECTIONS[1].data?.FirmPhoneNumber.formateText}}</p>
							<label>Telephone number</label>
						</div> 
					</td>
					<td colspan="2"> 
						<div> 
                            <p *ngIf="contents[0].SUB_SECTIONS[1].data?.FirmPhoneExt?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.FirmPhoneExt?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[1].data?.FirmPhoneExt?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.FirmPhoneExt?.text"></p>
                            <label>Extension</label>
                        </div>
                       
                    </td>
                   	<td width="34%" class="fh">
                        <div>
                            <p [innerHTML]="contents[0].SUB_SECTIONS[1].data?.VisitDate|date:'MMMM dd, yyyy'"></p>
                            <label>Date of visit</label>
						</div> 
					</td>
					<td width="16%"> 
						<div>   
                            <p [innerHTML]="contents[0].SUB_SECTIONS[1].data?.EngageDate|date:'MMMM dd, yyyy'"></p>
                            <label>Date of engagement</label>
                        </div>
                    </td>
                </tr> 
				</tbody>               
            </table>
			<h2>Site Statistics</h2>
            <table class="section-header">
                <tr>
                    <td style="width:25%">
                        <div>
							<p *ngIf="contents[0].SUB_SECTIONS[2].data?.BuildYear?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.BuildYear?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[2].data?.BuildYear?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.BuildYear?.text"></p>
                            <label>Year(s) of construction</label>
                        </div>
                    </td>
					<td  style="width:25%">
                        <div>
							<p *ngIf="contents[0].SUB_SECTIONS[2].data?.RenovYear?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.RenovYear?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[2].data?.RenovYear?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.RenovYear?.text"></p>
							<p style="margin-left: 20px; border-left: 2px solid black;">{{USDollar1.format(contents[0].SUB_SECTIONS[2].data.RenovCost)}}</p>
							 <label>Year last renovated (with amount)</label>
                        </div>
                    </td>
                    <td style="width:25%">
                        <div>
                            <p *ngIf="contents[0].SUB_SECTIONS[2].data?.BuildingType?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.BuildingType?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[2].data?.BuildingType?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.BuildingType?.text"></p>
                            <label>Construction type</label>
                        </div>
                    </td>
					<td style="width:25%">
                        <div>
                            <p style="width:90%" *ngIf="contents[0].SUB_SECTIONS[2].data?.Acre?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Acre?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p style="width:90%" *ngIf="!contents[0].SUB_SECTIONS[2].data?.Acre?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Acre?.text"></p>
                            <label>Acreage</label>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2">
                        <div>
							<p *ngIf="contents[0].SUB_SECTIONS[2].data?.Topo?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Topo?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[2].data?.Topo?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Topo?.text"></p>
                            <label>Topography</label>
                        </div>
                    </td>
					<td style="width:25%">
                        <div>
                            <p *ngIf="contents[0].SUB_SECTIONS[2].data?.FloodZone?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.FloodZone?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[2].data?.FloodZone?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.FloodZone?.text"></p>
                            <label>Flood zone</label>
                        </div>
                    </td>
					<td style="width:25%">
                        <div>
                           	<p style="width:90%" *ngIf="contents[0].SUB_SECTIONS[2].data?.PeakGround?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.PeakGround?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p style="width:90%" *ngIf="!contents[0].SUB_SECTIONS[2].data?.PeakGround?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.PeakGround?.text"></p><span style="margin-left: 6px">g</span>
                           
							<label>Peak ground acceleration</label>
                        </div>
                    </td>
                </tr>
				<tr>
					<td colspan="4">
						<div>
                            <p *ngIf="contents[0].SUB_SECTIONS[2].data?.Amenities?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Amenities?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[2].data?.Amenities?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Amenities?.text"></p>
                            <label>Amenities</label>
                        </div>
					</td>
				</tr>            
            </table>
			<p style="width:70%; display:inline-block;">Number of:</p><p style="display:inline-block;">Number of parking spaces:</p>
			<table class="section-header">
                <tr>
                    <td style="width:23%">
                        <div>
							<p *ngIf="contents[0].SUB_SECTIONS[2].data?.Units?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Units?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[2].data?.Units?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Units?.text"></p>
                            <label>Units</label>
                        </div>
                    </td>
					<td  style="width:23%">
                        <div>
							<p *ngIf="contents[0].SUB_SECTIONS[2].data?.ApartmentUnits?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.ApartmentUnits?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[2].data?.ApartmentUnits?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.ApartmentUnits?.text"></p>
							 <label>Apartment buildings</label>
                        </div>
                    </td>
                    <td style="width:23%">
                        <div>
                            
							<p *ngIf="contents[0].SUB_SECTIONS[2].data?.OtherUnits?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.OtherUnits?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[2].data?.OtherUnits?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.OtherUnits?.text"></p>
                            <label>Other buildings</label>
                        </div>
                    </td>
					<td style="width:10%">
                        <div>
                            
							<p style="width:90%" *ngIf="contents[0].SUB_SECTIONS[2].data?.Surface?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Surface?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p style="width:90%" *ngIf="!contents[0].SUB_SECTIONS[2].data?.Surface?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Surface?.text"></p>
                            <label>Surface</label>
                        </div>
                    </td>
					<td style="width:10%">
                        <div>
                            
							<p style="width:90%" *ngIf="contents[0].SUB_SECTIONS[2].data?.Garage?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Garage?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p style="width:90%" *ngIf="!contents[0].SUB_SECTIONS[2].data?.Garage?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Garage?.text"></p>
                            <label>Garage</label>
                        </div>
                    </td>
					<td style="width:11%">
                        <div>
                            
							<p style="width:90%" *ngIf="contents[0].SUB_SECTIONS[2].data?.Carports?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Carports?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p style="width:90%" *ngIf="!contents[0].SUB_SECTIONS[2].data?.Carports?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Carports?.text"></p>
                            <label>Carports</label>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div>
							
							<p *ngIf="contents[0].SUB_SECTIONS[2].data?.GroundUnits?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.GroundUnits?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[2].data?.GroundUnits?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.GroundUnits?.text"></p>
                            <label>Ground floor units</label>
                        </div>
                    </td>
					<td>
                        <div>
                          
							<p *ngIf="contents[0].SUB_SECTIONS[2].data?.Elevators?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Elevators?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[2].data?.Elevators?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Elevators?.text"></p>
                            <label>Elevators</label>
                        </div>
                    </td>
					<td>
                        <div>
                           <p style="width:90%" *ngIf="contents[0].SUB_SECTIONS[2].data?.Floors?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Floors?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p style="width:90%" *ngIf="!contents[0].SUB_SECTIONS[2].data?.Floors?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Floors?.text"></p>
                            <label>Floors</label>
                        </div>
                    </td>
              		<td colspan="3">
						<div>
							<p *ngIf="contents[0].SUB_SECTIONS[2].data?.Other?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Other?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[2].data?.Other?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Other?.text"></p>
                            <label>Other</label>
                        </div>
					</td>
				</tr>            
            </table>
			
				<div class="input-box">
					<label>Discuss other features:</label>
					<div class="textarea">{{contents[0].SUB_SECTIONS[2].data?.discuss}}</div>
				</div>
			
           <h2>List of Parties Present</h2>
		   <p>Provide a listing of parties involved in the site visit (including the consultants).</p>
		   <ng-container *ngFor="let row of contents[0].SUB_SECTIONS[3].data; let i=index">
			<table class="partiesTable" style="border:2px solid black">
				<tbody>
					<tr style="height: 14px;">
						<td rowspan="2" style="background-color: black;color: #FFFFFF;vertical-align: middle;width:4%; text-align: center;">
							{{i+1}}
						</td>
						<td style="background-color: #C0C0C0;width:10%; text-align: right">Company
						</td>
						<td style="width:38%;">
							<p>{{row.Company.text}}</p>
						</td>
						<td style="background-color: #C0C0C0;width:10%; text-align: right">Name
						</td>
						<td style="width:38%">
							<p>{{row.Name.text}}</p>
						</td>
					</tr>
					<tr style="height: 14px;">
						<td style="background-color: #C0C0C0;width:10%; text-align: right">Title
						</td>
						<td style="width:38%">
							<p>{{row.Title.text}}</p>
						</td>
						<td style="background-color: #C0C0C0;width:10%; text-align: right">Affiliation
						</td>
						<td style="width:38%">
							<p>{{row.Affiliation.text}}</p>
						</td>
					</tr>
					<tr style="border-top: double 2px black;height: 14px;">
						<td colspan="5" style="background-color: #C0C0C0;">Comments
						</td>
					</tr>
					<tr>
						<td colspan="5" >
							<p>{{row.Comment.text}}</p>
						</td>
					</tr>
				</tbody>
			</table>
		</ng-container>
		<h2>Documentation</h2>
		<p>Indicate if the below are attached or not attached. If they are not attached, then additional information should be provided in the comments</p>
		<div style="width:100%; font-size: 12px;display: inline-block;" >
			
			<div class='klistItem4'>
				<p style="border-bottom:solid 1px black; margin-bottom: 2px;">Document</p>
				<p >Limiting conditions</p>
			</div>
			<div class='klistItem3'>
				<p style="border-bottom:solid 1px black; margin-bottom: 2px">Status</p>
				<div *ngIf="contents[0].SUB_SECTIONS[4].data.documents[0]=='Y'" class="textarea">Attached</div>
				<div *ngIf="contents[0].SUB_SECTIONS[4].data.documents[0]=='N'" class="textarea">Not Attached</div>
				<div *ngIf="!contents[0].SUB_SECTIONS[4].data.documents[0]||contents[0].SUB_SECTIONS[4].data.documents[0]=='NA'" class="textarea">{{contents[0].SUB_SECTIONS[4].data.documents[0]}}</div>				
			</div>
			<div class='klistItem4' >
			<p style="margin-top:0;">Site plan</p>
			</div>
			<div  class='klistItem3'>		
				<div *ngIf="contents[0].SUB_SECTIONS[4].data.documents[1]=='Y'" class="textarea">Attached</div>
				<div *ngIf="contents[0].SUB_SECTIONS[4].data.documents[1]=='N'" class="textarea">Not Attached</div>
				<div *ngIf="!contents[0].SUB_SECTIONS[4].data.documents[1]||contents[0].SUB_SECTIONS[4].data.documents[1]=='NA'" class="textarea">{{contents[0].SUB_SECTIONS[4].data.documents[1]}}</div>				
			
			</div>
			<div class='klistItem4'>
			<p style="margin-top:0;">Renovation scope of work and budgets</p>
			</div>
			<div class='klistItem3'>
				<div *ngIf="contents[0].SUB_SECTIONS[4].data.documents[2]=='Y'" class="textarea">Attached</div>
				<div *ngIf="contents[0].SUB_SECTIONS[4].data.documents[2]=='N'" class="textarea">Not Attached</div>
				<div *ngIf="!contents[0].SUB_SECTIONS[4].data.documents[2]||contents[0].SUB_SECTIONS[4].data.documents[2]=='NA'" class="textarea">{{contents[0].SUB_SECTIONS[4].data.documents[2]}}</div>	
			</div>
			<div class='klistItem4'>
		
			<p style="margin-top:0;">Information provided by borrower (specified in appendix)</p>
			</div>
			<div class='klistItem3'>
				<div *ngIf="contents[0].SUB_SECTIONS[4].data.documents[3]=='Y'" class="textarea">Attached</div>
				<div *ngIf="contents[0].SUB_SECTIONS[4].data.documents[3]=='N'" class="textarea">Not Attached</div>
				<div *ngIf="!contents[0].SUB_SECTIONS[4].data.documents[3]||contents[0].SUB_SECTIONS[4].data.documents[3]=='NA'" class="textarea">{{contents[0].SUB_SECTIONS[4].data.documents[3]}}</div>	
			</div>
			<div class='klistItem4'>
			<p style="margin-top:0;" >Building and health code violations</p>
			</div>
			<div class='klistItem3'>
				<div *ngIf="contents[0].SUB_SECTIONS[4].data.documents[4]=='Y'" class="textarea">Attached</div>
				<div *ngIf="contents[0].SUB_SECTIONS[4].data.documents[4]=='N'" class="textarea">Not Attached</div>
				<div *ngIf="!contents[0].SUB_SECTIONS[4].data.documents[4]||contents[0].SUB_SECTIONS[4].data.documents[4]=='NA'" class="textarea">{{contents[0].SUB_SECTIONS[4].data.documents[4]}}</div>	
			</div>
			<div class='klistItem4'>
			<p style="margin-top:0;" >Environmental transaction screen</p>
			</div>
			<div class='klistItem3'>
				<div *ngIf="contents[0].SUB_SECTIONS[4].data.documents[5]=='Y'" class="textarea">Attached</div>
				<div *ngIf="contents[0].SUB_SECTIONS[4].data.documents[5]=='N'" class="textarea">Not Attached</div>
				<div *ngIf="!contents[0].SUB_SECTIONS[4].data.documents[5]||contents[0].SUB_SECTIONS[4].data.documents[5]=='NA'" class="textarea">{{contents[0].SUB_SECTIONS[4].data.documents[5]}}</div>	
			</div>
			<div class='klistItem4'>
			<p style="margin-top:0;" >Test and study results (e.g., structural, civil, asbestos, etc. - specified in appendix)</p>
			</div>
			<div class='klistItem3'>
				<div *ngIf="contents[0].SUB_SECTIONS[4].data.documents[6]=='Y'" class="textarea">Attached</div>
				<div *ngIf="contents[0].SUB_SECTIONS[4].data.documents[6]=='N'" class="textarea">Not Attached</div>
				<div *ngIf="!contents[0].SUB_SECTIONS[4].data.documents[6]||contents[0].SUB_SECTIONS[4].data.documents[6]=='NA'" class="textarea">{{contents[0].SUB_SECTIONS[4].data.documents[6]}}</div>	
			</div>
			<div class='klistItem4'>
			<p style="margin-top:0;" >Other records and data reviewed (specified in appendix)</p>
			</div>
			<div class='klistItem3'>
				<div *ngIf="contents[0].SUB_SECTIONS[4].data.documents[7]=='Y'" class="textarea">Attached</div>
				<div *ngIf="contents[0].SUB_SECTIONS[4].data.documents[7]=='N'" class="textarea">Not Attached</div>
				<div *ngIf="!contents[0].SUB_SECTIONS[4].data.documents[7]||contents[0].SUB_SECTIONS[4].data.documents[7]=='NA'" class="textarea">{{contents[0].SUB_SECTIONS[4].data.documents[7]}}</div>	
			</div>
			<div class='klistItem4'>
			<p style="margin-top:0;">Resume of inspector</p>
			</div>
			<div class='klistItem3'>
				<div *ngIf="contents[0].SUB_SECTIONS[4].data.documents[8]=='Y'" class="textarea">Attached</div>
				<div *ngIf="contents[0].SUB_SECTIONS[4].data.documents[8]=='N'" class="textarea">Not Attached</div>
				<div *ngIf="!contents[0].SUB_SECTIONS[4].data.documents[8]||contents[0].SUB_SECTIONS[4].data.documents[8]=='NA'" class="textarea">{{contents[0].SUB_SECTIONS[4].data.documents[8]}}</div>	
			</div>
			<div class='klistItem4'>
			<p style="margin-top:0;" >Resume of report writer/reviewer (if different from the inspector)</p>
			</div>
			<div class='klistItem3'>
				<div *ngIf="contents[0].SUB_SECTIONS[4].data.documents[9]=='Y'" class="textarea">Attached</div>
				<div *ngIf="contents[0].SUB_SECTIONS[4].data.documents[9]=='N'" class="textarea">Not Attached</div>
				<div *ngIf="!contents[0].SUB_SECTIONS[4].data.documents[9]||contents[0].SUB_SECTIONS[4].data.documents[9]=='NA'" class="textarea">{{contents[0].SUB_SECTIONS[4].data.documents[9]}}</div>	
			</div>
			<div class='klistItem4'>
			<p style="margin-top:0;" >Resume of environmental reviewer (if different from the inspector and/or report reviewer)</p>
			</div>
			<div class='klistItem3'>
				<div *ngIf="contents[0].SUB_SECTIONS[4].data.documents[10]=='Y'" class="textarea">Attached</div>
				<div *ngIf="contents[0].SUB_SECTIONS[4].data.documents[10]=='N'" class="textarea">Not Attached</div>
				<div *ngIf="!contents[0].SUB_SECTIONS[4].data.documents[10]||contents[0].SUB_SECTIONS[4].data.documents[10]=='NA'" class="textarea">{{contents[0].SUB_SECTIONS[4].data.documents[10]}}</div>	
			</div>
			<div class='klistItem4' >
			<p style="margin-top:0;" >Identification of any deviations from the Guide requirements and the most recent versions of the ASTM standards E2018 and E1528 as well as applicable environmental regulations established by the Environmental Protection Agency</p>
			</div>
			<div class='klistItem3'>
				<div *ngIf="contents[0].SUB_SECTIONS[4].data.documents[11]=='Y'" class="textarea">Attached</div>
				<div *ngIf="contents[0].SUB_SECTIONS[4].data.documents[11]=='N'" class="textarea">Not Attached</div>
				<div *ngIf="!contents[0].SUB_SECTIONS[4].data.documents[11]||contents[0].SUB_SECTIONS[4].data.documents[11]=='NA'" class="textarea">{{contents[0].SUB_SECTIONS[4].data.documents[11]}}</div>	
			</div>
			
				<div class="input-box">
					<label>Additional Comments:</label>
					<div class="textarea">{{contents[0].SUB_SECTIONS[4].data.additionalInfo}}</div>
				</div>
			
		</div>
		<h2>Data Collection and Records Inquiry</h2>
		<div style="font-size: 12px;">
		<div class="question-line" >
		<div class='klistItem5'>
			<p style="margin-top:0;">Was information pertaining to the maintenance, repair and replacement of major building components or systems reviewed?</p>
			</div>
			<div class='klistItem6'>
				<div *ngIf="contents[0].SUB_SECTIONS[5].data[0].status=='YES'" class="textarea">Yes</div>
				<div *ngIf="contents[0].SUB_SECTIONS[5].data[0].status=='NO'" class="textarea">No</div>
				<div *ngIf="!contents[0].SUB_SECTIONS[5].data[0].status" class="textarea"></div>	
			</div>
		</div>
			<div class="question-box" *ngIf="contents[0].SUB_SECTIONS[5].data[0].status=='NO'">
				<div class="input-box">
					<label>Explain why not:</label>
					<div class="textarea">{{contents[0].SUB_SECTIONS[5].data[0].Explanation}}</div>
				</div>
			</div>
			<div class="question-line" >
			<div class='klistItem5'>
				<p style="margin-top:0;" >Were all significant maintenance reports, repair receipts and replacement items completed within the past 12 months, as well as elevator, boiler and safety inspection records and certificates reviewed?</p>
			</div>
			<div class='klistItem6'>
				<div *ngIf="contents[0].SUB_SECTIONS[5].data[1].status=='YES'" class="textarea">Yes</div>
				<div *ngIf="contents[0].SUB_SECTIONS[5].data[1].status=='NO'" class="textarea">No</div>
				<div *ngIf="!contents[0].SUB_SECTIONS[5].data[1].status" class="textarea"></div>	
			</div>
		</div>
			<div class="question-box" *ngIf="contents[0].SUB_SECTIONS[5].data[1].status=='NO'">
				<div class="input-box">
					<label>Explain why not:</label>
					<div class="textarea">{{contents[0].SUB_SECTIONS[5].data[1].Explanation}}</div>
				</div>
			</div>
			<div class="question-line" >
			<div class='klistItem5'>
				<p style="margin-top:0;" >Was all available information related to planned capital improvements, inclusive of renovation/rehabilitation scope or work, and/or such work in progress reviewed?</p>
			</div>
			<div class='klistItem6'>
				<div *ngIf="contents[0].SUB_SECTIONS[5].data[2].status=='YES'" class="textarea">Yes</div>
				<div *ngIf="contents[0].SUB_SECTIONS[5].data[2].status=='NO'" class="textarea">No</div>
				<div *ngIf="!contents[0].SUB_SECTIONS[5].data[2].status" class="textarea"></div>	
			</div>
		</div>
			<div class="question-box" *ngIf="contents[0].SUB_SECTIONS[5].data[2].status=='NO'">
				<div class="input-box">
					<label>Explain why not:</label>
					<div class="textarea">{{contents[0].SUB_SECTIONS[5].data[2].Explanation}}</div>
				</div>
			</div>
			<div class="question-line" >
			<div class='klistItem5'>
				<p style="margin-top:0;" >Was evidence of completed capital expenditures or construction costs reviewed?</p>
			</div>
			<div class='klistItem6'>
				<div *ngIf="contents[0].SUB_SECTIONS[5].data[3].status=='YES'" class="textarea">Yes</div>
				<div *ngIf="contents[0].SUB_SECTIONS[5].data[3].status=='NO'" class="textarea">No</div>
				<div *ngIf="!contents[0].SUB_SECTIONS[5].data[3].status" class="textarea"></div>	
			</div>
			</div>
			<div class="question-box" *ngIf="contents[0].SUB_SECTIONS[5].data[3].status=='NO'">
				<div class="input-box">
					<label>Explain why not:</label>
					<div class="textarea">{{contents[0].SUB_SECTIONS[5].data[3].Explanation}}</div>
				</div>
			</div>
			<div class="question-line" >
			<div class='klistItem5'>
				<p style="margin-top:0;" >Were there any records of violations of any federal, State or local laws, ordinances or codes that remain open for the Property, including any violations related to zoning, subdivision and use, building and housing accessibility (including the Americans with Disabilities and Fair Housing Acts), health matters, fire safety or energy-related requirements?</p>
			</div>
			<div class='klistItem6'>
				<div *ngIf="contents[0].SUB_SECTIONS[5].data[4].status=='YES'" class="textarea">Yes</div>
				<div *ngIf="contents[0].SUB_SECTIONS[5].data[4].status=='NO'" class="textarea">No</div>
				<div *ngIf="!contents[0].SUB_SECTIONS[5].data[4].status" class="textarea"></div>	
			</div>
			</div>
			<div *ngIf="contents[0].SUB_SECTIONS[5].data[4].status=='YES'" style="width: 100%; padding-left: 4%;margin-top: 4px;">
				<p class='klistItem' style="width:75%">Provide details regarding the violations in Section III. Only violations that are considered to be life/safety issues or significant deficiencies, and that should be corrected as part of the Priority Repairs scope, need to be included</p>
			</div>
		</div>
		<h2>{{contents[0].SUB_SECTIONS[6].SECTION_TITLE}}</h2>
		<div style="margin-top: 6px;font-size: 12px;"><!--Reliance-->			
			<div class="textList" style="width:100%;">
				<p style="margin: 2px;">This report is for the use and benefit of, and may be relied upon by</p>
				<div style="padding-left: 10px;">
					<p>(a) the Seller/Servicer, Freddie Mac and any successors and assigns (“Lender”);</p>
					<p>(b) independent auditors, accountants, attorneys and other professionals acting on behalf of Lender;</p>
					<p>(c) governmental agencies having regulatory authority over Lender;</p>
					<p>(d) designated persons pursuant to an order or legal process of any court or governmental agency;</p>
					<p>(e) prospective purchasers of the Mortgage; and</p>
					<p>(f) with respect to any debt (or portion thereof) and/or securities secured, directly or indirectly, by the Property which is the subject of this &nbsp; &nbsp; &nbsp;report, the following parties and their respective successors and assigns:</p>
					<ul style="list-style-type:disc;margin-left: 20px;">
						<li style="font-weight: normal;">any placement agent or broker/dealer and any of their respective affiliates, agents and advisors;</li>
						<li style="font-weight: normal;">any initial purchaser or subsequent holder of such debt and/or securities;</li>
						<li style="font-weight: normal;">any Servicer or other agent acting on behalf of the holders of such debt and/or securities;</li>
						<li style="font-weight: normal;">any indenture trustee;</li>
						<li style="font-weight: normal;">any rating agency; and</li>
						<li style="font-weight: normal;">any institutional provider from time to time of any liquidity facility or credit support for such financings.</li>
					</ul>
				</div>
				<p>In addition, this report, or a reference to this report, may be included or quoted in any offering circular, information circular, offering memorandum, registration statement, private placement memorandum, prospectus or sales brochure (in either electronic or hard copy format) in connection with a securitization or transaction involving such debt (or portion thereof) and/or securities.</p>
			</div>
		
		</div>
		<div style="margin-top: 6px;font-size: 12px;"><!--Certification-->
			<h2>{{contents[0].SUB_SECTIONS[7].SECTION_TITLE}}</h2>
			<div style="width:100%">
				<p>The undersigned hereby certifies that:</p>
				<ul style="list-style-type:disc;margin-left: 20px;">
					<li>The attached physical risk report was prepared in accordance with all applicable requirements in the Freddie Mac Multifamily</li>
					<li>The inspection and report was prepared in a manner consistent with generally accepted industry practices and standards</li>
					<li>All information is true and correct, to the best of the undersigned's knowledge, and reflects the consultant's best professional opinion and</li>
					<li>No changes or additions have been made to the standard provisions of this form other than those expressly approved in writing by Freddie Mac</li>
				</ul>
			</div>
		
		</div>
		<div style="width:100%; display:inline; position:relative">
			<div style="width:49%; display:inline-block;">
				<div style="display:inline-block;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
					<div style="height:4px;"></div>
					<label style="margin-left:4px">Signature of property inspector</label><br>
					<ng-container *ngIf="contents[0].SUB_SECTIONS[7].data['inspector']['sign']">
						<img [src]="contents[0].SUB_SECTIONS[7].data['inspector']['sign']" alt="Signature" style="max-height:25px;width:auto;vertical-align:bottom; margin: 0 20px;">
					</ng-container>
					<ng-container *ngIf="!contents[0].SUB_SECTIONS[7].data['inspector']['sign']">
						<p style="min-height:25px; font-size: 14px;vertical-align:bottom;margin-left: 10px; line-height: 25px"></p>
					</ng-container>			
				</div>
			</div>
			<div style="width:49%; display:inline-block;margin-left:10px;vertical-align:bottom;">
				<div style="display:inline-block;margin:0;width:100%;border-left:4px solid black;border-bottom:1px solid black;">
					<div style="height:4px; border:none; "></div>
					<label style="margin-left:4px">Date</label><br>
					<p style="min-height:25px; font-size: 14px;vertical-align:bottom;padding-left: 10px; line-height: 25px">{{contents[0].SUB_SECTIONS[7].data['inspector']['date']|date:'MMMM dd, yyyy'}}</p>
				</div>
				</div>
			<div style="width:49%; display:inline-block;border-left:4px solid black;border-bottom:1px solid black;">
				<div style="height:4px;"></div>
				<label style="margin-left:4px">Name</label><br>
				<p style="min-height:25px; font-size: 14px;vertical-align:bottom;padding-left: 10px; line-height: 25px;">{{contents[0].SUB_SECTIONS[7].data['inspector']['name']}}</p>
			</div>
			<div style="width:49%; display:inline-block;margin-left:10px;border-left:4px solid black;border-bottom:1px solid black;">
			
				<div style="height:4px;"></div>
				<label style="margin-left:4px">Title</label><br>
				<p style="min-height:25px; font-size: 14px;vertical-align:bottom;padding-left: 10px; line-height: 25px;">{{contents[0].SUB_SECTIONS[7].data['inspector']['title']}}</p>
			
			</div>
		</div>
		<div class="question-line">
			<div class='klistItem5'>
				<p>Did a separate individual write or review the report?</p>
			</div>
			<div class='klistItem6'>
				<div *ngIf="contents[0].SUB_SECTIONS[7].data['otherRptReviewer'].required=='Y'" class="textarea">Yes</div>
				<div *ngIf="contents[0].SUB_SECTIONS[7].data['otherRptReviewer'].required=='N'" class="textarea">No</div>
				<div *ngIf="!contents[0].SUB_SECTIONS[7].data['otherRptReviewer'].required" class="textarea"></div>	
			</div>
		</div>
		<div *ngIf="contents[0].SUB_SECTIONS[7].data['otherRptReviewer'].required=='Y'" style="width:100%; display:inline; position:relative">
			<div style="width:49%; display:inline-block;">
				<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
					<div style="height:4px;"></div>
					<label style="margin-left:4px">Signature of writer/reviewer</label><br>
					<ng-container *ngIf="contents[0].SUB_SECTIONS[7].data['otherRptReviewer']['sign']">
						<img [src]="contents[0].SUB_SECTIONS[7].data['otherRptReviewer']['sign']" alt="Signature" style="max-height:25px;width:auto;vertical-align:bottom; margin: 0 20px;">
					</ng-container>
					<ng-container *ngIf="!contents[0].SUB_SECTIONS[7].data['otherRptReviewer']['sign']">
						<p style="min-height:25px; font-size: 14px;vertical-align:bottom;margin-left: 10px; line-height: 25px"></p>
					</ng-container>				
				</div>
			</div>
			
			<div style="width:49%; display:inline-block;margin-left:10px;vertical-align:bottom;">
			<div style="display:inline-block;margin:0;width:100%;border-left:4px solid black;border-bottom:1px solid black;">
				<div style="height:4px; border:none; "></div>
				<label style="margin-left:4px">Date</label><br>
				<p style="min-height:25px; font-size: 14px;vertical-align:bottom;padding-left: 10px; line-height: 25px">{{contents[0].SUB_SECTIONS[7].data['otherRptReviewer']['date']|date:'MMMM dd, yyyy'}}</p>
			</div>
			</div>
			<div style="width:49%; display:inline-block;border-left:4px solid black;border-bottom:1px solid black;">
			
				<div style="height:4px;"></div>
				<label style="margin-left:4px">Name</label><br>
				<p style="min-height:25px; font-size: 14px;vertical-align:bottom;padding-left: 10px; line-height: 25px;">{{contents[0].SUB_SECTIONS[7].data['otherRptReviewer']['name']}}</p>
				
			
			</div>
			<div style="width:49%; display:inline-block;margin-left:10px;border-left:4px solid black;border-bottom:1px solid black;">
			
				<div style="height:4px; border:none; "></div>
				<label style="margin-left:4px">Title</label><br>
				<p style="min-height:25px; font-size: 14px;vertical-align:bottom;padding-left: 10px; line-height: 25px;">{{contents[0].SUB_SECTIONS[7].data['otherRptReviewer']['title']}}</p>
			
			</div>
		</div>
		<div class="question-line">
			<div class='klistItem5'>
				<p >Was a separate individual required to review the environmental section?</p>
			</div>
			<div class='klistItem6'>
				<div *ngIf="contents[0].SUB_SECTIONS[7].data['otherEvReviewer'].required=='Y'" class="textarea">Yes</div>
				<div *ngIf="contents[0].SUB_SECTIONS[7].data['otherEvReviewer'].required=='N'" class="textarea">No</div>
				<div *ngIf="!contents[0].SUB_SECTIONS[7].data['otherEvReviewer'].required" class="textarea"></div>	
			</div>
		</div>
		<div *ngIf="contents[0].SUB_SECTIONS[7].data['otherEvReviewer'].required=='Y'" style="width:100%; display:inline; position:relative">
			<div style="width:49%; display:inline-block;">
				<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
					<div style="height:4px;"></div>
					<label style="margin-left:4px">Signature of reviewer</label><br>
					<ng-container *ngIf="contents[0].SUB_SECTIONS[7].data['otherEvReviewer']['sign']">
						<img [src]="contents[0].SUB_SECTIONS[7].data['otherEvReviewer']['sign']" alt="Signature" style="max-height:25px;width:auto;vertical-align:bottom; margin: 0 20px;">
					</ng-container>
					<ng-container *ngIf="!contents[0].SUB_SECTIONS[7].data['otherEvReviewer']['sign']">
						<p style="min-height:25px; font-size: 14px;vertical-align:bottom;margin-left: 10px; line-height: 25px"></p>
					</ng-container>					</div>
			</div>
			
			<div style="width:49%; display:inline-block;;margin-left:10px;vertical-align:bottom;">
			<div style="display:inline-block;margin:0;width:100%;border-left:4px solid black;border-bottom:1px solid black;">
				<div style="height:4px; border:none; "></div>
				<label style="margin-left:4px">Date</label><br>
				<p style="min-height:25px; font-size: 14px;vertical-align:bottom;padding-left: 10px; line-height: 25px;">{{contents[0].SUB_SECTIONS[7].data['otherEvReviewer']['date']|date:'MMMM dd, yyyy'}}</p>
			</div>
			</div>
			<div style="width:49%; display:inline-block;border-left:4px solid black;border-bottom:1px solid black;">
			
				<div style="height:4px;"></div>
				<label style="margin-left:4px">Name</label><br>
				<p style="min-height:25px; font-size: 14px;vertical-align:bottom;padding-left: 10px; line-height: 25px;">{{contents[0].SUB_SECTIONS[7].data['otherEvReviewer']['name']}}</p>
				
			</div>
			
			<div style="width:49%; display:inline-block;margin-left:10px;border-left:4px solid black;border-bottom:1px solid black;">
			
				<div style="height:4px; border:none; "></div>
				<label style="margin-left:4px">Title</label><br>
				<p style="min-height:25px; font-size: 14px;vertical-align:bottom;padding-left: 10px; line-height: 25px;">{{contents[0].SUB_SECTIONS[7].data['otherEvReviewer']['title']}}</p>
			
			</div>
		</div>
		</section>
		<section class="page-before" data-section-title="Section II">
            <header>
                <div class="freddie-mac-header">
                    <div class="freddie-mac-logo">
                        <img src="https://erisservice9.erisinfo.com/exreportw/frmimages/logo.jpg" alt="Freddie Mac Multifamily">
                    </div>
                    <div class="freddie-mac-title">
                        <strong>SBL Physical Risk Report</strong><br>
						<strong>{{contents[0].SUB_SECTIONS[0].data?.AsReportedName?.text}} ({{contents[0].SUB_SECTIONS[0].data?.CityName?.text}}, {{contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.text}})</strong>
                    </div>
                </div>
            </header>
            <h1>Section II: Unit Details</h1>
            <h2>Unit Mix and Inspection</h2>
            <p>Complete <strong>Table 1</strong> for residential units <i>only</i>. Commercial units, both spaces that are purpose-built and dwelling units converted to commercial use will be accounted for in <strong>Table 2</strong>. If "Other" dwelling units have been indicated, Table 3 will need to be completed as indicated.</p>
            <div class="unit-tables">
                <p class="table-title" style="background-color: #CCC;">Table 1 - below, indicate the unit type and occupancy at the time of the visit and the number of units inspected of each type</p>
                <div class="flex3">
                    <div>
                        <table>
                            <thead>
                                <tr>
                                    <th colspan="4" style="background-color: #CCC;">Unit Type</th>
                                </tr>
                                <tr>
                                    <th>BR</th>
                                    <th>BA</th>
                                    <th>Style</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let row of contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMix"  class="border-bottom">
                                    <td>{{row.BedroomCount}}</td>
                                    <td>{{row.BathroomCount}}</td>
                                    <td>{{row.StyleType}}</td>
                                </tr>							
                            </tbody>
                            <tfoot>
                                <td colspan="4" style="text-align: right; padding-top: 0.5rem;">Totals:</td>
                            </tfoot>
                        </table>
                    </div>
                    <div>
                        <table>
                            <thead>
                                <tr>
                                    <th colspan="4"style="background-color: #CCC;">Number of Units</th>
                                </tr>
                                <tr>
                                    <th>Occupied</th>
                                    <th>Vacant</th>
                                    <th>Down</th>
                                    <th>Other *</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr  *ngFor="let row of contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMix; let i=index; trackBy:trackByFuntion">
                                    <td>{{row.PptyUnitTypeOccupiedUnitCount}}</td>
                                    <td>{{row.VacantUnitCount}}</td>
                                    <td>{{row.PptyUnitTypeDownUnitCount}}</td>
                                    <td>{{row.PptyUnitTypeOtherUnitCount}}</td>
                                </tr>								
                            </tbody>                        
                        </table>
                    </div>
                    <div>
                        <table>
                            <thead>
                                <tr>
                                    <th colspan="4" style="background-color: #CCC;">Number of units inspected</th>
                                </tr>
                                <tr>
                                    <th>Occupied</th>
                                    <th>Vacant</th>
                                    <th>Down</th>
                                    <th>Other</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let row of contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMix; let i=index; trackBy:trackByFuntion">
                                    <td>{{row.PptyUnitTypeOccupiedInspectedUnitCount}}</td>
                                    <td>{{row.PptyUnitTypeVacantInspectedUnitCount}}</td>
                                    <td>{{row.PptyUnitTypeDownInspectedUnitCount}}</td>
                                    <td>{{row.PptyUnitTypeOtherInspectedUnitCount}}</td>
                                </tr>							
                            </tbody>                        
                        </table>
                    </div>
                </div>
                <div class="flex">
                    <div style="width: 66%">
                        <p class="table-title"  style="background-color: #CCC;">Table 2</p>
                        <table id="table2">
                            <thead>
                                <tr>
                                    <th colspan="5" style="background-color: #CCC;">Detail of Commercial Units</th>
                                </tr>
                                <tr>
                                    <th width="50%"></th>
                                    <th>Occupied</th>
                                    <th>Vacant</th>
                                    <th>Down</th>
                                    <th>Other</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="border-none">Number of purpose-built spaces</td>
                                    <td>{{contents[1].SUB_SECTIONS[0].data.PropertyCommercialUsageMix[0].OccupiedUnitCount}}</td>
                                    <td>{{contents[1].SUB_SECTIONS[0].data.PropertyCommercialUsageMix[0].VacantUnitCount}}</td>
                                    <td>{{contents[1].SUB_SECTIONS[0].data.PropertyCommercialUsageMix[0].DownUnitCount}}</td>
                                    <td style="background-color: #CCC;font-weight: bold;">{{contents[1].SUB_SECTIONS[0].data.PropertyCommercialUsageMix[0].UnitCount}}</td>
                                </tr>
                                <tr>
                                    <td class="border-none">Number of converted residential units</td>
                                    <td>{{contents[1].SUB_SECTIONS[0].data.PropertyCommercialUsageMix[1].OccupiedUnitCount}}</td>
                                    <td>{{contents[1].SUB_SECTIONS[0].data.PropertyCommercialUsageMix[1].VacantUnitCount}}</td>
                                    <td>{{contents[1].SUB_SECTIONS[0].data.PropertyCommercialUsageMix[1].DownUnitCount}}</td>
                                    <td style="background-color: #CCC;font-weight: bold;">{{contents[1].SUB_SECTIONS[0].data.PropertyCommercialUsageMix[1].UnitCount}}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colspan="5" style="padding: 0.5rem 0 0 0;">
                                        <table id="table2-total">
                                            <tr>
                                                <td>Occupied units, including commercial space and other</td>
                                                <td style="font-weight: bold;">{{contents[1].SUB_SECTIONS[0].data.summary.RsdntlTotalUnitCount}}</td>
                                            </tr>
                                            <tr>
                                                <td>Vacant/down units, including commercial space</td>
                                                <td style="font-weight: bold;">{{contents[1].SUB_SECTIONS[0].data.summary.CommercialTotalUnitCount}}</td>
                                            </tr>
                                            <tr>
                                                <td>Total number of ALL units, including commercial space</td>
                                                <td style="font-weight: bold;">{{contents[1].SUB_SECTIONS[0].data.summary.TotalUnitCount}}</td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                    <div style="width: 33%;">
                        <div style="width: 85%; margin: 0 auto;">
                            <p class="table-title" style="background-color: #CCC;">Table 3</p>
                            <table>
                                <thead>
                                    <tr>
                                        <th colspan="2" style="background-color: #dedede;">* Detail of "Other" noted above</th>
                                    </tr>
                                    <tr>
                                        <th width="80%"></th>
                                        <th>Total units</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="border-none">Management office</td>
                                        <td>{{contents[1].SUB_SECTIONS[0].data.PropertyOtherDetail.PptyTotalOtherMgmtOfficeUnitCount}}</td>
                                    </tr>
                                    <tr>
                                        <td class="border-none">Model</td>
                                        <td>{{contents[1].SUB_SECTIONS[0].data.PropertyOtherDetail.PptyTotalOtherModelUnitCount}}</td>
                                    </tr>
                                    <tr>
                                        <td class="border-none">Maintenance shop</td>
                                        <td>{{contents[1].SUB_SECTIONS[0].data.PropertyOtherDetail.PptyTotalOtherMaintenanceShopUnitCount}}</td>
                                    </tr>
                                    <tr>
                                        <td class="border-none">Storage</td>
                                        <td>{{contents[1].SUB_SECTIONS[0].data.PropertyOtherDetail.PptyTotalOtherStorageUnitCount}}</td>
                                    </tr>
                                    <tr>
                                        <td class="border-none">Hospitality suite</td>
                                        <td>{{contents[1].SUB_SECTIONS[0].data.PropertyOtherDetail.PptyTotalOtherHospitalitySuiteUnitCount}}</td>
                                    </tr>
                                    <tr>
                                        <td class="border-none">Other administrative</td>
                                        <td>{{contents[1].SUB_SECTIONS[0].data.PropertyOtherDetail.PptyTotalOtherMiscellaneousUnitCount}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
			<h2>Uncertified or Unpermitted Units and/or Modifications</h2>
			<div style="margin-top: 6px;font-size: 12px;">
			
				<div class="question-line">
					<div class='klistItem5'>
					<p>Were any uncertified or unpermitted units, and/or modifications to units identified or suspected, either via
						the inspection or from the building records research?</p>
				</div>
				<div class='klistItem6'>
					<div *ngIf="contents[1].SUB_SECTIONS[1].data.Violations=='YES'" class="textarea">Yes</div>
					<div *ngIf="contents[1].SUB_SECTIONS[1].data.Violations=='NO'" class="textarea">No</div>
					<div *ngIf="!contents[1].SUB_SECTIONS[1].data.Violations" class="textarea"></div>	
				</div>
			</div>
			<div *ngIf="contents[1].SUB_SECTIONS[1].data.Violations=='YES'">
				<div class="row" style="width: 55%;margin-left: 8px;">
				  <div class='klistItem' style="width:84%;">
					  <p style="width:95%;">Number of units certified with municipality:</p>
				  </div>
				  <div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
					  <div class="textarea">{{contents[1].SUB_SECTIONS[1].data.Certified}}</div>
				  </div>
				  <div class='klistItem' style="width:84%;">
					  <p style="width:95%;">Current number of units at the property (uncertified and certified):</p>
				  </div>
				  <div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
					  <div class="textarea">{{contents[1].SUB_SECTIONS[1].data.AllUnit}}</div>
				  </div>					
				</div>
				<ng-container *ngFor="let item of contents[1].SUB_SECTIONS[1].data.ViolationRecord;">
				  <table style="border:2px solid black; width:100%; border-collapse: collapse;">
					  <tbody>
						  <tr>
							  <td class="frm-graycell" style="width:20%">Location or Unit #</td>
							  <td style="width:53%; border-top:double 2px black">
								  {{item.Location}}
							  </td>
							  <td class="frm-graycell" style="width:20%">Violation on record?</td>
							  <td style="width:7%">
								<label *ngIf="item.OnRecords=='YES'" class="kItem1">Yes</label> 
								<label *ngIf="item.OnRecords=='NO'" class="kItem1">No</label>
							  </td>
						  </tr>
						  <tr>
							  <td class="frm-graycell" colspan="4">Description of violation and/or observed concerns</td>
						  </tr>
						  <tr>
							  <td  class="frm-normalcell" colspan="4">
								  <p>{{item.Description}}</p>
								  
							  </td>
						  </tr>
					  </tbody>
				  </table>
				</ng-container>
			</div>
		</div>
		
						<h2>Unit Inspection Information</h2>
						<p>Indicate the type of unit, using the following abbreviations: 0BR, 1BR, 2BR, etc. Give the unit number and status, using the following status codes: O =
							occupied, V = vacant, D = down and R = other (maintenance shop, management office, etc.). For example, an occupied one-bedroom unit numbered 101
							should be listed as 1BR/101/O.</p>
						<div style="width:100%; display:inline; position:relative; font-size: 12px;" class="unit-tables">
							<table style="width:100%; border-collapse: collapse;text-align: center; border:none">
								<tbody>
								<ng-container *ngFor="let row of unitrow|fill; let i=index; trackBy:trackByFuntion">
								<tr style="vertical-align: bottom;" class="border-bottom">
									<td style="border:none;	width:3%; padding:0; height:18px;"><span style="vertical-align: bottom;">{{4*i+1}}</span>
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:5%">
										<p style="text-align: center">{{contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i].UnitType}}</p>
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:12%">
										<p style=" width:99%;border:none;text-align: center;margin: 0;padding: 0;height: 24px;vertical-align: middle; border: 8px solid transparent;border-image: linear-gradient(to top,black  20%, transparent 20%) 1 100%;">{{contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i].SlrDesignatedUnitId}}</p>
										
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; padding:0;width:5%">
										<p style="text-align: center">{{contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i].OccupancyStatusType}}</p>
									</td>
								
									<td style="border:none;	width:3%; padding:0; height:18px;"><span style="vertical-align: bottom;">{{4*i+2}}</span>
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:5%" class="half-a-border-on-right">
										<p style="text-align: center">{{contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+1]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+1].UnitType}}</p>
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:12%">
										<p style=" width:99%;border:none;text-align: center;margin: 0;padding: 0;height: 24px;vertical-align: middle; border: 8px solid transparent;border-image: linear-gradient(to top,black  20%, transparent 20%) 1 100%;">{{contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+1]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+1].SlrDesignatedUnitId}}</p>
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; padding:0;width:5%">
										<p style="text-align: center">{{contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+1]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+1].OccupancyStatusType}}</p>
										
					
									</td>
								
									<td style="border:none;	width:3%; padding:0; height:18px;"><span style="vertical-align: bottom;">{{4*i+3}}</span>
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:5%">
										<p style="text-align: center">{{contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+2]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+2].UnitType}}</p>
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:12%">
										<p style=" width:99%;border:none;text-align: center;margin: 0;padding: 0;height: 24px;vertical-align: middle; border: 8px solid transparent;border-image: linear-gradient(to top,black  20%, transparent 20%) 1 100%;">{{contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+2]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+2].SlrDesignatedUnitId}}</p>
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; width:5%">
										<p style="text-align: center">{{contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+2]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+2].OccupancyStatusType}}</p>
									</td>
								
									<td style="border:none;	width:3%; padding:0; height:18px;"><span style="vertical-align: bottom;">{{4*i+4}}</span>
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:5%">
										<p style="text-align: center">{{contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+3]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+3].UnitType}}</p>
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; padding:0;width:12%">
										<p style=" width:99%;border:none;text-align: center;margin: 0;padding: 0;height: 24px;vertical-align: middle; border: 8px solid transparent;border-image: linear-gradient(to top,black  20%, transparent 20%) 1 100%;">{{contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+3]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+3].SlrDesignatedUnitId}}</p>
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; padding:0;width:5%">
										<p style="text-align: center">{{contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+3]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+3].OccupancyStatusType}}</p>
									</td>
								</tr>
								</ng-container>	
								</tbody>
							</table>							
						</div>
						<div class="question-line" style="font-size: 12px;">
							<div class='question'>
								<p>Were there any problems with gaining access to the required number of units?</p>
							</div>
							<div class='klistItem3'>
								<div *ngIf="contents[1].SUB_SECTIONS[2].data.AccessProblems.status=='YES'" class="textarea">Yes</div>
								<div *ngIf="contents[1].SUB_SECTIONS[2].data.AccessProblems.status=='NO'" class="textarea">No</div>
								<div *ngIf="!contents[1].SUB_SECTIONS[2].data.AccessProblems.status" class="textarea"></div>
							</div>
						</div>
							<div  class="input-box" *ngIf="contents[1].SUB_SECTIONS[2].data.AccessProblems.status=='YES'" style="font-size: 12px;margin-bottom: 4px;">
								<p>Provide details:</p>
								<div class="textarea">{{contents[1].SUB_SECTIONS[2].data.AccessProblems.description}}</div>
							</div>

		</section>	
								
		<section class="page-before" data-section-title="Section III">
            <header>
                <div class="freddie-mac-header">
                    <div class="freddie-mac-logo">
                        <img src="https://erisservice9.erisinfo.com/exreportw/frmimages/logo.jpg" alt="Freddie Mac Multifamily">
                    </div>
                    <div class="freddie-mac-title">
                        <strong>SBL Physical Risk Report</strong><br>
						<strong>{{contents[0].SUB_SECTIONS[0].data?.AsReportedName?.text}} ({{contents[0].SUB_SECTIONS[0].data?.CityName?.text}}, {{contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.text}})</strong>
                    </div>
                </div>
            </header>
            <h1>Section III: Property Condition Assessment</h1>
<div style="margin-top: 6px;">
	<ng-container *ngFor="let sec of contents[2].SUB_SECTIONS|slice:0:-4; trackBy: trackByFuntion; let j=index">
		<h2>{{sec.SECTION_TITLE}}</h2>
		<p *ngIf="sec.data.intro">{{sec.data.intro}}</p>
		<div style="width:100%; font-size: 12px;">		
		<div *ngIf="j==0">
			<div style="width:24.5%; display:inline-block;vertical-align: bottom;">
			<div style="display: flex;vertical-align: bottom;">
				<span class="under-line1">
					<label>{{sec.data.checkItem[0]}}</label>
				</span>
				<span>Galvanized water pipe</span>
			</div>
			<div  style="display: flex;vertical-align: bottom;">
				<span class="under-line1">
					<label>{{sec.data.checkItem[1]}}</label>
				</span>
				<span>Polybutylene water pipe</span>
			</div>
			</div>
			<div style="width:24.5%; display:inline-block;vertical-align: bottom;" >
				<div style="display: flex;">
					<span class="under-line1">
						<label>{{sec.data.checkItem[2]}}</label>
					</span>
					<span>Aluminum branch wiring</span>
				</div>
				<div style="display: flex;">
					<span class="under-line1">
						<label>{{sec.data.checkItem[3]}}</label>
					</span>
					<span >Edison base/T-type fuses</span>
				</div>
			</div>
				<div style="width:24.5%; display:inline-block;vertical-align: bottom;">
					<div style="display: flex;">
						<span class="under-line1">
							<label>{{sec.data.checkItem[4]}}</label>
						</span>
						<span>Recalls</span>
					</div>
					<div style="display: flex;">
						<span class="under-line1">
							<label>{{sec.data.checkItem[5]}}</label>
						</span>
						<span>Stab-lok breakers</span>
					</div>
					</div>
					<div style="width:24.5%; display:inline-block;vertical-align: bottom;">
						<div style="display: flex;">
							<span class="under-line1">
								<label>{{sec.data.checkItem[6]}}</label>
							</span>
							<span>Fiberboard exterior siding</span>
						</div>
						<div style="display: flex;">
							<span class="under-line1">
								<label>{{sec.data.checkItem[7]}}</label>
							</span>
							<span>T1-11 siding</span>
						</div>
						</div>
						<div style="width:73.5%; display:inline-block;vertical-align: bottom;">
							<div style="display: flex;">
								<span class="under-line1">
									<label>{{sec.data.checkItem[8]}}</label>
								</span>
								<span>EIFS (exterior foam insulation system)</span>
							</div>
						</div>
						<div style="width:24.5%; display:inline-block;vertical-align: bottom;">
							<div style="display: flex;">
								<span class="under-line1">
									<label>{{sec.data.None}}</label>
								</span>
								<span>None</span>
							</div>
						</div>
						<div style="width:70%; display:inline-block;vertical-align: bottom;">
							<div class="checkbox-other" style="display: flex;">
								<span class="under-line1">
									<label>{{sec.data.checkItem[9]}}</label>
								</span>
								<span style="margin-right: 4px;">Other</span>
								<span class="under-line"><label>{{sec.data.other}}</label></span>	
							</div>							
						</div>
		</div>
		<div *ngIf="j==1" style="width:100%; display:inline; position:relative;font-size: 12px;">
						<div style="width:33.1%; display:inline-block;vertical-align: bottom;">
							<div style="display: flex;">
								<span class="under-line1">
									<label>{{sec.data.checkItem[0]}}</label>
								</span>
								<span>Smoke detectors</span>
							</div>
						<div style="display: flex;">
							<span class="under-line1">
								<label>{{sec.data.checkItem[1]}}</label>
							</span>
							<span>Sprinklers</span>
						</div>
						<div style="display: flex;">
							<span class="under-line1">
								<label>{{sec.data.checkItem[2]}}</label>
							</span>
							<span>Intercom</span>
						</div>
						
						</div>
						<div style="width:33.1%; display:inline-block;vertical-align: bottom;" >
							<div style="display: flex;">
								<span class="under-line1">
									<label>{{sec.data.checkItem[3]}}</label>
								</span>
								<span>Carbon monoxide detectors</span>
							</div>
							<div style="display: flex;">
								<span class="under-line1">
									<label>{{sec.data.checkItem[4]}}</label>
								</span>
								<span>Emergency lights & exit signs</span>
							</div>
							<div style="display: flex;">
								<span class="under-line1">
									<label>{{sec.data.checkItem[5]}}</label>
								</span>
								<span>Security cameras</span>
							</div>
							</div>
							<div style="width:33.1%; display:inline-block;vertical-align: bottom;">
								<div style="display: flex;">
									<span class="under-line1">
										<label>{{sec.data.checkItem[6]}}</label>
									</span>
									<span>Fire extinguishers</span>
								</div>
								<div style="display: flex;">
									<span class="under-line1">
										<label>{{sec.data.checkItem[7]}}</label>
									</span>
									<span>Fire alarms</span>
								</div>
								<div style="display: flex;">
									<span class="under-line1">
										<label>{{sec.data.checkItem[8]}}</label>
									</span>
									<span>Secured entrance doors</span>
								</div>
								</div>
								<div  style="width:66.5%; display:inline-block;vertical-align: bottom;">
									<div class="checkbox-other" style="display: flex;">
										<span class="under-line1">
											<label>{{sec.data.checkItem[9]}}</label>
										</span>
										<span style="margin-right: 4px;">Other</span>
										<span class="under-line"><label>{{sec.data.other}}</label></span>	
									</div>	
								</div>
								<div   style="width:33.1%; display:inline-block;vertical-align: bottom;">
									<div style="display: flex;">
										<span class="under-line1">
											<label>{{sec.data.None}}</label>
										</span>	
										<span>None</span>
									</div>
								</div>
		</div>
		<div *ngIf="sec3type1.indexOf(j)>-1" style="font-size: 12px;">
			<div class="input-box" *ngIf="!sec.data.issues&&(!sec.data.checkItem||sec.data.checkItem.join('').length>0)&&(!sec.data.ifcover)" style=" margin-bottom: 4px;">
				<p>Description:</p>
				<div class="textarea">{{sec.data.otherDetail.description}}</div>
			</div>
			<div *ngIf="sec.data.issues">
				<ng-container *ngFor="let issue of sec.data.issues">
					<div class="question-line">
						<div class='klistItem5'>
						<p>{{issue.label}}</p>
					</div>
					<div  class='klistItem6'>
						<div *ngIf="issue.status=='YES'" class="textarea">Yes</div>
						<div *ngIf="issue.status=='NO'" class="textarea">No</div>
						<div *ngIf="!issue.status" class="textarea"></div>	
					</div>
					</div>
					<div class="input-box" *ngIf="issue.status=='YES'">
						<p >Description:</p>
						<div class="textarea">{{issue.description}}</div>
					</div>
				</ng-container>
			</div>
			<div *ngIf="sec.data.ifcover" >
				<div class="question-line">
					<div class='klistItem5'>
						<p>{{sec.data.ifcover.label}}</p>
					</div>
					<div  class='klistItem6'>
						<div *ngIf="sec.data.ifcover.status=='YES'" class="textarea">Yes</div>
						<div *ngIf="sec.data.ifcover.status=='NO'" class="textarea">No</div>
						<div *ngIf="!sec.data.ifcover.status" class="textarea"></div>	
					</div>
				</div>
				<div *ngIf="sec.data.ifcover.status=='YES'" class="input-box" >
					<p >Description:</p>
					<div class="textarea">{{sec.data.ifcover.description}}</div>
				</div>
			</div>	
			<div  *ngIf="((!sec.data.checkItem||sec.data.checkItem.join('').length>0)&&j!=4)||(j==4&&sec.data.ifcover.status=='YES')">
				<div *ngIf="!sec.data.issues" class="question-line">
					<div class='klistItem5'>
						<p style="width:100%;">What is the general condition of this component?</p>
					</div>
					<div class='klistItem6'>
						<div *ngIf="sec.data.otherDetail.condition" class="textarea">{{sec.data.otherDetail.condition}}</div>
						<div *ngIf="!sec.data.otherDetail.condition" class="textarea"></div>
					</div>
				</div>
				<div class="question-line">
					<div class='klistItem5'>
						<p>Were any deficiencies identified that could be categorized as a Critical, PR-90, Priority or Operational Repair?</p>
					</div>
					<div class='klistItem6'>
						<div *ngIf="sec.data.otherDetail.hasDeficiencies=='YES'" class="textarea">Yes</div>
							<div *ngIf="sec.data.otherDetail.hasDeficiencies=='NO'" class="textarea">No</div>
							<div *ngIf="!sec.data.otherDetail.hasDeficiencies" class="textarea"></div>	
					</div>
				</div>
			</div>
						<div *ngIf="sec.data.otherDetail.hasDeficiencies=='YES'&&(!sec.data.checkItem||sec.data.checkItem.join('').length>0)" style="margin-left: 20px;">
							<ng-container *ngFor="let item of sec.data.otherDetail.deficiencies;let i=index; trackBy:trackByFuntion">
								<div class="question-line">
									<div class='klistItem5'>
									<p>{{item.cat}}</p>
								</div>
								<div class='klistItem6'>
									<div *ngIf="item.status=='YES'" class="textarea">Yes</div>
									<div *ngIf="item.status=='NO'" class="textarea">No</div>
									<div *ngIf="!item.status" class="textarea"></div>	
									
								</div>
								</div>
								<div style="margin-left: 10px;">
									<div *ngIf="item.status=='YES'">
										<div class='klistItem4' style="width:30%">
											<p>Provide a brief description:</p>
										</div>
										<div class='klistItem3' style="width:70%; text-align: left;">
											<div class="textarea">{{item.description}}</div>
										</div>
										<ng-container *ngIf="item.type!='ors'">
											<div class='klistItem4' style="width:30%">
												<p>Cost to cure:</p>
											</div>
											<div class='klistItem3' style="width:100px">
												<div class="textarea">{{USDollar.format(item.cost)}}</div>
											</div>
										</ng-container>
									</div>
								</div>
							</ng-container>
						</div>
					</div>
					<div *ngIf="sec3type2.indexOf(j)>-1"  style="font-size: 12px;">
						<ng-container *ngFor="let sec1 of sec.data.sub">
							<p style="border-bottom:2px solid black;border-left:2px solid black;width:25%; font-size: 14px; margin-top:10px">{{sec1.subcat}}</p>
							<p *ngIf="sec1.otherDetail.intro">{{sec1.otherDetail.intro}}</p>
							<table *ngIf="sec1.otherDetail.providers" class="section-header">
								<ng-container *ngFor="let row of 6|fill; trackBy:trackByFuntion; let i=index">
								<tr>
									<td width="50%">
										<div>
											<p *ngIf="sec1.otherDetail.providers[2*i].html" [innerHTML]="sec1.otherDetail.providers[2*i].secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<label>{{sec1.otherDetail.providers[2*i].label}}</label>
										</div>
									</td>
									<td width="50%">
										<div>
											<p *ngIf="sec1.otherDetail.providers[2*i+1].html" [innerHTML]="sec1.otherDetail.providers[2*i+1].secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<label>{{sec1.otherDetail.providers[2*i+1].label}}</label>
										</div>
									</td>
								</tr>
								</ng-container>    
							</table>
							<div *ngIf="sec1.otherDetail.ifConditions">
								<div class="question-line">
									<div class='klistItem7'>
										<p  style="border-bottom:solid 1px black">Present/Not Present</p>
									</div>
									<div class='klistItem8'>
										<p style="border-bottom:solid 1px black">Safety/Security Device</p>
									</div>
								</div>
									<ng-container *ngFor="let condition of sec1.otherDetail.ifConditions; trackBy:trackByFuntion let h=index">
										<div class="question-line">
										<div class='klistItem7'>
											<div *ngIf="condition.status=='Y'" class="textarea leftbox">Present</div>
											<div *ngIf="condition.status=='N'" class="textarea leftbox">Not Present</div>
											<div *ngIf="!condition.status" class="textarea leftbox"></div>
											
										</div>
										<div class='klistItem8'>
											<p>{{condition.condition}}</p>
											<div *ngIf="condition.status=='Y'">
												<ng-container *ngIf="condition.questions">
													<div class="question-line">
														<div class='klistItem5'>
															<p>{{condition.questions[0].label}}</p>
														</div>
														<div class='klistItem6'>
															<div *ngIf="condition.questions[0].status=='YES'" class="textarea">Yes</div>
															<div *ngIf="condition.questions[0].status=='NO'" class="textarea">No</div>
															<div *ngIf="!condition.questions[0].status" class="textarea"></div>
																		
														</div>
													</div>
													<ng-container *ngIf="condition.questions[0].status=='YES'">
														<div class="question-line">
															<div class='klistItem5'>
															<p>{{condition.questions[1].label}}</p>
														</div>
														<div class='klistItem6'>
															<div *ngIf="condition.questions[1].status=='YES'" class="textarea">Yes</div>
															<div *ngIf="condition.questions[1].status=='NO'" class="textarea">No</div>
															<div *ngIf="!condition.questions[1].status" class="textarea"></div>
														</div>
														</div>
														<div *ngIf="condition.questions[1].moreinfo&&condition.questions[1].status=='YES'"  style="margin-left:10px">
															<div class="question-line">
																<div class='klistItem5'>
																<p>{{condition.questions[1].info}}</p>
															</div>
															<div class='klistItem6'>
																<div class="textarea">{{condition.questions[1].value+' '+condition.questions[1].unit}}</div>																
															</div>
															</div>
														</div>
													</ng-container>		
												</ng-container>
														<div *ngIf="(!condition.questions||condition.questions[0].status=='NO'||condition.questions[1].status=='YES')&&condition.description">
															<div class='input-box'>
																<p>{{condition.description.label}}</p>
																<div class="textarea">{{condition.description.text}}</div>
															</div>
															<div class="question-line">
																<div class='klistItem5'>
																<p>Were any deficiencies identified that could be categorized as a Critical, PR-90, Priority or Operational Repair?</p>
															</div>
															<div class='klistItem6'>
																<div *ngIf="condition.hasDeficiencies=='YES'" class="textarea">Yes</div>
																<div *ngIf="condition.hasDeficiencies=='NO'" class="textarea">No</div>
																<div *ngIf="!condition.hasDeficiencies" class="textarea"></div>														
															</div>
															</div>
														</div>
														<div *ngIf="condition.hasDeficiencies=='YES'" style="margin-left: 20px;">
															<ng-container *ngFor="let item of condition.deficiencies;let i=index; trackBy:trackByFuntion">
																<div class="question-line">
																	<div class='klistItem5'>
																	<p>{{item.cat}}</p>
																</div>
																<div class='klistItem6'>
																	<div *ngIf="item.status=='YES'" class="textarea">Yes</div>
																	<div *ngIf="item.status=='NO'" class="textarea">No</div>
																	<div *ngIf="!item.status" class="textarea"></div>
																</div>
																</div>
																<div *ngIf="item.status=='YES'" style="margin-left: 10px">
																	<div class="question-line">
																	<div class='klistItem5' style="width:30%">
																		<p>Provide a brief description:</p>
																	</div>
																	<div class='klistItem6'  style="width:70%; text-align: left;">
																		<div class="textarea">{{item.description}}</div>
																	</div>
																</div>
																	<ng-container *ngIf="item.type!='ors'">
																		<div class='klistItem4' style="width:30%">
																			<p>Cost to cure:</p>
																		</div>
																		<div class='klistItem3' style="width:100px">
																			<div class="textarea">{{USDollar.format(item.cost)}}</div>
																		</div>
																	</ng-container>											
																</div>
															</ng-container>
														</div>
														<p *ngIf="condition.intro">Please go to the <i>Problematic Materials and Conditions</i> section at the top of this page for further discussion.</p>			
													
																						
											</div>
											
										</div>
									</div>		 
									</ng-container>
								
							</div>
							<div *ngIf="sec1.otherDetail.ifPresent">
								<div  class="question-line" >
								<div class='klistItem5'>
									<p>{{sec1.otherDetail.ifPresent.question}}</p>
								</div>
								<div class='klistItem6'>
									<div *ngIf="sec1.otherDetail.ifPresent.status=='YES'" class="textarea">Yes</div>
									<div *ngIf="sec1.otherDetail.ifPresent.status=='NO'" class="textarea">No</div>
									<div *ngIf="!sec1.otherDetail.ifPresent.status" class="textarea"></div>	
								</div>
							</div>
						</div>
							<div class="input-box" *ngIf="(!sec1.otherDetail.ifPresent||sec1.otherDetail.ifPresent?.status=='YES')&&(!sec1.otherDetail.providers&&(!sec1.otherDetail.ifConditions))" style="margin-bottom: 4px;">
								<p>Description:</p>
								<div class="textarea">{{sec1.otherDetail.description}}</div>
							</div>
						
					<div *ngIf="(!sec1.otherDetail.ifPresent||sec1.otherDetail.ifPresent.status=='YES')&&(!sec1.otherDetail.ifConditions)">
						<div class="question-line">
							<div class='klistItem5'>
							<p>What is the general condition of these components?</p>
						</div>
						<div class='klistItem6'>
							<div *ngIf="sec1.otherDetail.condition" class="textarea">{{sec1.otherDetail.condition}}</div>
							<div *ngIf="!sec1.otherDetail.condition" class="textarea"></div>	
						</div>
						</div>
						<div *ngIf="sec1.otherDetail.detailQuestion">
							<ng-container *ngFor="let detailQ of sec1.otherDetail.detailQuestion">
								<div class="question-line">
									<div class='klistItem5'>
									<p>{{detailQ.question}}</p>
								</div>
								<div class='klistItem6'>
									<div *ngIf="detailQ.status=='YES'" class="textarea">Yes</div>
									<div *ngIf="detailQ.status=='NO'" class="textarea">No</div>
									<div *ngIf="!detailQ.status" class="textarea"></div>	
								</div>
								</div>
								<div *ngIf="detailQ.status=='NO'&&detailQ.sub" style="margin-left: 10px">
									<div class="question-line">
										<div class='klistItem5'>
										<p>{{detailQ.sub.label}}</p>
									</div>
									<div class='klistItem6'>
										<div *ngIf="detailQ.sub.status=='YES'" class="textarea">Yes</div>
										<div *ngIf="detailQ.sub.status=='NO'" class="textarea">No</div>
										<div *ngIf="!detailQ.sub.status" class="textarea"></div>	
									</div>
									</div>
									<div *ngIf="detailQ.sub.status=='NO'&&detailQ.sub.sub" style="margin-left: 10px">
										<div class="question-line">
											<div class='klistItem5'>
											<p>{{detailQ.sub.sub.label}}</p>
										</div>
										<div class='klistItem6'>
											<div *ngIf="detailQ.sub.sub.status=='YES'" class="textarea">Yes</div>
											<div *ngIf="detailQ.sub.sub.status=='NO'" class="textarea">No</div>
											<div *ngIf="!detailQ.sub.sub.status" class="textarea"></div>
										</div>
										</div>
										<div *ngIf="detailQ.sub.sub.status=='NO'&&detailQ.sub.sub.costs" style="margin-left: 10px;">
											<ng-container *ngFor="let costitem of detailQ.sub.sub.costs; let h=index">
												<div class="question-line">
													<div class='klistItem5'>
												<p>{{costitem.description}}</p>
											</div>
											<div class='klistItem6'>
												<div *ngIf="h>0" class="textarea">{{USDollar1.format(costitem.cost)}}</div>
												<div *ngIf="h==0" class="textarea">{{costitem.cost}}</div>
											</div>
												</div>
											</ng-container>
										</div>
									</div>
								</div>
								<div *ngIf="detailQ.status=='NO'&&detailQ.costs" style="margin-left: 10px;">
									<ng-container *ngFor="let costitem of detailQ.costs; let h=index">
										<div class="question-line">
											<div class='klistItem5'>
											<p>{{costitem.description}}</p>
										</div>
										<div class='klistItem6'>
											<div *ngIf="h>0" class="textarea">{{USDollar1.format(costitem.cost)}}</div>
											<div *ngIf="h==0" class="textarea">{{costitem.cost}}</div>											
										</div>
										</div>
									</ng-container>
								</div>
							</ng-container>
	
						</div>
						<div class="question-line">
							<div class='klistItem5'>
							<p>Did management report any concerns or were any deficiencies identified?</p>
						</div>
						<div class='klistItem6'>
							<div *ngIf="sec1.otherDetail.hasDeficiencies=='YES'" class="textarea">Yes</div>
							<div *ngIf="sec1.otherDetail.hasDeficiencies=='NO'" class="textarea">No</div>
							<div *ngIf="!sec1.otherDetail.hasDeficiencies" class="textarea"></div>
						</div>
						</div>
					</div>
					<div *ngIf="sec1.otherDetail.hasDeficiencies=='YES'" style="margin-left: 20px;">
						<ng-container *ngFor="let item of sec1.otherDetail.deficiencies;let i=index; trackBy:trackByFuntion">
							<div class="question-line">
								<div class='klistItem5'>
								<p>{{item.cat}}</p>
							</div>
							<div class='klistItem6'>
								<div *ngIf="item.status" class="textarea">{{item.status}}</div>
								<div *ngIf="!item.status" class="textarea"></div>
							</div>
							</div>
							<div *ngIf="item.status=='YES'" style="margin-left: 10px;">
								<div class='klistItem4' style="width:30%;">
									<p>Provide a brief description:</p>
								</div>
								<div class='klistItem3'  style="width:70%; text-align: left;">
									<div class="textarea">{{item.description}}</div>
								</div>
								<ng-container *ngIf="item.type!='ors'">
									<div class='klistItem4' style="width:30%">
										<p>Cost to cure:</p>
									</div>
									<div class='klistItem3' style="width:100px">
										<div class="textarea">{{USDollar.format(item.cost)}}</div>
									</div>
								</ng-container>
							</div>
						</ng-container>
					</div>
				</ng-container>
				</div>
	</div>
	</ng-container>
	<ng-container *ngFor="let sec of contents[2].SUB_SECTIONS|slice:-4:-2; trackBy: trackByFuntion; let j=index">
		<h2>{{sec.SECTION_TITLE}}</h2>
		<div style="width:100%;font-size: 12px;">
		<div *ngIf="sec.data.laws" class="question-line">
				<div class='klistItem5'>
				<p>{{sec.data.laws.label}}</p>
			</div>
			<div  class='klistItem6'>
				<div *ngIf="sec.data.laws.status=='YES'" class="textarea">Yes</div>
				<div *ngIf="sec.data.laws.status=='NO'" class="textarea">No</div>
				<div *ngIf="!sec.data.laws.status" class="textarea"></div>
			</div>			
		</div>
		<div class="question-line" *ngIf="sec.data.detail&&sec.data.laws.status=='YES'">
			<div class='klistItem5'>
				<p>{{sec.data.detail.label}}</p>
			</div>
			<div  class='klistItem6'>
				<div *ngIf="sec.data.detail.status=='YES'" class="textarea">Yes</div>
				<div *ngIf="sec.data.detail.status=='NO'" class="textarea">No</div>
				<div *ngIf="!sec.data.detail.status" class="textarea"></div>
			</div>			
		</div>
		<div class="question-line" *ngIf="sec.data.needRepair&&sec.data.laws.status=='NO'">
			<div class='klistItem5'>
				<p>{{sec.data.needRepair.label}}</p>
			</div>
			<div  class='klistItem6'>
				<div *ngIf="sec.data.needRepair.status=='YES'" class="textarea">Yes</div>
				<div *ngIf="sec.data.needRepair.status=='NO'" class="textarea">No</div>
				<div *ngIf="!sec.data.needRepair.status" class="textarea"></div>
			</div>	
				
		</div>
		<div class="input-box" *ngIf="sec.data.laws.status=='NO'&&sec.data.needRepair&&sec.data.needRepair.status=='YES'"> 
			<p style="margin-left: 40px;">Provide a brief description:</p>
			<div class="textarea">{{sec.data.needRepair.description}}</div>
		</div>
			
		<div *ngIf="((j==0&&sec.data.detail.status=='NO')||(j==1&&sec.data.detail.status=='YES'))&&sec.data.laws.status=='YES'">
			<div class="input-box">
				<p>Description:</p>
				<div class="textarea">{{sec.data.description}}</div>
			</div>
			<p *ngIf="j==0">Identify the type of repair required below to correct the deficiency:</p>
			<div style="margin-left: 20px;">
				<ng-container *ngFor="let item of sec.data.deficiencies;let i=index; trackBy:trackByFuntion">
					<div class="question-line">
						<div class='klistItem5'>
						<p>{{item.cat}}</p>
					</div>
					<div class='klistItem6'>
						<div *ngIf="item.status=='YES'" class="textarea">Yes</div>
						<div *ngIf="item.status=='NO'" class="textarea">No</div>
						<div *ngIf="!item.status" class="textarea"></div>
					</div>
					</div>
					<div *ngIf="item.status=='YES'" style="margin-left: 10px">
						<div class='klistItem4' style="width:30%;">
							<p>Provide a brief description:</p>
						</div>
						<div class='klistItem3'  style="width:70%; text-align: left;">
							<div class="textarea">{{item.description}}</div>
						</div>
						<ng-container *ngIf="item.type!='ors'">
							<div class='klistItem4' style="width:30%">
								<p>Cost to cure:</p>
							</div>
							<div class='klistItem3' style="width:100px">
								<div class="textarea">{{USDollar.format(item.cost)}}</div>
							</div>
						</ng-container>
					</div>					
				</ng-container>
			</div>
		</div>	
	</div>
	</ng-container>
	<h2>{{contents[2].SUB_SECTIONS[8].SECTION_TITLE}}</h2>
	<div style="width:100%; font-size:12px">		
		<div class="question-line">
			<div class='klistItem5'>
				<p>Total number of outstanding municipal violations as of the date of the site visit:</p>
			</div>
			<div class='klistItem6'>				
				<div class="textarea">{{contents[2].SUB_SECTIONS[8].data.violationCount}}</div>
			</div>					
			
		</div>
		<div class="input-box">
			<p>Provide a general description of the types of violations, excluding those that are considered life/safety issues or significant deficiencies:</p>
			<div class="textarea">{{contents[2].SUB_SECTIONS[8].data.description}}</div>
		</div>
		<p>List the violations and costs to cure below for those findings that are considered to be life/safety issues or significant deficiencies.</p>
		<p><b>Note: costs and descriptions should not be duplicated elsewhere in this report.</b></p>
		<table>
			<thead>
				<tr>
					<th class="frm-graycell" style="width:70%">Description of violation</th>
					<th class="frm-graycell" style="width:18%">Underlying physical<br> issue resolved?</th>
					<th class="frm-graycell" style="width:12%">Cost to Cure</th>
				</tr>
			</thead>
			<tbody>
				<ng-container *ngFor="let row of contents[2].SUB_SECTIONS[8].data.list">
					<tr>
						<td>{{row.description}}
						</td>
						<td>{{row.status}}
						</td>
						<td>{{USDollar.format(row.cost)}}
						</td>
					</tr>
				</ng-container>
			</tbody>
		</table>
		
		<div style="margin: 10px 0;position:relative; height:20px">
			<button class="frmBtn" style="float:right">Add</button>
			<button class="frmBtn" *ngIf="contents[2].SUB_SECTIONS[8].data.list.length>0">Delete Last Entry</button>		  
		</div>		
	</div>
	<h2>{{contents[2].SUB_SECTIONS[9].SECTION_TITLE}}</h2>
	<div style="width:100%; font-size:12px">
		<p>Provide a history of repairs and capital improvements for the last 12 months along with improvements planned for the next 24 months.</p>
		<table style="width: 100%;">
			<tbody>	
				<ng-container *ngFor="let row of contents[2].SUB_SECTIONS[9].data.list">
				
					<tr>
						<td  class="frm-graycell" rowspan="2"  style="width: 19%;">Description</td>
						<td rowspan="2"  style="width: 60%;">{{row.description}}
						</td>
						<td  class="frm-graycell" colspan="2"  style="width: 6%;text-align: right">Status</td>
						<td  style="width:15%;">
							{{row.status}}
						</td>
					</tr>
					<tr>
						<td  class="frm-graycell" colspan="2"  style="width: 6%;text-align: right;">Cost</td>
						<td  style="width: 15%;">{{USDollar.format(row.cost)}}
						</td>
					</tr>
				</ng-container>
			</tbody>
		</table>
		<div style="margin: 10px 0;position:relative; height:20px">
			<button class="frmBtn" style="float:right">Add</button>
			<button class="frmBtn" *ngIf="contents[2].SUB_SECTIONS[9].data.list.length>0" style="float:right">Delete Last Entry</button>		  
		</div>	
	</div>	
	</div>
</section>
		<section class="page-before" data-section-title="Section IV">
            <header>
                <div class="freddie-mac-header">
                    <div class="freddie-mac-logo">
                        <img src="https://erisservice9.erisinfo.com/exreportw/frmimages/logo.jpg" alt="Freddie Mac Multifamily">
                    </div>
                    <div class="freddie-mac-title">
                        <strong>SBL Physical Risk Report</strong><br>
						<strong>{{contents[0].SUB_SECTIONS[0].data?.AsReportedName?.text}} ({{contents[0].SUB_SECTIONS[0].data?.CityName?.text}}, {{contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.text}})</strong>
                    </div>
                </div>
            </header>
            <h1>Section IV: Environmental Site Assessment</h1>
		<div style="width:100%"><!--Environmental Summary-->
		<h2>{{contents[3].SUB_SECTIONS[0].SECTION_TITLE}}</h2>
		<div style="width:100%; position:relative; font-size: 12px;">
				<div style="width:100%;">
					<ng-container *ngFor="let item of contents[3].SUB_SECTIONS[0].data.summary">
					<div style="display:flex; ;margin:0;padding-top:4px; border-left:4px solid black;border-bottom:1px solid black;width:100%;">
						<label style="margin-left:4px; display:flex; width: 34%;" >{{item.label}}</label>
						<div style="display:flex; width: 13%;">
							<span [ngClass]="{'checkbox-checked1':item.acceptable=='Y', 'checkbox-unchecked1':!item.acceptable||item.acceptable=='N'}">Acceptable</span>
						</div>
						<div *ngIf="!item.requireMMP" style="display:flex; width: 15%;">
							<span [ngClass]="{'checkbox-checked1':item.requireOM=='Y', 'checkbox-unchecked1':!item.requireOM||item.requireOM=='N'}">O&M required</span>
						</div>
						<div *ngIf="item.requireMMP" style="display:flex; width: 15%;">
							<span [ngClass]="{'checkbox-checked1':item.requireMMP=='Y', 'checkbox-unchecked1':!item.requireMMP||item.requireMMP=='N'}">MMP required</span>
						</div>
						<div *ngIf="item.requireMMP" style="display:flex; width: 23%;">
							<span></span>
						</div>
						<div  *ngIf="!item.requireMMP" style="display:flex; width: 23%;">
							<span [ngClass]="{'checkbox-checked1':item.requireFurther=='Y', 'checkbox-unchecked1':!item.requireFurther||item.requireFurther=='N'}">Further testing required</span>
						</div>
						<div style="display:flex; width: 14%;">
							<span [ngClass]="{'checkbox-checked1':item.notacceptable=='Y', 'checkbox-unchecked1':!item.notacceptable||item.notacceptable=='N'}">Not Acceptable</span>
						</div>									
					</div>
					</ng-container>
				</div>
				<div class="question-line" style="width:100%; margin-top:4px; padding:2px;border-left:4px solid black;border-bottom:1px solid black;">
					<div class='klistItem5'>
						<p>{{contents[3].SUB_SECTIONS[0].data.law.label}}</p>
					</div>
					<div class='klistItem6'>
						<div *ngIf="contents[3].SUB_SECTIONS[0].data.law.status=='YES'" class="textarea">Yes</div>
						<div *ngIf="contents[3].SUB_SECTIONS[0].data.law.status=='NO'" class="textarea">No</div>
						<div *ngIf="!contents[3].SUB_SECTIONS[0].data.law.status" class="textarea"></div>
				</div>
				</div>
				<div>
					<ng-container *ngFor="let item of contents[3].SUB_SECTIONS[0].data.questions">
						<div *ngIf="contents[3].SUB_SECTIONS[0].data.summary[item.required][item.field]=='Y'" class="input-box" style="width: 100%; margin-bottom: 4px;">
							<p>{{item.label}}</p>
							<div class="textarea">{{item.description}}</div>
						</div>
					</ng-container>
				</div>
				<p style="margin:2px">Discuss asbestos in the <i>Asbestos</i> section below.</p>
				<p style="margin:2px">Discuss asbestos testing requirements in the <i>Asbestos</i> section below.</p>
				<p style="margin:2px">Discuss lead-based paint in the <i>Lead-Based Paint</i> section below.</p>
				<p style="margin:2px">Discuss lead-based paint testing requirements in the <i>Lead-Based Paint</i> section below.</p>
				<p style="margin:2px">Discuss mold in the <i>Mold</i> section below.</p>
		</div>
		<h2>{{contents[3].SUB_SECTIONS[1].SECTION_TITLE}}</h2>
		<div style="width:100%;position:relative">
				<div style="width:100%;font-size: 12px;">
					<div style="width:100%;margin-left: 0">
						<div class="question-line">
							<div class='klistItem5'>
							<p>{{contents[3].SUB_SECTIONS[1].data.issues[0].label}}</p>
						</div>
						<div class='klistItem6'>
							<div *ngIf="contents[3].SUB_SECTIONS[1].data.issues[0].status=='YES'" class="textarea">Yes</div>
							<div *ngIf="contents[3].SUB_SECTIONS[1].data.issues[0].status=='NO'" class="textarea">No</div>
							<div *ngIf="!contents[3].SUB_SECTIONS[1].data.issues[0].status" class="textarea"></div>
						</div>
						</div>
						<ng-container *ngIf="contents[3].SUB_SECTIONS[1].data.issues[0].status=='YES'">
							<div class="question-line">
								<div class='klistItem5'>
								<p>{{contents[3].SUB_SECTIONS[1].data.issues[1].label}}</p>
							</div>
							<div class='klistItem6'>
								<div *ngIf="contents[3].SUB_SECTIONS[1].data.issues[1].status=='YES'" class="textarea">Yes</div>
								<div *ngIf="contents[3].SUB_SECTIONS[1].data.issues[1].status=='NO'" class="textarea">No</div>
								<div *ngIf="!contents[3].SUB_SECTIONS[1].data.issues[1].status" class="textarea"></div>
							</div>
							</div>
							<div  class="input-box" style="width: 97.5%; margin-bottom: 4px;margin-left: 20px;">
								<p>Describe:</p>
								<div class="textarea">{{contents[3].SUB_SECTIONS[1].data.issues[1].description}}</div>
							</div>
						</ng-container>
					</div>
					<ng-container *ngIf="contents[3].SUB_SECTIONS[1].data.issues[1].status=='YES'">
						<div style="margin-left: 20px;">
							<ng-container *ngFor="let item of contents[3].SUB_SECTIONS[1].data.other">
								<div class="question-line">
									<div class='klistItem5'>
									<p>{{item.label}}</p>
								</div>
								<div class='klistItem6'>
									<div *ngIf="item.status=='YES'" class="textarea">Yes</div>
									<div *ngIf="item.status=='NO'" class="textarea">No</div>
									<div *ngIf="!item.status" class="textarea"></div>
								</div>
								</div>
							</ng-container>
						</div>
							<div *ngIf="contents[3].SUB_SECTIONS[1].data.otherDetail" style="margin-left: 20px;">
								<div class="question-line">
									<div class='klistItem5'>
									<p>{{contents[3].SUB_SECTIONS[1].data.otherDetail.label}}</p>
								</div>
								<div class='klistItem6'>
									<div *ngIf="contents[3].SUB_SECTIONS[1].data.otherDetail.hasDeficiencies=='YES'" class="textarea">Yes</div>
									<div *ngIf="contents[3].SUB_SECTIONS[1].data.otherDetail.hasDeficiencies=='NO'" class="textarea">No</div>
									<div *ngIf="!contents[3].SUB_SECTIONS[1].data.otherDetail.hasDeficiencies" class="textarea"></div>
								</div>
								</div>
							</div>
						
						<div *ngIf="contents[3].SUB_SECTIONS[1].data.otherDetail.hasDeficiencies=='YES'" style="margin-left: 40px;">
							<ng-container *ngFor="let item of contents[3].SUB_SECTIONS[1].data.otherDetail.deficiencies;let i=index; trackBy:trackByFuntion">
								<div class="question-line">
									<div class='klistItem5'>
									<p>{{item.cat}}</p>
								</div>
								<div class='klistItem6'>
									<div *ngIf="item.status=='YES'" class="textarea">Yes</div>
									<div *ngIf="item.status=='NO'" class="textarea">No</div>
									<div *ngIf="!item.status" class="textarea"></div>
								</div>
								</div>
								<div *ngIf="item.status=='YES'" style="margin-left: 10px;">
									<div class='klistItem4' style="width:30%;">
										<p>Provide a brief description:</p>
									</div>
									<div class='klistItem3' style="width:70%;text-align: left;">
										<div class="textarea" style="text-align: left;width:100%" (change)="getAllDeficiencies()">{{item.description}}</div>
									</div>
									<ng-container *ngIf="item.type!='ors'">
										<div class='klistItem4' style="width:30%;">
											<p>Cost to cure:</p>
										</div>
										<div class='klistItem3'  style="width:100px;">
											<div class="textarea">{{USDollar.format(item.cost)}}</div>
										</div><br>
									</ng-container>
								</div>
							</ng-container>
						</div>
					</ng-container>
					
						
					</div>
				</div>
				<h2>{{contents[3].SUB_SECTIONS[2].SECTION_TITLE}}</h2>
				
				<div style="width:100%;font-size: 12px;">
					<ng-container *ngFor="let items of contents[3].SUB_SECTIONS[2].data">
						<div>
							<div class="question-line">
								<div class='klistItem5'>
								<p>{{items.issues[0].label}}</p>
							</div>
							<div class='klistItem6'>
								<div *ngIf="items.issues[0].status=='YES'" class="textarea">Yes</div>
								<div *ngIf="items.issues[0].status=='NO'" class="textarea">No</div>
								<div *ngIf="!items.issues[0].status" class="textarea"></div>
							</div>
							</div>
							<ng-container *ngIf="items.issues[0].status=='YES'">
								<p>{{items.issues[0].descriptionLabel}}</p>
								<table style="margin: 4px 0;">
									<thead>
										<th class="frm-graycell" style="width:86%">Location</th>
										<th class="frm-graycell" style="width:14%">Condition</th>
										<th class="frm-graycell" style="width:14%">Potential for disturbance</th>
									</thead>
									<tbody>
										<ng-container *ngFor="let row of items.issues[0].materials">
											<tr>
												<td>{{row.location}}</td>
												<td>{{row.condition}}</td>
												<td>{{row.disturbance}}</td>
											</tr>
										</ng-container>
									</tbody>
								</table>
								<div style="margin: 10px 0;position:relative; height:20px">
									<button class="frmBtn" style="float:right" >Add</button>
									<button *ngIf="items.issues[0].materials.length>1" class="frmBtn" style="float:right">Delete Last Entry</button>		  
								</div>									
									<div  class="question-line" style=" margin-left: 20px;">
										<div class='klistItem5'>
										<p>{{items.issues[1].label}}</p>
									</div>
									<div   class='klistItem6'>
										<div *ngIf="items.issues[1].status=='YES'" class="textarea">Yes</div>
										<div *ngIf="items.issues[1].status=='NO'" class="textarea">No</div>
										<div *ngIf="!items.issues[1].status" class="textarea"></div>									
									</div>
								</div>
								<div  *ngIf="items.issues[1].status=='YES'" style="margin-left: 20px;">
									<div class="input-box"  *ngIf="items.issues[1].moreinfo">
										<p>{{items.issues[1].descriptionLabel}}</p>
										<div class="textarea">{{items.issues[1].description}}</div>
									</div>
									<div class="question-line">
										<div class='klistItem5'>
										<p>{{items.issues[2].label}}</p>
									</div>
									<div class='klistItem6'>
										<div *ngIf="items.issues[2].status=='YES'" class="textarea">Yes</div>
										<div *ngIf="items.issues[2].status=='NO'" class="textarea">No</div>
										<div *ngIf="!items.issues[2].status" class="textarea"></div>
									</div>
									</div>
									<div class="input-box" *ngIf="items.issues[2].status=='YES'">
										<p>Discuss the findings:</p>
										<div class="textarea">{{items.issues[2].description}}</div>
									</div>
								</div>
								
						</ng-container>
					</div>
							<ng-container *ngIf="items.issues[0].status=='YES'">
							<div *ngIf="items.otherDetail" style="margin-left: 20px;">
								<div class="question-line">
									<div class='klistItem5'>
						
								<p>{{items.otherDetail.label}}</p>
							</div>
							<div class='klistItem6'>
								<div *ngIf="items.otherDetail.hasDeficiencies=='YES'" class="textarea">Yes</div>
									<div *ngIf="items.otherDetail.hasDeficiencies=='NO'" class="textarea">No</div>
									<div *ngIf="!items.otherDetail.hasDeficiencies" class="textarea"></div>							
							</div>
								</div>
						
						<div *ngIf="items.otherDetail.hasDeficiencies=='YES'"style="margin-left: 20px;">
							<ng-container *ngFor="let item of items.otherDetail.deficiencies;let i=index; trackBy:trackByFuntion">
								<div class="question-line">
									<div class='klistItem5'>
									<p>{{item.cat}}</p>
								</div>
								<div class='klistItem6'>
									<div *ngIf="item.status=='YES'" class="textarea">Yes</div>
									<div *ngIf="item.status=='NO'" class="textarea">No</div>
									<div *ngIf="!item.status" class="textarea"></div>
								</div>
								</div>
								<div *ngIf="item.status=='YES'" style="margin-left: 10px;">
									<div class='klistItem4' style="width:30%;">
										<p>Provide a brief description:</p>
									</div>
									<div class='klistItem3' style="width:70%;text-align: left;">
										<div class="textarea">{{item.description}}</div>
									</div>
									<ng-container *ngIf="item.type!='ors'">
										<div class='klistItem4' style="width:30%;">
											<p>Cost to cure:</p>
										</div>
										<div class='klistItem3' style="width:100px;">
											<div class="textarea">{{USDollar.format(item.cost)}}</div>
										</div><br>
									</ng-container>
								</div>
							</ng-container>
						</div>
					</div>
					</ng-container>
				
				</ng-container>	
					
				</div>
				<h2>{{contents[3].SUB_SECTIONS[3].SECTION_TITLE}}</h2>
				<div style="width:100%;font-size: 12px;">
					<div class="question-line">
						<div class='klistItem5'>
								<p>{{contents[3].SUB_SECTIONS[3].data.issues[0].label}}</p>
							</div>
							<div class='klistItem6'>
								<div *ngIf="contents[3].SUB_SECTIONS[3].data.issues[0].status=='YES'" class="textarea">Yes</div>
									<div *ngIf="contents[3].SUB_SECTIONS[3].data.issues[0].status=='NO'" class="textarea">No</div>
									<div *ngIf="!contents[3].SUB_SECTIONS[3].data.issues[0].status" class="textarea"></div>									
							</div>
						</div>
							<ng-container *ngIf="contents[3].SUB_SECTIONS[3].data.issues[0].status=='YES'">
								<p>{{contents[3].SUB_SECTIONS[3].data.issues[0].descriptionLabel}}</p>
								<table>
									<thead>
										<th class="frm-graycell" style="width:86%">Location</th>
										<th class="frm-graycell" style="width:14%">Condition</th>
										
									</thead>
									<tbody>
										<ng-container *ngFor="let row of contents[3].SUB_SECTIONS[3].data.issues[0].materials">
											<tr>
												<td>{{row.location}}</td>
												<td>{{row.condition}}</td>
												
											</tr>
										</ng-container>
									</tbody>
								</table>
								<div style="margin: 10px 0;position:relative; height:20px">
									<button class="frmBtn" style="float:right">Add</button>
									<button *ngIf="contents[3].SUB_SECTIONS[3].data.issues[0].materials.length>1" class="frmBtn" style="float:right">Delete Last Entry</button>		  
								</div>									
							</ng-container>
					
							<ng-container *ngIf="contents[3].SUB_SECTIONS[3].data.issues[0].status=='YES'">
								<div *ngIf="contents[3].SUB_SECTIONS[3].data.otherDetail" style="margin-left: 20px;">
									<div class="question-line">
										<div class='klistItem5'>
									<p>{{contents[3].SUB_SECTIONS[3].data.otherDetail.label}}</p>
								</div>
								<div class='klistItem6'>
									<div *ngIf="contents[3].SUB_SECTIONS[3].data.otherDetail.hasDeficiencies=='YES'" class="textarea">Yes</div>
									<div *ngIf="contents[3].SUB_SECTIONS[3].data.otherDetail.hasDeficiencies=='NO'" class="textarea">No</div>
									<div *ngIf="!contents[3].SUB_SECTIONS[3].data.otherDetail.hasDeficiencies" class="textarea"></div>			
								</div>
									</div>
						
						<div *ngIf="contents[3].SUB_SECTIONS[3].data.otherDetail.hasDeficiencies=='YES'"style="margin-left: 20px;">
							<ng-container *ngFor="let item of contents[3].SUB_SECTIONS[3].data.otherDetail.deficiencies;let i=index; trackBy:trackByFuntion">
								<div class="question-line">
									<div class='klistItem5'>
									<p>{{item.cat}}</p>
								</div>
								<div class='klistItem6'>
									<div *ngIf="item.status=='YES'" class="textarea">Yes</div>
									<div *ngIf="item.status=='NO'" class="textarea">No</div>
									<div *ngIf="!item.status" class="textarea"></div>
								</div>
								</div>
								<div *ngIf="item.status=='YES'" style="margin-left: 10px;">
									<div class='klistItem4' style="width:30%;">
										<p>Provide a brief description:</p>
									</div>
									<div class='klistItem3' style="width:70%;text-align: left;">
										<div class="textarea">{{item.description}}</div>
									</div>
									<ng-container *ngIf="item.type!='ors'">
										<div class='klistItem4' style="width:30%;">
											<p>Cost to cure:</p>
										</div>
										<div class='klistItem3' style="width:100px">
											<div class="textarea">{{USDollar.format(item.cost)}}</div>
										</div><br>
									</ng-container>
								</div>
							</ng-container>
						</div>
					</div>
					</ng-container>					
				</div>	
				<h2>{{contents[3].SUB_SECTIONS[4].SECTION_TITLE}}</h2>
				
				<div style="width:100%;font-size: 12px;">
					
					
					<div class="question-line">
						<div class='klistItem5'>
								<p>{{contents[3].SUB_SECTIONS[4].data.issues[0].label}}</p>
							</div>
							<div class='klistItem6'>
								<div *ngIf="contents[3].SUB_SECTIONS[4].data.issues[0].status=='YES'" class="textarea">Yes</div>
									<div *ngIf="contents[3].SUB_SECTIONS[4].data.issues[0].status=='NO'" class="textarea">No</div>
									<div *ngIf="!contents[3].SUB_SECTIONS[4].data.issues[0].status" class="textarea"></div>
							</div>
						</div>
							
							<ol>
								<ng-container *ngFor="let item of contents[3].SUB_SECTIONS[4].data.issues[0].items">
									<li style="font-weight: normal;">{{item}}</li>
								</ng-container>
							</ol>
							<div class="input-box" *ngIf="contents[3].SUB_SECTIONS[4].data.issues[0].status=='NO'">
								<p>{{contents[3].SUB_SECTIONS[4].data.issues[0].descriptionLabel}}</p>
								<div class="textarea">{{contents[3].SUB_SECTIONS[4].data.issues[0].description}}</div>								
							</div>
							<div *ngIf="contents[3].SUB_SECTIONS[4].data.other">
								<ng-container *ngFor="let item of contents[3].SUB_SECTIONS[4].data.other">
									<div class="question-line">
										<div class='klistItem5'>
										<p>{{item.label}}</p>
									</div>
									<div class='klistItem6'>
										<div *ngIf="item.status=='YES'" class="textarea">Yes</div>
									<div *ngIf="item.status=='NO'" class="textarea">No</div>
									<div *ngIf="!item.status" class="textarea"></div>
									</div>
									</div>
									<div class="input-box" *ngIf="item.status=='YES'">
										<p>{{item.descriptionLabel}}</p>
										<div class="textarea">{{item.description}}</div>								
									</div>
								</ng-container>
							</div>
							<ng-container *ngIf="contents[3].SUB_SECTIONS[4].data.other[0].status=='YES'">
								<div *ngIf="contents[3].SUB_SECTIONS[4].data.otherDetail"style="margin-left: 20px;">
									<div class="question-line">
										<div class='klistItem5'>
									<p>{{contents[3].SUB_SECTIONS[4].data.otherDetail.label}}</p>
								</div>
								<div class='klistItem6'>
									<div *ngIf="contents[3].SUB_SECTIONS[4].data.otherDetail.hasDeficiencies=='YES'" class="textarea">Yes</div>
									<div *ngIf="contents[3].SUB_SECTIONS[4].data.otherDetail.hasDeficiencies=='NO'" class="textarea">No</div>
									<div *ngIf="!contents[3].SUB_SECTIONS[4].data.otherDetail.hasDeficiencies" class="textarea"></div>
								</div>
									</div>
						
						<div *ngIf="contents[3].SUB_SECTIONS[4].data.otherDetail.hasDeficiencies=='YES'" style="margin-left: 20px;">
							<ng-container *ngFor="let item of contents[3].SUB_SECTIONS[4].data.otherDetail.deficiencies;let i=index; trackBy:trackByFuntion">
								<div class="question-line">
									<div class='klistItem5'>
									<p>{{item.cat}}</p>
								</div>
								<div class='klistItem6'>
									<div *ngIf="item.status=='YES'" class="textarea">Yes</div>
									<div *ngIf="item.status=='NO'" class="textarea">No</div>
									<div *ngIf="!item.status" class="textarea"></div>
								</div>
								</div>
								<div *ngIf="item.status=='YES'" style="margin-left: 10px;">
									<div class='klistItem4' style="width:30%;">
										<p>Provide a brief description:</p>
									</div>
									<div class='klistItem3' style="width:70%; text-align: left;">
										<div class="textarea" >{{item.description}}</div>
									</div>
									<ng-container *ngIf="item.type!='ors'">
										<div class='klistItem4' style="width:30%;">
											<p>Cost to cure:</p>
										</div>
										<div class='klistItem3' style="width:100px;">
											<div class="textarea">{{USDollar.format(item.cost)}}</div>
										</div><br>
									</ng-container>
								</div>
							</ng-container>
						</div>
					</div>
					</ng-container>				
				</div>		
		</div>
	
	</section>
	<section class="page-before" data-section-title="Section V">
		<header>
			<div class="freddie-mac-header">
				<div class="freddie-mac-logo">
					<img src="https://erisservice9.erisinfo.com/exreportw/frmimages/logo.jpg" alt="Freddie Mac Multifamily">
				</div>
				<div class="freddie-mac-title">
					<strong>SBL Physical Risk Report</strong><br>
					<strong>{{contents[0].SUB_SECTIONS[0].data?.AsReportedName?.text}} ({{contents[0].SUB_SECTIONS[0].data?.CityName?.text}}, {{contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.text}})</strong>
				</div>
			</div>
		</header>
		<h1>Section V: List of Repairs and Capital Needs Over the Loan Term</h1>
		<h2>{{contents[4].SUB_SECTIONS[0].SECTION_TITLE}}</h2>
		<div style="width:100%;font-size: 12px;">
		<p>{{contents[4].SUB_SECTIONS[0].data.intro}}</p>
		<div style="width:100%; display:inline; position:relative">
			<ng-container *ngFor="let repairdata of contents[4].SUB_SECTIONS[0].data.summarylabel; let i=index; trackBy:trackByFuntion">
				<ng-container *ngIf="contents[4].SUB_SECTIONS[0].data.summarydata[repairdata.field].length>0" >
				<p style="border-bottom:2px solid black;border-left:2px solid black;width:30%; margin-bottom: 0; font-size: 14px;font-weight: bold; ">{{repairdata.label}}</p>
				<table style="margin-top: 0;border: none;margin-bottom: 20px;">
					<thead>
						<ng-container *ngFor="let col of repairdata.cols; let j=index; trackBy:trackByFuntion">
							<th style="border:none; background-color: white;" [ngStyle]="{'width':repairdata.space[j],'text-align':j==2?'center':'left'}">{{col}}</th>
						</ng-container>					
					</thead>
					<tbody>
						<ng-container *ngFor="let rowdata of contents[4].SUB_SECTIONS[0].data.summarydata[repairdata.field]; let j=index; trackBy:trackByFuntion">
							<tr>
								<ng-container *ngFor="let cell of repairdata.rows">
									<td style="border:1px black solid; border-collapse: collapse;" *ngIf="cell!='cost'">{{rowdata[cell]}}</td>
									<td style="text-align: center;border:1px black solid; border-collapse: collapse;" *ngIf="cell=='cost'" >{{USDollar.format(rowdata[cell])}}</td>
								</ng-container>
							</tr>						
						</ng-container>
						<ng-container *ngIf="repairdata.field!='ors';">
							<tr>
								<td colspan="2" style="text-align: right;border:none">
									TOTAL
								</td>
								<td class="frm-graycell"  style="text-align: center;font-size:16px">
									{{USDollar.format(repairdata.total)}}
								</td>
							</tr>					
					</ng-container>
					</tbody>
				</table>
			</ng-container>
			</ng-container>

			
				
		</div>		
	</div>
	<div style="width:100%"><!--Repair Costs-->
		<h2>{{contents[4].SUB_SECTIONS[1].SECTION_TITLE}}</h2>
		<div style="width:100%;font-size: 12px;">			
				<div style="width:100%">					
					<div class="question-line">
						<div class='klistItem5'>
							<p>{{contents[4].SUB_SECTIONS[1].data.label}}</p>
						</div>
						<div class='klistItem6'>
							<div *ngIf="contents[4].SUB_SECTIONS[1].data.status=='YES'" class="textarea">Yes</div>
							<div *ngIf="contents[4].SUB_SECTIONS[1].data.status=='NO'" class="textarea">No</div>
							<div *ngIf="!contents[4].SUB_SECTIONS[1].data.status" class="textarea"></div>
							
						</div>
					</div>
						<div  class="input-box" *ngIf="contents[4].SUB_SECTIONS[1].data.status=='YES'" style="width: 100%; margin-bottom: 4px;">
							<p>{{contents[4].SUB_SECTIONS[1].data.descriptionLabel}}</p>
							<div class="textarea" style="width: 100%;">{{contents[4].SUB_SECTIONS[1].data.description}}</div>	
						</div>
					
				</div>
			</div>		
	</div>
	<div style="width:100%"><!--Overall Property Condition Rating/Capital Needs Over the Loan Term-->
		<h2>{{contents[4].SUB_SECTIONS[2].SECTION_TITLE}}</h2>
		<p>{{contents[4].SUB_SECTIONS[2].data.intro}}</p>
		<div style="width:100%; display:inline; position:relative; font-size: 12px;">
				<div style="width:90%;display:inline-block; margin-left: 30px;">
					<div style="margin-top: 20px; border-bottom: 2px solid black;">
						<span type="radio" [ngClass]="{'radio-checked':contents[4].SUB_SECTIONS[2].data.rate=='Excellent', 'radio-unchecked':contents[4].SUB_SECTIONS[2].data.rate!='Excellent'}"><label class="rateItem">Excellent</label></span>
					</div>
					<p>Thee Property is new or maintained in like new condition with proactive maintenance practices, thus exhibiting no deferred maintenance or life safety/code issues.</p>
					<div style="margin-top: 20px; border-bottom: 2px solid black;">
						<span type="radio" [ngClass]="{'radio-checked':contents[4].SUB_SECTIONS[2].data.rate=='Above Average', 'radio-unchecked':contents[4].SUB_SECTIONS[2].data.rate!='Above Average'}"><label class="rateItem">Above Average</label></span>
					</div>
					<p>The Property is fully functional, well maintained, exhibits minimal wear and tear and no deferred maintenance or life safety/code issues. Any identified repairs are due to recent events (e.g., a wind storm or a burst pipe) or are very limited in scope (routine maintenance). Low reserves are required.</p>
					<div style="margin-top: 20px; border-bottom: 2px solid black;">
						<span type="radio" [ngClass]="{'radio-checked':contents[4].SUB_SECTIONS[2].data.rate=='Average', 'radio-unchecked':contents[4].SUB_SECTIONS[2].data.rate!='Average'}"><label class="rateItem">Average</label></span>
					</div>
					
					<p>The Property is fully functional and generally well maintained. It may exhibit customary wear and tear based on age and may have minimal deferred maintenance. Any life safety/code issues can be readily corrected as part of the operating budget and are isolated in nature. Moderate reserves are required.</p>
					<div style="margin-top: 20px; border-bottom: 2px solid black;">
						<span type="radio" [ngClass]="{'radio-checked':contents[4].SUB_SECTIONS[2].data.rate=='Below Average', 'radio-unchecked':contents[4].SUB_SECTIONS[2].data.rate!='Below Average'}"><label class="rateItem">Below Average</label></span>
					</div>
					
					<p>The Property exhibits pervasive wear and tear, some limits in functionality and deferred maintenance issues. Life safety/code issues are significant and/or numerous and involve substantial cost. High reserves are required.</p>
					<div  style="margin-top: 20px; border-bottom: 2px solid black;">
						<span type="radio" [ngClass]="{'radio-checked':contents[4].SUB_SECTIONS[2].data.rate=='Inferior', 'radio-unchecked':contents[4].SUB_SECTIONS[2].data.rate!='Inferior'}"><label class="rateItem">Inferior</label></span>
					</div>
					
					<p>The Property exhibits inferior/deteriorating conditions and some limits in functionality. Deferred maintenance is pervasive and will be costly to cure. Multiple life safety/code issues are identified and involve significant cost. Extensive repairs are required.</p>
					<div  class="input-box"style="width: 100%; margin-bottom: 4px;">
						<p style="margin-top: 30px;">{{contents[4].SUB_SECTIONS[2].data.descriptionLabel}}</p>
						<div class="textarea" style="width: 100%;">{{contents[4].SUB_SECTIONS[2].data.description}}</div>	
					</div>
									
				</div>
			</div>		
	</div>	
	
	</section>
	<section class="page-before" data-section-title="Section VI">
		<header>
			<div class="freddie-mac-header">
				<div class="freddie-mac-logo">
					<img src="https://erisservice9.erisinfo.com/exreportw/frmimages/logo.jpg" alt="Freddie Mac Multifamily">
				</div>
				<div class="freddie-mac-title">
					<strong>SBL Physical Risk Report</strong><br>
					<strong>{{contents[0].SUB_SECTIONS[0].data?.AsReportedName?.text}} ({{contents[0].SUB_SECTIONS[0].data?.CityName?.text}}, {{contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.text}})</strong>
				</div>
			</div>
		</header>
		<h1>Section VI: Definitions</h1>
		<div style="width:100%"><!--Section VI: Definitions-->
		<h2>{{contents[5].SUB_SECTIONS[0].SECTION_TITLE}}</h2>
		<div style="width:100%; display:inline; position:relative;font-size: 12px">
			<div style="border-bottom: 1px solid black;margin-top: 4px;">
				<p class="rateItem">Excellent</p>
			</div>
			<p style="margin-bottom: 20px;">The component is new or maintained in like new condition with proactive maintenance practices, thus exhibiting no deferred maintenance or life safety/code issues.</p>
				<p class="rateItem">Above Average</p>
				<hr class="line1">
			<p style="margin-bottom: 20px;">The component is fully functional, well maintained, exhibits minimal wear and tear and no deferred maintenance or life safety/code issues. Any identified repairs are due to recent events (e.g., a wind storm or a burst pipe) or are very limited in scope (routine maintenance). Low reserves are required.</p>	
				<p class="rateItem">Average</p>
				<hr class="line1">
			<p style="margin-bottom: 20px;">The component is fully functional and generally well maintained. It may exhibit customary wear and tear based on age and may have minimal deferred maintenance. Any life/safety codes issues can be readily corrected as part of the operating budget and are isolated in nature. Moderate reserves are required.</p>	
				<p class="rateItem">Below Average</p>
				<hr class="line1">
			<p style="margin-bottom: 20px;">The component exhibits pervasive wear and tear, some limits in functionality and deferred maintenance issues. Life safety/code issues are significant and/or numerous and involve substantial cost. High reserves are required.</p>	
				<p class="rateItem">Inferior</p>
				<hr class="line1">
			<p style="margin-bottom: 20px;">The component exhibits inferior/deteriorating conditions and some limits in functionality. Deferred maintenance is pervasive and will be costly to cure. Multiple life safety/code issues are identified and involve significant cost. Extensive repairs are required.</p>		
		</div>		
	</div>
	<div style="width:100%"><!--Section VI: Definitions-->
		<h2>{{contents[5].SUB_SECTIONS[1].SECTION_TITLE}}</h2>
		<div style="width:100%; display:inline; position:relative;font-size: 12px;">
			
				<p class="rateItem">Critical Repairs</p>
				<hr class="line1">
			<p style="margin-bottom: 20px;">These are repairs and replacements that significantly impact habitability, value, income or marketability and that must be corrected before Freddie Mac will proceed with the transaction.</p>
				<p class="rateItem">PR-90 Repairs</p>
				<hr class="line1">
			<p>These are corrective actions that must be completed within 90 days, and are limited to:</p>
			<ul  style="list-style-type:disc;margin-left: 20px;margin-bottom: 30px;">
				<li>Imminent life safety hazards</li>
				<li>Ongoing substantive damage to the property</li>
			
			</ul>
			
				<p class="rateItem">Priority Repairs</p>
				<hr class="line1">
			<p>These are repairs and replacements that are significant and must be addressed as soon as possible. Priority Repairs consist of:</p>
			<ul  style="list-style-type:disc;margin-left: 20px;">
				<li>All non-imminent life safety hazards</li>
				<li>Violations of any federal, State or local law, ordinance or code relating to zoning, subdivision and use, building and housing accessibility (including the Americans with Disabilities and Fair Housing Acts), health matters or fire safety</li>
				<li>Material deficiencies *</li>
				<li>Significant deferred maintenance *</li>
			</ul>
			<label style="float:right;font-size: 10px;">* Additional guidance can be found in Section 62.3(b) of the Freddie Mac Multifamily Seller/Servicer Guide</label>
			
				<p class="rateItem" style="margin-top: 30px;">Operational Repairs</p>
			<hr class="line1">
			<p>These are repairs and replacements that consist of Minor Deficiencies, Minor Deferred Maintenance and Handicap Accessibility Enhancements that are expected to be completed by the Borrower as part of a repairs and maintenance budget and that cannot be reasonably resolved by Routine Maintenance. Operational Repairs consist of:</p>
			<ul  style="list-style-type:disc;margin-left: 20px;">
				<li>Minor deficiencies *</li>
				<li>Minor deferred maintenance *</li>
				<li>Handicap Accessibility Enhancements *</li>				
			</ul>
			<label style="float:right;font-size: 10px;">* Additional guidance can be found in Section 62.3(b) of the Freddie Mac Multifamily Seller/Servicer Guide</label>
		</div>		
	</div>	
</section>	
	</ng-container>
</div>
<div #frmContent id="frmContent" style='display:none' *ngIf="curReport?.PHASE1_TYPE=='1103'&&contents.length>0">
	<section class="page-before" data-section-title="Section I">
            <header>
                <div style="width: 100%;margin: 10px 0;">                    
                    <img src="https://erisservice9.erisinfo.com/exreportw/frmimages/1103logo.PNG" style="width:100%;height:50px" alt="Freddie Mac Multifamily">					
                </div>
            </header>
            <h1>Section I: Summary</h1>
            <h2>Mortgage, Consultant and Property Information</h2>
            <table class="section-header">
                <tr>
                    <td width="25%">
                        <div>
                            <p *ngIf="contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.text"></p>
							<label>Freddie Mac loan number</label>
                        </div>
                    </td>
                    <td width="25%">
                        <div>
                            <p [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate|date:'MMMM dd, yyyy'"></p>
                            <label>Report date</label>
                        </div>
                    </td>
                    <td colspan="2" width="50%">
                        <div>
							<p *ngIf="contents[0].SUB_SECTIONS[0].data?.AsReportedName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AsReportedName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[0].data?.AsReportedName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AsReportedName?.text"></p>
                            <label>Property name</label>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" class="fh">
                        <div>
                            <p *ngIf="contents[0].SUB_SECTIONS[0].data?.AccountName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AccountName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[0].data?.AccountName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AccountName?.text"></p>
                            <label>Seller/Servicer name</label>
                        </div>
                    </td>
                    <td colspan="2" class="fh">
                        <div>
							<p *ngIf="contents[0].SUB_SECTIONS[0].data?.AddressLineText?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AddressLineText?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[0].data?.AddressLineText?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AddressLineText?.text"></p>
							<label>Address</label>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="fh">
                        <div>
							<p *ngIf="contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.text"></p>
							<label>Seller/Servicer number</label>
                        </div>
                    </td>
                    <td>
                        <div>
                            <p [innerHTML]="contents[0].SUB_SECTIONS[0].data?.VisitDate|date:'MMMM dd, yyyy'"></p>
                            <label>Inspection date</label>
                        </div>
                    </td>
                    <td colspan="2" class="fh">
                        <div>
                            <p><!--<span style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.CityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;  
								<span style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp; 
								<span style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span></p>
                            <label>City, State, Zip</label>-->
							<ng-container *ngIf="contents[0].SUB_SECTIONS[0].data?.CityName?.html"><span style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.CityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
							<ng-container *ngIf="!contents[0].SUB_SECTIONS[0].data?.CityName?.html&&contents[0].SUB_SECTIONS[0].data?.CityName?.text"><span style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.CityName?.text"></span>,&nbsp;</ng-container>
							<ng-container *ngIf="contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.html"><span style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
							<ng-container *ngIf="!contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.html&&contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.text"><span style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.text"></span>,&nbsp;</ng-container>
							<span *ngIf="contents[0].SUB_SECTIONS[0].data?.PostalCode?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>
							<span *ngIf="!contents[0].SUB_SECTIONS[0].data?.PostalCode?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PostalCode?.secHtml?.text"></span></p>
							<label>City, State, Zip</label>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2">
                        <div>
                            <p *ngIf="contents[0].SUB_SECTIONS[0].data?.FirmName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FirmName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[0].data?.FirmName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FirmName?.text"></p>
							<label>Environmental consultant (firm name)</label>
                        </div>
                    </td>
                    <td class="fh">
                        <div>
                            
							<p *ngIf="contents[0].SUB_SECTIONS[0].data?.Units?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.Units?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[0].data?.Units?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.Units?.text"></p>
                            <label>Number of units</label>
                        </div>
                    </td>
                    <td>
                        <div>
                            
							<p *ngIf="contents[0].SUB_SECTIONS[0].data?.ApartmentUnits?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.ApartmentUnits?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[0].data?.ApartmentUnits?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.ApartmentUnits?.text"></p>
                            <label>Number of residential buildings</label>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" class="fh">
                        <div>
                           <p *ngIf="contents[0].SUB_SECTIONS[0].data?.FirmAddressLineText?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FirmAddressLineText?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[0].data?.FirmAddressLineText?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FirmAddressLineText?.text"></p>
                            <label>Address</label>
                        </div>
                    </td>
            
                    <td class="fh">
                        <div>
                            
							<p *ngIf="contents[0].SUB_SECTIONS[0].data?.GroundUnits?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.GroundUnits?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[0].data?.GroundUnits?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.GroundUnits?.text"></p>
                            <label>Number of ground floor units</label>
                        </div>
                    </td>
					<td>
                        <div>
                         
							<p *ngIf="contents[0].SUB_SECTIONS[0].data?.BuildYear?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.BuildYear?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[0].data?.BuildYear?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.BuildYear?.text"></p>
                            <label>Date of construction</label>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" class="fh">
                        <div>
                            <p><!--<span style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FirmCityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;
								<span style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FirmStateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;
								<span style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FirmPostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span></p>
                            <label>City, State, Zip</label>-->
							<ng-container *ngIf="contents[0].SUB_SECTIONS[0].data?.FirmCityName?.html"><span style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FirmCityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
							<ng-container *ngIf="!contents[0].SUB_SECTIONS[0].data?.FirmCityName?.html&&contents[0].SUB_SECTIONS[0].data?.FirmCityName?.text"><span style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FirmCityName?.text"></span>,&nbsp;</ng-container>
							<ng-container *ngIf="contents[0].SUB_SECTIONS[0].data?.FirmStateUspsCode?.html"><span style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FirmStateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
							<ng-container *ngIf="!contents[0].SUB_SECTIONS[0].data?.FirmStateUspsCode?.html&&contents[0].SUB_SECTIONS[0].data?.FirmStateUspsCode?.text"><span style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FirmStateUspsCode?.text"></span>,&nbsp;</ng-container>
							<span *ngIf="contents[0].SUB_SECTIONS[0].data?.FirmPostalCode?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FirmPostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>
							<span *ngIf="!contents[0].SUB_SECTIONS[0].data?.FirmPostalCode?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FirmPostalCode?.secHtml?.text"></span></p>
							<label>City, State, Zip</label>
                        </div>
                    </td>
                    <td colspan="2">
                       
                    </td>
                </tr>
                <tr>
                    <td colspan="2" class="fh">
                        <div>
                            <!--<p [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FirmPhoneNumber?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>-->
                            <p>{{contents[0].SUB_SECTIONS[0].data?.FirmPhoneNumber.formateText}}</p>
							<label>Telephone number</label>
                        </div>
                    </td>
                    <td colspan="2" class="fh">
                        <div>
							<p><ng-container *ngIf="contents[0].SUB_SECTIONS[0].data?.OnsiteName?.html"><span style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.OnsiteName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
								<ng-container *ngIf="!contents[0].SUB_SECTIONS[0].data?.OnsiteName?.html&&contents[0].SUB_SECTIONS[0].data?.OnsiteName?.text"><span style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.OnsiteName?.text"></span>,&nbsp;</ng-container>
								<span *ngIf="contents[0].SUB_SECTIONS[0].data?.OnsiteTitle?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.OnsiteTitle?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>
								<span *ngIf="!contents[0].SUB_SECTIONS[0].data?.OnsiteTitle?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.OnsiteTitle?.text"></span></p>
							<label>On-site contact (with title)</label>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" class="fh">
                        <div>
							
							<p *ngIf="contents[0].SUB_SECTIONS[0].data?.InspectorName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.InspectorName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!contents[0].SUB_SECTIONS[0].data?.InspectorName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.InspectorName?.text"></p>
                            
                            <label>Name of inspector</label>
                        </div>
                    </td>
                    <td colspan="2" class="fh">
                        <div>
                            <!--<p [innerHTML]="contents[0].SUB_SECTIONS[0].data?.OnsitePhoneNo?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>-->
                            <p>{{contents[0].SUB_SECTIONS[0].data?.OnsitePhoneNo.formateText}}</p>
							<label>On-site contact telephone number</label>
                        </div>
                    </td>
                </tr>
            </table>
            <h2>{{contents[0].SUB_SECTIONS[1].SECTION_TITLE}}</h2>
			<div style="font-size: 12px; ">
				<p style="margin: 10px 0;">Check the applicable result for each hazard and provide costs where appropriate.</p>
				<table style="border: 1px solid black;border-left:4px solid black;text-align: center;margin-bottom: 20px;">
					<thead>
						<th style="width:29%; text-align: left">Environmental Issue</th>
						<th style="width:11%">Acceptable</th>
						<th style="width:16%" >Indicate if O&M<br>Program Required</th>
						<th style="width:11%" >Mitigation<br>Cost</th>
						<th style="width:11%" >Additional<br>Information<br>Required</th>
						<th style="width:22%" colspan="2">Section and<br>Page Number(s)</th>					
					</thead>
					<tbody>
						<ng-container *ngFor="let rowdata of contents[0].SUB_SECTIONS[1].data.summary">
							<tr>
								<td style="text-align: left">{{rowdata.label}}</td>
								<td>
									<img *ngIf="rowdata.acceptable=='Y'" style="width: 13px; height: 13px;" src="https://erisservice9.erisinfo.com/exreportw/frmimages/checkbox-checked-shadow.jpg" alt="checked">
									<img *ngIf="rowdata.acceptable!='Y'" style="width: 13px; height: 13px;"  src="https://erisservice9.erisinfo.com/exreportw/frmimages/checkbox-unchecked-shadow.jpg" alt="unchecked">
								</td>
								<td  style="position: relative;width:19%">
									<img *ngIf="rowdata.requireOM=='Y'||rowdata.requireMMP=='Y'" style="width: 13px; height: 13px;" src="https://erisservice9.erisinfo.com/exreportw/frmimages/checkbox-checked-shadow.jpg" alt="checked">
									<img *ngIf="!(rowdata.requireOM=='Y'||rowdata.requireMMP=='Y')" style="width: 13px; height: 13px;"  src="https://erisservice9.erisinfo.com/exreportw/frmimages/checkbox-unchecked-shadow.jpg" alt="unchecked">
									<ng-container *ngIf="rowdata.requireMMP==''||rowdata.requireMMP">
										<label style="position: absolute; right:20px">MMP</label>
									</ng-container>
								</td>
								<td><span>${{rowdata.cost}}</span>
									</td>
								<td>
									<img *ngIf="rowdata.requireFurther=='Y'" style="width: 13px; height: 13px;" src="https://erisservice9.erisinfo.com/exreportw/frmimages/checkbox-checked-shadow.jpg" alt="checked">
									<img *ngIf="rowdata.requireFurther!='Y'" style="width: 13px; height: 13px;"  src="https://erisservice9.erisinfo.com/exreportw/frmimages/checkbox-unchecked-shadow.jpg" alt="unchecked">
								</td>
								<td style="width:11%">{{rowdata.sectionNo}}</td>
								<td style="width:11%">{{rowdata.pageNo}}</td>							
							</tr>
						</ng-container>						
					</tbody>
				</table>
				<div style="border-left:solid 4px black; border-bottom:1px solid black;height:20px; vertical-align: bottom;">
					<label style="margin-right: 50px;">{{contents[0].SUB_SECTIONS[1].data.law.label}}</label>
					<span style="margin-right: 20px;" [ngClass]="{'checkbox-checked1':contents[0].SUB_SECTIONS[1].data.law.status=='Y', 'checkbox-unchecked1':contents[0].SUB_SECTIONS[1].data.law.status!='Y'}">Yes</span>
					<span  [ngClass]="{'checkbox-checked1':contents[0].SUB_SECTIONS[1].data.law.status=='N', 'checkbox-unchecked1':contents[0].SUB_SECTIONS[1].data.law.status!='N'}">No</span>
				</div>
			</div>

</section>
<section class="page-before" data-section-title="Section III">
	<header>
		<div class="freddie-mac-header">
			<div class="freddie-mac-logo">
				<img src="https://erisservice9.erisinfo.com/exreportw/frmimages/logo.jpg" alt="Freddie Mac Multifamily">
			</div>
			<div class="freddie-mac-title">
				<strong>Environmental Site Assessment</strong><br>
			</div>
		</div>
	</header>
	<h1>Section II: Private Wells, Radon and Attachments</h1>
	<h2 style="height: 18px;"></h2>
	<table class="section-header">
		<tr>
			<td width="25%">
				<div>
					<p *ngIf="contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
					<p *ngIf="!contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.text"></p>
					<label>Freddie Mac loan number</label>
				</div>
			</td>
			<td width="25%">
				<div>
					<p [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate|date:'MMMM dd, yyyy'"></p>
					<label>Report date</label>
				</div>
			</td>
			<td colspan="2" width="50%">
				<div>
					<p *ngIf="contents[0].SUB_SECTIONS[0].data?.AsReportedName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AsReportedName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
					<p *ngIf="!contents[0].SUB_SECTIONS[0].data?.AsReportedName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AsReportedName?.text"></p>
                    <label>Property name</label>
				</div>
			</td>
		</tr>
		<tr>
			<td colspan="2" class="fh">
				<div>
					<p *ngIf="contents[0].SUB_SECTIONS[0].data?.AccountName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AccountName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
					<p *ngIf="!contents[0].SUB_SECTIONS[0].data?.AccountName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AccountName?.text"></p>
                    <label>Seller/Servicer name</label>
				</div>
			</td>
			<td colspan="2" class="fh">
				<div>
					<p *ngIf="contents[0].SUB_SECTIONS[0].data?.AddressLineText?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AddressLineText?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
					<p *ngIf="!contents[0].SUB_SECTIONS[0].data?.AddressLineText?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AddressLineText?.text"></p>
					<label>Address</label>
				</div>
			</td>
		</tr>
		<tr>
			<td class="fh">
				<div>
					<p *ngIf="contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
					<p *ngIf="!contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.text"></p>
					<label>Seller/Servicer number</label>
				</div>
			</td>
			<td>
				<div>
					<p [innerHTML]="contents[0].SUB_SECTIONS[0].data?.VisitDate|date:'MMMM dd, yyyy'"></p>
					<label>Inspection date</label>
				</div>
			</td>
			<td colspan="2" class="fh">
				<div>
					<p><!--<span style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.CityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;  
						<span style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp; 
						<span style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span></p>
					<label>City, State, Zip</label>-->
					<ng-container *ngIf="contents[0].SUB_SECTIONS[0].data?.CityName?.html"><span style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.CityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
					<ng-container *ngIf="!contents[0].SUB_SECTIONS[0].data?.CityName?.html&&contents[0].SUB_SECTIONS[0].data?.CityName?.text"><span style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.CityName?.text"></span>,&nbsp;</ng-container>
					<ng-container *ngIf="contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.html"><span style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
					<ng-container *ngIf="!contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.html&&contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.text"><span style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.text"></span>,&nbsp;</ng-container><span *ngIf="contents[0].SUB_SECTIONS[0].data?.PostalCode?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>
							<span *ngIf="!contents[0].SUB_SECTIONS[0].data?.PostalCode?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PostalCode?.secHtml?.text"></span></p>
							<label>City, State, Zip</label>
				</div>
			</td>
		</tr>
		
	</table>
	<h2>{{contents[1].SUB_SECTIONS[0].SECTION_TITLE}}</h2>
	<div><!--Private Wells, Radon and Attachments-->
		<div style="font-size: 12px;">
			<div class="question-line">
				<div class="question">{{contents[1].SUB_SECTIONS[0].data?.label}}</div>
				<div class="question">
					<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':contents[1].SUB_SECTIONS[0].data.status=='Yes', 'radio-unchecked':contents[1].SUB_SECTIONS[0].data.status!='Yes'}">Yes</span>
					<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':contents[1].SUB_SECTIONS[0].data.status=='No', 'radio-unchecked':contents[1].SUB_SECTIONS[0].data.status!='No'}">No</span>
				</div>
			</div>
			
			<div class="question-line">
				<label>{{contents[1].SUB_SECTIONS[0].data.label2}}</label>
				<div class="textarea" style="width:90px; text-align: center">{{contents[1].SUB_SECTIONS[0].data.date|date:'MMMM dd, yyyy'}}</div>				
			</div>
		
			<div class="input-box" style="margin-left: 20px;">
				<label>{{contents[1].SUB_SECTIONS[0].data.label3}}</label>
				<div class="textarea">{{contents[1].SUB_SECTIONS[0].data.info}}</div>
			</div>									
		</div>
		
		<h2>{{contents[1].SUB_SECTIONS[1].SECTION_TITLE}}</h2>
		<div style="font-size: 12px;">
			<div class="question-line">
				<div class="question">{{contents[1].SUB_SECTIONS[1].data?.label}}</div>
				<div class="question">
					<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':contents[1].SUB_SECTIONS[1].data.status=='Yes', 'radio-unchecked':contents[1].SUB_SECTIONS[1].data.status!='Yes'}">Yes</span>
					<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':contents[1].SUB_SECTIONS[1].data.status=='No', 'radio-unchecked':contents[1].SUB_SECTIONS[1].data.status!='No'}">No</span>
				</div>
			</div>
			<div *ngIf="contents[1].SUB_SECTIONS[1].data.status=='No'" class="reason-box">
				<label>Explain below:</label>	
				<p style="margin: 2px;">{{contents[1].SUB_SECTIONS[1].data.info}}</p>									
			</div>
		</div>
		<h2>{{contents[1].SUB_SECTIONS[2].SECTION_TITLE}}</h2>
		<div style="font-size: 12px;">
			<ng-container *ngFor="let item of contents[1].SUB_SECTIONS[2].data.Attachments; let i=index; trackBy:trackByFuntion">
			<div style="display:flex; margin: 4px 0;">
				<label style="display: flex;width:40%; font-weight: bold;">{{item.label}}</label>
				<ng-container *ngIf="i<6">
					<label style="display: flex;width:20%;">
						<span type="radio" style='margin-right: 10px;' [ngClass]="{'checkbox-checked1':item.status=='attached', 'checkbox-unchecked1':item.status!='attached'}">Attached</span>
					</label>
					<label style="display: flex;width:20%;" >
						<span type="radio" style='margin-right: 10px;' [ngClass]="{'checkbox-checked1':item.status=='nattached', 'checkbox-unchecked1':item.status!='nattached'}">Not attached</span>
					</label>
					<label  style="display: flex;width:20%;" *ngIf="i==1||i==2">
						<span type="radio" style='margin-right: 10px;' [ngClass]="{'checkbox-checked1':item.status=='nreq', 'checkbox-unchecked1':item.status!='nreq'}">Not required</span>
					</label>
					<label  style="display: flex;width:20%;" *ngIf="i==4||i==5">
						<span type="radio" style='margin-right: 10px;' [ngClass]="{'checkbox-checked1':item.status=='navailable', 'checkbox-unchecked1':item.status!='navailable'}">Not available</span>
					</label>
				</ng-container>
			</div>
			<div  *ngIf="item.status=='nattached'||i==6" class="reason-box">
				<label *ngIf="i!=6">Explain below:</label>	
				<label *ngIf="i==6"></label>
				<p *ngIf="item.info" style="margin: 2px;">{{item.info}}</p>	
				<div *ngIf="!item.info" style="height:16px"></div>									
			</div>
		</ng-container>
		</div>
		
	</div>
</section>
<section class="page-before" data-section-title="Section III">
	<header>
		<div class="freddie-mac-header">
			<div class="freddie-mac-logo">
				<img src="https://erisservice9.erisinfo.com/exreportw/frmimages/logo.jpg" alt="Freddie Mac Multifamily">
			</div>
			<div class="freddie-mac-title">
				<strong>Environmental Site Assessment</strong><br>
			</div>
		</div>
	</header>
	<h1>Section III: Unit Inspection and Certification</h1>
	<h2 style="height: 18px;"></h2>
	<table class="section-header">
		<tr>
			<td width="25%">
				<div>
					<p *ngIf="contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
					<p *ngIf="!contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.text"></p>
					<label>Freddie Mac loan number</label>
				</div>
			</td>
			<td width="25%">
				<div>
					<p [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate|date:'MMMM dd, yyyy'"></p>
					<label>Report date</label>
				</div>
			</td>
			<td colspan="2" width="50%">
				<div>
					<p *ngIf="contents[0].SUB_SECTIONS[0].data?.AsReportedName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AsReportedName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
					<p *ngIf="!contents[0].SUB_SECTIONS[0].data?.AsReportedName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AsReportedName?.text"></p>
                    <label>Property name</label>
				</div>
			</td>
		</tr>
		<tr>
			<td colspan="2" class="fh">
				<div>
					<p *ngIf="contents[0].SUB_SECTIONS[0].data?.AccountName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AccountName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
					<p *ngIf="!contents[0].SUB_SECTIONS[0].data?.AccountName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AccountName?.text"></p>
                    <label>Seller/Servicer name</label>
				</div>
			</td>
			<td colspan="2" class="fh">
				<div>
					<p *ngIf="contents[0].SUB_SECTIONS[0].data?.AddressLineText?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AddressLineText?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
					<p *ngIf="!contents[0].SUB_SECTIONS[0].data?.AddressLineText?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AddressLineText?.text"></p>
					<label>Address</label>
				</div>
			</td>
		</tr>
		<tr>
			<td class="fh">
				<div>
					<p *ngIf="contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
					<p *ngIf="!contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.text"></p>
					<label>Seller/Servicer number</label>
				</div>
			</td>
			<td>
				<div>
					<p [innerHTML]="contents[0].SUB_SECTIONS[0].data?.VisitDate|date:'MMMM dd, yyyy'"></p>
					<label>Inspection date</label>
				</div>
			</td>
			<td colspan="2" class="fh">
				<div>
					<p><!--<span style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.CityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;  
						<span style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp; 
						<span style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span></p>
					<label>City, State, Zip</label>-->
					<ng-container *ngIf="contents[0].SUB_SECTIONS[0].data?.CityName?.html"><span style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.CityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
					<ng-container *ngIf="!contents[0].SUB_SECTIONS[0].data?.CityName?.html&&contents[0].SUB_SECTIONS[0].data?.CityName?.text"><span style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.CityName?.text"></span>,&nbsp;</ng-container>
					<ng-container *ngIf="contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.html"><span style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
					<ng-container *ngIf="!contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.html&&contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.text"><span style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.text"></span>,&nbsp;</ng-container><span *ngIf="contents[0].SUB_SECTIONS[0].data?.PostalCode?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>
							<span *ngIf="!contents[0].SUB_SECTIONS[0].data?.PostalCode?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PostalCode?.secHtml?.text"></span></p>
							<label>City, State, Zip</label>
				</div>
			</td>
		</tr>
		
	</table>
	<h2>{{contents[2].SUB_SECTIONS[0].SECTION_TITLE}}</h2>
	<!--Private Wells, Radon and Attachments-->
		<div style="font-size: 12px;">
			<div style="width: 100%">
				<table style="width:100%; border-collapse: collapse;text-align: center; border:none">
					<tbody>
					<ng-container *ngFor="let row of unitrow|fill; let i=index; trackBy:trackByFuntion">
					<tr style="vertical-align: bottom;line-height: 24px;">
						<td class='numberCell'>{{4*i+1}}</td>					
						<td class="underlineCell">
							<p>{{contents[2].SUB_SECTIONS[0].data.units[4*i]}}</p>
						</td>
						<td class='numberCell'>{{4*i+2}}</td>
						<td class="underlineCell">
							<p>{{contents[2].SUB_SECTIONS[0].data.units[4*i+1]}}</p>
						</td>
						<td class='numberCell'>{{4*i+3}}</td>
						<td class="underlineCell">
							<p>{{contents[2].SUB_SECTIONS[0].data.units[4*i+2]}}</p>
						</td>
						<td class='numberCell'>{{4*i+4}}</td>
						<td class="underlineCell">
							<p>{{contents[2].SUB_SECTIONS[0].data.units[4*i+3]}}</p>
						</td>
						
					</tr>
				</ng-container>			
					</tbody>
				</table>
			</div>
		</div>
	<h2>{{contents[2].SUB_SECTIONS[1].SECTION_TITLE}}</h2>
	<div style="font-size: 12px;">
	<div style="width:100%;margin-bottom: 20px;">
		<p>On behalf of the environmental consultant, the undersigned hereby certifies that:</p>
		<ul  style="list-style-type:disc;margin-left: 20px;">
			<li>The attached environmental report was prepared by the consultant in accordance with all applicable requirements in the Freddie Mac <i>Multifamily Seller/Servicer Guide</i>.</li>
			<li>The report was prepared in a manner consistent with generally accepted industry practices and standards.</li>
			<li>All information is true and correct, to the best of the undersigned's knowledge, and reflects the consultant's best professional opinion and judgment.</li>
			<li>No changes or additions have been made to the standard provisions of this form other than those expressly approved in writing by Freddie Mac.</li>
		</ul>
	</div>
	<div style="width:100%; display:inline; position:relative; ">
		<div style="width:49%; display:inline-block;">
			<div style="display:inline-block;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				
				<label style="margin-left:4px;font-size: 5.4pt;padding-left: 2px;">Consulting firm name</label><br><div style="height:4px;"></div>
				<input *ngIf="!contents[2].SUB_SECTIONS[1].data['firm'].html" type="text" style="border:none"/>
				<ng-container *ngIf="contents[2].SUB_SECTIONS[1].data['firm'].html">
					<p [innerHTML]="contents[2].SUB_SECTIONS[1].data?.firm?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
				</ng-container>
				
			</div>
			</div>
			<div style="width:49%; display:inline-block;">
			
				</div>
		<div style="width:49%; display:inline-block;">
			<div style="display:inline-block;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;vertical-align: bottom;">
				
				<label style="margin-left:4px;font-size: 5.4pt;padding-left: 2px;">Signature of authorized representative</label><br>
					<ng-container *ngIf="!contents[2].SUB_SECTIONS[1].data['sign']">
						<input type="text" style="border:none;width:90%"/>
					</ng-container>
				  <ng-container *ngIf="contents[2].SUB_SECTIONS[1].data['sign']">
					<img [src]="contents[2].SUB_SECTIONS[1].data['sign']" alt="Signature" style="max-height:25px;width:auto;vertical-align:bottom; margin: 0 20px;">
					<i class="far fa-trash-alt fa-sm float-sm-right iconBtn m-0" (click)="removeSign()"></i>
				  </ng-container>					
			</div>
		</div>
		
		<div style="width:49%; display:inline-block;;margin-left:10px; vertical-align: bottom;">
		<div style="display:inline-block;;margin:0;width:100%;">
			
			<label style="margin-left:4px;font-size: 5.4pt;padding-left: 2px;">Date</label><br>
			<div style="border:none; border-left:4px solid black;border-bottom:1px solid black;width:100%;padding-left: 4px">
				<div style="height:4px;"></div>
				<input *ngIf="!contents[2].SUB_SECTIONS[1].data['date']" type="text" style="border:none;"/>
				<p *ngIf="contents[2].SUB_SECTIONS[1].data['date']">{{contents[2].SUB_SECTIONS[1].data['date']|date:"MMMM dd, yyyy"}}</p>
			</div>
			
		</div>
		</div>
		<div style="width:49%; display:inline-block;">
		<div style="display:inline-block;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;;padding-left: 4px">
			<div style="height:4px;"></div>
			<label style="margin-left:4px;font-size: 5.4pt;padding-left: 2px;">Name (typed or printed)</label><br>
			<input *ngIf="!contents[2].SUB_SECTIONS[1].data['name']" type="text" style="border:none"/>
			<ng-container *ngIf="contents[2].SUB_SECTIONS[1].data['name']">
				<p>{{contents[2].SUB_SECTIONS[1].data['name']}}</p>
			</ng-container>
			
		</div>
		</div>
		<div style="width:49%; display:inline-block;margin-left:10px">
		<div style="display:inline-block;margin:0;width:100%;">
			
			<label style="margin-left:4px;font-size: 5.4pt;padding-left: 2px;">Title</label>
			<div style="border:none; border-left:4px solid black;border-bottom:1px solid black;width:100%;padding-left: 4px">
				<div style="height:4px;"></div>
				<input *ngIf="!contents[2].SUB_SECTIONS[1].data['title']" type="text" style="border:none;width:100%"/>
				<p *ngIf="contents[2].SUB_SECTIONS[1].data['title']">{{contents[2].SUB_SECTIONS[1].data['title']}}</p>
			</div>
		</div>
		</div>
	</div>
</div>
</section>	
</div>
<div  #frmContent id="frmContent" style='display:none' *ngIf="curReport?.PCA_INDICATOR=='frm1105'&&flatData">
	<section class="page-before" data-section-title="Section I">
            <header>
                <div class="freddie-mac-header">
                    <div class="freddie-mac-logo">
                        <img src="https://erisservice9.erisinfo.com/exreportw/frmimages/logo.jpg" alt="Freddie Mac Multifamily">
                    </div>
                    <div class="freddie-mac-title">
                        <strong>Property Condition Assessment</strong>
                    </div>
                </div>
            </header>
            <h1>Section I: Summary</h1>
            <h2>Mortgage, Consultant and Property Information</h2>
            <table class="section-header">
                <tr>
                    <td width="25%">
                        <div>
                            <p *ngIf="PropertyAsReportedHTML?.FrmLoanNo?.html" [innerHTML]="PropertyAsReportedHTML?.FrmLoanNo?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!PropertyAsReportedHTML?.FrmLoanNo?.html" [innerHTML]="PropertyAsReportedHTML?.FrmLoanNo?.text"></p>
                            <label>Freddie Mac loan number</label>
                        </div>
                    </td>
                    <td width="25%">
                        <div>
                            <p [innerHTML]="PropertyConditionAssessmentHTML?.FinalAsmntDate|date:'MMMM dd, yyyy'"></p>
                            <label>Report date</label>
                        </div>
                    </td>
                    <td colspan="2" width="50%">
                        <div>
                            <p *ngIf="PropertyAsReportedHTML?.AsReportedName?.html" [innerHTML]="PropertyAsReportedHTML?.AsReportedName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!PropertyAsReportedHTML?.AsReportedName?.html" [innerHTML]="PropertyAsReportedHTML?.AsReportedName?.text"></p>
                            <label>Property name</label>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2">
                        <div>
                            <p *ngIf="PropertyAsReportedHTML?.AccountName?.html" [innerHTML]="PropertyAsReportedHTML?.AccountName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!PropertyAsReportedHTML?.AccountName?.html" [innerHTML]="PropertyAsReportedHTML?.AccountName?.text"></p>
                            <label>Seller/Servicer name</label>
                        </div>
                    </td>
                    <td colspan="2" class="fh">
                        <div>
                            <p *ngIf="PropertyAsReportedHTML?.AddressLineText?.html" [innerHTML]="PropertyAsReportedHTML?.AddressLineText?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!PropertyAsReportedHTML?.AddressLineText?.html" [innerHTML]="PropertyAsReportedHTML?.AddressLineText?.text"></p>
                            <label>Address</label>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div>
                            <p *ngIf="PropertyAsReportedHTML?.PartyBusinessAccountId?.html" [innerHTML]="PropertyAsReportedHTML?.PartyBusinessAccountId?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!PropertyAsReportedHTML?.PartyBusinessAccountId?.html" [innerHTML]="PropertyAsReportedHTML?.PartyBusinessAccountId?.text"></p>
                            <label>Seller/Servicer number</label>
                        </div>
                    </td>
                    <td>
                        <div>
                            <p [innerHTML]="PropertyConditionAssessmentHTML?.PrelimInspectionDate|date:'MMMM dd, yyyy'"></p>
                            <label>Inspection date</label>
                        </div>
                    </td>
                    <td colspan="2" class="fh">
                        <div>
                            <p><ng-container *ngIf="PropertyAsReportedHTML?.CityName?.html"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.CityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
								<ng-container *ngIf="!PropertyAsReportedHTML?.CityName?.html&&PropertyAsReportedHTML?.CityName?.text"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.CityName?.text"></span>,&nbsp;</ng-container>
								<ng-container *ngIf="PropertyAsReportedHTML?.StateUspsCode?.html"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.StateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
								<ng-container *ngIf="!PropertyAsReportedHTML?.StateUspsCode?.html&&PropertyAsReportedHTML?.StateUspsCode?.text"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.StateUspsCode?.text"></span>,&nbsp;</ng-container> 
								<span *ngIf="PropertyAsReportedHTML?.PostalCode?.html" style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.PostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>
								<span *ngIf="!PropertyAsReportedHTML?.PostalCode?.html" style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.PostalCode?.secHtml?.text"></span></p>
                            <label>City, State, Zip</label>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div>
                            <p *ngIf="PropertyConditionAssessmentPropertyCoreCharacteristicsHTML?.PptyRsdntlBuildingCount?.html" [innerHTML]="PropertyConditionAssessmentPropertyCoreCharacteristicsHTML?.PptyRsdntlBuildingCount?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!PropertyConditionAssessmentPropertyCoreCharacteristicsHTML?.PptyRsdntlBuildingCount?.html" [innerHTML]="PropertyConditionAssessmentPropertyCoreCharacteristicsHTML?.PptyRsdntlBuildingCount?.text"></p>
                            <label>Number of apartment buildings</label>
                        </div>
                    </td>
                    <td>
                        <div>
                            <p *ngIf="PropertyConditionAssessmentPropertyCoreCharacteristicsHTML?.PptyNonRsdntlBuildingCount?.html" [innerHTML]="PropertyConditionAssessmentPropertyCoreCharacteristicsHTML?.PptyNonRsdntlBuildingCount?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!PropertyConditionAssessmentPropertyCoreCharacteristicsHTML?.PptyNonRsdntlBuildingCount?.html" [innerHTML]="PropertyConditionAssessmentPropertyCoreCharacteristicsHTML?.PptyNonRsdntlBuildingCount?.text"></p>
                            <label>Number of other buildings</label>
                        </div>
                    </td>
                    <td class="fh">
                        <div>
                            <p *ngIf="PropertyConditionAssessmentHTML?.OnsiteContactName?.html" [innerHTML]="PropertyConditionAssessmentHTML?.OnsiteContactName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!PropertyConditionAssessmentHTML?.OnsiteContactName?.html" [innerHTML]="PropertyConditionAssessmentHTML?.OnsiteContactName?.text"></p>
                            <label>On-site contact name</label>
                        </div>
                    </td>
                    <td>
                        <div>
                            <!--<p [innerHTML]="PropertyConditionAssessmentHTML?.OnsiteContactPhoneNumber?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>-->
							<!--<ng-container *ngIf="toPrint?.type!='frm'">
								<p *ngIf="PropertyConditionAssessmentHTML?.OnsiteContactPhoneNumber?.html" [innerHTML]="PropertyConditionAssessmentHTML?.OnsiteContactPhoneNumber?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
								<p *ngIf="!PropertyConditionAssessmentHTML?.OnsiteContactPhoneNumber?.html" [innerHTML]="PropertyConditionAssessmentHTML?.OnsiteContactPhoneNumber?.text"></p>
							</ng-container>
							<ng-container *ngIf="toPrint?.type=='frm'"></ng-container>-->
								<p>{{PropertyConditionAssessmentHTML?.OnsiteContactPhoneNumber.formateText}}</p>
							
							
							<label>On-site contact telephone number</label>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div>
                            <p *ngIf="PropertyConditionAssessmentPropertyCoreCharacteristicsHTML?.PptyFloorCount?.html" [innerHTML]="PropertyConditionAssessmentPropertyCoreCharacteristicsHTML?.PptyFloorCount?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!PropertyConditionAssessmentPropertyCoreCharacteristicsHTML?.PptyFloorCount?.html" [innerHTML]="PropertyConditionAssessmentPropertyCoreCharacteristicsHTML?.PptyFloorCount?.text"></p>
                            <label>Number of stories</label>
                        </div>
                    </td>
                    <td>
                        <div>
                            <p *ngIf="PropertyConditionAssessmentPropertyCoreCharacteristicsHTML?.PptyBuildingAgeYrCount?.html" [innerHTML]="PropertyConditionAssessmentPropertyCoreCharacteristicsHTML?.PptyBuildingAgeYrCount?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!PropertyConditionAssessmentPropertyCoreCharacteristicsHTML?.PptyBuildingAgeYrCount?.html" [innerHTML]="PropertyConditionAssessmentPropertyCoreCharacteristicsHTML?.PptyBuildingAgeYrCount?.text"></p>
							<label>Year(s) of construction</label><!--Age of buildings (in years)-->
                        </div>
                    </td>
                    <td colspan="2">
                        <div>
                            <p *ngIf="PropertyConditionAssessmentHTML?.AtInpectionWeatherDescription?.html" [innerHTML]="PropertyConditionAssessmentHTML?.AtInpectionWeatherDescription?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
                            <p *ngIf="!PropertyConditionAssessmentHTML?.AtInpectionWeatherDescription?.html" [innerHTML]="PropertyConditionAssessmentHTML?.AtInpectionWeatherDescription?.text"></p>
							<label>Weather at time of inspection (clear, rain, snow cover, etc.)</label>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2">
                        <div>
                            <p *ngIf="PropertyConditionAssessmentHTML?.FirmName?.html" [innerHTML]="PropertyConditionAssessmentHTML?.FirmName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!PropertyConditionAssessmentHTML?.FirmName?.html" [innerHTML]="PropertyConditionAssessmentHTML?.FirmName?.text"></p>
                            <label>Property condition consultant (firm name)</label>
                        </div>
                    </td>
                    <td colspan="2">
                        <div>
                            <p *ngIf="PropertyConditionAssessmentHTML?.InspectorName?.html" [innerHTML]="PropertyConditionAssessmentHTML?.InspectorName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!PropertyConditionAssessmentHTML?.InspectorName?.html" [innerHTML]="PropertyConditionAssessmentHTML?.InspectorName?.text"></p>
                            <label>Inspector's name</label>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" class="fh">
                        <div>
                            <p *ngIf="PropertyConditionAssessmentHTML?.FirmAddressLineText?.html" [innerHTML]="PropertyConditionAssessmentHTML?.FirmAddressLineText?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!PropertyConditionAssessmentHTML?.FirmAddressLineText?.html" [innerHTML]="PropertyConditionAssessmentHTML?.FirmAddressLineText?.text"></p>
                            <label>Address</label>
                        </div>
                    </td>
                    <td colspan="2" class="fh">
                        <div>
                            <p *ngIf="PropertyConditionAssessmentHTML?.InspectorTitle?.html" [innerHTML]="PropertyConditionAssessmentHTML?.InspectorTitle?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
							<p *ngIf="!PropertyConditionAssessmentHTML?.InspectorTitle?.html" [innerHTML]="PropertyConditionAssessmentHTML?.InspectorTitle?.text"></p>
                            <label>Title</label>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" class="fh">
                        <div>
                            <p><!--<span style="display: inline-table;" [innerHTML]="PropertyConditionAssessmentHTML?.FirmCityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;
								<span style="display: inline-table;" [innerHTML]="PropertyConditionAssessmentHTML?.FirmStateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;
								<span style="display: inline-table;" [innerHTML]="PropertyConditionAssessmentHTML?.FirmPostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span></p>
                            <label>City, State, Zip</label>-->
								<ng-container *ngIf="PropertyConditionAssessmentHTML?.FirmCityName?.html"><span style="display: inline-table;" [innerHTML]="PropertyConditionAssessmentHTML?.FirmCityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
								<ng-container *ngIf="!PropertyConditionAssessmentHTML?.FirmCityName?.html&&PropertyConditionAssessmentHTML?.FirmCityName?.text"><span style="display: inline-table;" [innerHTML]="PropertyConditionAssessmentHTML?.FirmCityName?.text"></span>,&nbsp;</ng-container>
								<ng-container *ngIf="PropertyConditionAssessmentHTML?.FirmStateUspsCode?.html"><span style="display: inline-table;" [innerHTML]="PropertyConditionAssessmentHTML?.FirmStateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
								<ng-container *ngIf="!PropertyConditionAssessmentHTML?.FirmStateUspsCode?.html&&PropertyConditionAssessmentHTML?.FirmStateUspsCode?.text"><span style="display: inline-table;" [innerHTML]="PropertyConditionAssessmentHTML?.FirmStateUspsCode?.text"></span>,&nbsp;</ng-container>
								<span *ngIf="PropertyConditionAssessmentHTML?.FirmPostalCode?.html" style="display: inline-table;" [innerHTML]="PropertyConditionAssessmentHTML?.FirmPostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>
								<span *ngIf="!PropertyConditionAssessmentHTML?.FirmPostalCode?.html" style="display: inline-table;" [innerHTML]="PropertyConditionAssessmentHTML?.FirmPostalCode?.secHtml?.text"></span></p>
                            <label>City, State, Zip</label>
                        </div>
                    </td>
                    <td colspan="2" class="fh">
                        <div>
                            <!--<ng-container *ngIf="toPrint?.type!='frm'">
								<p *ngIf="PropertyConditionAssessmentHTML?.InspectorPhoneNumber?.html" [innerHTML]="PropertyConditionAssessmentHTML?.InspectorPhoneNumber?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
								<p *ngIf="!PropertyConditionAssessmentHTML?.InspectorPhoneNumber?.html" [innerHTML]="PropertyConditionAssessmentHTML?.InspectorPhoneNumber?.text"></p>
							</ng-container>
							<ng-container *ngIf="toPrint?.type=='frm'"></ng-container>-->
								<p>{{PropertyConditionAssessmentHTML?.InspectorPhoneNumber.formateText}}</p>
							
							<label>Telephone number</label>
                        </div>
                    </td>
                </tr>
            </table>
            <h2>Building and Material Characteristics</h2>
            <p>Put an "x" in the appropriate boxes below and furnish additional information when requested</p>
            <div class="flex4">
                <div>
                    <h4>Building type</h4>
                    <ul>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('buildingType;garden')>-1, 'checkbox-unchecked':flatData.indexOf('buildingType;garden')==-1}">Garden</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('buildingType;walkUp')>-1, 'checkbox-unchecked':flatData.indexOf('buildingType;walkUp')==-1}"class="checkbox-unchecked">Walk-up</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('buildingType;elevator')>-1, 'checkbox-unchecked':flatData.indexOf('buildingType;elevator')==-1}" class="checkbox-checked">Elevator</span></li>
                        <li>
                            <ul>
                                <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('buildingType;elevator;lowrise')>-1, 'checkbox-unchecked':flatData.indexOf('buildingType;elevator;lowrise')==-1}">Lowrise</span></li>
                                <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('buildingType;elevator;midrise')>-1, 'checkbox-unchecked':flatData.indexOf('buildingType;elevator;midrise')==-1}">Midrise</span></li>
                                <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('buildingType;elevator;highrise')>-1, 'checkbox-unchecked':flatData.indexOf('buildingType;elevator;highrise')==-1}">High rise</span></li>
                            </ul>
                        </li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('buildingType;townhouse')>-1, 'checkbox-unchecked':flatData.indexOf('buildingType;townhouse')==-1}">Townhouse</span></li>
                        <li class="checkbox-other"><span [ngClass]="{'checkbox-checked':flatData.indexOf('buildingType;other')>-1, 'checkbox-unchecked':flatData.indexOf('buildingType;other')==-1}">Other</span>
							<span class="under-line">
							<label *ngIf="flatData.indexOf('buildingType;other')>-1" style="margin-left: 4px;">{{PropertyConditionAssessment[0].PropertyConditionAssessmentBuildingAndMaterials[flatData.indexOf('buildingType;other')]['OtherItemDescription']}}</label>
						</span></li>						
                    </ul>
                    <h4>Construction type</h4>
                    <ul>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('constructionType;woodFrame')>-1, 'checkbox-unchecked':flatData.indexOf('constructionType;woodFrame')==-1}">Wood frame</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('constructionType;metalFrame')>-1, 'checkbox-unchecked':flatData.indexOf('constructionType;metalFrame')==-1}">Metal frame</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('constructionType;structuralSteel')>-1, 'checkbox-unchecked':flatData.indexOf('constructionType;structuralSteel')==-1}">Structural steel</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('constructionType;masonry')>-1, 'checkbox-unchecked':flatData.indexOf('constructionType;masonry')==-1}">Mansonry</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('constructionType;structuralConcrete')>-1, 'checkbox-unchecked':flatData.indexOf('constructionType;structuralConcrete')==-1}">Structural concrete</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('constructionType;flatRoof')>-1, 'checkbox-unchecked':flatData.indexOf('constructionType;flatRoof')==-1}">Flat roof</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('constructionType;pitchedRoof')>-1, 'checkbox-unchecked':flatData.indexOf('constructionType;pitchedRoof')==-1}">Pitched roof</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('constructionType;flatRoofWithMansards')>-1, 'checkbox-unchecked':flatData.indexOf('constructionType;flatRoofWithMansards')==-1}">Flat roof with mansards</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('constructionType;fireTreatedPlywood')>-1, 'checkbox-unchecked':flatData.indexOf('constructionType;fireTreatedPlywood')==-1}">Fire-treated plywood</span></li>
                        <li class="checkbox-other"><span [ngClass]="{'checkbox-checked':flatData.indexOf('constructionType;other')>-1, 'checkbox-unchecked':flatData.indexOf('constructionType;other')==-1}">Other</span> 
							<span  class="under-line">
							<label style="margin-left: 4px;" *ngIf="flatData.indexOf('constructionType;other')>-1">{{PropertyConditionAssessment[0].PropertyConditionAssessmentBuildingAndMaterials[flatData.indexOf('constructionType;other')]['OtherItemDescription']}}</label>
						</span></li>
				    </ul>
                    <h4>Foundation type</h4>
                    <ul>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('foundationType;slabOnGrade')>-1, 'checkbox-unchecked':flatData.indexOf('foundationType;slabOnGrade')==-1}">Slab on grade</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('foundationType;concretePierDrilled')>-1, 'checkbox-unchecked':flatData.indexOf('foundationType;concretePierDrilled')==-1}">Concrete pier (drilled)</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('foundationType;spreadRaisedFoundation')>-1, 'checkbox-unchecked':flatData.indexOf('foundationType;spreadRaisedFoundation')==-1}">Spread, raised foundation</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('foundationType;undergroundParkingStructure')>-1, 'checkbox-unchecked':flatData.indexOf('foundationType;undergroundParkingStructure')==-1}">Underground parking structure</span></li>
                        <li class="checkbox-other"><span [ngClass]="{'checkbox-checked':flatData.indexOf('foundationType;other')>-1, 'checkbox-unchecked':flatData.indexOf('foundationType;other')==-1}">Other</span> 
							<span class="under-line">
							<label *ngIf="flatData.indexOf('foundationType;other')>-1" style="margin-left: 4px;">{{PropertyConditionAssessment[0].PropertyConditionAssessmentBuildingAndMaterials[flatData.indexOf('foundationType;other')]['OtherItemDescription']}}</label>
						</span></li>
						
                    </ul>
                    <h4>Parking</h4>
                    <ul>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('parking;surfaceUncovered')>-1, 'checkbox-unchecked':flatData.indexOf('parking;surfaceUncovered')==-1}">Surface (uncovered)</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('parking;structured')>-1, 'checkbox-unchecked':flatData.indexOf('parking;structured')==-1}">Structured</span></li>
                        <ul>
                            <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('parking;structured;carports')>-1, 'checkbox-unchecked':flatData.indexOf('parking;structured;carports')==-1}">Carports</span></li>
                            <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('parking;structured;garages')>-1, 'checkbox-unchecked':flatData.indexOf('parking;structured;garages')==-1}">Garages</span></li>
                            <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('parking;structured;underground')>-1, 'checkbox-unchecked':flatData.indexOf('parking;structured;underground')==-1}">Underground</span></li>
                        </ul>
                    </ul>
                </div>
                <div>
                    <h4>Envelope</h4>
                    <ul>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('envelope;stucco')>-1, 'checkbox-unchecked':flatData.indexOf('envelope;stucco')==-1}">Stucco</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('envelope;woodSiding')>-1, 'checkbox-unchecked':flatData.indexOf('envelope;woodSiding')==-1}">Wood siding</span></li>
                        <li>
                            <ul>
                                <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('envelope;woodSiding;t111')>-1, 'checkbox-unchecked':flatData.indexOf('envelope;woodSiding;t111')==-1}">T1-11</span></li>
                                <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('envelope;woodSiding;masonite')>-1, 'checkbox-unchecked':flatData.indexOf('envelope;woodSiding;masonite')==-1}">Masonite</span></li>
                                <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('envelope;woodSiding;planking')>-1, 'checkbox-unchecked':flatData.indexOf('envelope;woodSiding;planking')==-1}">Planking</span></li>
                            </ul>
                        </li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('envelope;vinylSiding')>-1, 'checkbox-unchecked':flatData.indexOf('envelope;vinylSiding')==-1}">Vinyl siding</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('envelope;brickVeneer')>-1, 'checkbox-unchecked':flatData.indexOf('envelope;brickVeneer')==-1}">Brick veneer</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('envelope;metalDoors')>-1, 'checkbox-unchecked':flatData.indexOf('envelope;metalDoors')==-1}">Metal doors</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('envelope;woodDoors')>-1, 'checkbox-unchecked':flatData.indexOf('envelope;woodDoors')==-1}">Wood doors</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('envelope;woodSashWindows')>-1, 'checkbox-unchecked':flatData.indexOf('envelope;woodSashWindows')==-1}">Wood sash windows</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('envelope;aluminumWindows')>-1, 'checkbox-unchecked':flatData.indexOf('envelope;aluminumWindows')==-1}">Aluminum windows</span></li>
                        <li class="checkbox-other"><span [ngClass]="{'checkbox-checked':flatData.indexOf('envelope;other')>-1, 'checkbox-unchecked':flatData.indexOf('envelope;other')==-1}">Other </span>
							<span *ngIf="flatData.indexOf('envelope;other')>-1" class="under-line">{{PropertyConditionAssessment[0].PropertyConditionAssessmentBuildingAndMaterials[flatData.indexOf('envelope;other')]['OtherItemDescription']}}
						</span></li>						
                    </ul>
                    <h4>Elevator</h4>
                    <ul>
                        <li class="checkbox-other"><span [ngClass]="{'checkbox-checked':flatData.indexOf('elevators;numberOfCabs')>-1, 'checkbox-unchecked':flatData.indexOf('elevators;numberOfCabs')==-1}">Number of cabs</span> 
							<span  class="under-line">
							<label style="margin-left: 4px;" *ngIf="flatData.indexOf('elevators;numberOfCabs')>-1">{{PropertyConditionAssessment[0].PropertyConditionAssessmentBuildingAndMaterials[flatData.indexOf('elevators;numberOfCabs')]['OtherItemDescription']}}</label>
						</span></li>
                        <li class="checkbox-other"><span>Last inspection date</span> 
							<span  class="under-line">
							<label style="margin-left: 4px;" *ngIf="flatData.indexOf('elevators;lastInspectionDate')>-1">{{PropertyConditionAssessment[0].PropertyConditionAssessmentBuildingAndMaterials[flatData.indexOf('elevators;lastInspectionDate')]['OtherItemDescription']}}</label>
						</span></li>
                    </ul>
                    <h4>Mechanicals (plumbing)</h4>
                    <ul>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('mechanicalsPlumbing;galvanizedWaterPiping')>-1, 'checkbox-unchecked':flatData.indexOf('mechanicalsPlumbing;galvanizedWaterPiping')==-1}">Galvanized water piping</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('mechanicalsPlumbing;copperWaterPiping')>-1, 'checkbox-unchecked':flatData.indexOf('mechanicalsPlumbing;copperWaterPiping')==-1}">Copper water piping</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('mechanicalsPlumbing;polybutyleneWaterPiping')>-1, 'checkbox-unchecked':flatData.indexOf('mechanicalsPlumbing;polybutyleneWaterPiping')==-1}">Polybutylene water piping</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('mechanicalsPlumbing;castIronWaste')>-1, 'checkbox-unchecked':flatData.indexOf('mechanicalsPlumbing;castIronWaste')==-1}">Cast iron waste</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('mechanicalsPlumbing;absPvcWaste')>-1, 'checkbox-unchecked':flatData.indexOf('mechanicalsPlumbing;absPvcWaste')==-1}">ABS/PVC waste</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('mechanicalsPlumbing;centralWaterHeater')>-1, 'checkbox-unchecked':flatData.indexOf('mechanicalsPlumbing;centralWaterHeater')==-1}">Central water heater</span>
                            <ul>
                                <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('mechanicalsPlumbing;centralWaterHeater;gas')>-1, 'checkbox-unchecked':flatData.indexOf('mechanicalsPlumbing;centralWaterHeater;gas')==-1}">Gas</span></li>
                                <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('mechanicalsPlumbing;centralWaterHeater;electric')>-1, 'checkbox-unchecked':flatData.indexOf('mechanicalsPlumbing;centralWaterHeater;electric')==-1}">Electric</span></li>
                            </ul>
                        </li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('mechanicalsPlumbing;individualWaterHeaters')>-1, 'checkbox-unchecked':flatData.indexOf('mechanicalsPlumbing;individualWaterHeaters')==-1}">Individual water heaters</span>
                            <ul>
                                <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('mechanicalsPlumbing;individualWaterHeaters;gas')>-1, 'checkbox-unchecked':flatData.indexOf('mechanicalsPlumbing;individualWaterHeaters;gas')==-1}">Gas</span></li>
                                <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('mechanicalsPlumbing;individualWaterHeaters;electric')>-1, 'checkbox-unchecked':flatData.indexOf('mechanicalsPlumbing;individualWaterHeaters;electric')==-1}">Electric</span></li>
                            </ul>
                        </li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('mechanicalsPlumbing;circulatingHotWater')>-1, 'checkbox-unchecked':flatData.indexOf('mechanicalsPlumbing;circulatingHotWater')==-1}">Circulating hot water</span></li>
                        <li class="checkbox-other"><span [ngClass]="{'checkbox-checked':flatData.indexOf('mechanicalsPlumbing;other')>-1, 'checkbox-unchecked':flatData.indexOf('mechanicalsPlumbing;other')==-1}">Other</span> 
							<span class="under-line">
							<label *ngIf="flatData.indexOf('mechanicalsPlumbing;other')>-1" style="margin-left: 4px;" >{{PropertyConditionAssessment[0].PropertyConditionAssessmentBuildingAndMaterials[flatData.indexOf('mechanicalsPlumbing;other')]['OtherItemDescription']}}</label>
						</span></li>						
                    </ul>
                </div>
                <div>
                    <h4>Mechanicals (HVAC)</h4>
                    <ul>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('mechanicalsHvac;centralBoilerSteamHeat')>-1, 'checkbox-unchecked':flatData.indexOf('mechanicalsHvac;centralBoilerSteamHeat')==-1}">Central boiler steam heat</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('mechanicalsHvac;hydronicSystem')>-1, 'checkbox-unchecked':flatData.indexOf('mechanicalsHvac;hydronicSystem')==-1}">Hydronic system</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('mechanicalsHvac;gasFauCentral')>-1, 'checkbox-unchecked':flatData.indexOf('mechanicalsHvac;gasFauCentral')==-1}">Gas FAU, central</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('mechanicalsHvac;electricFauCentral')>-1, 'checkbox-unchecked':flatData.indexOf('mechanicalsHvac;electricFauCentral')==-1}">Electric FAU, central</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('mechanicalsHvac;electricBaseboardHeat')>-1, 'checkbox-unchecked':flatData.indexOf('mechanicalsHvac;electricBaseboardHeat')==-1}">Electric baseboard heat</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('mechanicalsHvac;wallMountedAcUnit')>-1, 'checkbox-unchecked':flatData.indexOf('mechanicalsHvac;wallMountedAcUnit')==-1}">Wall-mounted AC unit</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('mechanicalsHvac;acCondenserUnits')>-1, 'checkbox-unchecked':flatData.indexOf('mechanicalsHvac;acCondenserUnits')==-1}">AC condenser units</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('mechanicalsHvac;evaporativeCoolerUnit')>-1, 'checkbox-unchecked':flatData.indexOf('mechanicalsHvac;evaporativeCoolerUnit')==-1}">Evaporative cooler unit</span></li>
                        <li class="checkbox-other"><span [ngClass]="{'checkbox-checked':flatData.indexOf('mechanicalsHvac;otherHeat')>-1, 'checkbox-unchecked':flatData.indexOf('mechanicalsHvac;otherHeat')==-1}">Other (heat)</span>
							<span class="under-line">
							<label *ngIf="flatData.indexOf('mechanicalsHvac;otherHeat')>-1" style="margin-left: 4px;">{{PropertyConditionAssessment[0].PropertyConditionAssessmentBuildingAndMaterials[flatData.indexOf('mechanicalsHvac;otherHeat')]['OtherItemDescription']}}</label>
						</span></li>
                        <li class="checkbox-other"><span [ngClass]="{'checkbox-checked':flatData.indexOf('mechanicalsHvac;otherAc')>-1, 'checkbox-unchecked':flatData.indexOf('mechanicalsHvac;otherAc')==-1}">Other (AC)</span>
							<span class="under-line">
							<label *ngIf="flatData.indexOf('mechanicalsHvac;otherAc')>-1" style="margin-left: 4px;">{{PropertyConditionAssessment[0].PropertyConditionAssessmentBuildingAndMaterials[flatData.indexOf('mechanicalsHvac;otherAc')]['OtherItemDescription']}}</label>
						</span></li>						
                    </ul>
                    <h4>Electrical</h4>
                    <ul>
                        <li><span class="checkbox-nobox">Unit capacity</span> 
							<span class="under-line" style="width:30px; margin: 0 6px;">
							<label *ngIf="flatData.indexOf('electrical;unitCapacityAmps')>-1" style="margin-left: 4px;">{{PropertyConditionAssessment[0].PropertyConditionAssessmentBuildingAndMaterials[flatData.indexOf('electrical;unitCapacityAmps')]['OtherItemDescription']}}</label>
						</span>amps</li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('electrical;aluminumBranchWiring')>-1, 'checkbox-unchecked':flatData.indexOf('electrical;aluminumBranchWiring')==-1}">Aluminum branch wiring</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('electrical;edisonBaseTTypeFuses')>-1, 'checkbox-unchecked':flatData.indexOf('electrical;edisonBaseTTypeFuses')==-1}">Edison base/T-type fuses</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('electrical;tamperProofFuses')>-1, 'checkbox-unchecked':flatData.indexOf('electrical;tamperProofFuses')==-1}">Tamper proof fuses</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('electrical;breakers')>-1, 'checkbox-unchecked':flatData.indexOf('electrical;breakers')==-1}">Breakers</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('electrical;gfiOutlets')>-1, 'checkbox-unchecked':flatData.indexOf('electrical;gfiOutlets')==-1}">GFI outlets</span></li>
                        <li class="checkbox-other"><span [ngClass]="{'checkbox-checked':flatData.indexOf('electrical;other')>-1, 'checkbox-unchecked':flatData.indexOf('electrical;other')==-1}">Other</span> 
							<span class="under-line">
							<label *ngIf="flatData.indexOf('electrical;other')>-1" style="margin-left: 4px;">{{PropertyConditionAssessment[0].PropertyConditionAssessmentBuildingAndMaterials[flatData.indexOf('electrical;other')]['OtherItemDescription']}}</label>
						</span></li>					
                    </ul>
                    <h4>Interior</h4>
                    <ul>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('interior;drywallWalls')>-1, 'checkbox-unchecked':flatData.indexOf('interior;drywallWalls')==-1}">Drywall walls</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('interior;plasterWalls')>-1, 'checkbox-unchecked':flatData.indexOf('interior;plasterWalls')==-1}">Plaster walls</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('interior;woodPaneling')>-1, 'checkbox-unchecked':flatData.indexOf('interior;woodPaneling')==-1}">Wood paneling</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('interior;carpeting')>-1, 'checkbox-unchecked':flatData.indexOf('interior;carpeting')==-1}">Carpeting</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('interior;woodFlooring')>-1, 'checkbox-unchecked':flatData.indexOf('interior;woodFlooring')==-1}">Wood flooring</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('interior;ceramicFloorTile')>-1, 'checkbox-unchecked':flatData.indexOf('interior;ceramicFloorTile')==-1}">Ceramic floor tile</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('interior;vinylFlooring')>-1, 'checkbox-unchecked':flatData.indexOf('interior;vinylFlooring')==-1}">Vinyl flooring</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('interior;woodDoors')>-1, 'checkbox-unchecked':flatData.indexOf('interior;woodDoors')==-1}">Wood doors</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('interior;metalDoors')>-1, 'checkbox-unchecked':flatData.indexOf('interior;metalDoors')==-1}">Metal doors</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('interior;sprayTexCeiling')>-1, 'checkbox-unchecked':flatData.indexOf('interior;sprayTexCeiling')==-1}">Spray-tex ceiling</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('interior;smoothCeiling')>-1, 'checkbox-unchecked':flatData.indexOf('interior;smoothCeiling')==-1}">Smooth ceiling</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('interior;orangePeelTextured')>-1, 'checkbox-unchecked':flatData.indexOf('interior;orangePeelTextured')==-1}">Orange peel/textured</span></li>
                        <li class="checkbox-other"><span [ngClass]="{'checkbox-checked':flatData.indexOf('interior;other')>-1, 'checkbox-unchecked':flatData.indexOf('interior;other')==-1}">Other</span> 
							<span class="under-line">
							<label *ngIf="flatData.indexOf('interior;other')>-1" style="margin-left: 4px;">{{PropertyConditionAssessment[0].PropertyConditionAssessmentBuildingAndMaterials[flatData.indexOf('interior;other')]['OtherItemDescription']}}</label>
						</span></li>						
                    </ul>
                </div>
                <div>
                    <h4>Amenities (site)</h4>
                    <ul>
                        <li><span [ngClass]="{'checkbox-checked':flatDataAmentities.indexOf('clubBuildingRoom')>-1, 'checkbox-unchecked':flatDataAmentities.indexOf('clubBuildingRoom')==-1}">Club building/room</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatDataAmentities.indexOf('swimmingPool')>-1, 'checkbox-unchecked':flatDataAmentities.indexOf('swimmingPool')==-1}">Swimming pool</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatDataAmentities.indexOf('spaAndOrSauna')>-1, 'checkbox-unchecked':flatDataAmentities.indexOf('spaAndOrSauna')==-1}">Spa and/or sauna</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatDataAmentities.indexOf('fitnessCenter')>-1, 'checkbox-unchecked':flatDataAmentities.indexOf('fitnessCenter')==-1}">Fitness center</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatDataAmentities.indexOf('barbeque')>-1, 'checkbox-unchecked':flatDataAmentities.indexOf('barbeque')==-1}">Barbecue</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatDataAmentities.indexOf('tennisCourts')>-1, 'checkbox-unchecked':flatDataAmentities.indexOf('tennisCourts')==-1}">Tennis courts</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatDataAmentities.indexOf('playgroundEquipment')>-1, 'checkbox-unchecked':flatDataAmentities.indexOf('playgroundEquipment')==-1}">Playground equipment</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatDataAmentities.indexOf('storage')>-1, 'checkbox-unchecked':flatDataAmentities.indexOf('storage')==-1}">Storage</span></li>
                        <li class="checkbox-other"><span [ngClass]="{'checkbox-checked':flatDataAmentities.indexOf('other')>-1, 'checkbox-unchecked':flatDataAmentities.indexOf('other')==-1}">Other </span>
							<span class="under-line">
							<label *ngIf="flatDataAmentities.indexOf('other')>-1" style="margin-left: 4px;">{{PropertyAmenity[flatDataAmentities.indexOf('other')].OtherTypeDescription}}</label>
						</span></li>					
                    </ul>
                    <h4>Mold</h4>
                    <ul>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('mold;moldEvidenceObserved')>-1, 'checkbox-unchecked':flatData.indexOf('mold;moldEvidenceObserved')==-1}">Mold evidence observed</span></li>
						<li><span [ngClass]="{'checkbox-checked':flatData.indexOf('mold;largeAreasMoldObserved')>-1, 'checkbox-unchecked':flatData.indexOf('mold;largeAreasMoldObserved')==-1}">Large areas of mold that are beyond typical housekeeping observed</span></li>	
						<li><span [ngClass]="{'checkbox-checked':flatData.indexOf('mold;areasImpactedObserved')>-1, 'checkbox-unchecked':flatData.indexOf('mold;areasImpactedObserved')==-1}">Areas impacted by water intrusions observed</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('mold;defectiveBuildingConditionsObserved')>-1, 'checkbox-unchecked':flatData.indexOf('mold;defectiveBuildingConditionsObserved')==-1}">Defective building conditions likely to lead to future water intrusions observed</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('mold;waterIntrusionsReported')>-1, 'checkbox-unchecked':flatData.indexOf('mold;waterIntrusionsReported')==-1}">Past/current water intrusions or leaks reported</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('mold;tenantComplaintsReported')>-1, 'checkbox-unchecked':flatData.indexOf('mold;tenantComplaintsReported')==-1}">Tenant complaints reported</span></li>
                    </ul>
                    <h4>Problem materials/equipment</h4>
                    <ul>
                        <li class="checkbox-other"><span [ngClass]="{'checkbox-checked':flatData.indexOf('problemMaterialsEquipment;otherA')>-1, 'checkbox-unchecked':flatData.indexOf('problemMaterialsEquipment;otherA')==-1}">Other</span> 
							<span class="under-line">
							<label *ngIf="flatData.indexOf('problemMaterialsEquipment;otherA')>-1" style="margin-left: 4px;">{{PropertyConditionAssessment[0].PropertyConditionAssessmentBuildingAndMaterials[flatData.indexOf('problemMaterialsEquipment;otherA')]['OtherItemDescription']}}</label>
						</span></li>
                        <!--<li class="checkbox-other"><span [ngClass]="{'checkbox-checked':flatData.indexOf('problemMaterialsEquipment;otherB')>-1, 'checkbox-unchecked':flatData.indexOf('problemMaterialsEquipment;otherB')==-1}">Other</span> 
							<span class="under-line">
							<label *ngIf="flatData.indexOf('problemMaterialsEquipment;otherB')>-1" style="margin-left: 4px;">{{PropertyConditionAssessment[0].PropertyConditionAssessmentBuildingAndMaterials[flatData.indexOf('problemMaterialsEquipment;otherB')]['OtherItemDescription']}}</label>
						</span></li>-->
					</ul>
                    <h4>Life/Safety devices</h4>
                    <ul>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('lifeSafetyDevices;smokeDetectors')>-1, 'checkbox-unchecked':flatData.indexOf('lifeSafetyDevices;smokeDetectors')==-1}">Smoke detectors</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('lifeSafetyDevices;carbonMonoxideDetectors')>-1, 'checkbox-unchecked':flatData.indexOf('lifeSafetyDevices;carbonMonoxideDetectors')==-1}">Carbon monoxide detectors</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('lifeSafetyDevices;fireExtinguishers')>-1, 'checkbox-unchecked':flatData.indexOf('lifeSafetyDevices;fireExtinguishers')==-1}">Fire extinguishers</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('lifeSafetyDevices;emergencyLighting')>-1, 'checkbox-unchecked':flatData.indexOf('lifeSafetyDevices;emergencyLighting')==-1}">Emergency lighting</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('lifeSafetyDevices;emergencyEscapes')>-1, 'checkbox-unchecked':flatData.indexOf('lifeSafetyDevices;emergencyEscapes')==-1}">Emergency escapes</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('lifeSafetyDevices;pullStationsCords')>-1, 'checkbox-unchecked':flatData.indexOf('lifeSafetyDevices;pullStationsCords')==-1}">Pull stations/cords</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('lifeSafetyDevices;fireAlarm')>-1, 'checkbox-unchecked':flatData.indexOf('lifeSafetyDevices;fireAlarm')==-1}">Fire alarm</span></li>
                        <li><span [ngClass]="{'checkbox-checked':flatData.indexOf('lifeSafetyDevices;sprinklers')>-1, 'checkbox-unchecked':flatData.indexOf('lifeSafetyDevices;sprinklers')==-1}">Sprinklers</span></li>
                    </ul>
                </div>
            </div>
            <h2 class="page-before">Unit Mix</h2>
            <p>Complete <strong>Table 1</strong> for residential units <i>only</i>. Commercial units, both spaces that are purpose-built and dwelling units converted to commercial use will be accounted for in <strong>Table 2</strong>. If "Other" dwelling units have been indicated, Table 3 will need to be completed as indicated.</p>
            <div class="unit-tables">
                <p class="table-title">Table 1 - below, indicte the unit type and occupancy at the time of the visit and the number of units inspected of each type</p>
                <div class="flex3">
                    <div>
                        <table>
                            <thead>
                                <tr>
                                    <th colspan="4">Unit Type</th>
                                </tr>
                                <tr>
                                    <th>BR</th>
                                    <th>BA</th>
                                    <th>SF</th>
                                    <th>Style</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let row of PropertyTotalRentRollSummary[0].PropertyResidentialUnitMix"  class="border-bottom">
                                    <td>{{row.BedroomCount}}</td>
                                    <td>{{row.BathroomCount}}</td>
                                    <td>{{row.AvgSquareFeetNumber}}</td>
                                    <td>{{row.StyleType}}</td>
                                </tr>
								<tr   style="height:16px" *ngIf="!PropertyTotalRentRollSummary[0].PropertyResidentialUnitMix||PropertyTotalRentRollSummary[0].PropertyResidentialUnitMix.length==1" class="border-bottom">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
								<tr  style="height:16px"  *ngIf="!PropertyTotalRentRollSummary[0].PropertyResidentialUnitMix||PropertyTotalRentRollSummary[0].PropertyResidentialUnitMix.length==0" class="border-bottom">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <td colspan="4" style="text-align: right; padding-top: 0.5rem;">Totals:</td>
                            </tfoot>
                        </table>
                    </div>
                    <div>
                        <table>
                            <thead>
                                <tr>
                                    <th colspan="4">Number of Units</th>
                                </tr>
                                <tr>
                                    <th>Occupied</th>
                                    <th>Vacant</th>
                                    <th>Down</th>
                                    <th>Other *</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr  *ngFor="let row of PropertyTotalRentRollSummary[0].PropertyResidentialUnitMix">
                                    <td>{{row.PptyUnitTypeOccupiedUnitCount}}</td>
                                    <td>{{row.VacantUnitCount}}</td>
                                    <td>{{row.PptyUnitTypeDownUnitCount}}</td>
                                    <td>{{row.PptyUnitTypeOtherUnitCount}}</td>
                                </tr>
								<tr  style="height:16px" *ngIf="!PropertyTotalRentRollSummary[0].PropertyResidentialUnitMix||PropertyTotalRentRollSummary[0].PropertyResidentialUnitMix.length==1">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
								<tr  style="height:16px" *ngIf="!PropertyTotalRentRollSummary[0].PropertyResidentialUnitMix||PropertyTotalRentRollSummary[0].PropertyResidentialUnitMix.length==0">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colspan="4" style="padding: 0.2rem 0 0 0;">
                                        <table class="tfoot-table">
                                            <tr>
                                                <td>{{PropertyTotalRentRollSummary[0].TotalOccupiedUnitCount}}</td>
                                                <td>{{PropertyTotalRentRollSummary[0].TotalVacantUnitCount}}</td>
                                                <td>{{PropertyTotalRentRollSummary[0].PptyTotalDownUnitCount}}</td>
                                                <td>{{PropertyTotalRentRollSummary[0].TotalOtherUnitCount}}</td>
                                            </tr>											
                                        </table>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                    <div>
                        <table>
                            <thead>
                                <tr>
                                    <th colspan="4">Number of units inspected</th>
                                </tr>
                                <tr>
                                    <th>Occupied</th>
                                    <th>Vacant</th>
                                    <th>Down</th>
                                    <th>Other</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let row of PropertyTotalRentRollSummary[0].PropertyResidentialUnitMix">
                                    <td>{{row.PptyUnitTypeOccupiedInspectedUnitCount}}</td>
                                    <td>{{row.PptyUnitTypeVacantInspectedUnitCount}}</td>
                                    <td>{{row.PptyUnitTypeDownInspectedUnitCount}}</td>
                                    <td>{{row.PptyUnitTypeOtherInspectedUnitCount}}</td>
                                </tr>
								<tr  style="height:16px" *ngIf="!PropertyTotalRentRollSummary[0].PropertyResidentialUnitMix||PropertyTotalRentRollSummary[0].PropertyResidentialUnitMix.length==1">
									<td></td>
									<td></td>
									<td></td>
									<td></td>
								</tr>
								<tr  style="height:16px" *ngIf="!PropertyTotalRentRollSummary[0].PropertyResidentialUnitMix||PropertyTotalRentRollSummary[0].PropertyResidentialUnitMix.length==0">
									<td></td>
									<td></td>
									<td></td>
									<td></td>
								</tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colspan="4" style="padding: 0.2rem 0 0 0;">
                                        <table class="tfoot-table">
                                            <tr>
                                                <td>{{PropertyConditionAssessment[0].RsdntlOccupiedInspectedUnitCount}}</td>
                                                <td>{{PropertyConditionAssessment[0].RsdntlVacantInspectedUnitCount}}</td>
                                                <td>{{PropertyConditionAssessment[0].RsdntlDownInspectedUnitCount}}</td>
                                                <td>{{PropertyConditionAssessment[0].RsdntlOtherInspectedUnitCount}}</td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
                <div class="flex">
                    <div style="width: 66%">
                        <p class="table-title">Table 2</p>
                        <table id="table2">
                            <thead>
                                <tr>
                                    <th colspan="5">Detail of Commercial Units</th>
                                </tr>
                                <tr>
                                    <th width="50%"></th>
                                    <th>Occupied</th>
                                    <th>Vacant</th>
                                    <th>Down</th>
                                    <th>Other</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="border-none">Number of purpose-built spaces</td>
                                    <td>{{PropertyTotalRentRollSummary[0].PropertyCommercialUsageMix[0].OccupiedUnitCount}}</td>
                                    <td>{{PropertyTotalRentRollSummary[0].PropertyCommercialUsageMix[0].VacantUnitCount}}</td>
                                    <td>{{PropertyTotalRentRollSummary[0].PropertyCommercialUsageMix[0].DownUnitCount}}</td>
                                    <td style="font-weight: bold;">{{PropertyTotalRentRollSummary[0].PropertyCommercialUsageMix[0].UnitCount}}</td>
                                </tr>
                                <tr>
                                    <td class="border-none">Number of converted residential units</td>
                                    <td>{{PropertyTotalRentRollSummary[0].PropertyCommercialUsageMix[1].OccupiedUnitCount}}</td>
                                    <td>{{PropertyTotalRentRollSummary[0].PropertyCommercialUsageMix[1].VacantUnitCount}}</td>
                                    <td>{{PropertyTotalRentRollSummary[0].PropertyCommercialUsageMix[1].DownUnitCount}}</td>
                                    <td style="font-weight: bold;">{{PropertyTotalRentRollSummary[0].PropertyCommercialUsageMix[1].UnitCount}}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colspan="5" style="padding: 0.5rem 0 0 0;">
                                        <table id="table2-total">
                                            <tr>
                                                <td>Total residential units</td>
                                                <td style="font-weight: bold;">{{PropertyTotalRentRollSummary[0].PropertyResidentialRentRollSummary[0].RsdntlTotalUnitCount}}</td>
                                            </tr>
                                            <tr>
                                                <td>Total commercial units/spaces</td>
                                                <td style="font-weight: bold;">{{PropertyTotalRentRollSummary[0].PropertyCommercialRentRollSummary[0].CommercialTotalUnitCount}}</td>
                                            </tr>
                                            <tr>
                                                <td>Total ALL units</td>
                                                <td style="font-weight: bold;">{{PropertyTotalRentRollSummary[0].TotalUnitCount}}</td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                    <div style="width: 33%;">
                        <div style="width: 85%; margin: 0 auto;">
                            <p class="table-title">Table 3</p>
                            <table>
                                <thead>
                                    <tr>
                                        <th colspan="2">* Detail of "Other" noted above</th>
                                    </tr>
                                    <tr>
                                        <th width="80%"></th>
                                        <th>Total units</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="border-none">Management office</td>
                                        <td>{{PropertyTotalRentRollSummary[0].PptyTotalOtherMgmtOfficeUnitCount}}</td>
                                    </tr>
                                    <tr>
                                        <td class="border-none">Model</td>
                                        <td>{{PropertyTotalRentRollSummary[0].PptyTotalOtherModelUnitCount}}</td>
                                    </tr>
                                    <tr>
                                        <td class="border-none">Maintenance shop</td>
                                        <td>{{PropertyTotalRentRollSummary[0].PptyTotalOtherMaintenanceShopUnitCount}}</td>
                                    </tr>
                                    <tr>
                                        <td class="border-none">Storage</td>
                                        <td>{{PropertyTotalRentRollSummary[0].PptyTotalOtherStorageUnitCount}}</td>
                                    </tr>
                                    <tr>
                                        <td class="border-none">Hospitality suite</td>
                                        <td>{{PropertyTotalRentRollSummary[0].PptyTotalOtherHospitalitySuiteUnitCount}}</td>
                                    </tr>
                                    <tr>
                                        <td class="border-none">Other</td>
                                        <td>{{PropertyTotalRentRollSummary[0].PptyTotalOtherMiscellaneousUnitCount}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
			
						<h2>Unit Inspection Information</h2>
						<p>Indicate the type of unit, using the following abbreviations: 0BR, 1BR, 2BR, 3BR, 4BR, 5BR. Give the unit number and status, using the following status codes: O = occupied, V = vacant, D = down and R = Other. (For example, an occupied one-bedroom unit numbered 101 should be listed as 1BR/101/O.)</p>
						<div style="width:100%; display:inline; position:relative" class="unit-tables">
							<table style="width:100%; border-collapse: collapse;text-align: center; border:none">
								<tbody>
								<ng-container *ngFor="let row of unitrow|fill; let i=index; trackBy:trackByFuntion">
								<tr style="vertical-align: bottom;" class="border-bottom">
									<td style="border:none;	width:3%; padding:0; height:18px;"><span style="vertical-align: bottom;">{{4*i+1}}</span>
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:5%">
										<p style="text-align: center">{{PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[4*i]&&PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[4*i].UnitType}}</p>
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:12%">
										<p style=" width:99%;border:none;text-align: center;margin: 0;padding: 0;height: 24px;vertical-align: middle; border: 8px solid transparent;border-image: linear-gradient(to top,black  20%, transparent 20%) 1 100%;">{{PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[4*i]&&PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[4*i].SlrDesignatedUnitId}}</p>
										
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; padding:0;width:5%">
										<p style="text-align: center">{{PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[4*i]&&PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[4*i].OccupancyStatusType}}</p>
									</td>
								
									<td style="border:none;	width:3%; padding:0; height:18px;"><span style="vertical-align: bottom;">{{4*i+2}}</span>
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:5%" class="half-a-border-on-right">
										<p style="text-align: center">{{PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[4*i+1]&&PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[4*i+1].UnitType}}</p>
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:12%">
										<p style=" width:99%;border:none;text-align: center;margin: 0;padding: 0;height: 24px;vertical-align: middle; border: 8px solid transparent;border-image: linear-gradient(to top,black  20%, transparent 20%) 1 100%;">{{PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[4*i+1]&&PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[4*i+1].SlrDesignatedUnitId}}</p>
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; padding:0;width:5%">
										<p style="text-align: center">{{PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[4*i+1]&&PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[4*i+1].OccupancyStatusType}}</p>
										
					
									</td>
								
									<td style="border:none;	width:3%; padding:0; height:18px;"><span style="vertical-align: bottom;">{{4*i+3}}</span>
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:5%">
										<p style="text-align: center">{{PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[4*i+2]&&PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[4*i+2].UnitType}}</p>
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:12%">
										<p style=" width:99%;border:none;text-align: center;margin: 0;padding: 0;height: 24px;vertical-align: middle; border: 8px solid transparent;border-image: linear-gradient(to top,black  20%, transparent 20%) 1 100%;">{{PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[4*i+2]&&PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[4*i+2].SlrDesignatedUnitId}}</p>
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; width:5%">
										<p style="text-align: center">{{PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[4*i+2]&&PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[4*i+2].OccupancyStatusType}}</p>
									</td>
								
									<td style="border:none;	width:3%; padding:0; height:18px;"><span style="vertical-align: bottom;">{{4*i+4}}</span>
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:5%">
										<p style="text-align: center">{{PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[4*i+3]&&PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[4*i+3].UnitType}}</p>
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; padding:0;width:12%">
										<p style=" width:99%;border:none;text-align: center;margin: 0;padding: 0;height: 24px;vertical-align: middle; border: 8px solid transparent;border-image: linear-gradient(to top,black  20%, transparent 20%) 1 100%;">{{PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[4*i+3]&&PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[4*i+3].SlrDesignatedUnitId}}</p>
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; padding:0;width:5%">
										<p style="text-align: center">{{PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[4*i+3]&&PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[4*i+3].OccupancyStatusType}}</p>
									</td>
								</tr>
								</ng-container>	
								<ng-container *ngIf="unitrow<5">
								<tr *ngFor="let row of (5-unitrow)|fill; let i=index; trackBy:trackByFuntion" style="vertical-align: bottom;height: 16px;" class="border-bottom">
									<td style="border:none;	width:3%; padding:0; height:18px;"><span style="vertical-align: bottom;">{{unitrow*4+4*i+1}}</span>
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:5%">
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:12%">
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; padding:0;width:5%">
									</td>
									<td style="border:none;	width:3%; padding:0; height:18px;"><span style="vertical-align: bottom;">{{unitrow*4+4*i+2}}</span>
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:5%" class="half-a-border-on-right">
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:12%">
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; padding:0;width:5%">
										
									</td>
								
									<td style="border:none;	width:3%; padding:0; height:18px;"><span style="vertical-align: bottom;">{{unitrow*4+4*i+3}}</span>
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:5%" class="half-a-border-on-right">
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:12%">
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; padding:0;width:5%">
										
									</td>
								
									<td style="border:none;	width:3%; padding:0; height:18px;"><span style="vertical-align: bottom;">{{unitrow*4+4*i+4}}</span>
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:5%" class="half-a-border-on-right">
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:12%">
									</td>
									<td style="border:none; border-bottom:1px solid black; height:14px; padding:0;width:5%">
										
									</td>
								</tr>
							</ng-container>
									
								</tbody>
							</table>
						</div>
							<h2 >List of Parties Present</h2>
							<p style="margin-bottom: 10px;">Provide a listing of parties involved in the site visit (including the consultants).</p>
								<ng-container *ngFor="let row of frmData.ListOfParties; let i=index">
									<table class="partiesTable" style="border:2px solid black" [ngStyle]="{'border-top':i>0?'none':'2px solid black'}">
										<tbody>
											<tr style="height: 14px;">
												<td rowspan="2" style="background-color: black;color: #FFFFFF;vertical-align: middle;width:4%; text-align: center;">
													{{i+1}}
												</td>
												<td style="background-color: #C0C0C0;width:10%; text-align: right">Company
												</td>
												<td style="width:38%;">{{row.Company}}
												</td>
												<td style="background-color: #C0C0C0;width:10%; text-align: right">Name
												</td>
												<td style="width:38%">{{row.Name}}
												</td>
											</tr>
											<tr style="height: 14px;">
												<td style="background-color: #C0C0C0;width:10%; text-align: right">Title
												</td>
												<td style="width:38%">{{row.Title}}
												</td>
												<td style="background-color: #C0C0C0;width:10%; text-align: right">Affiliation
												</td>
												<td style="width:38%">{{row.Affiliation}}
												</td>
											</tr>
											<tr style="border-top: double 2px black;height: 14px;">
												<td colspan="5" style="background-color: #C0C0C0;">Comments
												</td>
											</tr>
											<tr style="height: 14px;">
												<td colspan="5" >{{row.Comments}}
												</td>
											</tr>
										</tbody>
									</table>
								</ng-container>
						
						
							<h2 id="frm_sec0_4" class="page-before">Seismic Checklist</h2>
						<div class="question-line">
							<div class="question">
								Is the property located within an Elevated Seismic Hazard Region as defined in Section 64.2 of the Freddie Mac Multifamily Seller/Servicer Guide?
							</div>
							<div class="question">
								<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':PropertyConditionAssessment[0].PropertySeismicRiskAssessment[0].SeismicRiskFactorInd=='Y', 'radio-unchecked':PropertyConditionAssessment[0].PropertySeismicRiskAssessment[0].SeismicRiskFactorInd=='N'}">Yes</span>
								<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':PropertyConditionAssessment[0].PropertySeismicRiskAssessment[0].SeismicRiskFactorInd=='N', 'radio-unchecked':PropertyConditionAssessment[0].PropertySeismicRiskAssessment[0].SeismicRiskFactorInd=='y'}">No</span>
							</div>
						</div>
						<p style="font-style:italic">Mac Multifamily Seller/Servicer Guide?</p>
						<div *ngIf="PropertyConditionAssessment[0].PropertySeismicRiskAssessment[0].SeismicRiskFactorInd=='Y'">
						<p>Indicate if any of the following high-risk factors from Section 64.2(c) of the Guide were identified at the Property:</p>
						<div style="width:100%; font-size: 12px;display: inline-block;" >
							<div class='klistItem1'>
								<p style="border-bottom:solid 1px black; margin-bottom: 2px">Present/Not Present</p>
								<div *ngIf="PropertyConditionAssessment[0].PropertySeismicRiskAssessment[0].BuildingsWithWeakOrSoftFloorsInd=='Y'" class="textarea leftbox">Present</div>
								<div *ngIf="PropertyConditionAssessment[0].PropertySeismicRiskAssessment[0].BuildingsWithWeakOrSoftFloorsInd!='Y'" class="textarea leftbox">Not Present</div>
							</div>
							<div class='klistItem'>
								<p style="border-bottom:solid 1px black; margin-bottom: 2px;">Risk factor</p>
								<p >Buildings with a weak or soft story (as defined by the International Building Code) at any floor level</p>
							</div>
							<div class='klistItem1'>
								<div *ngIf="PropertyConditionAssessment[0].PropertySeismicRiskAssessment[0].BuildingsWithDirectContactToAdjacentBuildingsInd=='Y'" class="textarea leftbox">Present</div>
								<div *ngIf="PropertyConditionAssessment[0].PropertySeismicRiskAssessment[0].BuildingsWithDirectContactToAdjacentBuildingsInd!='Y'" class="textarea leftbox">Not Present</div>
							</div>
							<div class='klistItem' >
							<p style="margin-top:0;">Buildings constructed with direct contact to adjacent buildings, including buildings that are part of the same Property, as well as those in contact with buildings on a separate property (this does not include buildings that are a continuous structure with fire separation walls)</p>
							</div>
							<div  class='klistItem1'>
								<div *ngIf="PropertyConditionAssessment[0].PropertySeismicRiskAssessment[0].BuildingsWithPrevEarthquakeDamageInd=='Y'" class="textarea leftbox">Present</div>
								<div *ngIf="PropertyConditionAssessment[0].PropertySeismicRiskAssessment[0].BuildingsWithPrevEarthquakeDamageInd!='Y'" class="textarea leftbox">Not Present</div>
							</div>
							<div class='klistItem'>
							<p style="margin-top:0;">Buildings that have sustained previous structural earthquake damage with documented evidence of and repairs</p>
							</div>
							<div class='klistItem1'>
								<div *ngIf="PropertyConditionAssessment[0].PropertySeismicRiskAssessment[0].BuildingsHighRiseInd=='Y'" class="textarea leftbox">Present</div>
								<div *ngIf="PropertyConditionAssessment[0].PropertySeismicRiskAssessment[0].BuildingsHighRiseInd!='Y'" class="textarea leftbox">Not Present</div>
							</div>
							<div class='klistItem'>
						
							<p style="margin-top:0;">High-rise buildings (8-stories or greater above grade)</p>
							</div>
							<div class='klistItem1'>
								<div *ngIf="PropertyConditionAssessment[0].PropertySeismicRiskAssessment[0].BuildingsWithReinforcedConcreteBuiltPriorTo1994Indictor=='Y'" class="textarea leftbox">Present</div>
								<div *ngIf="PropertyConditionAssessment[0].PropertySeismicRiskAssessment[0].BuildingsWithReinforcedConcreteBuiltPriorTo1994Indictor!='Y'" class="textarea leftbox">Not Present</div>
							</div>
							<div class='klistItem'>
							<p style="margin-top:0;" >Reinforced concrete buildings constructed prior to 2000, including cast-in-place and precast structures</p>
							</div>
							<div class='klistItem1'>
								<div *ngIf="PropertyConditionAssessment[0].PropertySeismicRiskAssessment[0].BuildingsWithReinforcedConcreteLoadBearingWallsBuiltPriorTo1994Ind=='Y'" class="textarea leftbox">Present</div>
								<div *ngIf="PropertyConditionAssessment[0].PropertySeismicRiskAssessment[0].BuildingsWithReinforcedConcreteLoadBearingWallsBuiltPriorTo1994Ind!='Y'" class="textarea leftbox">Not Present</div>
							</div>
							<div class='klistItem'>
							<p style="margin-top:0;" >Reinforced concrete masonry bearing wall buildings constructed prior to 2000</p>
							</div>
							<div class='klistItem1'>
								<div *ngIf="PropertyConditionAssessment[0].PropertySeismicRiskAssessment[0].BuildingsWithUnreinforcedMasonryRetrofittedInd=='Y'" class="textarea leftbox">Present</div>
								<div *ngIf="PropertyConditionAssessment[0].PropertySeismicRiskAssessment[0].BuildingsWithUnreinforcedMasonryRetrofittedInd!='Y'" class="textarea leftbox">Not Present</div>
							</div>
							<div class='klistItem'>
							<p style="margin-top:0;" >Retrofitted, unreinforced masonry (URM) buildings</p>
							</div>
							<div class='klistItem1'>
								<div *ngIf="PropertyConditionAssessment[0].PropertySeismicRiskAssessment[0].BuildingsWithUnreinforcedMasonryRetrofittedPriorTo1995Indictor=='Y'" class="textarea leftbox">Present</div>
								<div *ngIf="PropertyConditionAssessment[0].PropertySeismicRiskAssessment[0].BuildingsWithUnreinforcedMasonryRetrofittedPriorTo1995Indictor!='Y'" class="textarea leftbox">Not Present</div>
							</div>
							<div class='klistItem'>
							<p style="margin-top:0;" >Non-retrofitted URM buildings (SRA report shall provide discussion of typical retrofit schemes and budget estimates for consideration)</p>
							</div>
							<div class='klistItem1'>
								<div *ngIf="PropertyConditionAssessment[0].PropertySeismicRiskAssessment[0].BuildingsWithWoodFrameConspicuousDeteriorationInd=='Y'" class="textarea leftbox">Present</div>
								<div *ngIf="PropertyConditionAssessment[0].PropertySeismicRiskAssessment[0].BuildingsWithWoodFrameConspicuousDeteriorationInd!='Y'" class="textarea leftbox">Not Present</div>
							</div>
							<div class='klistItem'>
							<p style="margin-top:0;" >Wood-framed buildings that exhibit conspicuous physical deterioration (e.g., water damage, dry rot, corrosion, physical distress) to the primary lateral load resisting elements</p>
							</div>
							<div class='klistItem1'>
								<div *ngIf="PropertyConditionAssessment[0].PropertySeismicRiskAssessment[0].WoodFrameBuiltPriorTo1950Ind=='Y'" class="textarea leftbox">Present</div>
								<div *ngIf="PropertyConditionAssessment[0].PropertySeismicRiskAssessment[0].WoodFrameBuiltPriorTo1950Ind!='Y'" class="textarea leftbox">Not Present</div>
							</div>
							<div class='klistItem'>
							<p style="margin-top:0;" >Wood-framed buildings constructed prior to 1960</p>
							</div>
							<div class='klistItem1'>
								<div *ngIf="PropertyConditionAssessment[0].PropertySeismicRiskAssessment[0].BuildingsWithWoodFrameParkingUnderUnitsNonRetrofittedAndBuiltPriorTo2000Ind=='Y'" class="textarea leftbox">Present</div>
								<div *ngIf="PropertyConditionAssessment[0].PropertySeismicRiskAssessment[0].BuildingsWithWoodFrameParkingUnderUnitsNonRetrofittedAndBuiltPriorTo2000Ind!='Y'" class="textarea leftbox">Not Present</div>
							</div>
							<div class='klistItem'>
							<p style="margin-top:0;" >Wood-framed buildings constructed prior to 2000, with ground-level parking (tuck-under parking) or commercial retail units under dwelling units, regardless of retrofit</p>
							</div>
							<div class='klistItem1'>
								<div *ngIf="PropertyConditionAssessment[0].PropertySeismicRiskAssessment[0].BuildingsWithLightFrameOverConcretePodiumBuiltPriorTo1994Ind=='Y'" class="textarea leftbox">Present</div>
								<div *ngIf="PropertyConditionAssessment[0].PropertySeismicRiskAssessment[0].BuildingsWithLightFrameOverConcretePodiumBuiltPriorTo1994Ind!='Y'" class="textarea leftbox">Not Present</div>
							</div>
							<div class='klistItem' >
							<p style="margin-top:0;" >Buildings with wood-frame construction over a concrete podium structure constructed prior to 2000</p>
							</div>
							<div class='klistItem1'>
								<div *ngIf="PropertyConditionAssessment[0].PropertySeismicRiskAssessment[0].BuildingsLocatedNearFaultOrSpecialStudyZoneInd=='Y'" class="textarea leftbox">Present</div>
								<div *ngIf="PropertyConditionAssessment[0].PropertySeismicRiskAssessment[0].BuildingsLocatedNearFaultOrSpecialStudyZoneInd!='Y'" class="textarea leftbox">Not Present</div>								
							</div>
							<div class='klistItem'>
							<p style="margin-top:0;" >A building located within 50 feet of a mapped earthquake fault trace or located within an Alquist-Priolo Earthquake Fault Zone (APEFZ) in California</p>
							</div>
							
						</div>
					</div>
						<div id="sec6" style="margin-top: 6px;font-size:12px">
							<h2 id="frm_sec0_5" >Consultant's Certification</h2>
						On behalf of the property condition consultant, the undersigned hereby certifies that:
						<ul>
						<li>The attached property condition report was prepared by the consultant in accordance with all applicable requirements in the Freddie Mac Multifamily Seller/Servicer Guide</li>
						<li>No changes or additions have been made to the standard provisions of this form other than those expressly approved in writing by Freddie Mac</li>
						<li>The report was prepared in a manner consistent with generally accepted industry practices and standards</li>
						<li>All information is true and correct, to the best of the undersigned's knowledge, and reflects the consultant's best professional opinion and judgment</li>
						</ul>
						<div style="width:100%; position:relative; padding-top: 10px;">
						<div style="width:49%;display:inline-block;">
							<div style="display:inline-block;;margin:0;border-left:5px solid black;border-bottom:1px solid black;width:100%;">
								<div style="height:4px;"></div>
								<label style="margin-left:4px">Consulting firm name</label><br>
								<p style="height:25px; font-size: 14px; vertical-align:bottom;margin-left: 10px; line-height: 25px;">{{frmData.firmname}}</p>
							</div>
						</div><br>
						<div style="width:49%; display:inline-block;vertical-align:bottom;">
							<div style="display:inline-block;;margin:0;border-left:5px solid black;border-bottom:1px solid black;width:100%;">
								<div style="height:4px;"></div>
								<label style="margin-left:4px">Signature of authorized representative</label><br>
								<ng-container *ngIf="frmData['frmSign']">
										<img  id='frmsign' [src]="frmData['frmSign']" alt="Signature" style="max-height:25px;width:auto;vertical-align:bottom; margin: 0 20px;">
								</ng-container>
								<ng-container *ngIf="!frmData['frmSign']">
									<p style="height:25px; font-size: 14px;vertical-align:bottom;margin-left: 10px; line-height: 25px"></p>
								</ng-container>
								
							</div>
						</div>
						
						<div style="width:49%; display:inline-block;;margin-left:10px">
						<div style="display:inline-block;;margin:0;width:100%;">
							<div style="height:4px; border:none; "></div>
							<label style="margin-left:8px">Date</label><br>
							<p style="border-left:5px solid black;height:25px; font-size: 14px;vertical-align:bottom;padding-left: 10px; line-height: 25px;border-bottom:1px solid black;">{{frmData['date']|date:'MMMM dd, yyyy'}}</p>
						</div>
						</div>
						<div style="width:49%; display:inline-block;">
						<div style="display:inline-block;;margin:0;border-left:5px solid black;border-bottom:1px solid black;width:100%;">
							<div style="height:4px;"></div>
							<label style="margin-left:4px">Name (typed or printed)</label><br>
							<p style="height:25px; font-size: 14px;vertical-align:bottom;margin-left: 10px; line-height: 25px">{{frmData['frmSignName']}}</p>
						</div>
						</div>
						<div style="width:49%; display:inline-block;margin-left:10px">
						<div style="display:inline-block;margin:0;width:100%;">
							<div style="height:4px; border:none; "></div>
							<label style="margin-left:8px">Title</label><br>
							<p style="border-left:5px solid black;height:25px; font-size: 14px;vertical-align:bottom;padding-left: 10px;; line-height: 25px;border-bottom:1px solid black;">{{frmData.title}}</p>
						</div>
						</div>
					</div>	
						</div>
					
					
				
        </section>
        <section class="page-before" data-section-title="Section II">
            <header>
                <div class="freddie-mac-header">
                    <div class="freddie-mac-logo">
                        <img src="https://erisservice9.erisinfo.com/exreportw/frmimages/logo.jpg" alt="Freddie Mac Multifamily">
                    </div>
                    <div class="freddie-mac-title">
                        <strong>Property Condition Assessment</strong>
                    </div>
                </div>
            </header>
            <h1>Section II: Property Inspection and Evaluation</h1>
            <table>
                <thead>
                    <tr>
                        <td class="wrapper">
                            <h2>&nbsp;</h2>
                            <table class="section-header">
                                <tr>
                                    <td width="25%">
                                        <div>
                                            <p *ngIf="PropertyAsReportedHTML?.FrmLoanNo?.html" [innerHTML]="PropertyAsReportedHTML?.FrmLoanNo?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.FrmLoanNo?.html" [innerHTML]="PropertyAsReportedHTML?.FrmLoanNo?.text"></p>
                                            <label>Freddie Mac loan number</label>
                                        </div>
                                    </td>
                                    <td width="25%">
                                        <div>
                                            <p [innerHTML]="PropertyConditionAssessmentHTML?.FinalAsmntDate|date:'MMMM dd, yyyy'"></p>
                                            <label>Report date</label>
                                        </div>
                                    </td>
                                    <td colspan="2" width="50%">
                                        <div>
                                            <p *ngIf="PropertyAsReportedHTML?.AsReportedName?.html" [innerHTML]="PropertyAsReportedHTML?.AsReportedName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AsReportedName?.html" [innerHTML]="PropertyAsReportedHTML?.AsReportedName?.text"></p>
											<label>Property name</label>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.AccountName?.html" [innerHTML]="PropertyAsReportedHTML?.AccountName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AccountName?.html" [innerHTML]="PropertyAsReportedHTML?.AccountName?.text"></p>
											<label>Seller/Servicer name</label>
                                        </div>
                                    </td>
                                    <td colspan="2" class="fh">
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.AddressLineText?.html" [innerHTML]="PropertyAsReportedHTML?.AddressLineText?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AddressLineText?.html" [innerHTML]="PropertyAsReportedHTML?.AddressLineText?.text"></p>
											<label>Address</label>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.PartyBusinessAccountId?.html" [innerHTML]="PropertyAsReportedHTML?.PartyBusinessAccountId?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.PartyBusinessAccountId?.html" [innerHTML]="PropertyAsReportedHTML?.PartyBusinessAccountId?.text"></p>
											<label>Seller/Servicer number</label>
                                        </div>
                                    </td>
                                    <td>
                                        <div>
                                            <p [innerHTML]="PropertyConditionAssessmentHTML?.PrelimInspectionDate|date:'MMMM dd, yyyy'"></p>
                                            <label>Inspection date</label>
                                        </div>
                                    </td>
                                    <td colspan="2" class="fh">
                                        <div>
                                            <p><ng-container *ngIf="PropertyAsReportedHTML?.CityName?.html"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.CityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="!PropertyAsReportedHTML?.CityName?.html&&PropertyAsReportedHTML?.CityName?.text"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.CityName?.text"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="PropertyAsReportedHTML?.StateUspsCode?.html"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.StateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="!PropertyAsReportedHTML?.StateUspsCode?.html&&PropertyAsReportedHTML?.StateUspsCode?.text"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.StateUspsCode?.text"></span>,&nbsp;</ng-container> 
												<span *ngIf="PropertyAsReportedHTML?.PostalCode?.html" style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.PostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>
												<span *ngIf="!PropertyAsReportedHTML?.PostalCode?.html" style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.PostalCode?.secHtml?.text"></span></p>
											<label>City, State, Zip</label>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="wrapper">
                            <h2>Site</h2>
                            <p>Complete the estimated useful life, condition, remaining useful life, action and comments for the applicable items listed below. Indicate the condition using the following abbreviations: 1 = Excellent, 2 = Very Good/Good, 3 = Fair, 4 = Deteriorated and 5 = Unacceptable. Indicate the action required using the following abbreviations: CR = Critical Repairs; PR = Priority Repairs; PR90 = 90 day Priority Repairs and RR = reserve for future repair/replacement. See Section VII for a complete description of each repair category. The consultant should attach additional information as needed. The consultant must also note any Mold observations on any component in the comment sections.</p>
							<div *ngIf='sec2tablesdata' id="sec2" style="font-size: 11px;">
								<table class='datatable' style="width:100%; font-size:10px; font-family:Arial, sans-serif;border: 1px solid black;border-collapse: collapse;margin-top: 10px;">
									<thead>
										<tr>
											<!--<ng-container *ngFor="let h of sec2tablesdata[0].cols; let o=index; trackBy:trackByFuntion">
												<th [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign,'border':h.border}" [ngClass]="h.bk"><p [ngStyle]="{'width':o<(sec2tablesdata[0].cols.length-2)?'66%':'100%'}">{{h.NAME}}</p>
												</th>	
											</ng-container>-->
											<th style="width:25%; text-align: left;border:1px solid black; vertical-align: bottom;">Item</th>
											<th style="width:13%; text-align: left;border:1px solid black; vertical-align: bottom;">Estimated <br>Useful Life</th>
											<th style="width:13%; text-align: left;border:1px solid black; vertical-align: bottom;">Condition<br> (1, 2, 3, 4, 5)</th>
											<th style="width:13%; text-align: left;border:1px solid black; vertical-align: bottom;">Rmaining <br>Useful Life</th>
											<th style="width:13%; text-align: left;border:1px solid black; vertical-align: bottom;">Action (CR, PR, <br>PR-90, RR)</th>	
											<th style="width:23%; text-align: left;border:1px solid black; vertical-align: bottom;">Comments/Mold Observations</th>										
										</tr>
									</thead>
									<tbody>
									<ng-container *ngFor="let r of sec2tablesdata[0].rows; let h=index; trackBy:trackByFuntion">
										<tr *ngIf="r.length>1">
											<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
												<td [ngClass]="k.bk" colSpan='{{k.colspan}}' [ngStyle]="{'text-align':sec2tablesdata[0].cols[q].celAllign, 'background-color':k.bk , 'font-weight':k.weight, width:sec2tablesdata[0].cols[q].width+sec2tablesdata[0].cols[q].unit, 'border':k.border,'padding-left':k.sub}">{{k.data}}
												</td>		
											</ng-container>
										</tr>
									</ng-container>  
								</tbody>
							</table>
							
							</div>
						</td>
					</tr>
				 </tbody>
            </table>
			<table class="page-before">
                <thead>
                    <tr>
                        <td class="wrapper">
                            <h2>&nbsp;</h2>
                            <table class="section-header">
                                <tr>
                                    <td width="25%">
                                        <div>
                                            <p *ngIf="PropertyAsReportedHTML?.FrmLoanNo?.html" [innerHTML]="PropertyAsReportedHTML?.FrmLoanNo?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.FrmLoanNo?.html" [innerHTML]="PropertyAsReportedHTML?.FrmLoanNo?.text"></p>
											<label>Freddie Mac loan number</label>
                                        </div>
                                    </td>
                                    <td width="25%">
                                        <div>
                                            <p [innerHTML]="PropertyConditionAssessmentHTML?.FinalAsmntDate|date:'MMMM dd, yyyy'"></p>
                                            <label>Report date</label>
                                        </div>
                                    </td>
                                    <td colspan="2" width="50%">
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.AsReportedName?.html" [innerHTML]="PropertyAsReportedHTML?.AsReportedName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AsReportedName?.html" [innerHTML]="PropertyAsReportedHTML?.AsReportedName?.text"></p>
											<label>Property name</label>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.AccountName?.html" [innerHTML]="PropertyAsReportedHTML?.AccountName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AccountName?.html" [innerHTML]="PropertyAsReportedHTML?.AccountName?.text"></p>
											<label>Seller/Servicer name</label>
                                        </div>
                                    </td>
                                    <td colspan="2" class="fh">
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.AddressLineText?.html" [innerHTML]="PropertyAsReportedHTML?.AddressLineText?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AddressLineText?.html" [innerHTML]="PropertyAsReportedHTML?.AddressLineText?.text"></p>
											<label>Address</label>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.PartyBusinessAccountId?.html" [innerHTML]="PropertyAsReportedHTML?.PartyBusinessAccountId?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.PartyBusinessAccountId?.html" [innerHTML]="PropertyAsReportedHTML?.PartyBusinessAccountId?.text"></p>
											<label>Seller/Servicer number</label>
                                        </div>
                                    </td>
                                    <td>
                                        <div>
                                            <p [innerHTML]="PropertyConditionAssessmentHTML?.PrelimInspectionDate|date:'MMMM dd, yyyy'"></p>
                                            <label>Inspection date</label>
                                        </div>
                                    </td>
                                    <td colspan="2" class="fh">
                                        <div>
                                            <p><ng-container *ngIf="PropertyAsReportedHTML?.CityName?.html"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.CityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="!PropertyAsReportedHTML?.CityName?.html&&PropertyAsReportedHTML?.CityName?.text"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.CityName?.text"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="PropertyAsReportedHTML?.StateUspsCode?.html"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.StateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="!PropertyAsReportedHTML?.StateUspsCode?.html&&PropertyAsReportedHTML?.StateUspsCode?.text"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.StateUspsCode?.text"></span>,&nbsp;</ng-container> 
												<span *ngIf="PropertyAsReportedHTML?.PostalCode?.html" style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.PostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>
												<span *ngIf="!PropertyAsReportedHTML?.PostalCode?.html" style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.PostalCode?.secHtml?.text"></span></p>
											<label>City, State, Zip</label>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="wrapper">
							<h2>Structural, building envelope and common area furniture, fixtures and equipment</h2>
                            <p>Complete the estimated useful life, condition, remaining useful life, action and comments for the applicable items listed below. Indicate the condition using the following abbreviations: 1 = Excellent, 2 = Very Good/Good, 3 = Fair, 4 = Deteriorated and 5 = Unacceptable. Indicate the action required using the following abbreviations: CR = Critical Repairs; PR = Priority Repairs; PR90 = 90 day Priority Repairs and RR = reserve for future repair/replacement. See Section VII for a complete description of each repair category. The consultant should attach additional information as needed. The consultant must also note any Mold observations on any component in the comment sections.</p>
							<div *ngIf='sec2tablesdata' id="sec3" style="font-size: 11px">
								<table class='datatable' style="width:100%; font-size:10px; font-family:Arial, sans-serif;border: 1px solid black;border-collapse: collapse;margin-top: 10px">
									<thead>
										<tr>
											<th style="width:25%; text-align: left;border:1px solid black; vertical-align: bottom;">Item</th>
											<th style="width:13%; text-align: left;border:1px solid black; vertical-align: bottom;">Estimated <br>Useful Life</th>
											<th style="width:13%; text-align: left;border:1px solid black; vertical-align: bottom;">Condition<br> (1, 2, 3, 4, 5)</th>
											<th style="width:13%; text-align: left;border:1px solid black; vertical-align: bottom;">Rmaining <br>Useful Life</th>
											<th style="width:13%; text-align: left;border:1px solid black; vertical-align: bottom;">Action (CR, PR, <br>PR-90, RR)</th>	
											<th style="width:23%; text-align: left;border:1px solid black; vertical-align: bottom;">Comments/Mold Observations</th>	
										</tr>
									</thead>
									<tbody>
										<ng-container *ngFor="let r of sec2tablesdata[1].rows; let h=index; trackBy:trackByFuntion">
											<tr *ngIf="r.length>1">
												<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
													<td [ngClass]="k.bk" colSpan='{{k.colspan}}' [ngStyle]="{'text-align':sec2tablesdata[1].cols[q].celAllign, 'background-color':k.bk , 'font-weight':k.weight, width:sec2tablesdata[1].cols[q].width+sec2tablesdata[1].cols[q].unit, 'border':k.border,'padding-left':k.sub}">{{k.data}}
													</td>		
												</ng-container>
											</tr>
										</ng-container>
									</tbody>  
							</table>
							</div>

						</td>
					</tr>	
				</tbody>
			</table>
			<table class="page-before">
                <thead>
                    <tr>
                        <td class="wrapper">
                            <h2>&nbsp;</h2>
                            <table class="section-header">
                                <tr>
                                    <td width="25%">
                                        <div>
                                            <p *ngIf="PropertyAsReportedHTML?.FrmLoanNo?.html" [innerHTML]="PropertyAsReportedHTML?.FrmLoanNo?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.FrmLoanNo?.html" [innerHTML]="PropertyAsReportedHTML?.FrmLoanNo?.text"></p>
											<label>Freddie Mac loan number</label>
                                        </div>
                                    </td>
                                    <td width="25%">
                                        <div>
                                            <p [innerHTML]="PropertyConditionAssessmentHTML?.FinalAsmntDate|date:'MMMM dd, yyyy'"></p>
                                            <label>Report date</label>
                                        </div>
                                    </td>
                                    <td colspan="2" width="50%">
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.AsReportedName?.html" [innerHTML]="PropertyAsReportedHTML?.AsReportedName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AsReportedName?.html" [innerHTML]="PropertyAsReportedHTML?.AsReportedName?.text"></p>
											<label>Property name</label>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.AccountName?.html" [innerHTML]="PropertyAsReportedHTML?.AccountName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AccountName?.html" [innerHTML]="PropertyAsReportedHTML?.AccountName?.text"></p>
											<label>Seller/Servicer name</label>
                                        </div>
                                    </td>
                                    <td colspan="2" class="fh">
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.AddressLineText?.html" [innerHTML]="PropertyAsReportedHTML?.AddressLineText?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AddressLineText?.html" [innerHTML]="PropertyAsReportedHTML?.AddressLineText?.text"></p>
											<label>Address</label>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.PartyBusinessAccountId?.html" [innerHTML]="PropertyAsReportedHTML?.PartyBusinessAccountId?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.PartyBusinessAccountId?.html" [innerHTML]="PropertyAsReportedHTML?.PartyBusinessAccountId?.text"></p>
											<label>Seller/Servicer number</label>
                                        </div>
                                    </td>
                                    <td>
                                        <div>
                                            <p [innerHTML]="PropertyConditionAssessmentHTML?.PrelimInspectionDate|date:'MMMM dd, yyyy'"></p>
                                            <label>Inspection date</label>
                                        </div>
                                    </td>
                                    <td colspan="2" class="fh">
                                        <div>
                                            <p><ng-container *ngIf="PropertyAsReportedHTML?.CityName?.html"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.CityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="!PropertyAsReportedHTML?.CityName?.html&&PropertyAsReportedHTML?.CityName?.text"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.CityName?.text"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="PropertyAsReportedHTML?.StateUspsCode?.html"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.StateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="!PropertyAsReportedHTML?.StateUspsCode?.html&&PropertyAsReportedHTML?.StateUspsCode?.text"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.StateUspsCode?.text"></span>,&nbsp;</ng-container> 
												<span *ngIf="PropertyAsReportedHTML?.PostalCode?.html" style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.PostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>
												<span *ngIf="!PropertyAsReportedHTML?.PostalCode?.html" style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.PostalCode?.secHtml?.text"></span></p>
											<label>City, State, Zip</label>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="wrapper">
							<h2>Mechanical and electrical</h2>
							<p>Complete the estimated useful life, condition, remaining useful life, action and comments for the applicable items listed below. Indicate the condition using the following abbreviations: 1 = Excellent, 2 = Very Good/Good, 3 = Fair, 4 = Deteriorated and 5 = Unacceptable. Indicate the action required using the following abbreviations: CR = Critical Repairs; PR = Priority Repairs; PR90 = 90 day Priority Repairs and RR = reserve for future repair/replacement. See Section VII for a complete description of each repair category. The consultant should attach additional information as needed. The consultant must also note any Mold observations on any component in the comment sections.</p>
							<div  *ngIf='sec2tablesdata' id="sec4" style="font-size: 11px">
								<table class='datatable' style="width:100%; font-size:10px; font-family:Arial, sans-serif;border: 1px solid black;border-collapse: collapse;margin-top: 10px">
									<thead>
										<tr>
											<th style="width:25%; text-align: left;border:1px solid black; vertical-align: bottom;">Item</th>
											<th style="width:13%; text-align: left;border:1px solid black; vertical-align: bottom;">Estimated <br>Useful Life</th>
											<th style="width:13%; text-align: left;border:1px solid black; vertical-align: bottom;">Condition<br> (1, 2, 3, 4, 5)</th>
											<th style="width:13%; text-align: left;border:1px solid black; vertical-align: bottom;">Rmaining <br>Useful Life</th>
											<th style="width:13%; text-align: left;border:1px solid black; vertical-align: bottom;">Action (CR, PR, <br>PR-90, RR)</th>	
											<th style="width:23%; text-align: left;border:1px solid black; vertical-align: bottom;">Comments/Mold Observations</th>	
										</tr>
									</thead>
									<tbody>
										<ng-container *ngFor="let r of sec2tablesdata[2].rows; let h=index; trackBy:trackByFuntion">
											<tr *ngIf="r.length>1">
												<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
													<td [ngClass]="k.bk" colSpan='{{k.colspan}}' [ngStyle]="{'text-align':sec2tablesdata[2].cols[q].celAllign, 'background-color':k.bk , 'font-weight':k.weight, width:sec2tablesdata[2].cols[q].width+sec2tablesdata[2].cols[q].unit, 'border':k.border,'padding-left':k.sub}">{{k.data}}
													</td>		
												</ng-container>
											</tr>
										</ng-container>
									</tbody>	  
								</table>
							</div>
						</td>
					</tr>	
				</tbody>
			</table>
			<table class="page-before">
                <thead>
                    <tr>
                        <td class="wrapper">
                            <h2>&nbsp;</h2>
                            <table class="section-header">
                                <tr>
                                    <td width="25%">
                                        <div>
                                            <p *ngIf="PropertyAsReportedHTML?.FrmLoanNo?.html" [innerHTML]="PropertyAsReportedHTML?.FrmLoanNo?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.FrmLoanNo?.html" [innerHTML]="PropertyAsReportedHTML?.FrmLoanNo?.text"></p>
											<label>Freddie Mac loan number</label>
                                        </div>
                                    </td>
                                    <td width="25%">
                                        <div>
                                            <p [innerHTML]="PropertyConditionAssessmentHTML?.FinalAsmntDate|date:'MMMM dd, yyyy'"></p>
                                            <label>Report date</label>
                                        </div>
                                    </td>
                                    <td colspan="2" width="50%">
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.AsReportedName?.html" [innerHTML]="PropertyAsReportedHTML?.AsReportedName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AsReportedName?.html" [innerHTML]="PropertyAsReportedHTML?.AsReportedName?.text"></p>
											<label>Property name</label>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.AccountName?.html" [innerHTML]="PropertyAsReportedHTML?.AccountName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AccountName?.html" [innerHTML]="PropertyAsReportedHTML?.AccountName?.text"></p>
											<label>Seller/Servicer name</label>
                                        </div>
                                    </td>
                                    <td colspan="2" class="fh">
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.AddressLineText?.html" [innerHTML]="PropertyAsReportedHTML?.AddressLineText?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AddressLineText?.html" [innerHTML]="PropertyAsReportedHTML?.AddressLineText?.text"></p>
											<label>Address</label>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.PartyBusinessAccountId?.html" [innerHTML]="PropertyAsReportedHTML?.PartyBusinessAccountId?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.PartyBusinessAccountId?.html" [innerHTML]="PropertyAsReportedHTML?.PartyBusinessAccountId?.text"></p>
											<label>Seller/Servicer number</label>
                                        </div>
                                    </td>
                                    <td>
                                        <div>
                                            <p [innerHTML]="PropertyConditionAssessmentHTML?.PrelimInspectionDate|date:'MMMM dd, yyyy'"></p>
                                            <label>Inspection date</label>
                                        </div>
                                    </td>
                                    <td colspan="2" class="fh">
                                        <div>
                                            <p><ng-container *ngIf="PropertyAsReportedHTML?.CityName?.html"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.CityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="!PropertyAsReportedHTML?.CityName?.html&&PropertyAsReportedHTML?.CityName?.text"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.CityName?.text"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="PropertyAsReportedHTML?.StateUspsCode?.html"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.StateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="!PropertyAsReportedHTML?.StateUspsCode?.html&&PropertyAsReportedHTML?.StateUspsCode?.text"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.StateUspsCode?.text"></span>,&nbsp;</ng-container> 
												<span *ngIf="PropertyAsReportedHTML?.PostalCode?.html" style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.PostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>
												<span *ngIf="!PropertyAsReportedHTML?.PostalCode?.html" style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.PostalCode?.secHtml?.text"></span></p>
											<label>City, State, Zip</label>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="wrapper"><h2>Dwelling units</h2>
							<p>Complete the estimated useful life, condition, remaining useful life, action and comments for the applicable items listed below. Indicate the condition using the following abbreviations: 1 = Excellent, 2 = Very Good/Good, 3 = Fair, 4 = Deteriorated and 5 = Unacceptable. Indicate the action required using the following abbreviations: CR = Critical Repairs; PR = Priority Repairs; PR90 = 90 day Priority Repairs and RR = reserve for future repair/replacement. See Section VII for a complete description of each repair category. The consultant should attach additional information as needed. The consultant must also note any Mold observations on any component in the comment sections.</p>
							<div  *ngIf='sec2tablesdata' id="sec5" style="font-size: 11px">
								<table class='datatable' style="width:100%; font-size:10px; font-family:Arial, sans-serif;border: 1px solid black;border-collapse: collapse;margin-top: 10px">
									<thead>
										<tr>
											<th style="width:25%; text-align: left;border:1px solid black; vertical-align: bottom;">Item</th>
											<th style="width:13%; text-align: left;border:1px solid black; vertical-align: bottom;">Estimated <br>Useful Life</th>
											<th style="width:13%; text-align: left;border:1px solid black; vertical-align: bottom;">Condition<br> (1, 2, 3, 4, 5)</th>
											<th style="width:13%; text-align: left;border:1px solid black; vertical-align: bottom;">Rmaining <br>Useful Life</th>
											<th style="width:13%; text-align: left;border:1px solid black; vertical-align: bottom;">Action (CR, PR, <br>PR-90, RR)</th>	
											<th style="width:23%; text-align: left;border:1px solid black; vertical-align: bottom;">Comments/Mold Observations</th>	
										</tr>
									</thead>
									<tbody>
										<ng-container *ngFor="let r of sec2tablesdata[3].rows; let h=index; trackBy:trackByFuntion">
											<tr *ngIf="r.length>1">
												<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
													<td [ngClass]="k.bk" colSpan='{{k.colspan}}' [ngStyle]="{'text-align':sec2tablesdata[3].cols[q].celAllign, 'background-color':k.bk , 'font-weight':k.weight, width:sec2tablesdata[3].cols[q].width+sec2tablesdata[3].cols[q].unit, 'border':k.border,'padding-left':k.sub}">{{k.data}}
													</td>		
												</ng-container>
											</tr>
										</ng-container>
									</tbody>	  
							</table>
							</div>
						</td>
					</tr>	
				</tbody>
			</table>
			<div class="page-before" style="width:100%">
                
                            <h2>&nbsp;</h2>
                            <table class="section-header">
                                <tr>
                                    <td width="25%">
                                        <div>
                                            <p *ngIf="PropertyAsReportedHTML?.FrmLoanNo?.html" [innerHTML]="PropertyAsReportedHTML?.FrmLoanNo?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.FrmLoanNo?.html" [innerHTML]="PropertyAsReportedHTML?.FrmLoanNo?.text"></p>
											<label>Freddie Mac loan number</label>
                                        </div>
                                    </td>
                                    <td width="25%">
                                        <div>
                                            <p [innerHTML]="PropertyConditionAssessmentHTML?.FinalAsmntDate|date:'MMMM dd, yyyy'"></p>
                                            <label>Report date</label>
                                        </div>
                                    </td>
                                    <td colspan="2" width="50%">
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.AsReportedName?.html" [innerHTML]="PropertyAsReportedHTML?.AsReportedName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AsReportedName?.html" [innerHTML]="PropertyAsReportedHTML?.AsReportedName?.text"></p>
											<label>Property name</label>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.AccountName?.html" [innerHTML]="PropertyAsReportedHTML?.AccountName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AccountName?.html" [innerHTML]="PropertyAsReportedHTML?.AccountName?.text"></p>
											<label>Seller/Servicer name</label>
                                        </div>
                                    </td>
                                    <td colspan="2" class="fh">
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.AddressLineText?.html" [innerHTML]="PropertyAsReportedHTML?.AddressLineText?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AddressLineText?.html" [innerHTML]="PropertyAsReportedHTML?.AddressLineText?.text"></p>
											<label>Address</label>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.PartyBusinessAccountId?.html" [innerHTML]="PropertyAsReportedHTML?.PartyBusinessAccountId?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.PartyBusinessAccountId?.html" [innerHTML]="PropertyAsReportedHTML?.PartyBusinessAccountId?.text"></p>
											<label>Seller/Servicer number</label>
                                        </div>
                                    </td>
                                    <td>
                                        <div>
                                            <p [innerHTML]="PropertyConditionAssessmentHTML?.PrelimInspectionDate|date:'MMMM dd, yyyy'"></p>
                                            <label>Inspection date</label>
                                        </div>
                                    </td>
                                    <td colspan="2" class="fh">
                                        <div>
                                            <p><ng-container *ngIf="PropertyAsReportedHTML?.CityName?.html"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.CityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="!PropertyAsReportedHTML?.CityName?.html&&PropertyAsReportedHTML?.CityName?.text"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.CityName?.text"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="PropertyAsReportedHTML?.StateUspsCode?.html"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.StateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="!PropertyAsReportedHTML?.StateUspsCode?.html&&PropertyAsReportedHTML?.StateUspsCode?.text"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.StateUspsCode?.text"></span>,&nbsp;</ng-container> 
												<span *ngIf="PropertyAsReportedHTML?.PostalCode?.html" style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.PostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>
												<span *ngIf="!PropertyAsReportedHTML?.PostalCode?.html" style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.PostalCode?.secHtml?.text"></span></p>
											<label>City, State, Zip</label>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        
							<div style="width:100%; padding:10px 0; ">
								<h2>Overall Property Condition Rating</h2>
								<p style="margin-top: 4px;">Provide a description of the overall property condition:</p>
								<div class="textarea" style="width: 100%;min-height: 32px !important; max-height: 600px !important;overflow: hidden;font-size: 9pt !important;" >{{frmData.overallPropertyRating.overallCondition}}</div>
								<div class="totalbox">
									<p class="leftlabel1">Based on the condition of the property, what is the overall property condition rating</p>
									<div class="textarea rightbox" style="padding:2px 8px; width: 140px;">{{frmData.overallPropertyRating.overallRating}}</div>		 
								</div>
							</div>							
			</div>		
        </section>
        <section class="page-before" data-section-title="Section III">
            <header>
                <div class="freddie-mac-header">
                    <div class="freddie-mac-logo">
                        <img src="https://erisservice9.erisinfo.com/exreportw/frmimages/logo.jpg" alt="Freddie Mac Multifamily">
                    </div>
                    <div class="freddie-mac-title">
                        <strong>Property Condition Assessment</strong>
                    </div>
                </div>
            </header>
			<h1>Section III: Repairs and Cost Estimates</h1>
			<table>
                <thead>
                    <tr>
                        <td class="wrapper">
                            <h2>&nbsp;</h2>
                            <table class="section-header">
                                <tr>
                                    <td width="25%">
                                        <div>
                                            <p *ngIf="PropertyAsReportedHTML?.FrmLoanNo?.html" [innerHTML]="PropertyAsReportedHTML?.FrmLoanNo?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.FrmLoanNo?.html" [innerHTML]="PropertyAsReportedHTML?.FrmLoanNo?.text"></p>
											<label>Freddie Mac loan number</label>
                                        </div>
                                    </td>
                                    <td width="25%">
                                        <div>
                                            <p [innerHTML]="PropertyConditionAssessmentHTML?.FinalAsmntDate|date:'MMMM dd, yyyy'"></p>
                                            <label>Report date</label>
                                        </div>
                                    </td>
                                    <td colspan="2" width="50%">
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.AsReportedName?.html" [innerHTML]="PropertyAsReportedHTML?.AsReportedName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AsReportedName?.html" [innerHTML]="PropertyAsReportedHTML?.AsReportedName?.text"></p>
											<label>Property name</label>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.AccountName?.html" [innerHTML]="PropertyAsReportedHTML?.AccountName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AccountName?.html" [innerHTML]="PropertyAsReportedHTML?.AccountName?.text"></p>
											<label>Seller/Servicer name</label>
                                        </div>
                                    </td>
                                    <td colspan="2" class="fh">
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.AddressLineText?.html" [innerHTML]="PropertyAsReportedHTML?.AddressLineText?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AddressLineText?.html" [innerHTML]="PropertyAsReportedHTML?.AddressLineText?.text"></p>
											<label>Address</label>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.PartyBusinessAccountId?.html" [innerHTML]="PropertyAsReportedHTML?.PartyBusinessAccountId?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.PartyBusinessAccountId?.html" [innerHTML]="PropertyAsReportedHTML?.PartyBusinessAccountId?.text"></p>
											<label>Seller/Servicer number</label>
                                        </div>
                                    </td>
                                    <td>
                                        <div>
                                            <p [innerHTML]="PropertyConditionAssessmentHTML?.PrelimInspectionDate|date:'MMMM dd, yyyy'"></p>
                                            <label>Inspection date</label>
                                        </div>
                                    </td>
                                    <td colspan="2" class="fh">
                                        <div>
                                            <p><ng-container *ngIf="PropertyAsReportedHTML?.CityName?.html"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.CityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="!PropertyAsReportedHTML?.CityName?.html&&PropertyAsReportedHTML?.CityName?.text"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.CityName?.text"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="PropertyAsReportedHTML?.StateUspsCode?.html"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.StateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="!PropertyAsReportedHTML?.StateUspsCode?.html&&PropertyAsReportedHTML?.StateUspsCode?.text"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.StateUspsCode?.text"></span>,&nbsp;</ng-container> 
												<span *ngIf="PropertyAsReportedHTML?.PostalCode?.html" style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.PostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>
												<span *ngIf="!PropertyAsReportedHTML?.PostalCode?.html" style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.PostalCode?.secHtml?.text"></span></p>
											<label>City, State, Zip</label>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </thead>
             	<tbody></tbody>   
			</table>
			<div id="sec2" style="font-size:11px">
				<h2 id="frm_sec2_1" style="color:white; background-color:black;padding:4px">Repairs Identification</h2>
			
				<!--<label >Were any Critical or Priority Repairs identified?</label>
				<div class="question">
					<input type="radio" name="sec3-2" [checked]="PropertyConditionAssessment['PropertyRepair']&&PropertyConditionAssessment['PropertyRepair'].length>0">
					<label>Yes</label>
					<input type="radio" name="sec3-2"  [checked]="!PropertyConditionAssessment['PropertyRepair']||PropertyConditionAssessment['PropertyRepair'].length==0">
					<label>No</label>
				</div>-->
				<div class="question-line">
					<div class="question">
						Were any Critical or Priority Repairs identified?
					</div>
					<div class="question">
						<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':repairtCount[5] , 'radio-unchecked':!repairtCount[5]}">Yes</span>
					
						<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':!repairtCount[5], 'radio-unchecked': repairtCount[5]}">No</span>
					</div>
				</div>
				<p *ngIf="repairtCount[5]" style='margin-left:20px'>Identify the area of the property where repairs needs were identified:</p>
				<ul *ngIf="repairtCount[5]" style="margin-left:30px">
					<li><span style="margin-right:20px" [ngClass]="{'checkbox-checked1':repairtCount[0],'checkbox-unchecked1': !repairtCount[0]}">Site</span></li>
					<li><span style="margin-right:20px" [ngClass]="{'checkbox-checked1':repairtCount[1],'checkbox-unchecked1': !repairtCount[1]}">Structural, building envelope and common area furniture, fixtures and equipment</span></li>
					<li><span style="margin-right:20px" [ngClass]="{'checkbox-checked1':repairtCount[2],'checkbox-unchecked1': !repairtCount[2]}">Mechanical and electrical</span></li>
					<li><span style="margin-right:20px" [ngClass]="{'checkbox-checked1':repairtCount[3],'checkbox-unchecked1': !repairtCount[3]}">Dwelling units</span></li>
					</ul>
			
			
				<!--<div class="question-line">
					<div class="question">
						Were any Operational Repairs identified?
					</div>
					<div class="question">
						<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':repairtCount[4], 'radio-unchecked':!repairtCount[4]}">Yes</span>
					
					<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':!repairtCount[4], 'radio-unchecked': repairtCount[4]}">No</span>
					</div>
				</div>-->
			
			
			</div>
			<div id="sec3" *ngIf="repairtCount[5]" style="font-size: 11px">
				<h2 id="frm_sec2_2" style="color:white; background-color:black;padding:4px">Critical and Priority Repairs</h2>
			<div *ngIf="repairtCount[0]">
				<p style="border-bottom:2px solid black;border-left:2px solid black; font-size: 14px;margin-top: 10px;font-weight: bold;">Site</p>
			<table class='datatable' style="width:100%; font-size:10px; font-family:Arial, sans-serif;border: 1px solid black;border-collapse: collapse;margin-top: 10px; margin-bottom: 10px;">
				<thead><tr>
					<!--<ng-container *ngFor="let h of sec3tablesdata[0].cols; let o=index; trackBy:trackByFuntion">
						<th [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign, 'border':h.border}" [ngClass]="h.bk"><p style="width:40px">{{h.NAME}}</p>
						</th>	
					</ng-container>-->
					<th style="width:25%; text-align: left;border:1px solid black; vertical-align: bottom;">Item</th>
					<th style="width:10%; text-align: left;border:1px solid black; vertical-align: bottom;">Repair<br>Type</th>
					<th style="width:8%; text-align: left;border:1px solid black; vertical-align: bottom;">Unit of <br>Measure</th>
					<th style="width:10%; text-align: left;border:1px solid black; vertical-align: bottom;">Quantity</th>
					<th style="width:12%; text-align: left;border:1px solid black; vertical-align: bottom;">Per Item<br>Cost </th>	
					<th style="width:12%; text-align: left;border:1px solid black; vertical-align: bottom;">Total <br>Costs</th>
					<th style="width:25%; text-align: left;border:1px solid black; vertical-align: bottom;">Comments</th>
				</tr></thead>
				<tbody> 
					<ng-container *ngIf="sec3tablesdata">
					<ng-container *ngFor="let r of sec3tablesdata[0].rows; let h=index; trackBy:trackByFuntion">
					<tr *ngIf="r.length>1">
						<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
							<td [ngClass]="k.bk" colSpan='{{k.colspan}}' [ngStyle]="{'text-align':k.celAllign?k.celAllign:sec3tablesdata[0].cols[q].celAllign, 'background-color':k.bk , 'font-weight':k.weight, 'border':k.border}">
								<span *ngIf="k.sign&&k.data>0">{{USDollar.format(k.data)}}</span>
								<span *ngIf="!k.sign">{{k.data}}</span>
							</td>		
						</ng-container>
					</tr>
				</ng-container> 
			</ng-container>
			</tbody> 
			</table>
			</div> 
			<div *ngIf="repairtCount[1]">
			<p style="border-bottom:2px solid black;border-left:2px solid black; font-size: 14px;margin-top: 10px;font-weight: bold;">Structural, Building Envelope and Common Area Furniture, Fixtures and Equipment</p>
				<table class='datatable' style="width:100%; font-size:10px; font-family:Arial, sans-serif;border: 1px solid black;border-collapse: collapse;margin-top: 10px; margin-bottom: 10px;">
					<thead><tr>
						<th style="width:25%; text-align: left;border:1px solid black; vertical-align: bottom;">Item</th>
						<th style="width:10%; text-align: left;border:1px solid black; vertical-align: bottom;">Repair<br>Type</th>
						<th style="width:8%; text-align: left;border:1px solid black; vertical-align: bottom;">Unit of <br>Measure</th>
						<th style="width:10%; text-align: left;border:1px solid black; vertical-align: bottom;">Quantity</th>
						<th style="width:12%; text-align: left;border:1px solid black; vertical-align: bottom;">Per Item<br>Cost </th>	
						<th style="width:12%; text-align: left;border:1px solid black; vertical-align: bottom;">Total <br>Costs</th>
						<th style="width:25%; text-align: left;border:1px solid black; vertical-align: bottom;">Comments</th>
				</tr></thead>
				<tbody>
					<ng-container *ngIf="sec3tablesdata">
					<ng-container *ngFor="let r of sec3tablesdata[1].rows; let h=index; trackBy:trackByFuntion">
					<tr *ngIf="r.length>1">
						<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
							<td [ngClass]="k.bk" colSpan='{{k.colspan}}' [ngStyle]="{'text-align':k.celAllign?k.celAllign:sec3tablesdata[1].cols[q].celAllign, 'background-color':k.bk , 'font-weight':k.weight, 'border':k.border}">
								<span *ngIf="k.sign&&k.data>0">{{USDollar.format(k.data)}}</span>
								<span *ngIf="!k.sign">{{k.data}}</span>
							</td>		
						</ng-container>
					</tr>
				</ng-container>
				</ng-container>
			</tbody> 
			</table> 
			</div>
			<div *ngIf="repairtCount[2]">
			<p style="border-bottom:2px solid black;border-left:2px solid black; font-size: 14px;margin-top: 10px;font-weight: bold;">Mechanical and Electrical</p>
				<table class='datatable' style="width:100%; font-size:10px; font-family:Arial, sans-serif;border: 1px solid black;border-collapse: collapse;margin-top: 10px; margin-bottom: 10px;">
				<thead><tr>
					<th style="width:25%; text-align: left;border:1px solid black; vertical-align: bottom;">Item</th>
					<th style="width:10%; text-align: left;border:1px solid black; vertical-align: bottom;">Repair<br>Type</th>
					<th style="width:8%; text-align: left;border:1px solid black; vertical-align: bottom;">Unit of <br>Measure</th>
					<th style="width:10%; text-align: left;border:1px solid black; vertical-align: bottom;">Quantity</th>
					<th style="width:12%; text-align: left;border:1px solid black; vertical-align: bottom;">Per Item<br>Cost </th>	
					<th style="width:12%; text-align: left;border:1px solid black; vertical-align: bottom;">Total <br>Costs</th>
					<th style="width:25%; text-align: left;border:1px solid black; vertical-align: bottom;">Comments</th>
				</tr>
				</thead>
				<tbody>
					<ng-container *ngIf="sec3tablesdata">
				<ng-container *ngFor="let r of sec3tablesdata[2].rows; let h=index; trackBy:trackByFuntion">
					<tr *ngIf="r.length>1">
						<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
							<td [ngClass]="k.bk" colSpan='{{k.colspan}}' [ngStyle]="{'text-align':k.celAllign?k.celAllign:sec3tablesdata[2].cols[q].celAllign, 'background-color':k.bk , 'font-weight':k.weight, 'border':k.border}">
								<span *ngIf="k.sign&&k.data>0">{{USDollar.format(k.data)}}</span>
								<span *ngIf="!k.sign">{{k.data}}</span>
							</td>		
						</ng-container>
					</tr>
				</ng-container>
				</ng-container>
			</tbody>  
			</table> 
			</div>
			<div *ngIf="repairtCount[3]">
			<p style="border-bottom:2px solid black;border-left:2px solid black; font-size: 14px;margin-top: 10px;font-weight: bold;">Dwelling Units</p>
			<table class='datatable' style="width:100%; font-size:10px; font-family:Arial, sans-serif;border: 1px solid black;border-collapse: collapse;margin-top: 10px; margin-bottom: 10px;">
				<thead><tr>
					<th style="width:25%; text-align: left;border:1px solid black; vertical-align: bottom;">Item</th>
					<th style="width:10%; text-align: left;border:1px solid black; vertical-align: bottom;">Repair<br>Type</th>
					<th style="width:8%; text-align: left;border:1px solid black; vertical-align: bottom;">Unit of <br>Measure</th>
					<th style="width:10%; text-align: left;border:1px solid black; vertical-align: bottom;">Quantity</th>
					<th style="width:12%; text-align: left;border:1px solid black; vertical-align: bottom;">Per Item<br>Cost </th>	
					<th style="width:12%; text-align: left;border:1px solid black; vertical-align: bottom;">Total <br>Costs</th>
					<th style="width:25%; text-align: left;border:1px solid black; vertical-align: bottom;">Comments</th>
				</tr>
			</thead>
			<tbody>
				<ng-container *ngIf="sec3tablesdata">
				<ng-container *ngFor="let r of sec3tablesdata[3].rows; let h=index; trackBy:trackByFuntion">
					<tr *ngIf="r.length>1">
						<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
							<td [ngClass]="k.bk" colSpan='{{k.colspan}}' [ngStyle]="{'text-align':k.celAllign?k.celAllign:sec3tablesdata[3].cols[q].celAllign, 'background-color':k.bk , 'font-weight':k.weight, 'border':k.border}">
								<span *ngIf="k.sign&&k.data>0">{{USDollar.format(k.data)}}</span>
								<span *ngIf="!k.sign">{{k.data}}</span>
							</td>		
						</ng-container>
					</tr>
				</ng-container> 
			</ng-container>
			</tbody> 
			</table>
			</div>
				<table class='datatable' style="width:100%; font-size:10px; font-family:Arial, sans-serif;border: none;border-collapse: collapse;margin-top: 10px; margin-bottom: 10px;">
					<tbody>
						<tr>
							<td class="frm-graycell" style="width:65%; text-align: right; font-weight: bold;font-size: 14px;border:2px solid black">Total
							</td>		
							<td style="width:12%; border:2px solid black; text-align: center;">{{USDollar.format(frmData['repairTotal'])}}           
							</td>
							<td style="width:25%; border:none"></td>
						</tr> 
					</tbody>  
				</table> 
			</div>
			<!--<div id="ORTABLE" *ngIf='repairtCount[4]' style="font-size: 11px">
				<h2 id="frm_sec2_3">Operational Repairs</h2>
				<table class='datatable' style="width:100%; font-size:10px; font-family:Arial, sans-serif;border: 1px solid black;border-collapse: collapse;margin-top: 10px; margin-bottom: 10px;">
					<thead>
						<tr>
							<th class="frm-graycell"  style="font-weight: bold;border: 1px solid black; text-align: left;height:20px; vertical-align: bottom;">Description</th>	
						</tr>
					</thead>
					<tbody>
						<ng-container *ngFor="let row of ORrows">
						<tr>
						<td style="border: 1px solid black">{{row}}</td>                
						</tr>
					</ng-container>
					</tbody>
				</table>
			</div>-->
        </section>
        <section class="page-before" data-section-title="Section IV">
            <header>
                <div class="freddie-mac-header">
                    <div class="freddie-mac-logo">
                        <img src="https://erisservice9.erisinfo.com/exreportw/frmimages/logo.jpg" alt="Freddie Mac Multifamily">
                    </div>
                    <div class="freddie-mac-title">
                        <strong>Property Condition Assessment</strong>
                    </div>
                </div>
            </header>
            <h1>Section IV: Private Wells, Wastewater Treatment Systems and Lift Stations</h1>
            <table>
                <thead>
                    <tr>
                        <td class="wrapper">
                            <h2>&nbsp;</h2>
                            <table class="section-header">
                                <tr>
                                    <td width="25%">
                                        <div>
                                            <p *ngIf="PropertyAsReportedHTML?.FrmLoanNo?.html" [innerHTML]="PropertyAsReportedHTML?.FrmLoanNo?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.FrmLoanNo?.html" [innerHTML]="PropertyAsReportedHTML?.FrmLoanNo?.text"></p>
											<label>Freddie Mac loan number</label>
                                        </div>
                                    </td>
                                    <td width="25%">
                                        <div>
                                            <p [innerHTML]="PropertyConditionAssessmentHTML?.FinalAsmntDate|date:'MMMM dd, yyyy'"></p>
                                            <label>Report date</label>
                                        </div>
                                    </td>
                                    <td colspan="2" width="50%">
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.AsReportedName?.html" [innerHTML]="PropertyAsReportedHTML?.AsReportedName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AsReportedName?.html" [innerHTML]="PropertyAsReportedHTML?.AsReportedName?.text"></p>
											<label>Property name</label>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.AccountName?.html" [innerHTML]="PropertyAsReportedHTML?.AccountName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AccountName?.html" [innerHTML]="PropertyAsReportedHTML?.AccountName?.text"></p>
											<label>Seller/Servicer name</label>
                                        </div>
                                    </td>
                                    <td colspan="2" class="fh">
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.AddressLineText?.html" [innerHTML]="PropertyAsReportedHTML?.AddressLineText?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AddressLineText?.html" [innerHTML]="PropertyAsReportedHTML?.AddressLineText?.text"></p>
											<label>Address</label>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.PartyBusinessAccountId?.html" [innerHTML]="PropertyAsReportedHTML?.PartyBusinessAccountId?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.PartyBusinessAccountId?.html" [innerHTML]="PropertyAsReportedHTML?.PartyBusinessAccountId?.text"></p>
											<label>Seller/Servicer number</label>
                                        </div>
                                    </td>
                                    <td>
                                        <div>
                                            <p [innerHTML]="PropertyConditionAssessmentHTML?.PrelimInspectionDate|date:'MMMM dd, yyyy'"></p>
                                            <label>Inspection date</label>
                                        </div>
                                    </td>
                                    <td colspan="2" class="fh">
                                        <div>
                                            <p><ng-container *ngIf="PropertyAsReportedHTML?.CityName?.html"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.CityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="!PropertyAsReportedHTML?.CityName?.html&&PropertyAsReportedHTML?.CityName?.text"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.CityName?.text"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="PropertyAsReportedHTML?.StateUspsCode?.html"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.StateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="!PropertyAsReportedHTML?.StateUspsCode?.html&&PropertyAsReportedHTML?.StateUspsCode?.text"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.StateUspsCode?.text"></span>,&nbsp;</ng-container> 
												<span *ngIf="PropertyAsReportedHTML?.PostalCode?.html" style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.PostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>
												<span *ngIf="!PropertyAsReportedHTML?.PostalCode?.html" style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.PostalCode?.secHtml?.text"></span></p>
											<label>City, State, Zip</label>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="wrapper">
                            <div>
                                <h2>Private Wells, Waste Water and Lift Stations</h2>
                                <p>Indicate if any of the following systems are present at the property:</p>
                                <ul>
                                    <li><span [ngClass]='{"checkbox-checked1":frmData.waterCheck[0],"checkbox-unchecked1":!frmData.waterCheck[0]}'>Private wells (drinking water)</span></li>
                                    <li><span [ngClass]='{"checkbox-checked1":frmData.waterCheck[1],"checkbox-unchecked1":!frmData.waterCheck[1]}'>Private wells (NON drinking water)</span></li>
                                    <li><span [ngClass]='{"checkbox-checked1":frmData.waterCheck[2],"checkbox-unchecked1":!frmData.waterCheck[2]}'>Private wastewater treatment systems</span></li>
                                    <li><span [ngClass]='{"checkbox-checked1":frmData.waterCheck[3],"checkbox-unchecked1":!frmData.waterCheck[3]}'>Private lift stations</span></li>
                                    <li><span [ngClass]='{"checkbox-checked1":frmData.waterCheck[4],"checkbox-unchecked1":!frmData.waterCheck[4]}'>None of these systems are present</span></li>
                                </ul>
                                <div *ngIf="frmData.waterCheck[0]&&flatPartySetSec3&&flatPartySetSec3.privateWellsDrinkingWater">
                                    <h2 style="background-color: #CCC;color:black">Private Wells (drinking water)</h2>
                                    <div class="input-box">
                                        <label>Describe the system, its historical operations (including how long it’s been in service) and adequacy:</label>
                                        <div class="textarea">{{flatPartySetSec3.privateWellsDrinkingWater.WaterSystemOperationsDescription}}</div>
                                    </div>
                                    <div class="input-box">
                                        <label>Provide the cost of connecting the property to a municipal water system, and the level of work required to accomplish this:</label>
                                        <div class="textarea">{{flatPartySetSec3.privateWellsDrinkingWater.WaterSystemToMunicipalSystemConnectionDescription}}</div>
                                    </div>
                                    <div class="question-line">
                                        <div class="question">Who is responsible for maintaining the system?</div>
                                    </div>
                                    <div class="question-box">
                                        <div class="question-line">
                                            <div class="question">
                                                <span [ngClass]="{'checkbox-checked1':flatPartySetSec3.privateWellsDrinkingWater.WaterSystemMaintenanceResponsiblePartyType=='Professional third-party', 'checkbox-unchecked1':flatPartySetSec3.privateWellsDrinkingWater.WaterSystemMaintenanceResponsiblePartyType!='Professional third-party'}">Professional third-party</span>
                                            </div>
                                            <div *ngIf="flatPartySetSec3.privateWellsDrinkingWater.WaterSystemMaintenanceResponsiblePartyType=='Professional third-party'" class="question flex">
                                                <p style="flex-basis: 21%; text-align: right;">Name:</p>
                                                <div class="textarea" style="display:flex; flex-basis: 79%;">{{flatPartySetSec3.privateWellsDrinkingWater.WaterSystemMaintenanceResponsiblePartyName}}</div>
                                            </div>
                                        </div>
                                        <div class="question-line">
                                            <div class="question">
                                                <span [ngClass]="{'checkbox-checked1':flatPartySetSec3.privateWellsDrinkingWater.WaterSystemMaintenanceResponsiblePartyType=='Other', 'checkbox-unchecked1':flatPartySetSec3.privateWellsDrinkingWater.WaterSystemMaintenanceResponsiblePartyType!='other'}">Other</span>
                                            </div>
                                            <div *ngIf="flatPartySetSec3.privateWellsDrinkingWater.WaterSystemMaintenanceResponsiblePartyType=='Other'" class="question flex">
                                                <p style="flex-basis: 21%; text-align: right;">Name:</p>
                                                <div class="textarea"  style="display:flex; flex-basis: 79%;">{{flatPartySetSec3.privateWellsDrinkingWater.WaterSystemMaintenanceResponsiblePartyName}}</div>
                                            </div>
                                        </div>
                                        <div *ngIf="flatPartySetSec3.privateWellsDrinkingWater.WaterSystemMaintenanceResponsiblePartyType=='Other'" class="question-line">
                                            <div class="question">
                                            </div>
                                            <div class="question flex">
                                                <p style="flex-basis: 21%; text-align: right;">Qualifications:</p>
                                                <div class="textarea"  style="display:flex; flex-basis: 79%;">{{flatPartySetSec3.privateWellsDrinkingWater.WaterSystemMaintenancePartyQualificationsDescription}}</div>
                                            </div>
                                        </div>
										<ng-container *ngIf="flatPartySetSec3.privateWellsDrinkingWater.WaterSystemMaintenanceResponsiblePartyType=='Professional third-party'||flatPartySetSec3.privateWellsDrinkingWater.WaterSystemMaintenanceResponsiblePartyType=='Other'" >
											<div class="question-line">
												<div class="question" style="flex-basis: 70%;">
													Are there any concerns regarding the quality of maintenance being performed on the system?
												</div>
												<div class="question">
													<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec3.privateWellsDrinkingWater.indexOf('qualityOfMaintenanceConcerns')>-1, 'radio-unchecked':flatDataSec3.privateWellsDrinkingWater.indexOf('qualityOfMaintenanceConcerns')==-1}">Yes</span>
													<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec3.privateWellsDrinkingWater.indexOf('qualityOfMaintenanceConcerns')==-1, 'radio-unchecked': flatDataSec3.privateWellsDrinkingWater.indexOf('qualityOfMaintenanceConcerns')>-1}">No</span>
												</div>
											</div>
											<div *ngIf="(flatPartySetSec3.privateWellsDrinkingWater.WaterSystemMaintenanceResponsiblePartyType=='Professional third-party'||flatPartySetSec3.privateWellsDrinkingWater.WaterSystemMaintenanceResponsiblePartyType=='Other')&&flatDataSec3.privateWellsDrinkingWater.indexOf('qualityOfMaintenanceConcerns')>-1" class="input-box">
												<label>Provide details:</label>
												<div class="textarea">{{flatDataSetSec3.privateWellsDrinkingWater[flatDataSec3.privateWellsDrinkingWater.indexOf('qualityOfMaintenanceConcerns')].WaterSystemViolationDescription}}</div>
											</div>
										</ng-container>
                                    </div>
									
									<div class="question-line">
										<div class="question">
											Is equipment accessible to individuals other than authorized personnel?
										</div>
										 <div class="question">
											<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec3.privateWellsDrinkingWater.indexOf('isEquipmentAccessible')>-1, 'radio-unchecked':flatDataSec3.privateWellsDrinkingWater.indexOf('isEquipmentAccessible')==-1}">Yes</span>
											<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec3.privateWellsDrinkingWater.indexOf('isEquipmentAccessible')==-1, 'radio-unchecked': flatDataSec3.privateWellsDrinkingWater.indexOf('isEquipmentAccessible')>-1}">No</span>
										</div>
									</div>
									<div *ngIf="flatDataSec3.privateWellsDrinkingWater.indexOf('isEquipmentAccessible')>-1" class="question-box">
                                        <div class="input-box">
                                            <label>Provide details:</label>
                                            <div class="textarea">{{flatDataSetSec3.privateWellsDrinkingWater[flatDataSec3.privateWellsDrinkingWater.indexOf('isEquipmentAccessible')].WaterSystemViolationDescription}}</div>
                                        </div>
                                    </div>
								
									<div class="question-line">
										<div class="question" style="flex-basis: 70%;">
											Are there any concerns regarding the backup water source?
										</div>
										 <div class="question">
											<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec3.privateWellsDrinkingWater.indexOf('backUpWaterSource')>-1, 'radio-unchecked':flatDataSec3.privateWellsDrinkingWater.indexOf('backUpWaterSource')==-1}">Yes</span>
											<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec3.privateWellsDrinkingWater.indexOf('backUpWaterSource')==-1, 'radio-unchecked': flatDataSec3.privateWellsDrinkingWater.indexOf('backUpWaterSource')>-1}">No</span>
										</div>
									</div>
										<div *ngIf="flatDataSec3.privateWellsDrinkingWater.indexOf('backUpWaterSource')>-1" class="question-box">
											<div class="input-box">
												<label>Please describe the backup water source:</label>
												<div class="textarea">{{flatDataSetSec3.privateWellsDrinkingWater[flatDataSec3.privateWellsDrinkingWater.indexOf('backUpWaterSource')].WellDrinkingWaterBackupSourceDescription}}</div>
											</div>
										</div>
										<div *ngIf="flatDataSec3.privateWellsDrinkingWater.indexOf('backUpWaterSource')>-1" class="question-box">
											<div class="input-box">
												<label>Describe the concern:</label>
												<div class="textarea">{{flatDataSetSec3.privateWellsDrinkingWater[flatDataSec3.privateWellsDrinkingWater.indexOf('backUpWaterSource')].WaterSystemViolationDescription}}</div>
											</div>
										</div>
											
									<div class="question-line">
										<div class="question" style="flex-basis: 70%;">
											Are there any current or previous violations?
										</div>
										 <div class="question">
											<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec3.privateWellsDrinkingWater.indexOf('currentOrPreviousViolations')>-1, 'radio-unchecked':flatDataSec3.privateWellsDrinkingWater.indexOf('currentOrPreviousViolations')==-1}">Yes</span>
											<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec3.privateWellsDrinkingWater.indexOf('currentOrPreviousViolations')==-1, 'radio-unchecked': flatDataSec3.privateWellsDrinkingWater.indexOf('currentOrPreviousViolations')>-1}">No</span>
										</div>
									</div>
									<div *ngIf="flatDataSec3.privateWellsDrinkingWater.indexOf('currentOrPreviousViolations')>-1" class="question-box">
											<div class="input-box">
												<label>Provide details:</label>
												<div class="textarea">{{flatDataSetSec3.privateWellsDrinkingWater[flatDataSec3.privateWellsDrinkingWater.indexOf('currentOrPreviousViolations')].WaterSystemViolationDescription}}</div>
											</div>
										</div>
										<div class="question-line">
											<div class="question" style="flex-basis: 70%;">
												Is this system type atypical for the market?
											</div>
											 <div class="question">
												<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec3.privateWellsDrinkingWater.indexOf('atypicalSystemForMarket')>-1, 'radio-unchecked':flatDataSec3.privateWellsDrinkingWater.indexOf('atypicalSystemForMarket')==-1}">Yes</span>
												<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec3.privateWellsDrinkingWater.indexOf('atypicalSystemForMarket')==-1, 'radio-unchecked': flatDataSec3.privateWellsDrinkingWater.indexOf('atypicalSystemForMarket')>-1}">No</span>
											</div>
										</div>
										<div *ngIf="flatDataSec3.privateWellsDrinkingWater.indexOf('atypicalSystemForMarket')>-1"class="question-box">
											<div class="input-box">
												<label>Provide details:</label>
												<div class="textarea">{{flatDataSetSec3.privateWellsDrinkingWater[flatDataSec3.privateWellsDrinkingWater.indexOf('atypicalSystemForMarket')].WaterSystemViolationDescription}}</div>
											</div>
										</div>
										<div class="question-line">
											<div class="question">
												Is any other person or property, other than the Borrower or subject property, authorized to use the system?
											</div>
											 <div class="question">
												<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec3.privateWellsDrinkingWater&&flatDataSec3.privateWellsDrinkingWater.indexOf('otherPersonsAuthorized')>-1, 'radio-unchecked':!flatDataSec3.privateWellsDrinkingWater||flatDataSec3.privateWellsDrinkingWater.indexOf('otherPersonsAuthorized')==-1}">Yes</span>
												<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':!flatDataSec3.privateWellsDrinkingWater||flatDataSec3.privateWellsDrinkingWater.indexOf('otherPersonsAuthorized')==-1, 'radio-unchecked':flatDataSec3.privateWellsDrinkingWater&&flatDataSec3.privateWellsDrinkingWater.indexOf('otherPersonsAuthorized')>-1}">No</span>
											</div>
										</div>
										<div *ngIf="flatDataSec3.privateWellsDrinkingWater.indexOf('otherPersonsAuthorized')>-1" class="question-box">
											<div class="input-box">
												<label>Provide details:</label>
												<div class="textarea">{{flatDataSetSec3.privateWellsDrinkingWater[flatDataSec3.privateWellsDrinkingWater.indexOf('otherPersonsAuthorized')].WaterSystemViolationDescription}}</div>
											</div>
										</div>
										<div class="question-line">
											<div class="question">
												Is any part of the system owned or maintained by the residents?
											</div>
											 <div class="question">
												<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec3.privateWellsDrinkingWater.indexOf('partsOwnedByResidents')>-1, 'radio-unchecked':flatDataSec3.privateWellsDrinkingWater.indexOf('partsOwnedByResidents')==-1}">Yes</span>
												<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec3.privateWellsDrinkingWater.indexOf('partsOwnedByResidents')==-1, 'radio-unchecked': flatDataSec3.privateWellsDrinkingWater.indexOf('partsOwnedByResidents')>-1}">No</span>
											</div>
										</div>
										<div *ngIf="flatDataSec3.privateWellsDrinkingWater.indexOf('partsOwnedByResidents')>-1" class="question-box">
											<div class="input-box">
												<label>Provide details:</label>
												<div class="textarea">{{flatDataSetSec3.privateWellsDrinkingWater[flatDataSec3.privateWellsDrinkingWater.indexOf('partsOwnedByResidents')].WaterSystemViolationDescription}}</div>
											</div>
										</div>
										<div class="question-line">
											<div class="question">
												Does the system fail to meet or exceed applicable federal, state and/or local requirements?
											</div>
											 <div class="question">
												<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec3.privateWellsDrinkingWater.indexOf('failureToMeetRequirements')>-1, 'radio-unchecked':flatDataSec3.privateWellsDrinkingWater.indexOf('failureToMeetRequirements')==-1}">Yes</span>
												<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec3.privateWellsDrinkingWater.indexOf('isEquipmentfailureToMeetRequirementsAccessible')==-1, 'radio-unchecked': flatDataSec3.privateWellsDrinkingWater.indexOf('failureToMeetRequirements')>-1}">No</span>
											</div>
										</div>
										<div *ngIf="flatDataSec3.privateWellsDrinkingWater.indexOf('failureToMeetRequirements')>-1" class="question-box">
											<div class="input-box">
												<label>Provide details:</label>
												<div class="textarea">{{flatDataSetSec3.privateWellsDrinkingWater[flatDataSec3.privateWellsDrinkingWater.indexOf('failureToMeetRequirements')].WaterSystemViolationDescription}}</div>
											</div>
										</div>
									
										</div>
										
										<div *ngIf="frmData.waterCheck[1]&&flatDataSetSec3&&flatDataSetSec3['privateWellsNonDrinkingWater'][0]">
											<h2 style="color:black; background-color:#ccc">Private wells (NON drinking water)</h2>
											<div class="input-box">
												<label>Specify the use and note any concerns:</label>
												<div class="textarea">{{flatDataSetSec3.privateWellsNonDrinkingWater[0].WaterSystemOperationsDescription}}</div>
											</div>
										</div>
										<div *ngIf="frmData.waterCheck[2]&&flatPartySetSec3&&flatPartySetSec3['wasteWaterTreatment']">
										<h2 style="color:black; background-color:#ccc">Private wastewater treatment systems</h2>
										<hr>
										<div  style="font-size: 11px;">
											<div class="question-line">
												<div class="question">Identify the type of system(s) present:</div>
											</div>
											<div class="question-box">
												<div class="question">
													<span [ngClass]="{'checkbox-checked1':flatDataSec3.wasteWaterTreatment.indexOf('septicSystem')>-1, 'checkbox-unchecked1':flatDataSec3.wasteWaterTreatment.indexOf('septicSystem')==-1}">Septic system</span>
												</div>
												<div class="question">
													<span [ngClass]="{'checkbox-checked1':flatDataSec3.wasteWaterTreatment.indexOf('sewageTreatmentPlant')>-1, 'checkbox-unchecked1':flatDataSec3.wasteWaterTreatment.indexOf('sewageTreatmentPlant')==-1}">Sewage treatment plant</span>
												</div>
											</div>
										<hr>
										<ng-container  *ngIf="flatDataSec3.wasteWaterTreatment.indexOf('septicSystem')>-1||flatDataSec3.wasteWaterTreatment.indexOf('sewageTreatmentPlant')>-1" >
										
											<div class="input-box">
												<label>Describe the system, its historical operations (including how long it’s been in service) and adequacy:</label>
												<div class="textarea">{{flatPartySetSec3.wasteWaterTreatment.WaterSystemOperationsDescription}}</div>
											</div>
										
										
											<div *ngIf="flatDataSec3.wasteWaterTreatment.indexOf('septicSystem')>-1" class="input-box">
												<label>Describe the leach field and distance to surrounding bodies of water that could be impacted by the effluent:</label>
												<div class="textarea">{{flatPartySetSec3.wasteWaterTreatment.WastewaterLeachFieldDescription}}</div>
											</div>
										
										
											<div *ngIf="flatDataSec3.wasteWaterTreatment.indexOf('sewageTreatmentPlant')>-1" class="input-box">
												<label>Describe the body of water into which the waste water treatment system effluent is discharged, including distance:</label>
												<div class="textarea">{{flatPartySetSec3.wasteWaterTreatment.WastewaterEffluentDischargeDescription}}</div>
											</div>
										
										
											<div class="input-box">
												<label>Provide the cost of connecting the property to a municipal water system, and the level of work required to accomplish this:</label>
												<div class="textarea">{{flatPartySetSec3.wasteWaterTreatment.WaterSystemToMunicipalSystemConnectionDescription}}</div>
											</div>
										
										<div class="question-line">
											<div class="question">Who is responsible for maintaining the system?</div>
										</div>
										<div class="question-box">
											<div class="question-line">
												<div class="question">
													<span [ngClass]="{'checkbox-checked1':flatPartySetSec3.wasteWaterTreatment.WaterSystemMaintenanceResponsiblePartyType=='Professional third-party', 'checkbox-unchecked1':flatPartySetSec3.wasteWaterTreatment.WaterSystemMaintenanceResponsiblePartyType!='Professional third-party'}">Professional third-party</span>
												</div>
												<div *ngIf="flatPartySetSec3.wasteWaterTreatment.WaterSystemMaintenanceResponsiblePartyType=='Professional third-party'" class="question flex">
													<p style="flex-basis: 21%; text-align: right;">Name:</p>
													<div class="textarea" style="display:flex; flex-basis: 79%;">{{flatPartySetSec3.wasteWaterTreatment.WaterSystemMaintenanceResponsiblePartyName}}</div>
												</div>
											</div>
											<div class="question-line">
												<div class="question">
													<span [ngClass]="{'checkbox-checked1':flatPartySetSec3.wasteWaterTreatment.WaterSystemMaintenanceResponsiblePartyType=='Other', 'checkbox-unchecked1':flatPartySetSec3.wasteWaterTreatment.WaterSystemMaintenanceResponsiblePartyType!='Other'}">Other</span>
												</div>
												<div *ngIf="flatPartySetSec3.wasteWaterTreatment.WaterSystemMaintenanceResponsiblePartyType=='Other'" class="question flex">
													<p style="flex-basis: 21%; text-align: right;">Name:</p>
													<div class="textarea" style="display:flex; flex-basis: 79%;">{{flatPartySetSec3.wasteWaterTreatment.WaterSystemMaintenanceResponsiblePartyName}}</div>
												</div>
											</div>
											<div *ngIf="flatPartySetSec3.wasteWaterTreatment.WaterSystemMaintenanceResponsiblePartyType=='Other'" class="question-line">
												<div class="question">
												</div>
												<div class="question flex">
													<p style="flex-basis: 21%; text-align: right;">Qualifications:</p>
													<div class="textarea" style="display:flex; flex-basis: 79%;">{{flatPartySetSec3.wasteWaterTreatment.WaterSystemMaintenancePartyQualificationsDescription}}</div>
												</div>
											</div>
											<ng-container *ngIf="flatPartySetSec3.wasteWaterTreatment.WaterSystemMaintenanceResponsiblePartyType=='Professional third-party'||flatPartySetSec3.wasteWaterTreatment.WaterSystemMaintenanceResponsiblePartyType=='Other'">
												<div class="question-line">
													<div class="question" style="flex-basis: 70%;">
														Are there any concerns regarding the quality of maintenance being performed on the system?
													</div>
													<div class="question">
														<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec3.wasteWaterTreatment.indexOf('qualityOfMaintenanceConcerns')>-1, 'radio-unchecked':flatDataSec3.wasteWaterTreatment.indexOf('qualityOfMaintenanceConcerns')==-1}">Yes</span>
														<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec3.wasteWaterTreatment.indexOf('qualityOfMaintenanceConcerns')==-1, 'radio-unchecked': flatDataSec3.wasteWaterTreatment.indexOf('qualityOfMaintenanceConcerns')>-1}">No</span>
													</div>
												</div>
												<div *ngIf="flatDataSec3.wasteWaterTreatment.indexOf('qualityOfMaintenanceConcerns')>-1" class="input-box">
													<label>Provide details:</label>
													<div class="textarea">{{flatDataSetSec3.wasteWaterTreatment[flatDataSec3.wasteWaterTreatment.indexOf('qualityOfMaintenanceConcerns')].WaterSystemViolationDescription}}</div>
												</div>
											</ng-container>
										</div>
										
									</ng-container>
									<div class="question-line">
										<div class="question" style="flex-basis: 70%;">
											Are any buildings or structures located on top of the leach field?
										</div>
										 <div class="question">
											<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec3.wasteWaterTreatment.indexOf('structureOnTopOfLeachField')>-1, 'radio-unchecked':flatDataSec3.wasteWaterTreatment.indexOf('structureOnTopOfLeachField')==-1}">Yes</span>
											<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec3.wasteWaterTreatment.indexOf('structureOnTopOfLeachField')==-1, 'radio-unchecked': flatDataSec3.wasteWaterTreatment.indexOf('structureOnTopOfLeachField')>-1}">No</span>
										</div>
									</div>
									<div *ngIf="flatDataSec3.wasteWaterTreatment.indexOf('structureOnTopOfLeachField')>-1" class="question-box">
                                        <div class="input-box">
                                            <label>Provide details:</label>
                                            <div class="textarea">{{flatDataSetSec3.wasteWaterTreatment[flatDataSec3.wasteWaterTreatment.indexOf('structureOnTopOfLeachField')].WaterSystemViolationDescription}}</div>
                                        </div>
                                    </div>										
									<div class="question-line">
										<div class="question" style="flex-basis: 70%;">
											Is equipment accessible to individuals other than authorized personnel?
										</div>
										 <div class="question">
											<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec3.wasteWaterTreatment.indexOf('isEquipmentAccessible')>-1, 'radio-unchecked':flatDataSec3.wasteWaterTreatment.indexOf('isEquipmentAccessible')==-1}">Yes</span>
											<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec3.wasteWaterTreatment.indexOf('isEquipmentAccessible')==-1, 'radio-unchecked': flatDataSec3.wasteWaterTreatment.indexOf('isEquipmentAccessible')>-1}">No</span>
										</div>
									</div>
									<div *ngIf="flatDataSec3.wasteWaterTreatment.indexOf('isEquipmentAccessible')>-1" class="question-box">
                                        <div class="input-box">
                                            <label>Provide details:</label>
                                            <div class="textarea">{{flatDataSetSec3.wasteWaterTreatment[flatDataSec3.wasteWaterTreatment.indexOf('isEquipmentAccessible')].WaterSystemViolationDescription}}</div>
                                        </div>
                                    </div>
									<div class="question-line">
										<div class="question" style="flex-basis: 70%;">
											Are there any current or previous violations?
										</div>
										 <div class="question">
											<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec3.wasteWaterTreatment.indexOf('currentOrPreviousViolations')>-1, 'radio-unchecked':flatDataSec3.wasteWaterTreatment.indexOf('currentOrPreviousViolations')==-1}">Yes</span>
											<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec3.wasteWaterTreatment.indexOf('currentOrPreviousViolations')==-1, 'radio-unchecked': flatDataSec3.wasteWaterTreatment.indexOf('currentOrPreviousViolations')>-1}">No</span>
										</div>
									</div>
									<div *ngIf="flatDataSec3.wasteWaterTreatment.indexOf('currentOrPreviousViolations')>-1" class="question-box">
                                        <div class="input-box">
                                            <label>Provide details:</label>
                                            <div class="textarea">{{flatDataSetSec3.wasteWaterTreatment[flatDataSec3.wasteWaterTreatment.indexOf('currentOrPreviousViolations')].WaterSystemViolationDescription}}</div>
                                        </div>
                                    </div>	
									<div class="question-line">
										<div class="question" style="flex-basis: 70%;">
											this system type atypical for the market?
										</div>
										 <div class="question">
											<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec3.wasteWaterTreatment.indexOf('atypicalSystemForMarket')>-1, 'radio-unchecked':flatDataSec3.wasteWaterTreatment.indexOf('atypicalSystemForMarket')==-1}">Yes</span>
											<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec3.wasteWaterTreatment.indexOf('atypicalSystemForMarket')==-1, 'radio-unchecked': flatDataSec3.wasteWaterTreatment.indexOf('atypicalSystemForMarket')>-1}">No</span>
										</div>
									</div>
									<div *ngIf="flatDataSec3.wasteWaterTreatment.indexOf('atypicalSystemForMarket')>-1" class="question-box">
                                        <div class="input-box">
                                            <label>Provide details:</label>
                                            <div class="textarea">{{flatDataSetSec3.wasteWaterTreatment[flatDataSec3.wasteWaterTreatment.indexOf('atypicalSystemForMarket')].WaterSystemViolationDescription}}</div>
                                        </div>
                                    </div>
									<div class="question-line">
										<div class="question">
											Is any other person or property, other than the Borrower or subject property, authorized to use the system?
										</div>
										 <div class="question">
											<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec3.wasteWaterTreatment.indexOf('otherPersonsAuthorized')>-1, 'radio-unchecked':flatDataSec3.wasteWaterTreatment.indexOf('otherPersonsAuthorized')==-1}">Yes</span>
											<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec3.wasteWaterTreatment.indexOf('otherPersonsAuthorized')==-1, 'radio-unchecked': flatDataSec3.wasteWaterTreatment.indexOf('otherPersonsAuthorized')>-1}">No</span>
										</div>
									</div>
									<div *ngIf="flatDataSec3.wasteWaterTreatment.indexOf('otherPersonsAuthorized')>-1" class="question-box">
                                        <div class="input-box">
                                            <label>Provide details:</label>
                                            <div class="textarea">{{flatDataSetSec3.wasteWaterTreatment[flatDataSec3.wasteWaterTreatment.indexOf('otherPersonsAuthorized')].WaterSystemViolationDescription}}</div>
                                        </div>
                                    </div>	
									<div class="question-line">
										<div class="question">
											Is any part of the system owned or maintained by the residents?
										</div>
										 <div class="question">
											<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec3.wasteWaterTreatment.indexOf('partsOwnedByResidents')>-1, 'radio-unchecked':flatDataSec3.wasteWaterTreatment.indexOf('partsOwnedByResidents')==-1}">Yes</span>
											<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec3.wasteWaterTreatment.indexOf('partsOwnedByResidents')==-1, 'radio-unchecked': flatDataSec3.wasteWaterTreatment.indexOf('partsOwnedByResidents')>-1}">No</span>
										</div>
									</div>
									<div *ngIf="flatDataSec3.wasteWaterTreatment.indexOf('partsOwnedByResidents')>-1" class="question-box">
                                        <div class="input-box">
                                            <label>Provide details:</label>
                                            <div class="textarea">{{flatDataSetSec3.wasteWaterTreatment[flatDataSec3.wasteWaterTreatment.indexOf('partsOwnedByResidents')].WaterSystemViolationDescription}}</div>
                                        </div>
                                    </div>
									<div class="question-line">
										<div class="question">
											Does the system fail to meet or exceed applicable federal, state and/or local requirements?
										</div>
										 <div class="question">
											<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec3.wasteWaterTreatment.indexOf('failureToMeetRequirements')>-1, 'radio-unchecked':flatDataSec3.wasteWaterTreatment.indexOf('failureToMeetRequirements')==-1}">Yes</span>
											<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec3.wasteWaterTreatment.indexOf('failureToMeetRequirements')==-1, 'radio-unchecked': flatDataSec3.wasteWaterTreatment.indexOf('failureToMeetRequirements')>-1}">No</span>
										</div>
									</div>
									<div *ngIf="flatDataSec3.wasteWaterTreatment.indexOf('failureToMeetRequirements')>-1" class="question-box">
                                        <div class="input-box">
                                            <label>Provide details:</label>
                                            <div class="textarea">{{flatDataSetSec3.wasteWaterTreatment[flatDataSec3.wasteWaterTreatment.indexOf('failureToMeetRequirements')].WaterSystemViolationDescription}}</div>
                                        </div>
                                    </div>
									</div>
									</div>
									<div *ngIf="frmData.waterCheck[3]&&flatPartySetSec3&&flatPartySetSec3['privateLiftStations']"> 
										<h2 style="color:black; background-color:#ccc">Private lift stations</h2>
										<div  style="font-size: 11px;">
										<div class="input-box">
                                            <label>Describe the system, its historical operations (including how long it’s been in service) and adequacy:</label>
                                            <div class="textarea">{{flatPartySetSec3.privateLiftStations.WaterSystemOperationsDescription}}</div>
                                        </div>
										<div class="question-line">
											<div class="question">Who is responsible for maintaining the system?</div>
										</div>
										<div class="question-box">
											<div class="question-line">
												<div class="question">
													<span [ngClass]="{'checkbox-checked1':flatPartySetSec3.privateLiftStations.WaterSystemMaintenanceResponsiblePartyType=='Professional third-party', 'checkbox-unchecked1':flatPartySetSec3.privateLiftStations.WaterSystemMaintenanceResponsiblePartyType!='Professional third-party'}">Professional third-party</span>
												</div>
												<div *ngIf="flatPartySetSec3.privateLiftStations.WaterSystemMaintenanceResponsiblePartyType=='Professional third-party'" class="question flex">
													<p style="flex-basis: 21%; text-align: right;">Name:</p>
													<div class="textarea" style="display:flex; flex-basis: 79%;">{{flatPartySetSec3.privateLiftStations.WaterSystemMaintenanceResponsiblePartyName}}</div>
												</div>
											</div>
											<div class="question-line">
												<div class="question">
													<span [ngClass]="{'checkbox-checked1':flatPartySetSec3.privateLiftStations.WaterSystemMaintenanceResponsiblePartyType=='Other', 'checkbox-unchecked1':flatPartySetSec3.privateLiftStations.WaterSystemMaintenanceResponsiblePartyType!='Other'}">Other</span>
												</div>
												<div class="question flex">
													<ng-container *ngIf="flatPartySetSec3.privateLiftStations.WaterSystemMaintenanceResponsiblePartyType=='Other'" >
														<p style="flex-basis: 21%; text-align: right;">Name:</p>
														<div class="textarea" style="display:flex; flex-basis: 79%;">{{flatPartySetSec3.privateLiftStations.WaterSystemMaintenanceResponsiblePartyName}}</div>
													</ng-container>
												</div>
											</div>
											<div *ngIf="flatPartySetSec3.privateLiftStations.WaterSystemMaintenanceResponsiblePartyType=='Other'" class="question-line">
												<div class="question">
												</div>
												<div class="question flex">
													<p style="flex-basis: 21%; text-align: right;">Qualifications:</p>
													<div class="textarea" style="display:flex; flex-basis: 79%;">{{flatPartySetSec3.privateLiftStations.WaterSystemMaintenancePartyQualificationsDescription}}</div>
												</div>
											</div>
											<ng-container *ngIf="flatPartySetSec3.privateLiftStations.WaterSystemMaintenanceResponsiblePartyType=='Professional third-party'||flatPartySetSec3.privateLiftStations.WaterSystemMaintenanceResponsiblePartyType=='Other'">
												<div class="question-line">
													<div class="question" style="flex-basis: 70%;">
														Are there any concerns regarding the quality of maintenance being performed on the system?
													</div>
													<div class="question">
														<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec3.privateLiftStations.indexOf('qualityOfMaintenanceConcerns')>-1, 'radio-unchecked':flatDataSec3.privateLiftStations.indexOf('qualityOfMaintenanceConcerns')==-1}">Yes</span>
														<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec3.privateLiftStations.indexOf('qualityOfMaintenanceConcerns')==-1, 'radio-unchecked': flatDataSec3.privateLiftStations.indexOf('qualityOfMaintenanceConcerns')>-1}">No</span>
													</div>
												</div>
												<div *ngIf="flatDataSec3.privateLiftStations.indexOf('qualityOfMaintenanceConcerns')>-1" class="input-box">
													<label>Provide details:</label>
													<div class="textarea">{{flatDataSetSec3.privateLiftStations[flatDataSec3.privateLiftStations.indexOf('qualityOfMaintenanceConcerns')].WaterSystemViolationDescription}}</div>
												</div>
											</ng-container>
										</div>
										<div class="question-line">
											<div class="question" style="flex-basis: 70%;">
												Are any buildings or structures located on top of the lift station?
											</div>
											 <div class="question">
												<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec3.privateLiftStations.indexOf('structureOnTopOfLiftStation')>-1, 'radio-unchecked':flatDataSec3.privateLiftStations.indexOf('structureOnTopOfLiftStation')==-1}">Yes</span>
												<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec3.privateLiftStations.indexOf('structureOnTopOfLiftStation')==-1, 'radio-unchecked':flatDataSec3.privateLiftStations.indexOf('structureOnTopOfLiftStation')>-1}">No</span>
											</div>
										</div>
										<div *ngIf="flatDataSec3.privateLiftStations.indexOf('structureOnTopOfLiftStation')>-1" class="question-box">
											<div class="input-box">
												<label>Provide details:</label>
												<div class="textarea">{{flatDataSetSec3.privateLiftStations[flatDataSec3.privateLiftStations.indexOf('structureOnTopOfLiftStation')].WaterSystemViolationDescription}}</div>
											</div>
										</div>
										<div class="question-line">
											<div class="question" style="flex-basis: 70%;">
												Is equipment accessible to individuals other than authorized personnel?
											</div>
											 <div class="question">
												<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec3.privateLiftStations.indexOf('isEquipmentAccessible')>-1, 'radio-unchecked':flatDataSec3.privateLiftStations.indexOf('isEquipmentAccessible')==-1}">Yes</span>
												<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec3.privateLiftStations.indexOf('isEquipmentAccessible')==-1, 'radio-unchecked':flatDataSec3.privateLiftStations.indexOf('isEquipmentAccessible')>-1}">No</span>
											</div>
										</div>
										<div *ngIf="flatDataSec3.privateLiftStations.indexOf('isEquipmentAccessible')>-1" class="question-box">
											<div class="input-box">
												<label>Provide details:</label>
												<div class="textarea">{{flatDataSetSec3.privateLiftStations[flatDataSec3.privateLiftStations.indexOf('isEquipmentAccessible')].WaterSystemViolationDescription}}</div>
											</div>
										</div>
										<div class="question-line">
											<div class="question" style="flex-basis: 70%;">
												Are there any current or previous violations?
											</div>
											 <div class="question">
												<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec3.privateLiftStations.indexOf('currentOrPreviousViolations')>-1, 'radio-unchecked':flatDataSec3.privateLiftStations.indexOf('currentOrPreviousViolations')==-1}">Yes</span>
												<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec3.privateLiftStations.indexOf('currentOrPreviousViolations')==-1, 'radio-unchecked':flatDataSec3.privateLiftStations.indexOf('currentOrPreviousViolations')>-1}">No</span>
											</div>
										</div>
										<div *ngIf="flatDataSec3.privateLiftStations.indexOf('currentOrPreviousViolations')>-1" class="question-box">
											<div class="input-box">
												<label>Provide details:</label>
												<div class="textarea">{{flatDataSetSec3.privateLiftStations[flatDataSec3.privateLiftStations.indexOf('currentOrPreviousViolations')].WaterSystemViolationDescription}}</div>
											</div>
										</div>
										<div class="question-line">
											<div class="question" style="flex-basis: 70%;">
												Is this system type atypical for the market?
											</div>
											 <div class="question">
												<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec3.privateLiftStations.indexOf('atypicalSystemForMarket')>-1, 'radio-unchecked':flatDataSec3.privateLiftStations.indexOf('atypicalSystemForMarket')==-1}">Yes</span>
												<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec3.privateLiftStations.indexOf('atypicalSystemForMarket')==-1, 'radio-unchecked':flatDataSec3.privateLiftStations.indexOf('atypicalSystemForMarket')>-1}">No</span>
											</div>
										</div>
										<div *ngIf="flatDataSec3.privateLiftStations.indexOf('atypicalSystemForMarket')>-1" class="question-box">
											<div class="input-box">
												<label>Provide details:</label>
												<div class="textarea">{{flatDataSetSec3.privateLiftStations[flatDataSec3.privateLiftStations.indexOf('atypicalSystemForMarket')].WaterSystemViolationDescription}}</div>
											</div>
										</div>
										<div class="question-line">
											<div class="question">
												Is any other person or property, other than the Borrower or subject property, authorized to use the system?
											</div>
											 <div class="question">
												<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec3.privateLiftStations.indexOf('otherPersonsAuthorized')>-1, 'radio-unchecked':flatDataSec3.privateLiftStations.indexOf('otherPersonsAuthorized')==-1}">Yes</span>
												<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec3.privateLiftStations.indexOf('otherPersonsAuthorized')==-1, 'radio-unchecked':flatDataSec3.privateLiftStations.indexOf('otherPersonsAuthorized')>-1}">No</span>
											</div>
										</div>
										<div *ngIf="flatDataSec3.privateLiftStations.indexOf('otherPersonsAuthorized')>-1" class="question-box">
											<div class="input-box">
												<label>Provide details:</label>
												<div class="textarea">{{flatDataSetSec3.privateLiftStations[flatDataSec3.privateLiftStations.indexOf('otherPersonsAuthorized')].WaterSystemViolationDescription}}</div>
											</div>
										</div>
										<div class="question-line">
											<div class="question">
												Is any part of the system owned or maintained by the residents?
											</div>
											 <div class="question">
												<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec3.privateLiftStations.indexOf('partsOwnedByResidents')>-1, 'radio-unchecked':flatDataSec3.privateLiftStations.indexOf('partsOwnedByResidents')==-1}">Yes</span>
												<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec3.privateLiftStations.indexOf('partsOwnedByResidents')==-1, 'radio-unchecked':flatDataSec3.privateLiftStations.indexOf('partsOwnedByResidents')>-1}">No</span>
											</div>
										</div>
										<div *ngIf="flatDataSec3.privateLiftStations.indexOf('partsOwnedByResidents')>-1" class="question-box">
											<div class="input-box">
												<label>Provide details:</label>
												<div class="textarea">{{flatDataSetSec3.privateLiftStations[flatDataSec3.privateLiftStations.indexOf('partsOwnedByResidents')].WaterSystemViolationDescription}}</div>
											</div>
										</div>
										<div class="question-line">
											<div class="question">
												Does the system fail to meet or exceed applicable federal, state and/or local requirements?
											</div>
											 <div class="question">
												<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec3.privateLiftStations.indexOf('failureToMeetRequirements')>-1, 'radio-unchecked':flatDataSec3.privateLiftStations.indexOf('failureToMeetRequirements')==-1}">Yes</span>
												<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec3.privateLiftStations.indexOf('failureToMeetRequirements')==-1, 'radio-unchecked':flatDataSec3.privateLiftStations.indexOf('failureToMeetRequirements')>-1}">No</span>
											</div>
										</div>
										<div *ngIf="flatDataSec3.privateLiftStations.indexOf('failureToMeetRequirements')>-1" class="question-box">
											<div class="input-box">
												<label>Provide details:</label>
												<div class="textarea">{{flatDataSetSec3.privateLiftStations[flatDataSec3.privateLiftStations.indexOf('failureToMeetRequirements')].WaterSystemViolationDescription}}</div>
											</div>
										</div>										
									</div>                                    
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </section>
        <section class="page-before" data-section-title="Section V">
            <header>
                <div class="freddie-mac-header">
                    <div class="freddie-mac-logo">
                        <img src="https://erisservice9.erisinfo.com/exreportw/frmimages/logo.jpg" alt="Freddie Mac Multifamily">
                    </div>
                    <div class="freddie-mac-title">
                        <strong>Property Condition Assessment</strong>
                    </div>
                </div>
            </header>
            <h1>Section V: Manufactured Housing Communities</h1>
           
			<table>
                <thead>
                    <tr>
                        <td class="wrapper">
                            <h2>&nbsp;</h2>
                            <table class="section-header">
                                <tr>
                                    <td width="25%">
                                        <div>
                                            <p *ngIf="PropertyAsReportedHTML?.FrmLoanNo?.html" [innerHTML]="PropertyAsReportedHTML?.FrmLoanNo?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.FrmLoanNo?.html" [innerHTML]="PropertyAsReportedHTML?.FrmLoanNo?.text"></p>
											<label>Freddie Mac loan number</label>
                                        </div>
                                    </td>
                                    <td width="25%">
                                        <div>
                                            <p [innerHTML]="PropertyConditionAssessmentHTML?.FinalAsmntDate|date:'MMMM dd, yyyy'"></p>
                                            <label>Report date</label>
                                        </div>
                                    </td>
                                    <td colspan="2" width="50%">
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.AsReportedName?.html" [innerHTML]="PropertyAsReportedHTML?.AsReportedName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AsReportedName?.html" [innerHTML]="PropertyAsReportedHTML?.AsReportedName?.text"></p>
											<label>Property name</label>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.AccountName?.html" [innerHTML]="PropertyAsReportedHTML?.AccountName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AccountName?.html" [innerHTML]="PropertyAsReportedHTML?.AccountName?.text"></p>
											<label>Seller/Servicer name</label>
                                        </div>
                                    </td>
                                    <td colspan="2" class="fh">
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.AddressLineText?.html" [innerHTML]="PropertyAsReportedHTML?.AddressLineText?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AddressLineText?.html" [innerHTML]="PropertyAsReportedHTML?.AddressLineText?.text"></p>
											<label>Address</label>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.PartyBusinessAccountId?.html" [innerHTML]="PropertyAsReportedHTML?.PartyBusinessAccountId?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.PartyBusinessAccountId?.html" [innerHTML]="PropertyAsReportedHTML?.PartyBusinessAccountId?.text"></p>
											<label>Seller/Servicer number</label>
                                        </div>
                                    </td>
                                    <td>
                                        <div>
                                            <p [innerHTML]="PropertyConditionAssessmentHTML?.PrelimInspectionDate|date:'MMMM dd, yyyy'"></p>
                                            <label>Inspection date</label>
                                        </div>
                                    </td>
                                    <td colspan="2" class="fh">
                                        <div>
                                            <p><ng-container *ngIf="PropertyAsReportedHTML?.CityName?.html"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.CityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="!PropertyAsReportedHTML?.CityName?.html&&PropertyAsReportedHTML?.CityName?.text"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.CityName?.text"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="PropertyAsReportedHTML?.StateUspsCode?.html"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.StateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="!PropertyAsReportedHTML?.StateUspsCode?.html&&PropertyAsReportedHTML?.StateUspsCode?.text"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.StateUspsCode?.text"></span>,&nbsp;</ng-container> 
												<span *ngIf="PropertyAsReportedHTML?.PostalCode?.html" style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.PostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>
												<span *ngIf="!PropertyAsReportedHTML?.PostalCode?.html" style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.PostalCode?.secHtml?.text"></span></p>
											<label>City, State, Zip</label>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="wrapper">
							<div class="question-line">
								<div class="question">
									Is the property a Manufactured Housing Community ("MHC"), or does it contain MHC units?
								</div>
								 <div class="question">
									<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':PropertyConditionAssessment[0].ManufacturedHousingInd=='Y', 'radio-unchecked':PropertyConditionAssessment[0].ManufacturedHousingInd=='N'}">Yes</span>
									<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':PropertyConditionAssessment[0].ManufacturedHousingInd=='N', 'radio-unchecked':PropertyConditionAssessment[0].ManufacturedHousingInd=='Y'}">No</span>
								</div>
							</div>
							<ng-container *ngIf="PropertyConditionAssessment[0].ManufacturedHousingInd=='Y'">
								<div class="input-box">
									<label>How large are the pad sites? What size homes can they accommodate (e.g., single-wide, double-wide, etc.)?</label>
									<div class="textarea">{{PropertyConditionAssessment[0].ManufacturedHousingPadSiteSizeDescription}}</div>
								</div>

							<div class="question-line">
								<div class="question" style="width:75%">
									Are there any homes that were not installed in compliance with all zoning and building codes?
								</div>
								 <div class="question">
									<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('homesNotInZoningCompliance')>-1, 'radio-unchecked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('homesNotInZoningCompliance')==-1}">Yes</span>
									<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('homesNotInZoningCompliance')==-1, 'radio-unchecked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('homesNotInZoningCompliance')>-1}">No</span>
								</div>
							</div>
							<div *ngIf="flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('homesNotInZoningCompliance')>-1" class="question-box">
								<div class="input-box">
									<label>Provide details:</label>
									<div class="textarea">{{flatDataSetSec4.PropertyConditionAssessmentManufacturedHousing[flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('homesNotInZoningCompliance')].ViolationDescription}}</div>
								</div>
							</div>
							<div class="question-line">
								<div class="question">
									Are there any decks or patios that are not professionally built, or do not provide sound and adequate access to all homes?
								</div>
								 <div class="question">
									<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('homesWithUnprofessionalDecksAndPatios')>-1, 'radio-unchecked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('homesWithUnprofessionalDecksAndPatios')==-1}">Yes</span>
									<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('homesWithUnprofessionalDecksAndPatios')==-1, 'radio-unchecked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('homesWithUnprofessionalDecksAndPatios')>-1}">No</span>
								</div>
							</div>
							<div *ngIf="flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('homesWithUnprofessionalDecksAndPatios')>-1" class="question-box">
								<div class="input-box">
									<label>Provide details:</label>
									<div class="textarea">{{flatDataSetSec4.PropertyConditionAssessmentManufacturedHousing[flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('homesWithUnprofessionalDecksAndPatios')].ViolationDescription}}</div>
								</div>
							</div>
							<div class="question-line">
								<div class="question"  style="width:75%">
									Are there any homes that have not been professionally skirted?
								</div>
								 <div class="question">
									<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('homesWithUnprofessionalSkirting')>-1, 'radio-unchecked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('homesWithUnprofessionalSkirting')==-1}">Yes</span>
									<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('homesWithUnprofessionalSkirting')==-1, 'radio-unchecked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('homesWithUnprofessionalSkirting')>-1}">No</span>
								</div>
							</div>
							<div *ngIf="flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('homesWithUnprofessionalSkirting')>-1" class="question-box">
								<div class="input-box">
									<label>Identify units without skirting:</label>
									<div class="textarea">{{flatDataSetSec4.PropertyConditionAssessmentManufacturedHousing[flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('homesWithUnprofessionalSkirting')].ViolationDescription}}</div>
								</div>
							</div>
							<div class="question-line">
								<div class="question"  style="width:75%">
									Are there any homes with exposed hitches?
								</div>
								 <div class="question">
									<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('homesWithExposedHitches')>-1, 'radio-unchecked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('homesWithExposedHitches')==-1}">Yes</span>
									<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('homesWithExposedHitches')==-1, 'radio-unchecked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('homesWithExposedHitches')>-1}">No</span>
								</div>
							</div>
							<div *ngIf="flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('homesWithExposedHitches')>-1" class="question-box">
								<div class="input-box">
									<label>Identify units with exposed hitches:</label>
									<div class="textarea">{{flatDataSetSec4.PropertyConditionAssessmentManufacturedHousing[flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('homesWithExposedHitches')].ViolationDescription}}</div>
								</div>
							</div>
							<div class="question-line">
								<div class="question" style="width:75%">
									Are tenant-owned ancillary structures (e.g., sheds, playhouses, etc.) allowed on the pad sites?
								</div>
								 <div class="question">
									<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('tenantOwnedStructures')>-1, 'radio-unchecked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('tenantOwnedStructures')==-1}">Yes</span>
									<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('tenantOwnedStructures')==-1, 'radio-unchecked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('tenantOwnedStructures')>-1}">No</span>
								</div>
							</div>
							<div *ngIf="flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('tenantOwnedStructures')>-1" class="question-box">
								<div class="input-box">
									<label>Provide details:</label>
									<div class="textarea">{{flatDataSetSec4.PropertyConditionAssessmentManufacturedHousing[flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('tenantOwnedStructures')].ViolationDescription}}</div>
								</div>
							
							<div class="question-line">
								<div class="question" style="width:85%">
									Are any deficiencies present regarding these structures that could have a detrimental effect on the homes or the community as a whole (such as curb appeal)?
								</div>
								 <div class="question">
									<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('tenantOwnedStructures.deficienciesPresent')>-1, 'radio-unchecked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('tenantOwnedStructures.deficienciesPresent')==-1}">Yes</span>
									<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('tenantOwnedStructures.deficienciesPresent')==-1, 'radio-unchecked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('tenantOwnedStructures.deficienciesPresent')>-1}">No</span>
								</div>
							</div>
							<div *ngIf="flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('tenantOwnedStructures.deficienciesPresent')>-1" class="question-box">
								<div class="input-box">
									<label>Provide details:</label>
									<div class="textarea">{{flatDataSetSec4.PropertyConditionAssessmentManufacturedHousing[flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('tenantOwnedStructures.deficienciesPresent')].ViolationDescription}}</div>
								</div>
							</div>
							</div>
							<div class="question-line">
								<div class="question">
									Did any of the borrower-owned homes fail to meet any local seismic codes or requirements?
								</div>
								 <div class="question">
									<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('borrowerOwnedHomesNotMeetingSeismicCodes')>-1, 'radio-unchecked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('borrowerOwnedHomesNotMeetingSeismicCodes')==-1}">Yes</span>
									<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('borrowerOwnedHomesNotMeetingSeismicCodes')==-1, 'radio-unchecked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('borrowerOwnedHomesNotMeetingSeismicCodes')>-1}">No</span>
								</div>
							</div>
							<div *ngIf="flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('borrowerOwnedHomesNotMeetingSeismicCodes')>-1" class="question-box">
								<div class="input-box">
									<label>Provide details:</label>
									<div class="textarea">{{flatDataSetSec4.PropertyConditionAssessmentManufacturedHousing[flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('borrowerOwnedHomesNotMeetingSeismicCodes')].ViolationDescription}}</div>
								</div>
							</div>
							<div class="question-line">
								<div class="question">What utilities are available at each pad site?</div>
							</div>
							<div class="question-box">
								<div class="question-line" style="width:80%">
									<div class="question">
										<span [ngClass]="{'checkbox-checked1':flatDataSec4.ManufacturedHousingUtility.indexOf('municipalWater')>-1, 'checkbox-unchecked1':flatDataSec4.ManufacturedHousingUtility.indexOf('municipalWater')==-1}">Municipal water</span>
									</div>
									<div class="question">
										<span [ngClass]="{'checkbox-checked1':flatDataSec4.ManufacturedHousingUtility.indexOf('privateWater')>-1, 'checkbox-unchecked1':flatDataSec4.ManufacturedHousingUtility.indexOf('privateWater')==-1}">Private water</span>
									</div>
									<div class="question">
										<span [ngClass]="{'checkbox-checked1':flatDataSec4.ManufacturedHousingUtility.indexOf('electric')>-1, 'checkbox-unchecked1':flatDataSec4.ManufacturedHousingUtility.indexOf('electric')==-1}">Electric</span>
									</div>
									<div class="question">
										<span [ngClass]="{'checkbox-checked1':flatDataSec4.ManufacturedHousingUtility.indexOf('gas')>-1, 'checkbox-unchecked1':flatDataSec4.ManufacturedHousingUtility.indexOf('gas')==-1}">Gas</span>
									</div>
									<div class="question">
										<span [ngClass]="{'checkbox-checked1':flatDataSec4.ManufacturedHousingUtility.indexOf('other')>-1, 'checkbox-unchecked1':flatDataSec4.ManufacturedHousingUtility.indexOf('other')==-1}">Other</span>
									</div>
									</div><div class="question-line" style="width:33.2%">
									<div class="question">
										<span [ngClass]="{'checkbox-checked1':flatDataSec4.ManufacturedHousingUtility.indexOf('municipalSewer')>-1, 'checkbox-unchecked1':flatDataSec4.ManufacturedHousingUtility.indexOf('municipalSewer')==-1}">Municipal sewer</span>
									</div>
									<div class="question">
										<span [ngClass]="{'checkbox-checked1':flatDataSec4.ManufacturedHousingUtility.indexOf('privateSewer')>-1, 'checkbox-unchecked1':flatDataSec4.ManufacturedHousingUtility.indexOf('privateSewer')==-1}">Private sewer</span>
									</div>
								</div>
								<div *ngIf="flatDataSec4.ManufacturedHousingUtility.indexOf('other')>-1" class="input-box">
									<label>Provide details for "Other":</label>
									<div class="textarea">{{flatDataSetSec4.ManufacturedHousingUtility[flatDataSec4.ManufacturedHousingUtility.indexOf('other')].OtherTypeDescription}}</div>
								</div>
							</div>
							<div class="question-line">
								<div class="question">
									Is the property located in a flood zone?
								</div>
								 <div class="question">
									<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('propertyInFloodZone')>-1, 'radio-unchecked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('propertyInFloodZone')==-1}">Yes</span>
									<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('propertyInFloodZone')==-1, 'radio-unchecked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('propertyInFloodZone')>-1}">No</span>
								</div>
							</div>
							<div *ngIf="flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('propertyInFloodZone')>-1" class="question-box">
								<div class="input-box">
									<label>Provide details regarding the number of pad sites and common buildings that are affected.</label>
									<div class="textarea">{{flatDataSetSec4.PropertyConditionAssessmentManufacturedHousing[flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('propertyInFloodZone')].ViolationDescription}}</div>
								</div>
							</div>
							<div class="question-line">
								<div class="question" style="width:80%">
									Are any of the pad sites supplied with less than 60 amperes of power?
								</div>
								 <div class="question">
									<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('lowAmperagePads')>-1, 'radio-unchecked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('lowAmperagePads')==-1}">Yes</span>
									<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('lowAmperagePads')==-1, 'radio-unchecked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('lowAmperagePads')>-1}">No</span>
								</div>
							</div>
							<div *ngIf="flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('lowAmperagePads')>-1" class="question-box">
								<div class="question-line">
									<div class="question">
										Does the available level of power fail to meet any state and local building codes?
									</div>
									 <div class="question">
										<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('lowAmperagePads.codeFailure')>-1, 'radio-unchecked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('lowAmperagePads.codeFailure')==-1}">Yes</span>
										<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('lowAmperagePads.codeFailure')==-1, 'radio-unchecked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('lowAmperagePads.codeFailure')>-1}">No</span>
									</div>
								</div>
								<div *ngIf="flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('lowAmperagePads.codeFailure')>-1" class="question-box">
								<div class="input-box">
									<label>Provide details:</label>
									<div class="textarea">{{flatDataSetSec4.PropertyConditionAssessmentManufacturedHousing[flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('lowAmperagePads.codeFailure')].ViolationDescription}}</div>
								</div>
							</div>
								<div class="question-line">
									<div class="question">
										Is the current level of power insufficient for any home(s)?
									</div>
									 <div class="question">
										<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('lowAmperagePads.insufficientPower')>-1, 'radio-unchecked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('lowAmperagePads.insufficientPower')==-1}">Yes</span>
										<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('lowAmperagePads.insufficientPower')==-1, 'radio-unchecked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('lowAmperagePads.insufficientPower')>-1}">No</span>
									</div>
								</div>
								<div *ngIf="flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('lowAmperagePads.insufficientPower')>-1"  class="question-box">
								<div class="input-box">
									<label>Provide details:</label>
									<div class="textarea">{{flatDataSetSec4.PropertyConditionAssessmentManufacturedHousing[flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('lowAmperagePads.insufficientPower')].ViolationDescription}}</div>
								</div>
							</div>
							</div>
							<div class="question-line">
								<div class="question"  style="width:80%">
									Are there any pad sites not ready for occupancy (missing road access, connections to utilities, curb cuts, etc.)?
								</div>
								 <div class="question">
									<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('padsNotReadyForOccupancy')>-1, 'radio-unchecked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('padsNotReadyForOccupancy')==-1}">Yes</span>
									<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('padsNotReadyForOccupancy')==-1, 'radio-unchecked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('padsNotReadyForOccupancy')>-1}">No</span>
								</div>
							</div>
							<div *ngIf="flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('padsNotReadyForOccupancy')>-1" class="question-box">
								<div class="input-box">
									<label>List the pad site numbers, and explain why each pad site is not ready for occupancy:</label>
									<div class="textarea">{{flatDataSetSec4.PropertyConditionAssessmentManufacturedHousing[flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('padsNotReadyForOccupancy')].ViolationDescription}}</div>
								</div>
							</div>
							<div class="question-line">
								<div class="question">
									Do any pads have unpaved or gravel driveways (e.g., no asphalt, concrete, etc.)?
								</div>
								 <div class="question">
									<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('padsWithUnpavedDriveways')>-1, 'radio-unchecked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('padsWithUnpavedDriveways')==-1}">Yes</span>
									<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('padsWithUnpavedDriveways')==-1, 'radio-unchecked':flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('padsWithUnpavedDriveways')>-1}">No</span>
								</div>
							</div>
							<div *ngIf="flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('padsWithUnpavedDriveways')>-1" class="question-box">
								<div class="question-line">
									<div class="question"  style="width:80%">
										Are any of the pad sites with unpaved driveways currently occupied?
									</div>
									 <div class="question">
										<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSetSec4.PropertyConditionAssessmentManufacturedHousing[flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('padsWithUnpavedDriveways')].UnpavedDrivewayPadSiteWithCurrentlyOccupiedHomeInd=='Y', 'radio-unchecked':flatDataSetSec4.PropertyConditionAssessmentManufacturedHousing[flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('padsWithUnpavedDriveways')].UnpavedDrivewayPadSiteWithCurrentlyOccupiedHomeInd=='N'}">Yes</span>
										<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSetSec4.PropertyConditionAssessmentManufacturedHousing[flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('padsWithUnpavedDriveways')].UnpavedDrivewayPadSiteWithCurrentlyOccupiedHomeInd=='N', 'radio-unchecked':flatDataSetSec4.PropertyConditionAssessmentManufacturedHousing[flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('padsWithUnpavedDriveways')].UnpavedDrivewayPadSiteWithCurrentlyOccupiedHomeInd=='Y'}">No</span>
									</div>
								</div>
								<div *ngIf="flatDataSetSec4.PropertyConditionAssessmentManufacturedHousing[flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('padsWithUnpavedDriveways')].UnpavedDrivewayPadSiteWithCurrentlyOccupiedHomeInd=='Y'" class="question-box">
								<div class="question-line">
									<label>How many?</label>
									<div class="textarea" style="width:90px; text-align: center">{{flatDataSetSec4.PropertyConditionAssessmentManufacturedHousing[flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('padsWithUnpavedDriveways')].UnpavedDrivewayPadSiteWithCurrentlyOccupiedHomeCount}}</div>
								</div>
							</div>
								<div class="question-line">
									<div class="question" style="width:80%">
										Are any of the pad sites with unpaved driveways currently vacant/down/offline?
									</div>
									 <div class="question">
										<span type="radio" style='margin-right: 10px;' [ngClass]="{'radio-checked':flatDataSetSec4.PropertyConditionAssessmentManufacturedHousing[flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('padsWithUnpavedDriveways')].UnpavedDrivewayPadSiteWithVacantDownOfflineHomeInd=='Y', 'radio-unchecked':flatDataSetSec4.PropertyConditionAssessmentManufacturedHousing[flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('padsWithUnpavedDriveways')].UnpavedDrivewayPadSiteWithVacantDownOfflineHomeInd=='N'}">Yes</span>
										<span type="radio" style='margin-right: 10px;'  [ngClass]="{'radio-checked':flatDataSetSec4.PropertyConditionAssessmentManufacturedHousing[flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('padsWithUnpavedDriveways')].UnpavedDrivewayPadSiteWithVacantDownOfflineHomeInd=='N', 'radio-unchecked':flatDataSetSec4.PropertyConditionAssessmentManufacturedHousing[flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('padsWithUnpavedDriveways')].UnpavedDrivewayPadSiteWithVacantDownOfflineHomeInd=='Y'}">No</span>
									</div>
								</div>
								<div class="question-box"  *ngIf="flatDataSetSec4.PropertyConditionAssessmentManufacturedHousing[flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('padsWithUnpavedDriveways')].UnpavedDrivewayPadSiteWithVacantDownOfflineHomeInd=='Y'" >
									<div class="question-line">
										<label>How many pad sites with unpaved driveways have a vacant home on them?</label>
										<div class="textarea"  style="width:90px; text-align: center">{{flatDataSetSec4.PropertyConditionAssessmentManufacturedHousing[flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('padsWithUnpavedDriveways')].UnpavedDrivewayPadSiteWithVacantHomeCount}}</div>
									</div>
									<div class="question-line">
										<label>How many pad sites with unpaved driveways have never had a home on them?</label>
										<div class="textarea"  style="width:90px; text-align: center">{{flatDataSetSec4.PropertyConditionAssessmentManufacturedHousing[flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('padsWithUnpavedDriveways')].UnpavedDrivewayPadSiteNeverHadHomeCount}}</div>
									</div>
									<div class="question-line">
										<label>How many pad sites with unpaved driveways have had a home on them in the past, but don't now?</label>
										<div class="textarea"  style="width:90px; text-align: center">{{flatDataSetSec4.PropertyConditionAssessmentManufacturedHousing[flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('padsWithUnpavedDriveways')].UnpavedDrivewayPadSiteWithPastNotPresentHomeCount}}</div>
									</div>
								</div>
								<div class="question-line">
									<label>What is the total cost to pave all unpaved driveways?</label>
									<div class="textarea"  style="width:90px; text-align: center">{{'$'+flatDataSetSec4.PropertyConditionAssessmentManufacturedHousing[flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('padsWithUnpavedDriveways')].UnpavedDrivewayPadSiteTotalPavingCostAmt}}</div>
								</div>
								<div class="input-box">
									<label>For all pad sites with unpaved driveways, please list the pad site numbers and the current state of the driveways:</label>
									<div class="textarea">{{flatDataSetSec4.PropertyConditionAssessmentManufacturedHousing[flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('padsWithUnpavedDriveways')].ViolationDescription}}</div>
								</div>
							</div>
							<ng-container *ngIf="flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('padsWithUnpavedDriveways')>-1">
								<div style="border-top:double 2px #666; color:#666; margin-top:20px; padding-top:20px;"></div>
								<div class="totalbox">
									<p class="leftlabel">Number of Occupied Pad Sites with unpaved driveways</p>
									<div class="textarea rightbox">{{flatDataSetSec4.PropertyConditionAssessmentManufacturedHousing[flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('padsWithUnpavedDriveways')]?.UnpavedDrivewayPadSiteWithCurrentlyOccupiedHomeCount}}</div>		 
								</div>
								<div class="totalbox">
									<p class="leftlabel">Number of Vacant Pad Sites with unpaved driveways</p>
									<div class="textarea rightbox">{{flatDataSetSec4.PropertyConditionAssessmentManufacturedHousing[flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('padsWithUnpavedDriveways')]?.UnpavedDrivewayPadSiteWithVacantHomeCount+flatDataSetSec4.PropertyConditionAssessmentManufacturedHousing[flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('padsWithUnpavedDriveways')]?.UnpavedDrivewayPadSiteNeverHadHomeCount+flatDataSetSec4.PropertyConditionAssessmentManufacturedHousing[flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('padsWithUnpavedDriveways')]?.UnpavedDrivewayPadSiteWithPastNotPresentHomeCount}}</div>		 
								</div>
								<div class="totalbox">
									<p class="leftlabel">Total Pad Sites with unpaved driveways</p>
									<div class="textarea rightbox">{{frmData['sec4OutPutData'][1]}}</div>		 
								</div>
								<div class="totalbox">
									<p class="leftlabel">Cost to pave each unpaved driveway</p>
									<div class="textarea rightbox">{{frmData['sec4OutPutData'][2]}}</div>		 
								</div>
							</ng-container>
						</ng-container>							
						</td>
					</tr>
				</tbody>
			</table>
        </section>
        <section class="page-before landscape-content" data-section-title="Section VI">
            <header>
                <div class="freddie-mac-header">
                    <div class="freddie-mac-logo">
                        <img src="https://erisservice9.erisinfo.com/exreportw/frmimages/logo.jpg" alt="Freddie Mac Multifamily">
                    </div>
                    <div class="freddie-mac-title">
                        <strong>Property Condition Assessment</strong>
                    </div>
                </div>
            </header>
            <h1>Section VI: Capital Needs Over the Loan Term</h1>
            <table>
                <thead>
                    <tr>
                        <td class="wrapper">
                            <h2>&nbsp;</h2>
                            <table class="section-header">
                                <tr>
                                    <td width="20%">
                                        <div>
                                            <p *ngIf="PropertyAsReportedHTML?.FrmLoanNo?.html" [innerHTML]="PropertyAsReportedHTML?.FrmLoanNo?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.FrmLoanNo?.html" [innerHTML]="PropertyAsReportedHTML?.FrmLoanNo?.text"></p>
											<label>Freddie Mac loan number</label>
                                        </div>
                                    </td>
                                    <td width="20%">
                                        <div>
                                            <p [innerHTML]="PropertyConditionAssessmentHTML?.FinalAsmntDate|date:'MMMM dd, yyyy'"></p>
                                            <label>Report date</label>
                                        </div>
                                    </td>
                                    <td colspan="2" width="40%">
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.AsReportedName?.html" [innerHTML]="PropertyAsReportedHTML?.AsReportedName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AsReportedName?.html" [innerHTML]="PropertyAsReportedHTML?.AsReportedName?.text"></p>
											<label>Property name</label>
                                        </div>
                                    </td>
									<td width="20%">
                                        <div>
                                            <p [innerHTML]="PropertyConditionAssessmentPropertyCoreCharacteristicsHTML?.PptyBuildingAgeYrCount?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
                                            <label>Building Age</label>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.AccountName?.html" [innerHTML]="PropertyAsReportedHTML?.AccountName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AccountName?.html" [innerHTML]="PropertyAsReportedHTML?.AccountName?.text"></p>
											<label>Seller/Servicer name</label>
                                        </div>
                                    </td>
                                    <td colspan="2" class="fh">
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.AddressLineText?.html" [innerHTML]="PropertyAsReportedHTML?.AddressLineText?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AddressLineText?.html" [innerHTML]="PropertyAsReportedHTML?.AddressLineText?.text"></p>
											<label>Address</label>
                                        </div>
                                    </td>
									<td>
                                        <div>
                                            <p> {{pcaOp.reserve-2}} +2</p>
                                            <label>Mortgage term</label>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.PartyBusinessAccountId?.html" [innerHTML]="PropertyAsReportedHTML?.PartyBusinessAccountId?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.PartyBusinessAccountId?.html" [innerHTML]="PropertyAsReportedHTML?.PartyBusinessAccountId?.text"></p>
											<label>Seller/Servicer number</label>
                                        </div>
                                    </td>
                                    <td>
                                        <div>
                                            <p [innerHTML]="PropertyConditionAssessmentHTML?.PrelimInspectionDate|date:'MMMM dd, yyyy'"></p>
                                            <label>Inspection date</label>
                                        </div>
                                    </td>
                                    <td colspan="2" class="fh">
                                        <div>
                                            <p><ng-container *ngIf="PropertyAsReportedHTML?.CityName?.html"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.CityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="!PropertyAsReportedHTML?.CityName?.html&&PropertyAsReportedHTML?.CityName?.text"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.CityName?.text"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="PropertyAsReportedHTML?.StateUspsCode?.html"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.StateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="!PropertyAsReportedHTML?.StateUspsCode?.html&&PropertyAsReportedHTML?.StateUspsCode?.text"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.StateUspsCode?.text"></span>,&nbsp;</ng-container> 
												<span *ngIf="PropertyAsReportedHTML?.PostalCode?.html" style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.PostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>
												<span *ngIf="!PropertyAsReportedHTML?.PostalCode?.html" style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.PostalCode?.secHtml?.text"></span></p>
											<label>City, State, Zip</label>
                                        </div>
                                    </td>
									<td>
                                        <div>
                                            <p>{{PropertyTotalRentRollSummary[0].PropertyResidentialRentRollSummary[0].RsdntlTotalUnitCount}}</p>
                                            <label>Number of units</label>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="wrapper">
							<label style="font-size: 6pt;">Complete the quantity, unit and per item costs for the applicable items listed below. Indicate the projected expenditures for those items in each year of the loan term plus two years up to a maximum of 12 years.</label>
							<div *ngIf='sec6tablesdata' id="frm_sec5_1" style="margin-top:6px; font-size: 11px">
								<h2 id="frm_sec5_1_0" style="color:white; background-color:black;font-size: 7.56pt; padding:4px; margin-top: 10px;margin-bottom: 10px;">SITE</h2> 
								<table class='datatable1' style="width:100%; font-size:6.12pt; font-family:Arial, sans-serif;border: 1px solid black;border-collapse: collapse;">
									<tr>
										<ng-container *ngFor="let h of sec6tablesdata[0].cols; let o=index; trackBy:trackByFuntion">
											<th [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign, 'border':h.border}" [ngClass]="h.bk">{{h.NAME}}
											</th>	
										</ng-container>
									</tr>
									<ng-container *ngFor="let r of sec6tablesdata[0].rows; let h=index; trackBy:trackByFuntion">
										<tr *ngIf="r.length>1">
											<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
												<td [ngClass]="k.bk" colSpan='{{k.colspan}}' [ngStyle]="{'text-align':sec6tablesdata[0].cols[q].celAllign, 'background-color':k.bk , 'font-weight':k.weight, width:sec6tablesdata[0].cols[q].width+sec6tablesdata[0].cols[q].unit, 'border':k.border,'padding-left':k.sub}">
													<span *ngIf="k.sign&&k.data>0">{{USDollar.format(k.data)}}</span>
													<span *ngIf="!k.sign">{{k.data}}</span>
												</td>		
											</ng-container>
										</tr>
									</ng-container>  
								</table>   
							</div>
						</td>
					</tr>
				</tbody>
			</table>
			<div class="page-before"></div>
			<table>
                <thead>
                    <tr>
                        <td class="wrapper">
                            <h2>&nbsp;</h2>
                            <table class="section-header">
                                <tr>
                                    <td width="20%">
                                        <div>
                                            <p *ngIf="PropertyAsReportedHTML?.FrmLoanNo?.html" [innerHTML]="PropertyAsReportedHTML?.FrmLoanNo?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.FrmLoanNo?.html" [innerHTML]="PropertyAsReportedHTML?.FrmLoanNo?.text"></p>
											<label>Freddie Mac loan number</label>
                                        </div>
                                    </td>
                                    <td width="20%">
                                        <div>
                                            <p [innerHTML]="PropertyConditionAssessmentHTML?.FinalAsmntDate|date:'MMMM dd, yyyy'"></p>
                                            <label>Report date</label>
                                        </div>
                                    </td>
                                    <td colspan="2" width="40%">
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.AsReportedName?.html" [innerHTML]="PropertyAsReportedHTML?.AsReportedName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AsReportedName?.html" [innerHTML]="PropertyAsReportedHTML?.AsReportedName?.text"></p>
											<label>Property name</label>
                                        </div>
                                    </td>
									<td width="20%">
                                        <div>
                                            <p [innerHTML]="PropertyConditionAssessmentPropertyCoreCharacteristicsHTML?.PptyBuildingAgeYrCount?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
                                            <label>Building Age</label>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.AccountName?.html" [innerHTML]="PropertyAsReportedHTML?.AccountName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AccountName?.html" [innerHTML]="PropertyAsReportedHTML?.AccountName?.text"></p>
											<label>Seller/Servicer name</label>
                                        </div>
                                    </td>
                                    <td colspan="2" class="fh">
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.AddressLineText?.html" [innerHTML]="PropertyAsReportedHTML?.AddressLineText?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AddressLineText?.html" [innerHTML]="PropertyAsReportedHTML?.AddressLineText?.text"></p>
											<label>Address</label>
                                        </div>
                                    </td>
									<td>
                                        <div>
                                            <p> {{pcaOp.reserve-2}} +2</p>
                                            <label>Mortgage term</label>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.PartyBusinessAccountId?.html" [innerHTML]="PropertyAsReportedHTML?.PartyBusinessAccountId?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.PartyBusinessAccountId?.html" [innerHTML]="PropertyAsReportedHTML?.PartyBusinessAccountId?.text"></p>
											<label>Seller/Servicer number</label>
                                        </div>
                                    </td>
                                    <td>
                                        <div>
                                            <p [innerHTML]="PropertyConditionAssessmentHTML?.PrelimInspectionDate|date:'MMMM dd, yyyy'"></p>
                                            <label>Inspection date</label>
                                        </div>
                                    </td>
                                    <td colspan="2" class="fh">
                                        <div>
                                            <p><ng-container *ngIf="PropertyAsReportedHTML?.CityName?.html"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.CityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="!PropertyAsReportedHTML?.CityName?.html&&PropertyAsReportedHTML?.CityName?.text"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.CityName?.text"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="PropertyAsReportedHTML?.StateUspsCode?.html"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.StateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="!PropertyAsReportedHTML?.StateUspsCode?.html&&PropertyAsReportedHTML?.StateUspsCode?.text"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.StateUspsCode?.text"></span>,&nbsp;</ng-container> 
												<span *ngIf="PropertyAsReportedHTML?.PostalCode?.html" style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.PostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>
												<span *ngIf="!PropertyAsReportedHTML?.PostalCode?.html" style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.PostalCode?.secHtml?.text"></span></p>
											<label>City, State, Zip</label>
                                        </div>
                                    </td>
									<td>
                                        <div>
                                            <p>{{PropertyTotalRentRollSummary[0].PropertyResidentialRentRollSummary[0].RsdntlTotalUnitCount}}</p>
                                            <label>Number of units</label>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="wrapper">
							<div *ngIf='sec6tablesdata' id="sec3" style="margin-top:6px; font-size: 11px">
								<h2  style="color:white; background-color:black;padding:4px; font-size: 7.56pt;font-weight: bold; margin-top: 10px;margin-bottom: 10px;">STRUCTURAL, BUILDING ENVELOPE AND COMMON AREA FURNITURE, FIXTURES AND EQUIPMENT</h2>
								<table class='datatable1' style="width:100%; font-size:6.12PT; font-family:Arial, sans-serif;border: 1px solid black;border-collapse: collapse;">
									<tr>
										<ng-container *ngFor="let h of sec6tablesdata[1].cols; let o=index; trackBy:trackByFuntion">
											<th [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign, 'border':h.border}" [ngClass]="h.bk">{{h.NAME}}
											</th>	
										</ng-container>
									</tr>
									<ng-container *ngFor="let r of sec6tablesdata[1].rows; let h=index; trackBy:trackByFuntion">
										<tr *ngIf="r.length>1">
											<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
												<td [ngClass]="k.bk" colSpan='{{k.colspan}}' [ngStyle]="{'text-align':sec6tablesdata[1].cols[q].celAllign, 'background-color':k.bk , 'font-weight':k.weight, width:sec6tablesdata[1].cols[q].width+sec6tablesdata[1].cols[q].unit, 'border':k.border,'padding-left':k.sub}">
													<span *ngIf="k.sign&&k.data>0">{{USDollar.format(k.data)}}</span>
													<span *ngIf="!k.sign">{{k.data}}</span>
												</td>		
											</ng-container>
										</tr>
									</ng-container>  
								</table>   
							</div>
						</td>
					</tr>
				</tbody>
			</table>
			<div class="page-before"></div>
			<table>
                <thead>
                    <tr>
                        <td class="wrapper">
                            <h2>&nbsp;</h2>
                            <table class="section-header">
                                <tr>
                                    <td width="20%">
                                        <div>
                                            <p *ngIf="PropertyAsReportedHTML?.FrmLoanNo?.html" [innerHTML]="PropertyAsReportedHTML?.FrmLoanNo?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.FrmLoanNo?.html" [innerHTML]="PropertyAsReportedHTML?.FrmLoanNo?.text"></p>
											<label>Freddie Mac loan number</label>
                                        </div>
                                    </td>
                                    <td width="20%">
                                        <div>
                                            <p [innerHTML]="PropertyConditionAssessmentHTML?.FinalAsmntDate|date:'MMMM dd, yyyy'"></p>
                                            <label>Report date</label>
                                        </div>
                                    </td>
                                    <td colspan="2" width="40%">
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.AsReportedName?.html" [innerHTML]="PropertyAsReportedHTML?.AsReportedName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AsReportedName?.html" [innerHTML]="PropertyAsReportedHTML?.AsReportedName?.text"></p>
											<label>Property name</label>
                                        </div>
                                    </td>
									<td width="20%">
                                        <div>
                                            <p [innerHTML]="PropertyConditionAssessmentPropertyCoreCharacteristicsHTML?.PptyBuildingAgeYrCount?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
                                            <label>Building Age</label>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.AccountName?.html" [innerHTML]="PropertyAsReportedHTML?.AccountName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AccountName?.html" [innerHTML]="PropertyAsReportedHTML?.AccountName?.text"></p>
											<label>Seller/Servicer name</label>
                                        </div>
                                    </td>
                                    <td colspan="2" class="fh">
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.AddressLineText?.html" [innerHTML]="PropertyAsReportedHTML?.AddressLineText?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AddressLineText?.html" [innerHTML]="PropertyAsReportedHTML?.AddressLineText?.text"></p>
											<label>Address</label>
                                        </div>
                                    </td>
									<td>
                                        <div>
                                            <p> {{pcaOp.reserve-2}} +2</p>
                                            <label>Mortgage term</label>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.PartyBusinessAccountId?.html" [innerHTML]="PropertyAsReportedHTML?.PartyBusinessAccountId?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.PartyBusinessAccountId?.html" [innerHTML]="PropertyAsReportedHTML?.PartyBusinessAccountId?.text"></p>
											<label>Seller/Servicer number</label>
                                        </div>
                                    </td>
                                    <td>
                                        <div>
                                            <p [innerHTML]="PropertyConditionAssessmentHTML?.PrelimInspectionDate|date:'MMMM dd, yyyy'"></p>
                                            <label>Inspection date</label>
                                        </div>
                                    </td>
                                    <td colspan="2" class="fh">
                                        <div>
                                            <p><ng-container *ngIf="PropertyAsReportedHTML?.CityName?.html"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.CityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="!PropertyAsReportedHTML?.CityName?.html&&PropertyAsReportedHTML?.CityName?.text"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.CityName?.text"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="PropertyAsReportedHTML?.StateUspsCode?.html"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.StateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="!PropertyAsReportedHTML?.StateUspsCode?.html&&PropertyAsReportedHTML?.StateUspsCode?.text"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.StateUspsCode?.text"></span>,&nbsp;</ng-container> 
												<span *ngIf="PropertyAsReportedHTML?.PostalCode?.html" style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.PostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>
												<span *ngIf="!PropertyAsReportedHTML?.PostalCode?.html" style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.PostalCode?.secHtml?.text"></span></p>
											<label>City, State, Zip</label>
                                        </div>
                                    </td>
									<td>
                                        <div>
                                            <p>{{PropertyTotalRentRollSummary[0].PropertyResidentialRentRollSummary[0].RsdntlTotalUnitCount}}</p>
                                            <label>Number of units</label>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="wrapper">
							<div *ngIf='sec6tablesdata' id="sec4" style="margin-top:6px; font-size: 11px">
								<h2 style="color:white; background-color:black;padding:4px; font-size: 7.56pt;margin-top: 10px;margin-bottom: 10px;">MECHANICAL AND ELECTRICAL</h2>
								<table class='datatable1' style="width:100%; font-size:6.12PT; font-family:Arial, sans-serif;border: 1px solid black;border-collapse: collapse;">
									<tr>
										<ng-container *ngFor="let h of sec6tablesdata[2].cols; let o=index; trackBy:trackByFuntion">
											<th [ngClass]="h.bk" [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign, 'border':h.border}">{{h.NAME}}
											</th>	
										</ng-container>
									</tr>
									<ng-container *ngFor="let r of sec6tablesdata[2].rows; let h=index; trackBy:trackByFuntion">
										<tr *ngIf="r.length>1">
											<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
												<td [ngClass]="k.bk" colSpan='{{k.colspan}}' [ngStyle]="{'text-align':sec6tablesdata[2].cols[q].celAllign, 'background-color':k.bk , 'font-weight':k.weight, width:sec6tablesdata[2].cols[q].width+sec6tablesdata[2].cols[q].unit, 'border':k.border,'padding-left':k.sub}">
													<span *ngIf="k.sign&&k.data>0">{{USDollar.format(k.data)}}</span>
													<span *ngIf="!k.sign">{{k.data}}</span>
												</td>		
											</ng-container>
										</tr>
									</ng-container>  
								</table>  
							</div>
						</td>
					</tr>
				</tbody>
			</table>
			<div class="page-before"></div>
			<table>
                <thead>
                    <tr>
                        <td class="wrapper">
                            <h2>&nbsp;</h2>
                            <table class="section-header">
                                <tr>
                                    <td width="20%">
                                        <div>
                                            <p *ngIf="PropertyAsReportedHTML?.FrmLoanNo?.html" [innerHTML]="PropertyAsReportedHTML?.FrmLoanNo?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.FrmLoanNo?.html" [innerHTML]="PropertyAsReportedHTML?.FrmLoanNo?.text"></p>
											<label>Freddie Mac loan number</label>
                                        </div>
                                    </td>
                                    <td width="20%">
                                        <div>
                                            <p [innerHTML]="PropertyConditionAssessmentHTML?.FinalAsmntDate|date:'MMMM dd, yyyy'"></p>
                                            <label>Report date</label>
                                        </div>
                                    </td>
                                    <td colspan="2" width="40%">
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.AsReportedName?.html" [innerHTML]="PropertyAsReportedHTML?.AsReportedName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AsReportedName?.html" [innerHTML]="PropertyAsReportedHTML?.AsReportedName?.text"></p>
											<label>Property name</label>
                                        </div>
                                    </td>
									<td width="20%">
                                        <div>
                                            <p [innerHTML]="PropertyConditionAssessmentPropertyCoreCharacteristicsHTML?.PptyBuildingAgeYrCount?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
                                            <label>Building Age</label>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.AccountName?.html" [innerHTML]="PropertyAsReportedHTML?.AccountName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AccountName?.html" [innerHTML]="PropertyAsReportedHTML?.AccountName?.text"></p>
											<label>Seller/Servicer name</label>
                                        </div>
                                    </td>
                                    <td colspan="2" class="fh">
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.AddressLineText?.html" [innerHTML]="PropertyAsReportedHTML?.AddressLineText?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.AddressLineText?.html" [innerHTML]="PropertyAsReportedHTML?.AddressLineText?.text"></p>
											<label>Address</label>
                                        </div>
                                    </td>
									<td>
                                        <div>
                                            <p> {{pcaOp.reserve-2}} +2</p>
                                            <label>Mortgage term</label>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div>
											<p *ngIf="PropertyAsReportedHTML?.PartyBusinessAccountId?.html" [innerHTML]="PropertyAsReportedHTML?.PartyBusinessAccountId?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></p>
											<p *ngIf="!PropertyAsReportedHTML?.PartyBusinessAccountId?.html" [innerHTML]="PropertyAsReportedHTML?.PartyBusinessAccountId?.text"></p>
											<label>Seller/Servicer number</label>
                                        </div>
                                    </td>
                                    <td>
                                        <div>
                                            <p [innerHTML]="PropertyConditionAssessmentHTML?.PrelimInspectionDate|date:'MMMM dd, yyyy'"></p>
                                            <label>Inspection date</label>
                                        </div>
                                    </td>
                                    <td colspan="2" class="fh">
                                        <div>
                                            <p><ng-container *ngIf="PropertyAsReportedHTML?.CityName?.html"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.CityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="!PropertyAsReportedHTML?.CityName?.html&&PropertyAsReportedHTML?.CityName?.text"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.CityName?.text"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="PropertyAsReportedHTML?.StateUspsCode?.html"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.StateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>,&nbsp;</ng-container>
												<ng-container *ngIf="!PropertyAsReportedHTML?.StateUspsCode?.html&&PropertyAsReportedHTML?.StateUspsCode?.text"><span style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.StateUspsCode?.text"></span>,&nbsp;</ng-container> 
												
												<span *ngIf="PropertyAsReportedHTML?.PostalCode?.html" style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.PostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span>
												<span *ngIf="!PropertyAsReportedHTML?.PostalCode?.html" style="display: inline-table;" [innerHTML]="PropertyAsReportedHTML?.PostalCode?.secHtml?.text"></span></p>
											<label>City, State, Zip</label>
                                        </div>
                                    </td>
									<td>
                                        <div>
                                            <p>{{PropertyTotalRentRollSummary[0].PropertyResidentialRentRollSummary[0].RsdntlTotalUnitCount}}</p>
                                            <label>Number of units</label>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="wrapper">
							<div *ngIf='sec6tablesdata' id="sec5" style="margin-top:6px; font-size: 11px">
							<h2 style="color:white; background-color:black;padding:4px; font-size: 7.56pt; margin-top: 10px;margin-bottom: 10px;">DWELLING UNITS</h2> 
							<table class='datatable1' style="width:100%; font-size:6.12PT; font-family:Arial, sans-serif;border: 1px solid black;border-collapse: collapse;">
								<tr>
									<ng-container *ngFor="let h of sec6tablesdata[0].cols; let o=index; trackBy:trackByFuntion">
										<th [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign,'border':h.border}" [ngClass]="h.bk">{{h.NAME}}
										</th>	
									</ng-container>
								</tr>
								<ng-container *ngFor="let r of sec6tablesdata[3].rows; let h=index; trackBy:trackByFuntion">
									<tr *ngIf="r.length>1">
										<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
											<td [ngClass]="k.bk" colSpan='{{k.colspan}}' [ngStyle]="{'text-align':sec6tablesdata[3].cols[q].celAllign, 'background-color':k.bk , 'font-weight':k.weight, width:sec6tablesdata[3].cols[q].width+sec6tablesdata[3].cols[q].unit, 'border':k.border,'padding-left':k.sub}">
												<span *ngIf="k.sign&&k.data>0">{{USDollar.format(k.data)}}</span>
												<span *ngIf="!k.sign">{{k.data}}</span>
											</td>		
										</ng-container>
									</tr>
								</ng-container>  
							</table> 
						</div>
				<div *ngIf='sec6tablesdata' style="border:2px double black;margin-top: 20px;padding:16px 8px">
					<label style="font-size: 14pt;">TOTALS</label>
					<table class='datatable1' style="width:98%; margin-left:8px; font-size:10px; font-family:Arial, sans-serif;border: none;border-collapse: collapse">
						<tr>
						<ng-container *ngFor="let h of sec6tablesdata[4].cols; let o=index; trackBy:trackByFuntion">
								<th [ngClass]="h.bk" [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign, 'border':h.border, 'background-color':o>0?'black':'none', 'color':'white'}" >{{h.NAME}}
								</th>	
							</ng-container>
						</tr>
						<ng-container *ngFor="let r of sec6tablesdata[4].rows; let h=index; trackBy:trackByFuntion">
							<tr *ngIf="r.length>1">
								<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
									<td [ngClass]="k.bk" colSpan='{{k.colspan}}' [ngStyle]="{'text-align':sec6tablesdata[4].cols[q].celAllign, 'background-color':k.bk , width:sec6tablesdata[4].cols[q].width+sec6tablesdata[4].cols[q].unit, 'border':q>0?'1px black solid':'none'}">
										<span *ngIf="k.sign&&k.data>0">{{USDollar.format(k.data)}}</span>
										<span *ngIf="!k.sign">{{k.data}}</span>
									</td>		
								</ng-container>
							</tr>
						</ng-container>  
					</table>
					<div class="row" style="padding:8px 0 0 8px">
						<div style="width:25%; display:inline-block">
						<table  class='datatable1' style="font-size:10px; font-family:Arial, sans-serif;border: none;border-collapse: collapse">
							<tbody>
							<ng-container *ngFor="let r of sec6tablesdata[5].rows; let h=index; trackBy:trackByFuntion">
								<tr *ngIf="r.length>1">
									<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
										<td [ngStyle]="{'text-align':k.celAllign, width:k.width+k.unit, 'border':k.border}">
											<span *ngIf="k.sign&&k.data>0">{{USDollar.format(k.data)}}</span>
											<span *ngIf="!k.sign">{{k.data}}</span>                  
										</td>		
									</ng-container>
								</tr>
							</ng-container>
						</tbody>  
						</table>
					</div>
						<div style="width:30%; display:inline-block; margin-left: 60px;">
						<table  class='datatable1' style="font-size:10px; font-family:Arial, sans-serif;border: none;border-collapse: collapse">
							<tbody>
							<ng-container *ngFor="let r of sec6tablesdata[6].rows; let h=index; trackBy:trackByFuntion">
								<tr *ngIf="r.length>1">
									<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
										<td [ngStyle]="{'text-align':k.celAllign, width:k.width+k.unit, 'border':k.border}">
											<span *ngIf="k.sign&&k.data>0">{{USDollar.format(k.data)}}</span>
											<span *ngIf="!k.sign">{{k.data}}</span>                   
										</td>		
									</ng-container>
								</tr>
							</ng-container>
						</tbody>  
						</table>
						</div>
					</div>
				</div>
						</td>
					</tr>
				</tbody>
			</table>
        </section>
        <section class="page-before" data-section-title="Section VII">
            <header>
                <div class="freddie-mac-header">
                    <div class="freddie-mac-logo">
                        <img src="https://erisservice9.erisinfo.com/exreportw/frmimages/logo.jpg" alt="Freddie Mac Multifamily">
                    </div>
                    <div class="freddie-mac-title">
                        <strong>Property Condition Assessment</strong>
                    </div>
                </div>
            </header>
            <h1>Section VII: Repair Categories</h1>
            <div id="sec1" style="font-size: 11px">
				<h2 style="color:white; background-color:black;padding:4px">Conditions</h2>
	
				<p style="font-weight: bold;border-bottom:1px solid black; margin-top:20px">1 – Excellent</p>
				<p>Typically newer property or recent major rehab/significant investment, no Deferred Maintenance, no Life Safety Hazards/code violations, superior repair and maintenance practices, capital needs addressed.</p>
				
				<p style="font-weight: bold;border-bottom:1px solid black; margin-top:20px">2 – Very Good/Good</p>
				<p>Some minor issues noted that can be resolved by onsite maintenance, no/isolated Deferred Maintenance, no/isolated Life Safety Hazards/code violations, proactive repair and maintenance practices, majority of capital needs addressed with no impact to Property performance.</p>
				
				
				<p style="font-weight: bold;border-bottom:1px solid black; margin-top:20px">3 – Fair</p>
				<p>Declining condition or Isolated deterioration typically requiring an outside contract to remediate, material Deferred Maintenance, some Life Safety Hazards/code violations, reactive repair and maintenance practices, critical capital needs addressed but additional capital investment required.</p>
				
				<p style="font-weight: bold;border-bottom:1px solid black; margin-top:20px">4 – Deteriorated</p>
				<p>Substantial issues noted with follow-up required, extensive Deferred Maintenance, Life Safety Hazards/code violations requiring immediate attention, reactive repair and maintenance practices that do not address concerns, critical capital needs are not being addressed which is negatively impacting Property performance.</p>
				
				<p style="font-weight: bold;border-bottom:1px solid black; margin-top:20px">5 – Unacceptable</p>
				<p>Functionality of systems and components is compromised which materially impacts marketability, excessive Deferred Maintenance, significant Life Safety Hazards/code violations requiring immediate action, inadequate repair and maintenance practices, critical capital needs are not being addressed.</p>
				<br>
				<h2 style="color:white; background-color:black;padding:4px">Repair Categories</h2>
				<p>Only Critical Repairs, PR-90 Repairs and Priority Repairs should be noted on Form 1105. No other repair items should be listed.</p>
				
				<p style="font-weight: bold;border-bottom:1px solid black; margin-top:20px">Critical Repairs</p>
				<p>These are repairs and replacements that significantly impact habitability, value, income or marketability and that must be corrected before Freddie Mac will proceed with the transaction.</p>
				
				<p style="font-weight: bold;border-bottom:1px solid black; margin-top:20px">PR-90 Repairs</p>
				<p>These are corrective actions that must be completed within 90 days, and are limited to:</p>
				<ul style="list-style-type: disc; padding-left: 40px;">
					<li>Imminent life safety hazards</li>
					<li>Ongoing substantive damage to the property</li>
				</ul>
				
				<p style="font-weight: bold;border-bottom:1px solid black; margin-top:20px">Priority Repairs</p>
				<p>These are repairs and replacements that are significant and must be addressed as soon as possible. Priority Repairs consist of:</p>
				<ul style="list-style-type: disc; padding-left: 40px;">
					<li>All non-imminent life safety hazards</li>
					<li>Violations of any federal, State or local law, ordinance or code relating to zoning, subdivision and use, building and housing accessibility (including the Americans with Disabilities and Fair Housing Acts), health matters or fire safety</li>
					<li>Material deficiencies *</li>
					<li>Significant deferred maintenance *</li>
				</ul>
				<p style="text-align:right; font-size:11px">* Additional guidance can be found in Section 62.3(b) of the Freddie Mac Multifamily Seller/Servicer Guide</p>
				
				<!--<p style="font-weight: bold;border-bottom:1px solid black; margin-top:20px">Operational Repairs</p>
				<p>These are repairs and replacements that consist of Minor Deficiencies, Minor Deferred Maintenance and Handicap Accessibility Enhancements that are expected to be completed by the Borrower as part of a repairs and maintenance budget and that cannot be reasonably resolved by Routine Maintenance. Operational Repairs consist of:</p>
				<ul>
					<li>Minor deficiencies *</li>
					<li>Minor deferred maintenance *</li>
					<li>Handicap Accessibility Enhancements *</li>
					<p style="text-align:right; font-size:11px">* Additional guidance can be found in Section 62.3(b) of the Freddie Mac Multifamily Seller/Servicer Guide</p>
				</ul>-->
			</div>
			
	
        </section>
	
</div>

<iframe *ngIf="iframeSrc" id="printFrame" (load)="resizeIframe($event)" style="width:100%; border:none;" [src]="iframeSrc"></iframe>
